import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type AddGridValueInput = {
  columnPosition: Scalars['Int'];
  gridMasterId: Scalars['Int'];
  rowPosition: Scalars['Int'];
  value: Scalars['String'];
  valueAddedDate: Scalars['String'];
};

export type AddLoadingListOutput = {
  __typename?: 'AddLoadingListOutput';
  carDetailsId?: Maybe<Scalars['Int']>;
  legId: Scalars['Int'];
  loadingListItems?: Maybe<Array<LoadingListItem>>;
  trailerDetailsId?: Maybe<Scalars['Int']>;
};

export type AddMasterGridDataInput = {
  columnHeaders: Array<Scalars['String']>;
  gridName: Scalars['String'];
  gridType: Scalars['String'];
  isNumberGridWithTotal: Scalars['Boolean'];
  locationId: Scalars['Int'];
  rowHeaders: Array<Scalars['String']>;
};

export type AddMasterValueBoxInput = {
  boxName: Scalars['String'];
  frequency: Array<FrequencyDays>;
  isAddedFromTerminal: Scalars['Boolean'];
  isAlphaNumeric?: Maybe<Scalars['Boolean']>;
  isFixedBox: Scalars['Boolean'];
  isTimeBox: Scalars['Boolean'];
  isYesNoBox: Scalars['Boolean'];
  locationId: Scalars['Int'];
};

export type AssociatedRoutesResponse = {
  __typename?: 'AssociatedRoutesResponse';
  arrivalLocation: Scalars['String'];
  arrivalTime?: Maybe<Scalars['String']>;
  departureLocation: Scalars['String'];
  departureTime?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  routeId: Scalars['Int'];
  routeName: Scalars['String'];
  routePosition: Scalars['Int'];
  subContractorLocationName: Scalars['String'];
  tourId: Scalars['Int'];
  tourName: Scalars['String'];
};

export type BookMarkItemResponse = {
  __typename?: 'BookMarkItemResponse';
  capacity?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  legs?: Maybe<Array<RouteLeg>>;
  routeId: Scalars['String'];
  status: FixedTourGenerateResponseStatus;
  tourRouteId: Scalars['Int'];
  truckLicencePlateNo?: Maybe<Scalars['String']>;
};

export type BookmarkTourRouteTemplate = {
  __typename?: 'BookmarkTourRouteTemplate';
  bookmark: Scalars['Boolean'];
  id: Scalars['Int'];
  tourRouteTemplate: TourRouteTemplate;
  tourRouteTemplateId: Scalars['Int'];
  user: User;
  userId: Scalars['Int'];
};

export type CarOrTrailerDetails = {
  id: Scalars['Int'];
  loadingListItems: Array<LoadingListItemInput>;
};

export type CarTrailerDetailsInput = {
  actualCapacity?: Maybe<Scalars['Int']>;
  containerId?: Maybe<Scalars['String']>;
  gateNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  legId?: Maybe<Scalars['Int']>;
  loadCages?: Maybe<Scalars['Int']>;
  loadPAL?: Maybe<Scalars['Int']>;
  loadPPL?: Maybe<Scalars['Int']>;
  registrationNumber?: Maybe<Scalars['String']>;
  togref?: Maybe<Scalars['String']>;
  type: TaskName;
  unloadCages?: Maybe<Scalars['Int']>;
  unloadPAL?: Maybe<Scalars['Int']>;
  unloadPPL?: Maybe<Scalars['Int']>;
};

export type CarTrailerDetailsOutput = {
  __typename?: 'CarTrailerDetailsOutput';
  actualCapacity?: Maybe<Scalars['Int']>;
  errorMessage?: Maybe<Scalars['String']>;
  gateNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  legId?: Maybe<Scalars['Int']>;
  registrationNumber?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  type: TaskName;
};

export type Card = {
  __typename?: 'Card';
  contacts: Array<CardContact>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedBy: Scalars['String'];
  deviationToCustomer?: Maybe<DeviationToCustomer>;
  files: Array<CardFile>;
  id: Scalars['Int'];
  lastUpdatedBy: Scalars['String'];
  locations: Array<LocationEntity>;
  name: Scalars['String'];
  notes: Array<CardNote>;
  type: CardType;
  updatedAt: Scalars['DateTime'];
};

export type CardContact = {
  __typename?: 'CardContact';
  card: Card;
  cardId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedBy: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  lastUpdatedBy: Scalars['String'];
  location?: Maybe<LocationEntity>;
  locationId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  note: Scalars['String'];
  phoneNumber: Scalars['String'];
  role: Scalars['String'];
  tags: Array<CardContactTag>;
  updatedAt: Scalars['DateTime'];
};

export type CardContactTag = {
  __typename?: 'CardContactTag';
  contacts: Array<CardContact>;
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CardFile = {
  __typename?: 'CardFile';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedBy: Scalars['String'];
  id: Scalars['Int'];
  location?: Maybe<LocationEntity>;
  locationId?: Maybe<Scalars['Int']>;
  mimetype: Scalars['String'];
  originalname: Scalars['String'];
  path: Scalars['String'];
  size: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type CardNote = {
  __typename?: 'CardNote';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedBy: Scalars['String'];
  id: Scalars['Int'];
  lastUpdatedBy: Scalars['String'];
  location?: Maybe<LocationEntity>;
  locationId?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum CardType {
  Checkpoint = 'Checkpoint',
  Customer = 'Customer',
  Subcontractor = 'Subcontractor',
  Terminal = 'Terminal'
}

export type ChecklistRouteLegLoadinglistItems = {
  id?: Maybe<Scalars['Float']>;
  locationId: Scalars['Float'];
  note?: Maybe<Scalars['String']>;
  packages?: Maybe<Scalars['Float']>;
  palletSpace: Scalars['Float'];
  pallets: Scalars['Float'];
  weight?: Maybe<Scalars['Float']>;
};

export type ChecklistRouteLegs = {
  arrivalTime: Scalars['String'];
  departureTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  idNum: Scalars['Float'];
  load: Scalars['Boolean'];
  loadingListItems: Array<ChecklistRouteLegLoadinglistItems>;
  locationId: Scalars['Float'];
  note?: Maybe<Scalars['String']>;
  position: Scalars['Float'];
  productionDate: Scalars['String'];
  transportationDate: Scalars['String'];
  unload: Scalars['Boolean'];
};

export type ChecklistRoutes = {
  idNum: Scalars['Float'];
  legs: Array<ChecklistRouteLegs>;
};

export type CostAllocation = {
  __typename?: 'CostAllocation';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  items: Array<CostAllocationItem>;
  route: Route;
  updatedAt: Scalars['DateTime'];
};

export type CostAllocationInput = {
  id?: Maybe<Scalars['Int']>;
  items: Array<CostAllocationItemInput>;
};

export type CostAllocationInputV2 = {
  id?: Maybe<Scalars['Int']>;
  items: Array<CostAllocationItemInput>;
};

export type CostAllocationItem = {
  __typename?: 'CostAllocationItem';
  additionalCost: Scalars['Boolean'];
  additionalDiscount: Scalars['Boolean'];
  bringCost: Scalars['Boolean'];
  comment: Scalars['String'];
  cost: Scalars['Float'];
  costAllocationId: Scalars['Int'];
  currency?: Maybe<Currency>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  department: Department;
  departmentId: Scalars['String'];
  id: Scalars['Int'];
  includedKpi: Scalars['Boolean'];
  includedPrice: Scalars['Boolean'];
  location?: Maybe<LocationEntity>;
  tags?: Maybe<Scalars['String']>;
  type: CostAllocationItemType;
  updatedAt: Scalars['DateTime'];
};

export type CostAllocationItemInput = {
  additionalCost: Scalars['Boolean'];
  additionalDiscount: Scalars['Boolean'];
  bringCost: Scalars['Boolean'];
  comment: Scalars['String'];
  cost: Scalars['Float'];
  currency?: Maybe<Scalars['String']>;
  departmentId: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  includedKpi: Scalars['Boolean'];
  includedPrice: Scalars['Boolean'];
  locationId?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['String']>;
  type: CostAllocationItemType;
};

export enum CostAllocationItemType {
  Barrier = 'Barrier',
  Bridge = 'Bridge',
  Customs = 'Customs',
  ElectricalCost = 'ElectricalCost',
  Ferry = 'Ferry',
  Materials = 'Materials',
  Pickup = 'Pickup',
  Road = 'Road',
  Trailer = 'Trailer',
  Transport = 'Transport',
  TransportHd = 'TransportHD',
  Waitingtime = 'Waitingtime'
}

export type CountryDepartmentGroup = {
  __typename?: 'CountryDepartmentGroup';
  country: Scalars['String'];
  departments: Array<Scalars['String']>;
};

export type CreateCardContactInput = {
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  tagIds: Array<Scalars['Int']>;
};

export type CreateCardContactTagInput = {
  title: Scalars['String'];
};

export type CreateDocumentTagInput = {
  title: Scalars['String'];
};

export type CreateHolidayInput = {
  alternateGenerateDate?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  endDate: Scalars['String'];
  endTime: Scalars['String'];
  isStrictCancel: Scalars['Boolean'];
  locationId?: Maybe<Scalars['Int']>;
  startDate: Scalars['String'];
  startTime: Scalars['String'];
  title: Scalars['String'];
};

export type CreateLocationInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  fromLocationId?: Maybe<Scalars['Int']>;
  isPromoted: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  locationGroup?: Maybe<Scalars['String']>;
  locationShortCode: Scalars['String'];
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  phLocationId: Scalars['String'];
  postalCode: Scalars['String'];
  tagIds?: Maybe<Array<Scalars['Int']>>;
  toLocationId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type CreateLocationTagInput = {
  title: Scalars['String'];
};

export type CreateNoteInput = {
  text: Scalars['String'];
  title: Scalars['String'];
};

export type CreateRouteAlertInput = {
  id?: Maybe<Scalars['Float']>;
  legs: LegInput;
  routeId?: Maybe<Scalars['String']>;
};

export type CreateShipmentInput = {
  createdFrom?: Maybe<Scalars['String']>;
  fromLocationId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  loadingListItem: Array<CreateShipmentLoadingList>;
  name: Scalars['String'];
  shipmentDate?: Maybe<Scalars['String']>;
  toLocationId: Scalars['Int'];
};

export type CreateShipmentLoadingList = {
  checked: Scalars['Boolean'];
  classification?: Maybe<DangerousGoodsClassification>;
  createdFrom?: Maybe<Scalars['String']>;
  customWaybillNo?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  customsProcedure?: Maybe<CustomsProcedureNew>;
  fromLocationId?: Maybe<Scalars['Int']>;
  grossVolumeM3?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  isDangerous: Scalars['Boolean'];
  isLimitedQty: Scalars['Boolean'];
  isRemainingGoods: Scalars['Boolean'];
  isVoecCustomer: Scalars['Boolean'];
  lliEdiAdditionalDetails?: Maybe<LliEdiAdditionalDetailsInput>;
  locationId: Scalars['Int'];
  note: Scalars['String'];
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  serviceCode?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['Int']>>;
  toLocationId?: Maybe<Scalars['Int']>;
  unNumber?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export enum Currency {
  Dkk = 'DKK',
  Eur = 'EUR',
  Nok = 'NOK',
  Sek = 'SEK'
}

export type CustomerLevelDeviationResponse = {
  __typename?: 'CustomerLevelDeviationResponse';
  actualArrivalTime?: Maybe<Scalars['String']>;
  cause?: Maybe<DeviationCause>;
  consequence: Scalars['Boolean'];
  createdBy: Scalars['String'];
  customerId: Scalars['Int'];
  customerLocation?: Maybe<Scalars['String']>;
  customerName: Scalars['String'];
  deviationApplicableDate: Scalars['String'];
  deviationId: Scalars['Int'];
  emailSent: Scalars['Boolean'];
  emailSentTimestamp?: Maybe<Scalars['DateTime']>;
  fault: DeviationFault;
  faultLocation?: Maybe<Scalars['String']>;
  faultLocationId?: Maybe<Scalars['Int']>;
  fromToToCountry?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDangerous?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  locationItemNote?: Maybe<Scalars['String']>;
  newCustomer?: Maybe<Scalars['String']>;
  otherReason?: Maybe<Scalars['String']>;
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  reason?: Maybe<Reason>;
  routeId?: Maybe<Scalars['Int']>;
  routeNameOrFaultLocation: Scalars['String'];
  toCity?: Maybe<Scalars['String']>;
  toLocation?: Maybe<Scalars['String']>;
  toLocationId?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  weight?: Maybe<Scalars['Float']>;
};

export type Customers = {
  __typename?: 'Customers';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  customerId: Scalars['String'];
  customerMapper?: Maybe<CustomersMapping>;
  customerName: Scalars['String'];
  deletedBy?: Maybe<Scalars['String']>;
  partyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type CustomersMapping = {
  __typename?: 'CustomersMapping';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  customers?: Maybe<Customers>;
  customsProcedure?: Maybe<CustomsProcedureForMapping>;
  deletedBy?: Maybe<Scalars['String']>;
  fromLocationId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  toLocationId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type CustomersMappingInput = {
  customerIds: Array<Scalars['String']>;
  customsProcedure?: Maybe<CustomsProcedureNew>;
  fromLocationId?: Maybe<Scalars['Int']>;
  isHideOrders?: Maybe<Scalars['Boolean']>;
  loadingListItemIds: Array<Scalars['Int']>;
  toLocationId?: Maybe<Scalars['Int']>;
};

export enum CustomsProcedureForMapping {
  Digitoll = 'DIGITOLL',
  Digitollextern = 'DIGITOLLEXTERN',
  Digitollvoec = 'DIGITOLLVOEC',
  Lettervolume = 'LETTERVOLUME',
  T1 = 'T1',
  T2 = 'T2',
  Tvinn = 'TVINN',
  Voec = 'VOEC'
}

export enum CustomsProcedureNew {
  Digitoll = 'DIGITOLL',
  Digitollextern = 'DIGITOLLEXTERN',
  Digitollvoec = 'DIGITOLLVOEC',
  Lettervolume = 'LETTERVOLUME',
  T1 = 'T1',
  T2 = 'T2',
  Tvinn = 'TVINN',
  Voec = 'VOEC'
}

export enum DangerousGoodsClassification {
  CorrosiveSubstances = 'CorrosiveSubstances',
  Explosives = 'Explosives',
  FlammableLiquids = 'FlammableLiquids',
  FlammableSolids = 'FlammableSolids',
  Gases = 'Gases',
  MiscellaneousDangerousSubstancesandArticles = 'MiscellaneousDangerousSubstancesandArticles',
  OxidizingSubstancesandOrganicPeroxides = 'OxidizingSubstancesandOrganicPeroxides',
  RadioactiveMaterial = 'RadioactiveMaterial',
  ToxicandInfectiousSubstances = 'ToxicandInfectiousSubstances'
}


export enum Days {
  Fri = 'Fri',
  Mon = 'Mon',
  Sat = 'Sat',
  Sun = 'Sun',
  Thu = 'Thu',
  Tue = 'Tue',
  Wed = 'Wed'
}

export type DeleteAttachmentFileDto = {
  entityId: Scalars['Int'];
  entityType: Scalars['String'];
  fileId: Scalars['Int'];
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  result: Scalars['Boolean'];
};

export type Department = {
  __typename?: 'Department';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Deviation = {
  __typename?: 'Deviation';
  actualArrivalTime?: Maybe<Scalars['String']>;
  cause?: Maybe<DeviationCause>;
  consequence: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  customers: Array<LocationEntity>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy: Scalars['String'];
  deviationApplicableDate?: Maybe<Scalars['DateTime']>;
  deviationToCustomer?: Maybe<Array<DeviationToCustomer>>;
  deviationToLocation?: Maybe<Array<DeviationToLocation>>;
  emailSent?: Maybe<Scalars['DateTime']>;
  englishMessageCustomers: Scalars['String'];
  fault: DeviationFault;
  faultLocation?: Maybe<LocationEntity>;
  faultLocationId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  lastUpdatedBy: Scalars['String'];
  localMessageCustomers: Scalars['String'];
  note: Scalars['String'];
  route: Route;
  routeId: Scalars['Int'];
  toLocation?: Maybe<LocationEntity>;
  toLocationId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export enum DeviationCause {
  CustomsIssues = 'CustomsIssues',
  DelayedFerry = 'DelayedFerry',
  ForceMajeure = 'ForceMajeure',
  LateDeparture = 'LateDeparture',
  LeftoverCargo = 'LeftoverCargo',
  Other = 'Other',
  PoliceControl = 'PoliceControl',
  TechnicalIssueOnEquipmentOrTruck = 'TechnicalIssueOnEquipmentOrTruck',
  TrafficIssues = 'TrafficIssues'
}

export enum DeviationFault {
  AddedFromTerminal = 'AddedFromTerminal',
  BringCustoms = 'BringCustoms',
  Customer = 'Customer',
  ExternalPart = 'ExternalPart',
  FaultFromTerminal = 'FaultFromTerminal',
  Other = 'Other',
  Subcontractor = 'Subcontractor',
  Terminal = 'Terminal',
  WeatherConditions = 'WeatherConditions'
}

export type DeviationInput = {
  actualArrivalTime?: Maybe<Scalars['String']>;
  cause?: Maybe<DeviationCause>;
  consequence: Scalars['Boolean'];
  fault: DeviationFault;
  faultLocationId?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  routeId: Scalars['Int'];
};

export type DeviationToCustomer = {
  __typename?: 'DeviationToCustomer';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  customer: Card;
  customerId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy: Scalars['String'];
  deviation: Deviation;
  deviationId: Scalars['Int'];
  id: Scalars['Int'];
  lastEmailSent?: Maybe<Scalars['DateTime']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  location?: Maybe<LocationEntity>;
  locationId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DeviationToLocation = {
  __typename?: 'DeviationToLocation';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deviation: Deviation;
  deviationId: Scalars['Int'];
  id: Scalars['Int'];
  isDangerous?: Maybe<Scalars['Boolean']>;
  lastEmailSent?: Maybe<Scalars['DateTime']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  location: LocationEntity;
  locationId: Scalars['Int'];
  locationItemNote?: Maybe<Scalars['String']>;
  newCustomer?: Maybe<Scalars['String']>;
  otherReason?: Maybe<Scalars['String']>;
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  reason?: Maybe<Reason>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['Float']>;
};

export type DispatchRouteLegInput = {
  arrivalTime?: Maybe<Scalars['String']>;
  carLoadingListItems?: Maybe<Array<LoadingListItemInput>>;
  departureTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isLoadingInCar?: Maybe<Scalars['Boolean']>;
  isLoadingInTrailer?: Maybe<Scalars['Boolean']>;
  lcOperations?: Maybe<Array<RouteLegLcOperationV2Input>>;
  legTag?: Maybe<Scalars['String']>;
  load?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['Int']>;
  locationNote?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  trailerLoadingListItems?: Maybe<Array<LoadingListItemInput>>;
  transportationDate?: Maybe<Scalars['String']>;
  transportationDateOffset?: Maybe<Scalars['Int']>;
  unload?: Maybe<Scalars['Boolean']>;
};

export type DocumentFile = {
  __typename?: 'DocumentFile';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedBy: Scalars['String'];
  id: Scalars['Int'];
  lastUpdatedBy: Scalars['String'];
  mimetype: Scalars['String'];
  originalname: Scalars['String'];
  path: Scalars['String'];
  size: Scalars['Float'];
  tags: Array<DocumentFileTag>;
  updatedAt: Scalars['DateTime'];
};

export type DocumentFileTag = {
  __typename?: 'DocumentFileTag';
  createdAt: Scalars['DateTime'];
  files: Array<DocumentFile>;
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DriverInfo = {
  driverEmail?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  driverPhoneNumber?: Maybe<Scalars['String']>;
  licensePlate?: Maybe<Scalars['String']>;
};

export type EditDeviationInput = {
  actualArrivalTime?: Maybe<Scalars['String']>;
  cause?: Maybe<DeviationCause>;
  consequence: Scalars['Boolean'];
  emailSent?: Maybe<Scalars['DateTime']>;
  fault: DeviationFault;
  faultLocation?: Maybe<UpdateLocationInput>;
  faultLocationId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  routeId: Scalars['Int'];
};

export type EditLocationDeviationInput = {
  consequence: Scalars['Boolean'];
  customerDeviationListItemsInput: Array<EditLocationDeviationListItemsInput>;
  deviationApplicableDate: Scalars['DateTime'];
  fault: DeviationFault;
  faultLocationId: Scalars['Int'];
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  routeId?: Maybe<Scalars['Int']>;
  toLocationId: Scalars['Int'];
  toLocationIdArray?: Maybe<Array<Scalars['Int']>>;
};

export type EditLocationDeviationListItemsInput = {
  deviationId: Scalars['Int'];
  id: Scalars['Int'];
  isDangerous?: Maybe<Scalars['Boolean']>;
  isNewCustomer?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['Int'];
  locationItemNote?: Maybe<Scalars['String']>;
  newCustomer?: Maybe<Scalars['String']>;
  otherReason?: Maybe<Scalars['String']>;
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  reason?: Maybe<Reason>;
  weight?: Maybe<Scalars['Float']>;
};

export type EditLocationReportInfoInput = {
  info: Scalars['String'];
  infoType: InfoType;
  locationReportInfoId: Scalars['Int'];
};

export type EditLocationReportInfoReplyInput = {
  locationReportInfoId: Scalars['Int'];
  replyText: Scalars['String'];
};

export type EditMasterValueBoxInput = {
  boxId: Scalars['Int'];
  boxName: Scalars['String'];
  frequency: Array<FrequencyDays>;
};

export type EditShipmentLoadingList = {
  checked: Scalars['Boolean'];
  classification?: Maybe<DangerousGoodsClassification>;
  connectedNB?: Maybe<Scalars['String']>;
  customCleared: Scalars['Boolean'];
  customClearedForImport: Scalars['Boolean'];
  customCmrNo?: Maybe<Scalars['String']>;
  customInvoiceNo?: Maybe<Scalars['String']>;
  customMrnNo?: Maybe<Scalars['String']>;
  customNote?: Maybe<Scalars['String']>;
  customVOECId?: Maybe<Scalars['String']>;
  customWaybillNo?: Maybe<Scalars['String']>;
  customsProcedure?: Maybe<CustomsProcedureNew>;
  id?: Maybe<Scalars['Int']>;
  isDangerous: Scalars['Boolean'];
  isImportedFromShipment?: Maybe<Scalars['Boolean']>;
  isLimitedQty?: Maybe<Scalars['Boolean']>;
  isRemainingGoods: Scalars['Boolean'];
  isVoecCustomer: Scalars['Boolean'];
  locationId: Scalars['Int'];
  note: Scalars['String'];
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  tagIds?: Maybe<Array<Scalars['Int']>>;
  terminalCleared: Scalars['Boolean'];
  terminalDevInfo?: Maybe<Scalars['String']>;
  terminalDevPackages?: Maybe<Scalars['Int']>;
  terminalDevPalletSpace?: Maybe<Scalars['Float']>;
  terminalDevPallets?: Maybe<Scalars['Int']>;
  terminalDevWeight?: Maybe<Scalars['Float']>;
  terminalNotCleared: Scalars['Boolean'];
  terminalShipmentNotArrived: Scalars['Boolean'];
  unNumber?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type EditValueBoxEntry = {
  boxNameText: Scalars['String'];
  boxValue: Scalars['String'];
  entryId: Scalars['Int'];
  valueAddedDate: Scalars['String'];
  valueAddedDay: Scalars['String'];
  valueBoxId: Scalars['Int'];
};

export type ExcelImportDataInput = {
  Address: Scalars['String'];
  City: Scalars['String'];
  CountryCode: Scalars['String'];
  LocationName: Scalars['String'];
  PostalCode: Scalars['String'];
};

export type FileItemInput = {
  id: Scalars['Float'];
};

export type FileItemInputV2 = {
  id: Scalars['Float'];
};

export type FilterConfig = {
  filterConfiguration: Scalars['JSONObject'];
  filterName: Scalars['String'];
  tableName: Scalars['String'];
};

export type FixedTourGenerateInput = {
  dateString: Scalars['String'];
  routeId: Scalars['Int'];
};

export type FixedTourGenerateResponse = {
  __typename?: 'FixedTourGenerateResponse';
  createdRouteId?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  routeType?: Maybe<RouteType>;
  status: FixedTourGenerateResponseStatus;
};

export enum FixedTourGenerateResponseStatus {
  NotFound = 'NotFound',
  RouteAlreadyDispatched = 'RouteAlreadyDispatched',
  Success = 'Success'
}

export type FixedTrafficLeg = {
  __typename?: 'FixedTrafficLeg';
  arrivalCity?: Maybe<Scalars['String']>;
  arrivalCountry?: Maybe<Scalars['String']>;
  arrivalTime: Scalars['String'];
  capacity?: Maybe<Scalars['Int']>;
  days: Array<Days>;
  departureCity?: Maybe<Scalars['String']>;
  departureCountry?: Maybe<Scalars['String']>;
  departureTime?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  load: Scalars['Boolean'];
  note: Scalars['String'];
  routeForId: Scalars['Int'];
  routeId: Scalars['String'];
  startDate: Scalars['String'];
  subcontractorLocation: LocationEntity;
  tourId: Scalars['Int'];
  unload: Scalars['Boolean'];
};

export enum FrequencyDays {
  Fri = 'Fri',
  Mon = 'Mon',
  Sat = 'Sat',
  Sun = 'Sun',
  Thu = 'Thu',
  Tue = 'Tue',
  Wed = 'Wed'
}

export type FrontPagePostsAvailability = {
  __typename?: 'FrontPagePostsAvailability';
  hasGrid: Scalars['Boolean'];
  hasInfo: Scalars['Boolean'];
  hasValueBox: Scalars['Boolean'];
  locationId: Scalars['Int'];
  locationName: Scalars['String'];
  startDate: Scalars['String'];
};

export enum FuelType {
  Bio = 'BIO',
  Diesel = 'Diesel',
  Electric = 'Electric',
  Gasoline = 'Gasoline',
  Hvo = 'HVO',
  Train = 'Train',
  TrainElectric = 'TrainElectric'
}

export type GridFilter = {
  __typename?: 'GridFilter';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filterConfiguration?: Maybe<Scalars['JSONObject']>;
  filterName: Scalars['String'];
  id: Scalars['Int'];
  tableName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type GridValues = {
  __typename?: 'GridValues';
  columnHeaders: Array<Scalars['String']>;
  gridEntries?: Maybe<Scalars['JSON']>;
  gridEntryId: Scalars['Int'];
  gridName: Scalars['String'];
  gridType: Scalars['String'];
  id: Scalars['Int'];
  isGridDeleted: Scalars['Boolean'];
  isNumberGridWithTotal: Scalars['Boolean'];
  location?: Maybe<Scalars['String']>;
  locationId: Scalars['Int'];
  rowHeaders: Array<Scalars['String']>;
  valueAddedDate?: Maybe<Scalars['String']>;
};

export type Holiday = {
  __typename?: 'Holiday';
  alternateGenerateDate?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  date: Scalars['String'];
  deletedBy: Scalars['String'];
  endDate: Scalars['String'];
  endTime: Scalars['String'];
  id: Scalars['Int'];
  isStrictCancel?: Maybe<Scalars['Boolean']>;
  locationDetails: LocationDetails;
  locationId?: Maybe<Scalars['Int']>;
  startTime: Scalars['String'];
  title: Scalars['String'];
};

export type IncomingRoutesToTerminal = {
  __typename?: 'IncomingRoutesToTerminal';
  inbound?: Maybe<Array<ReportToTerminalInboundOutboundRouteList>>;
  outbound?: Maybe<Array<ReportToTerminalInboundOutboundRouteList>>;
};

export enum InfoType {
  Important = 'Important',
  Info = 'Info'
}

export type InternalTerminal = {
  __typename?: 'InternalTerminal';
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  reportExportedAt?: Maybe<Scalars['DateTime']>;
  reportExportedBy?: Maybe<Scalars['String']>;
  terminal: Card;
  terminalId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type InternalTerminalGridEntries = {
  __typename?: 'InternalTerminalGridEntries';
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  gridEntries?: Maybe<Scalars['JSON']>;
  gridEntryId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  valueAddedDate?: Maybe<Scalars['String']>;
};

export type InternalTerminalReportInfo = {
  __typename?: 'InternalTerminalReportInfo';
  createdBy?: Maybe<Scalars['String']>;
  dateForAddInfo: Scalars['DateTime'];
  files: Array<DocumentFile>;
  id: Scalars['Int'];
  info: Scalars['String'];
  infoType: InfoType;
  internalTerminal?: Maybe<InternalTerminal>;
  internalTerminalId?: Maybe<Scalars['Int']>;
  isAddedFromTerminal: Scalars['Boolean'];
  location: LocationEntity;
  locationId?: Maybe<Scalars['Int']>;
  replyInfo?: Maybe<Scalars['String']>;
  replyText?: Maybe<Scalars['String']>;
};

export type InternalTerminalValueBoxEntries = {
  __typename?: 'InternalTerminalValueBoxEntries';
  boxNameText: Scalars['String'];
  boxValue: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  valueAddedDate: Scalars['String'];
  valueAddedDay: Scalars['String'];
  valueBoxId: Scalars['Int'];
};

export type InternalTerminalValueBoxMaster = {
  __typename?: 'InternalTerminalValueBoxMaster';
  boxEntries: Array<InternalTerminalValueBoxEntries>;
  boxName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  frequency: Array<FrequencyDays>;
  id: Scalars['Int'];
  internalTerminal?: Maybe<InternalTerminal>;
  internalTerminalId?: Maybe<Scalars['Int']>;
  isAddedFromTerminal: Scalars['Boolean'];
  isAlphaNumeric: Scalars['Boolean'];
  isFixedBox: Scalars['Boolean'];
  isTimeBox: Scalars['Boolean'];
  isYesNoBox: Scalars['Boolean'];
  location: LocationEntity;
  locationId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type InvoiceDataInput = {
  invoiceNote?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
};



export type LegDetails = {
  actualArrivalDate?: Maybe<Scalars['String']>;
  actualArrivalTime?: Maybe<Scalars['String']>;
  actualCapacity?: Maybe<Scalars['Int']>;
  actualDepartureDate?: Maybe<Scalars['String']>;
  actualDepartureTime?: Maybe<Scalars['String']>;
  ansvBefraktare?: Maybe<Scalars['String']>;
  arrivalTime?: Maybe<Scalars['String']>;
  assigned?: Maybe<Scalars['Boolean']>;
  carRegistrationNumber?: Maybe<Scalars['String']>;
  departureTime?: Maybe<Scalars['String']>;
  distanceInKM?: Maybe<Scalars['Float']>;
  fuel?: Maybe<FuelType>;
  id: Scalars['Int'];
  kippReceivedBy?: Maybe<Scalars['String']>;
  kippTimeWhenReceived?: Maybe<Scalars['String']>;
  loadCarPPL?: Maybe<Scalars['Float']>;
  loadTrailerPPL?: Maybe<Scalars['Float']>;
  locationId?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  receivedBy?: Maybe<Scalars['String']>;
  receivedStatus?: Maybe<RecievedStatus>;
  routeDriverEmail?: Maybe<Scalars['String']>;
  routeDriverName?: Maybe<Scalars['String']>;
  routeDriverPhoneNumber?: Maybe<Scalars['String']>;
  terminalNote?: Maybe<Scalars['String']>;
  timeWhenAssigned?: Maybe<Scalars['String']>;
  timeWhenReceived?: Maybe<Scalars['String']>;
  tom?: Maybe<Scalars['Boolean']>;
  trailerRegistrationNumber?: Maybe<Scalars['String']>;
  transportationDate?: Maybe<Scalars['String']>;
  unloadCarPPL?: Maybe<Scalars['Float']>;
  unloadTrailerPPL?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type LegInput = {
  arrivalArrivalTime?: Maybe<Scalars['String']>;
  arrivalDepartureTime?: Maybe<Scalars['String']>;
  departureArrivalTime?: Maybe<Scalars['String']>;
  departureDepartureTime?: Maybe<Scalars['String']>;
  firstLegDate?: Maybe<Scalars['String']>;
  firstLegTerminalName?: Maybe<Scalars['String']>;
  lastLegDate?: Maybe<Scalars['String']>;
  lastLegTerminalName?: Maybe<Scalars['String']>;
};

export type LegLoadingListInput = {
  carDetails: CarOrTrailerDetails;
  id: Scalars['Int'];
  trailerDetails: CarOrTrailerDetails;
};

export type LegsListUpdateSubscription = {
  __typename?: 'LegsListUpdateSubscription';
  legId: Scalars['Int'];
  refreshWholeGrid?: Maybe<Scalars['Boolean']>;
  routeLeg: RouteLeg;
};

export type LegsPositionInput = {
  id: Scalars['Int'];
  position: Scalars['Int'];
  productionDate: Scalars['String'];
  transportationDate: Scalars['String'];
};

export type LliEdiAdditionalDetails = {
  __typename?: 'LliEdiAdditionalDetails';
  apiProvidedFields?: Maybe<Array<Scalars['String']>>;
  consigneeCity?: Maybe<Scalars['String']>;
  consigneeCountryCode?: Maybe<Scalars['String']>;
  consigneeDeliveryAddressLine1?: Maybe<Scalars['String']>;
  consigneeDeliveryAddressLine2?: Maybe<Scalars['String']>;
  consigneeName?: Maybe<Scalars['String']>;
  consigneePhoneNumber?: Maybe<Scalars['String']>;
  consigneePostalCode?: Maybe<Scalars['String']>;
  consigneeReceiverRef?: Maybe<Scalars['String']>;
  consigneeStreet?: Maybe<Scalars['String']>;
  consignmentUniqueId?: Maybe<Scalars['String']>;
  consignorCity?: Maybe<Scalars['String']>;
  consignorCountryCode?: Maybe<Scalars['String']>;
  consignorName?: Maybe<Scalars['String']>;
  consignorPhoneNumber?: Maybe<Scalars['String']>;
  consignorPickupAddressLine1?: Maybe<Scalars['String']>;
  consignorPickupAddressLine2?: Maybe<Scalars['String']>;
  consignorPostalCode?: Maybe<Scalars['String']>;
  consignorSenderRef?: Maybe<Scalars['String']>;
  consignorStreet?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdFrom?: Maybe<Scalars['String']>;
  deliveryInstructions?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lliConsignmentItems?: Maybe<Scalars['JSON']>;
  loadingListItem: LoadingListItem;
  loadingListItemId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type LliEdiAdditionalDetailsInput = {
  apiProvidedFields?: Maybe<Array<Scalars['String']>>;
  consigneeCity?: Maybe<Scalars['String']>;
  consigneeCountryCode?: Maybe<Scalars['String']>;
  consigneeDeliveryAddressLine1?: Maybe<Scalars['String']>;
  consigneeDeliveryAddressLine2?: Maybe<Scalars['String']>;
  consigneeName?: Maybe<Scalars['String']>;
  consigneePhoneNumber?: Maybe<Scalars['String']>;
  consigneePostalCode?: Maybe<Scalars['String']>;
  consigneeReceiverRef?: Maybe<Scalars['String']>;
  consigneeStreet?: Maybe<Scalars['String']>;
  consignmentUniqueId?: Maybe<Scalars['String']>;
  consignorCity?: Maybe<Scalars['String']>;
  consignorCountryCode?: Maybe<Scalars['String']>;
  consignorName?: Maybe<Scalars['String']>;
  consignorPhoneNumber?: Maybe<Scalars['String']>;
  consignorPickupAddressLine1?: Maybe<Scalars['String']>;
  consignorPickupAddressLine2?: Maybe<Scalars['String']>;
  consignorPostalCode?: Maybe<Scalars['String']>;
  consignorSenderRef?: Maybe<Scalars['String']>;
  consignorStreet?: Maybe<Scalars['String']>;
  createdFrom?: Maybe<Scalars['String']>;
  deliveryInstructions?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lliConsignmentItems?: Maybe<Scalars['JSON']>;
};

export type LoadingList = {
  checked: Scalars['Boolean'];
  classification?: Maybe<DangerousGoodsClassification>;
  customWaybillNo?: Maybe<Scalars['String']>;
  customsProcedure?: Maybe<CustomsProcedureNew>;
  id?: Maybe<Scalars['Int']>;
  isDangerous: Scalars['Boolean'];
  isLimitedQty?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['Int'];
  note: Scalars['String'];
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  unNumber?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type LoadingListInput = {
  carDetailsId?: Maybe<Scalars['Int']>;
  carOrTrailer: TaskName;
  legId: Scalars['Int'];
  loadingList: Array<LoadingListItemInput>;
  trailerDetailsId?: Maybe<Scalars['Int']>;
};

export type LoadingListItem = {
  __typename?: 'LoadingListItem';
  carDetails: RouteLegCarTask;
  carDetailsId: Scalars['Int'];
  checked: Scalars['Boolean'];
  classification?: Maybe<DangerousGoodsClassification>;
  cmrDate?: Maybe<Scalars['String']>;
  connectedNB?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  createdFrom?: Maybe<Scalars['String']>;
  customCleared: Scalars['Boolean'];
  customClearedForImport: Scalars['Boolean'];
  customCmrNo?: Maybe<Scalars['String']>;
  customInvoiceNo?: Maybe<Scalars['String']>;
  customMrnNo?: Maybe<Scalars['String']>;
  customNote?: Maybe<Scalars['String']>;
  customVOECId?: Maybe<Scalars['String']>;
  customWaybillNo?: Maybe<Scalars['String']>;
  customer?: Maybe<Customers>;
  customsProcedure?: Maybe<CustomsProcedureNew>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy: Scalars['String'];
  files: Array<DocumentFile>;
  fromLocation?: Maybe<LocationEntity>;
  fromLocationId?: Maybe<Scalars['Int']>;
  grossVolumeM3?: Maybe<Scalars['Float']>;
  hiddenAt?: Maybe<Scalars['DateTime']>;
  hiddenBy?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDangerous: Scalars['Boolean'];
  isImportedFromShipment: Scalars['Boolean'];
  isLimitedQty: Scalars['Boolean'];
  isNewShipmentLLI: Scalars['Boolean'];
  isOrderHidden?: Maybe<Scalars['Boolean']>;
  isRemainingGoods: Scalars['Boolean'];
  isSystemGenerated: Scalars['Boolean'];
  isVoecCustomer: Scalars['Boolean'];
  lastUpdatedBy: Scalars['String'];
  leg: RouteLeg;
  legId: Scalars['Int'];
  lliEdiAdditionalDetails?: Maybe<LliEdiAdditionalDetails>;
  location?: Maybe<LocationEntity>;
  locationId: Scalars['Int'];
  note: Scalars['String'];
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  preplannedRoute?: Maybe<Scalars['String']>;
  routeDetail: RouteDetailsInLl;
  serviceCode?: Maybe<Scalars['String']>;
  shipment: Shipment;
  shipmentDate?: Maybe<Scalars['String']>;
  shipmentId: Scalars['Int'];
  tags?: Maybe<Array<ShipmentTag>>;
  templateName?: Maybe<Scalars['String']>;
  terminalCleared: Scalars['Boolean'];
  terminalDevInfo?: Maybe<Scalars['String']>;
  terminalDevPackages?: Maybe<Scalars['Int']>;
  terminalDevPalletSpace?: Maybe<Scalars['Float']>;
  terminalDevPallets?: Maybe<Scalars['Int']>;
  terminalDevWeight?: Maybe<Scalars['Float']>;
  terminalNotCleared: Scalars['Boolean'];
  terminalShipmentNotArrived: Scalars['Boolean'];
  toLocation?: Maybe<LocationEntity>;
  toLocationId?: Maybe<Scalars['Int']>;
  trailerDetails: RouteLegTrailerTask;
  trailerDetailsId: Scalars['Int'];
  unNumber?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatedFrom?: Maybe<Scalars['String']>;
  volume?: Maybe<Volume>;
  weight?: Maybe<Scalars['Float']>;
};

export type LoadingListItemInput = {
  checked: Scalars['Boolean'];
  classification?: Maybe<DangerousGoodsClassification>;
  createdFrom?: Maybe<Scalars['String']>;
  customWaybillNo?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  customsProcedure?: Maybe<CustomsProcedureNew>;
  fromLocationId?: Maybe<Scalars['Int']>;
  grossVolumeM3?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  isDangerous: Scalars['Boolean'];
  isLimitedQty: Scalars['Boolean'];
  lliEdiAdditionalDetails?: Maybe<LliEdiAdditionalDetailsInput>;
  locationId: Scalars['Int'];
  note: Scalars['String'];
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  serviceCode?: Maybe<Scalars['String']>;
  toLocationId?: Maybe<Scalars['Int']>;
  unNumber?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type LocationContact = {
  __typename?: 'LocationContact';
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  tags?: Maybe<Array<LocationContactTag>>;
};

export type LocationContactTag = {
  __typename?: 'LocationContactTag';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type LocationDetails = {
  __typename?: 'LocationDetails';
  country: Scalars['String'];
  fullAddress: Scalars['String'];
  id: Scalars['Int'];
};

export type LocationDeviationInput = {
  consequence: Scalars['Boolean'];
  customerDeviationListItemsInput: Array<LocationDeviationListItemsInput>;
  deviationApplicableDate: Scalars['DateTime'];
  fault: DeviationFault;
  faultLocationId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  toLocationId: Scalars['Int'];
  toLocationIdArray?: Maybe<Array<Scalars['Int']>>;
};

export type LocationDeviationListItemsInput = {
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDangerous?: Maybe<Scalars['Boolean']>;
  isNewCustomer?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['Int'];
  locationItemNote?: Maybe<Scalars['String']>;
  newCustomer?: Maybe<Scalars['String']>;
  otherReason?: Maybe<Scalars['String']>;
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  reason?: Maybe<Reason>;
  weight?: Maybe<Scalars['Float']>;
};

export type LocationEntity = {
  __typename?: 'LocationEntity';
  address: Scalars['String'];
  amphoraLocationId?: Maybe<Scalars['String']>;
  card: Card;
  cardId: Scalars['Int'];
  city: Scalars['String'];
  contacts?: Maybe<Array<CardContact>>;
  country: Scalars['String'];
  countryLong: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  customOfficeNumber?: Maybe<Scalars['String']>;
  customerFromLocation: LocationEntity;
  customerToLocation: LocationEntity;
  deletedAt: Scalars['DateTime'];
  deletedBy: Scalars['String'];
  deviationToCustomer?: Maybe<DeviationToCustomer>;
  deviationToLocation?: Maybe<DeviationToLocation>;
  deviations: Array<Deviation>;
  files?: Maybe<Array<CardFile>>;
  fromLocation: LocationEntity;
  fromLocationId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isPromoted: Scalars['Boolean'];
  lastUpdatedBy: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  locationGroup?: Maybe<Scalars['String']>;
  locationRegions?: Maybe<Array<LocationRegionEntity>>;
  locationShortCode: Scalars['String'];
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  notes?: Maybe<Array<CardNote>>;
  phLocationId: Scalars['String'];
  postalCode: Scalars['String'];
  tags?: Maybe<Array<LocationTag>>;
  tinNumber?: Maybe<Scalars['String']>;
  toDeviations?: Maybe<Array<Deviation>>;
  toLocation: LocationEntity;
  toLocationId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type LocationRegionEntity = {
  __typename?: 'LocationRegionEntity';
  availability?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastUpdatedBy: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  location?: Maybe<LocationEntity>;
  locationId: Scalars['Int'];
  longitude?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  positionGroup?: Maybe<Scalars['String']>;
  positionName: Scalars['String'];
  positionType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LocationReportInfoInput = {
  createUntilDate: Scalars['DateTime'];
  dateForAddInfo: Scalars['DateTime'];
  info: Scalars['String'];
  infoType: InfoType;
  isAddedFromTerminal?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['Int'];
};

export type LocationReportInfoResponse = {
  __typename?: 'LocationReportInfoResponse';
  createdBy: Scalars['String'];
  dateForAddInfo: Scalars['String'];
  files: Array<DocumentFile>;
  id: Scalars['Int'];
  info: Scalars['String'];
  infoType: InfoType;
  isAddedFromTerminal: Scalars['Boolean'];
  locationId?: Maybe<Scalars['Int']>;
  replyInfo?: Maybe<Scalars['String']>;
  replyText?: Maybe<Scalars['String']>;
};

export type LocationTag = {
  __typename?: 'LocationTag';
  contacts: Array<LocationEntity>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt: Scalars['DateTime'];
  deletedBy: Scalars['String'];
  id: Scalars['Int'];
  locations?: Maybe<Array<LocationEntity>>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ManualRoutesGenLog = {
  __typename?: 'ManualRoutesGenLog';
  generatedAt: Scalars['DateTime'];
  generatedBy: Scalars['String'];
  id: Scalars['Int'];
  isSkipCronChecked: Scalars['Boolean'];
};

export type ManualRoutesGenLogInput = {
  isSkipCronChecked: Scalars['Boolean'];
  stats: Scalars['JSONObject'];
};

export type MasterGridResponse = {
  __typename?: 'MasterGridResponse';
  columnHeaders: Array<Scalars['String']>;
  gridName: Scalars['String'];
  id: Scalars['Int'];
  isNumberGridWithTotal: Scalars['Boolean'];
  locationId?: Maybe<Scalars['Int']>;
  rowHeaders: Array<Scalars['String']>;
};

export type MasterValueBoxResponse = {
  __typename?: 'MasterValueBoxResponse';
  boxName: Scalars['String'];
  frequency: Array<FrequencyDays>;
  id: Scalars['Int'];
  isAddedFromTerminal: Scalars['Boolean'];
  isAlphaNumeric: Scalars['Boolean'];
  isFixedBox: Scalars['Boolean'];
  isTimeBox: Scalars['Boolean'];
  isYesNoBox: Scalars['Boolean'];
  locationId?: Maybe<Scalars['Int']>;
};

export type MonthRepeatByDayInput = {
  repeatDayNum: Scalars['Int'];
  type: Scalars['String'];
};

export type MonthRepeatByWeeksInput = {
  repeatWeekNum: Array<Scalars['String']>;
  selectedDays: Array<Scalars['String']>;
  type: Scalars['String'];
};

export type MultipleLliInfo = {
  __typename?: 'MultipleLLIInfo';
  orderId: Scalars['Int'];
  shipmentDate: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCustomerMappingDetails: Array<LoadingListItem>;
  addFilterConfiguration: GridFilter;
  addFixedValueBoxes: Scalars['Boolean'];
  addHoliday: Holiday;
  addLegToRoute: Route;
  addLocationFixedValueBoxes: Scalars['Boolean'];
  addLocationGridValue: InternalTerminalGridEntries;
  addLocationMasterGridBox: Scalars['Boolean'];
  addLocationMasterValueBox: Scalars['Boolean'];
  addLocationNote: LocationEntity;
  addLocationReportInfo: Scalars['Boolean'];
  addManualRoutesGenLog: ManualRoutesGenLog;
  addNewLoadingListItems: AddLoadingListOutput;
  addNewVersionShipmentLLI: Array<LoadingListItem>;
  addShipmentLLI: Array<LoadingListItem>;
  addTagByType: Array<Scalars['String']>;
  connectLocation: PublicUser;
  createContactTag: CardContactTag;
  createDeviation: Deviation;
  createDocumentFileTag: DocumentFileTag;
  createLocation: LocationEntity;
  createLocationContact: CardContact;
  createLocationDeviation: Array<Deviation>;
  createLocationTag: LocationTag;
  createMultipleSporadicRoute: Scalars['Int'];
  createShipment: Shipment;
  createShipmentTag: ShipmentTag;
  createSporadicRoute: Route;
  createSporadicRouteV2: Route;
  createSporadicRouteWithoutDispatcher: Route;
  createTourTemplate: TourTemplate;
  deleteAttachmentFile: Scalars['Boolean'];
  deleteContactTag: Scalars['Boolean'];
  deleteDeviation: Scalars['Boolean'];
  deleteDocumentFile: Scalars['Boolean'];
  deleteGridFilter: Scalars['Boolean'];
  deleteHoliday: Scalars['Boolean'];
  deleteLeg: Array<RouteLeg>;
  deleteLoadingListItem: Scalars['Boolean'];
  deleteLocation: Scalars['Boolean'];
  deleteLocationContact: Scalars['Boolean'];
  deleteLocationFile: Scalars['Boolean'];
  deleteLocationMasterGrid: DeleteResult;
  deleteLocationMasterValueBox: DeleteResult;
  deleteLocationNote: Scalars['Boolean'];
  deleteLocationReportInfo: DeleteResult;
  deleteLocationTag: Scalars['Boolean'];
  deleteLocationValueBoxEntry: DeleteResult;
  deleteMultipleRoute: Scalars['Int'];
  deleteRoute: Scalars['Boolean'];
  deleteShipment: Scalars['Boolean'];
  deleteShipmentTag: Scalars['Boolean'];
  deleteTagsByType: Scalars['Boolean'];
  deleteTourTemplate: Scalars['Boolean'];
  demoteLocation: LocationEntity;
  editDeviation: Deviation;
  editLocationDeviation: Deviation;
  editLocationMasterValueBox: InternalTerminalValueBoxMaster;
  editLocationReportInfo: InternalTerminalReportInfo;
  editLocationReportInfoReply: InternalTerminalReportInfo;
  editLocationValueBoxEntry: InternalTerminalValueBoxEntries;
  generateFixedTour: FixedTourGenerateResponse;
  importLocation: Array<LocationEntity>;
  linkOrUnlinkOrderInLeg: Scalars['Int'];
  manageFileOfRoute: Scalars['Boolean'];
  promoteLocation: LocationEntity;
  saveRouteLegAndLoadingListV2: Route;
  truckFillAndTime: RouteLeg;
  updateBookmark: UpdateBookMarkResponse;
  updateBulkShipmentLLI: Scalars['Boolean'];
  updateCarTrailerDetails: CarTrailerDetailsOutput;
  updateConfiguration: PublicUser;
  updateCostAllocation: Route;
  updateDriver: Route;
  updateDriverAndRegistrationDetails: RouteLeg;
  updateDriverAndRegistrationDetailsBatch: Array<RouteLeg>;
  updateExtraColumns: Route;
  updateFilterConfiguration: GridFilter;
  updateInvoice: Route;
  updateLegDetails: RouteLeg;
  updateLegPosition: Array<RouteLeg>;
  updateLegWithLoadingList: RouteLeg;
  updateLoadingListItem: LoadingListItem;
  updateLoadingListItems: Scalars['Boolean'];
  updateLocation: LocationEntity;
  updateLocationContact: CardContact;
  updateLocationNote: CardNote;
  updateLock: RouteLock;
  updateLockOnBulkRoutes: Scalars['Boolean'];
  updateMinimalRoutes: Scalars['Boolean'];
  updateNewshipmentLLI: LoadingListItem;
  updatePartialShipment: Scalars['Boolean'];
  updateRoute: Route;
  updateRouteGridConfig: PublicUser;
  updateRouteGroupTag: Scalars['Boolean'];
  updateRouteLegDataColumns: RouteLeg;
  updateRouteLevelColumns: Route;
  updateRouteV2: Route;
  updateSetting: Setting;
  updateShipment: Shipment;
  updateSporadicRoute: Route;
  updateSporadicRouteV2: Route;
  updateTftConfiguration: PublicUser;
  updateTourTemplate: TourTemplate;
  updateTrafficGridsConfig: PublicUser;
  updateTripInfoFromProdApp: Scalars['Boolean'];
  updateVolumeDetails: Volume;
};


export type MutationAddCustomerMappingDetailsArgs = {
  input: CustomersMappingInput;
};


export type MutationAddFilterConfigurationArgs = {
  input: FilterConfig;
};


export type MutationAddFixedValueBoxesArgs = {
  locationId: Scalars['Int'];
};


export type MutationAddHolidayArgs = {
  input: CreateHolidayInput;
};


export type MutationAddLegToRouteArgs = {
  id: Scalars['Int'];
  input: Array<RouteLegInput>;
};


export type MutationAddLocationFixedValueBoxesArgs = {
  locationId: Scalars['Int'];
};


export type MutationAddLocationGridValueArgs = {
  gridValue: AddGridValueInput;
};


export type MutationAddLocationMasterGridBoxArgs = {
  gridData: AddMasterGridDataInput;
};


export type MutationAddLocationMasterValueBoxArgs = {
  boxData: AddMasterValueBoxInput;
};


export type MutationAddLocationNoteArgs = {
  id: Scalars['Int'];
  input: CreateNoteInput;
};


export type MutationAddLocationReportInfoArgs = {
  input: LocationReportInfoInput;
};


export type MutationAddManualRoutesGenLogArgs = {
  input: ManualRoutesGenLogInput;
};


export type MutationAddNewLoadingListItemsArgs = {
  input: LoadingListInput;
};


export type MutationAddNewVersionShipmentLliArgs = {
  input: Array<NewVersionShipmentLli>;
};


export type MutationAddShipmentLliArgs = {
  input: Array<LoadingList>;
  shipmentId: Scalars['Int'];
};


export type MutationAddTagByTypeArgs = {
  tag: Scalars['String'];
  type: Scalars['String'];
};


export type MutationConnectLocationArgs = {
  locationId: Scalars['Int'];
};


export type MutationCreateContactTagArgs = {
  input: CreateCardContactTagInput;
};


export type MutationCreateDeviationArgs = {
  input: DeviationInput;
};


export type MutationCreateDocumentFileTagArgs = {
  input: CreateDocumentTagInput;
};


export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


export type MutationCreateLocationContactArgs = {
  input: CreateCardContactInput;
  locationId: Scalars['Int'];
};


export type MutationCreateLocationDeviationArgs = {
  input: Array<LocationDeviationInput>;
};


export type MutationCreateLocationTagArgs = {
  input: CreateLocationTagInput;
};


export type MutationCreateMultipleSporadicRouteArgs = {
  dates: Array<Scalars['String']>;
  input: SporadicRouteInput;
};


export type MutationCreateShipmentArgs = {
  input: CreateShipmentInput;
};


export type MutationCreateShipmentTagArgs = {
  title: Scalars['String'];
};


export type MutationCreateSporadicRouteArgs = {
  input: SporadicRouteInput;
  numberOfCopies?: Maybe<Scalars['Int']>;
};


export type MutationCreateSporadicRouteV2Args = {
  input: SporadicRouteInputV2;
};


export type MutationCreateSporadicRouteWithoutDispatcherArgs = {
  input: SporadicRouteInput;
};


export type MutationCreateTourTemplateArgs = {
  input: TourTemplateInput;
};


export type MutationDeleteAttachmentFileArgs = {
  input: DeleteAttachmentFileDto;
};


export type MutationDeleteContactTagArgs = {
  tagId: Scalars['Int'];
};


export type MutationDeleteDeviationArgs = {
  customerId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type MutationDeleteDocumentFileArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteGridFilterArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteHolidayArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLegArgs = {
  id: Scalars['Int'];
  routeId: Scalars['Int'];
};


export type MutationDeleteLoadingListItemArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationDeleteLocationArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLocationContactArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLocationFileArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLocationMasterGridArgs = {
  Id: Scalars['Int'];
};


export type MutationDeleteLocationMasterValueBoxArgs = {
  boxId: Scalars['Int'];
};


export type MutationDeleteLocationNoteArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLocationReportInfoArgs = {
  locationReportInfoId: Scalars['Int'];
};


export type MutationDeleteLocationTagArgs = {
  tagId: Scalars['Int'];
};


export type MutationDeleteLocationValueBoxEntryArgs = {
  entryId: Scalars['Int'];
};


export type MutationDeleteMultipleRouteArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationDeleteRouteArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteShipmentArgs = {
  id: Scalars['Int'];
  shipmentDate: Scalars['String'];
  updatedFrom: Scalars['String'];
};


export type MutationDeleteShipmentTagArgs = {
  tagId: Scalars['Int'];
};


export type MutationDeleteTagsByTypeArgs = {
  type: Scalars['String'];
};


export type MutationDeleteTourTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationDemoteLocationArgs = {
  locationId: Scalars['Int'];
};


export type MutationEditDeviationArgs = {
  input: EditDeviationInput;
};


export type MutationEditLocationDeviationArgs = {
  input: EditLocationDeviationInput;
};


export type MutationEditLocationMasterValueBoxArgs = {
  boxData: EditMasterValueBoxInput;
};


export type MutationEditLocationReportInfoArgs = {
  input: EditLocationReportInfoInput;
};


export type MutationEditLocationReportInfoReplyArgs = {
  input: EditLocationReportInfoReplyInput;
};


export type MutationEditLocationValueBoxEntryArgs = {
  boxEntry: EditValueBoxEntry;
};


export type MutationGenerateFixedTourArgs = {
  input: FixedTourGenerateInput;
};


export type MutationImportLocationArgs = {
  input: Array<ExcelImportDataInput>;
};


export type MutationLinkOrUnlinkOrderInLegArgs = {
  input: OrderLinkUnlinkInput;
};


export type MutationManageFileOfRouteArgs = {
  fileId: Scalars['Int'];
  isAttach: Scalars['Boolean'];
  routeId: Scalars['Int'];
};


export type MutationPromoteLocationArgs = {
  id: Scalars['Int'];
  isPromoted: Scalars['Boolean'];
};


export type MutationSaveRouteLegAndLoadingListV2Args = {
  input: SaveRouteLegAndLoadingListV2Input;
};


export type MutationTruckFillAndTimeArgs = {
  input: TruckFillAndTimeInput;
};


export type MutationUpdateBookmarkArgs = {
  bookmark: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type MutationUpdateBulkShipmentLliArgs = {
  input: ShipmentOrderBulkUpdateInput;
};


export type MutationUpdateCarTrailerDetailsArgs = {
  input: CarTrailerDetailsInput;
};


export type MutationUpdateConfigurationArgs = {
  input: UserConfigurationInput;
};


export type MutationUpdateCostAllocationArgs = {
  costAllocation: UpdateCostAllocationInput;
  id: Scalars['Int'];
};


export type MutationUpdateDriverArgs = {
  driverData: DriverInfo;
  id: Scalars['Int'];
};


export type MutationUpdateDriverAndRegistrationDetailsArgs = {
  input: RouteLegDriverDetailsInput;
};


export type MutationUpdateDriverAndRegistrationDetailsBatchArgs = {
  input: RouteLegDriverDetailsBatchInput;
};


export type MutationUpdateExtraColumnsArgs = {
  extraColumnData: ExtraColumnInfo;
  id: Scalars['Int'];
};


export type MutationUpdateFilterConfigurationArgs = {
  filterConfiguration: Scalars['JSONObject'];
  id: Scalars['Int'];
};


export type MutationUpdateInvoiceArgs = {
  id: Scalars['Int'];
  invoiceData: InvoiceDataInput;
};


export type MutationUpdateLegDetailsArgs = {
  input: LegDetails;
};


export type MutationUpdateLegPositionArgs = {
  input: Array<LegsPositionInput>;
};


export type MutationUpdateLegWithLoadingListArgs = {
  input: LegLoadingListInput;
};


export type MutationUpdateLoadingListItemArgs = {
  input: ShipmentLoadingList;
  routeName?: Maybe<Scalars['String']>;
  shipmentId?: Maybe<Scalars['Int']>;
};


export type MutationUpdateLoadingListItemsArgs = {
  input: UpdateLoadingListInput;
};


export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};


export type MutationUpdateLocationContactArgs = {
  input: UpdateCardContactInput;
};


export type MutationUpdateLocationNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateLockArgs = {
  lock: Scalars['Int'];
  reload: Scalars['Int'];
  routeId: Scalars['Int'];
};


export type MutationUpdateLockOnBulkRoutesArgs = {
  forGroup: Scalars['String'];
  isLock: Scalars['Boolean'];
  routeIds: Array<Scalars['Int']>;
};


export type MutationUpdateMinimalRoutesArgs = {
  input: UpdateMinimalRouteInput;
};


export type MutationUpdateNewshipmentLliArgs = {
  input: ShipmentLoadingList;
};


export type MutationUpdatePartialShipmentArgs = {
  input: ShipmentPartialUpdateInput;
};


export type MutationUpdateRouteArgs = {
  id: Scalars['Int'];
  input: SporadicRouteInput;
};


export type MutationUpdateRouteGridConfigArgs = {
  input: UserConfigurationInput;
};


export type MutationUpdateRouteGroupTagArgs = {
  id: Scalars['Int'];
  routeGroupTag: Scalars['String'];
};


export type MutationUpdateRouteLegDataColumnsArgs = {
  id: Scalars['Int'];
  routeLegData: RouteLegDataColumnInfo;
};


export type MutationUpdateRouteLevelColumnsArgs = {
  id: Scalars['Int'];
  routeColumnData: RouteLevelInfo;
};


export type MutationUpdateRouteV2Args = {
  id: Scalars['Int'];
  input: SporadicRouteInputV2;
};


export type MutationUpdateSettingArgs = {
  id: Scalars['Int'];
  input: SettingInput;
};


export type MutationUpdateShipmentArgs = {
  input: ShipmentEditInput;
  orderListUnchanged?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateSporadicRouteArgs = {
  id: Scalars['Int'];
  input: SporadicRouteInput;
};


export type MutationUpdateSporadicRouteV2Args = {
  id: Scalars['Int'];
  input: SporadicRouteInputV2;
};


export type MutationUpdateTftConfigurationArgs = {
  input: UserConfigurationInput;
};


export type MutationUpdateTourTemplateArgs = {
  id: Scalars['Int'];
  input: TourTemplateInput;
};


export type MutationUpdateTrafficGridsConfigArgs = {
  input: UserConfigurationInputWithTableName;
};


export type MutationUpdateTripInfoFromProdAppArgs = {
  capacity?: Maybe<Scalars['Int']>;
  carRegNumber?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['String']>;
  dateTimeStamp: Scalars['String'];
  driverName?: Maybe<Scalars['String']>;
  gateNumber?: Maybe<Scalars['String']>;
  items?: Maybe<Scalars['String']>;
  legId: Scalars['Int'];
  palletPlaces?: Maybe<Scalars['String']>;
  pallets?: Maybe<Scalars['String']>;
  trailerRegNumber?: Maybe<Scalars['String']>;
  tripStatus: Scalars['String'];
  updateFor: Scalars['String'];
};


export type MutationUpdateVolumeDetailsArgs = {
  input: VolumeColumsInput;
};

export type NewVersionShipmentLli = {
  checked: Scalars['Boolean'];
  classification?: Maybe<DangerousGoodsClassification>;
  cmrDate?: Maybe<Scalars['String']>;
  customWaybillNo?: Maybe<Scalars['String']>;
  customsProcedure?: Maybe<CustomsProcedureNew>;
  fromLocationId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  isDangerous: Scalars['Boolean'];
  isLimitedQty?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['Int'];
  note: Scalars['String'];
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  shipmentDate?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['Int']>>;
  templateName?: Maybe<Scalars['String']>;
  toLocationId: Scalars['Int'];
  unNumber?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type OrderLinkUnlinkInput = {
  isLink: Scalars['Boolean'];
  legId: Scalars['Int'];
  loadInCar: Scalars['Boolean'];
  loadInTrailer: Scalars['Boolean'];
  orderIds: Array<Scalars['Int']>;
  routeId: Scalars['Int'];
  terminalId: Scalars['Int'];
  transDate: Scalars['String'];
};

export type PromotedLocationResponse = {
  __typename?: 'PromotedLocationResponse';
  address: Scalars['String'];
  city: Scalars['String'];
  contacts?: Maybe<Array<LocationContact>>;
  country: Scalars['String'];
  id: Scalars['Int'];
  isPromoted: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  postalCode: Scalars['String'];
};

export type PublicUser = {
  __typename?: 'PublicUser';
  admin: Scalars['Boolean'];
  configuration?: Maybe<Scalars['JSONObject']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customsAccess: Scalars['Boolean'];
  department: Scalars['String'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  lastName: Scalars['String'];
  location?: Maybe<LocationEntity>;
  locationId?: Maybe<Scalars['Int']>;
  roles: Array<Scalars['String']>;
  routesConfiguration?: Maybe<Scalars['JSONObject']>;
  terminalAccess: Scalars['Boolean'];
  tftConfiguration?: Maybe<Scalars['JSONObject']>;
  trafficAccess: Scalars['Boolean'];
};

export type Query = {
  __typename?: 'Query';
  activeLocation: LocationEntity;
  allLocationWithSearch: Array<LocationEntity>;
  associatedRoutes: Array<AssociatedRoutesResponse>;
  bookmarkedDispatchedRoutes: Array<BookMarkItemResponse>;
  cardContactTag: CardContactTag;
  cardContactTags: Array<CardContactTag>;
  checkLegsHaveAnyDangerGoods: Scalars['Boolean'];
  checkRouteDeleteImpact: RouteDeleteImpact;
  department: Department;
  departments: Array<Department>;
  deviation: Deviation;
  deviationToLocationForDeviationId: Array<DeviationToLocation>;
  deviations: Array<Deviation>;
  deviationsForRoute: Array<Deviation>;
  documentFileTags: Array<DocumentFileTag>;
  fetchLegsMatchingShipment: Array<RouteLeg>;
  fetchRoutesForProdApp: Array<RouteLeg>;
  fetchRoutesForProdAppWithToken: Array<RouteLeg>;
  files: Array<DocumentFile>;
  fixedTrafficLegs: Array<FixedTrafficLeg>;
  getAllRouteGroupTags: Array<Scalars['String']>;
  getDepartmentOptions: Array<CountryDepartmentGroup>;
  getFilesForRouteId: Array<DocumentFile>;
  getFiltersByUserId: Array<GridFilter>;
  getLocationDeviations: Array<CustomerLevelDeviationResponse>;
  getLocationsWithContacts: Array<LocationEntity>;
  getPostsForTerminal?: Maybe<TerminalPostsDetail>;
  getPostsFromAllTerminals: Array<FrontPagePostsAvailability>;
  getProductionGroup: Array<Scalars['String']>;
  getPromotedLocations: Array<PromotedLocationResponse>;
  getRouteByIdV2: Route;
  getRouteGridConfig: PublicUser;
  getShipmentTags: Array<ShipmentTag>;
  getTftConfig: PublicUser;
  getTourRoute: TourRouteTemplate;
  getTrafficGridsConfig: PublicUser;
  getUserLocationData: ResponseUserDataWithLocation;
  holidayForCountryOnDate: Scalars['Boolean'];
  holidays: Array<Holiday>;
  incomingRoutesToTerminal: IncomingRoutesToTerminal;
  loadingListItem: LoadingListItem;
  loadingListItems: Array<LoadingListItem>;
  location: LocationEntity;
  locationContact: CardContact;
  locationContacts: Array<CardContact>;
  locationGridValues: Array<GridValues>;
  locationGridValuesForTraffic: Array<GridValues>;
  locationMasterGrid: Array<MasterGridResponse>;
  locationMasterValueBoxes: Array<MasterValueBoxResponse>;
  locationReportInfo: Array<LocationReportInfoResponse>;
  locationSearch: Array<LocationEntity>;
  locationTag: LocationTag;
  locationTags: Array<LocationTag>;
  locationValueBoxesForDay: Array<ValueBoxForDayResponse>;
  locations: Array<LocationEntity>;
  locationsByIdList: Array<LocationEntity>;
  me: PublicUser;
  multipleDates: Scalars['String'];
  newShipmentLoadingList: Array<LoadingListItem>;
  otherTours: Array<TourTemplate>;
  pingUser: Scalars['Boolean'];
  refetchLatestLeg: RouteLeg;
  route: Route;
  routeLegForViewLoadingList: Array<RouteLeg>;
  routeLegWrappers: Array<RouteLegWrapper>;
  routeLock: RouteLock;
  routeV2: Route;
  routes: Array<Route>;
  sendDriverNotification: Scalars['Boolean'];
  sendManualAlertsOnSporadicRouteCreate: Scalars['Boolean'];
  settings: Array<Setting>;
  shipmentById: Shipment;
  shipmentTemplates: Array<Shipment>;
  shipments: Array<Shipment>;
  shipmentsByDate: Array<Shipment>;
  status: Scalars['String'];
  tagsByType: Array<Scalars['String']>;
  tourRouteTemplates: Array<TourRouteTemplate>;
  tourTemplate: TourTemplate;
  tourTemplates: Array<TourTemplate>;
  tourTemplatesWithGroupTag: Array<Scalars['String']>;
  tourTemplatesWithResponsiblePerson: Array<Scalars['String']>;
};


export type QueryActiveLocationArgs = {
  id: Scalars['Int'];
};


export type QueryAllLocationWithSearchArgs = {
  search?: Maybe<Scalars['String']>;
};


export type QueryAssociatedRoutesArgs = {
  id: Scalars['Int'];
};


export type QueryBookmarkedDispatchedRoutesArgs = {
  date?: Maybe<Scalars['String']>;
};


export type QueryCardContactTagArgs = {
  id: Scalars['Int'];
};


export type QueryCheckLegsHaveAnyDangerGoodsArgs = {
  legIds: Array<Scalars['Int']>;
};


export type QueryCheckRouteDeleteImpactArgs = {
  routeStartDates: Array<RouteStartDateInput>;
  tourId: Scalars['Int'];
};


export type QueryDepartmentArgs = {
  id: Scalars['String'];
};


export type QueryDeviationArgs = {
  id: Scalars['Int'];
};


export type QueryDeviationToLocationForDeviationIdArgs = {
  deviationId: Scalars['Int'];
};


export type QueryDeviationsArgs = {
  endDate: Scalars['String'];
  searchTerm?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
};


export type QueryDeviationsForRouteArgs = {
  routeId: Scalars['Int'];
};


export type QueryFetchLegsMatchingShipmentArgs = {
  fromLocationId: Scalars['Int'];
  orderId: Scalars['Int'];
  toLocationId: Scalars['Int'];
  transportDate: Scalars['String'];
};


export type QueryFetchRoutesForProdAppArgs = {
  cetDateTimeString?: Maybe<Scalars['String']>;
  event: Scalars['String'];
  futureHours: Scalars['Int'];
  gateNumbers?: Maybe<Array<Scalars['String']>>;
  pastHours?: Maybe<Scalars['Int']>;
  tripStatus?: Maybe<Scalars['String']>;
  unitId: Scalars['String'];
};


export type QueryFetchRoutesForProdAppWithTokenArgs = {
  cetDateTimeString?: Maybe<Scalars['String']>;
  event: Scalars['String'];
  futureHours: Scalars['Int'];
  gateNumbers?: Maybe<Array<Scalars['String']>>;
  pastHours?: Maybe<Scalars['Int']>;
  tripStatus?: Maybe<Scalars['String']>;
  unitId: Scalars['String'];
};


export type QueryFixedTrafficLegsArgs = {
  terminalId: Scalars['Int'];
};


export type QueryGetAllRouteGroupTagsArgs = {
  transportDate: Scalars['String'];
};


export type QueryGetFilesForRouteIdArgs = {
  routeId: Scalars['Int'];
};


export type QueryGetFiltersByUserIdArgs = {
  tableName: Scalars['String'];
};


export type QueryGetLocationDeviationsArgs = {
  deviationId?: Maybe<Scalars['Int']>;
  endDate: Scalars['String'];
  searchTerm?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  terminalIds?: Maybe<Array<Scalars['Int']>>;
};


export type QueryGetPostsForTerminalArgs = {
  locationId?: Maybe<Scalars['Int']>;
  locationName?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
};


export type QueryGetPostsFromAllTerminalsArgs = {
  startDate: Scalars['String'];
};


export type QueryGetProductionGroupArgs = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
  terminalId: Scalars['Int'];
};


export type QueryGetPromotedLocationsArgs = {
  search?: Maybe<Scalars['String']>;
};


export type QueryGetRouteByIdV2Args = {
  routeId: Scalars['Int'];
};


export type QueryGetTourRouteArgs = {
  routeId: Scalars['Int'];
};


export type QueryHolidayForCountryOnDateArgs = {
  country: Scalars['String'];
  date: Scalars['String'];
};


export type QueryHolidaysArgs = {
  country: Scalars['String'];
};


export type QueryIncomingRoutesToTerminalArgs = {
  date: Scalars['String'];
  terminalId: Scalars['Int'];
};


export type QueryLoadingListItemArgs = {
  id: Scalars['Int'];
};


export type QueryLocationArgs = {
  id: Scalars['Int'];
};


export type QueryLocationContactArgs = {
  id: Scalars['Int'];
};


export type QueryLocationContactsArgs = {
  contactId?: Maybe<Scalars['Int']>;
  locationId?: Maybe<Scalars['Int']>;
};


export type QueryLocationGridValuesArgs = {
  gridType: Scalars['String'];
  locationId: Scalars['Int'];
  valueAddedDate: Scalars['String'];
};


export type QueryLocationGridValuesForTrafficArgs = {
  gridType: Scalars['String'];
  locationId: Scalars['Int'];
  valueAddedDate: Scalars['String'];
};


export type QueryLocationMasterGridArgs = {
  locationId: Scalars['Int'];
};


export type QueryLocationMasterValueBoxesArgs = {
  forTerminal: Scalars['Boolean'];
  locationId: Scalars['Int'];
};


export type QueryLocationReportInfoArgs = {
  dateForAddInfo: Scalars['String'];
  forTerminal: Scalars['Boolean'];
  locationId: Scalars['Int'];
};


export type QueryLocationSearchArgs = {
  search?: Maybe<Scalars['String']>;
};


export type QueryLocationTagArgs = {
  id: Scalars['Int'];
};


export type QueryLocationValueBoxesForDayArgs = {
  date: Scalars['String'];
  forTerminal: Scalars['Boolean'];
  locationId: Scalars['Int'];
};


export type QueryLocationsArgs = {
  forCountryCode?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryLocationsByIdListArgs = {
  idList: Array<Scalars['Int']>;
};


export type QueryMultipleDatesArgs = {
  id: Scalars['Int'];
};


export type QueryNewShipmentLoadingListArgs = {
  endDate: Scalars['String'];
  ids?: Maybe<Array<Scalars['Int']>>;
  showHiddenOrders?: Maybe<Scalars['Boolean']>;
  startDate: Scalars['String'];
};


export type QueryOtherToursArgs = {
  excludeId: Scalars['Int'];
  searchTerm?: Maybe<Scalars['String']>;
};


export type QueryPingUserArgs = {
  routeId: Scalars['Int'];
};


export type QueryRefetchLatestLegArgs = {
  legId: Scalars['Int'];
  locationId: Scalars['Int'];
};


export type QueryRouteArgs = {
  id: Scalars['Int'];
};


export type QueryRouteLegForViewLoadingListArgs = {
  legId: Scalars['Int'];
};


export type QueryRouteLegWrappersArgs = {
  routeId: Scalars['Int'];
};


export type QueryRouteLockArgs = {
  routeId: Scalars['Int'];
};


export type QueryRouteV2Args = {
  id: Scalars['Int'];
};


export type QueryRoutesArgs = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};


export type QuerySendDriverNotificationArgs = {
  message: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type QuerySendManualAlertsOnSporadicRouteCreateArgs = {
  emails: Scalars['String'];
  route: CreateRouteAlertInput;
};


export type QueryShipmentByIdArgs = {
  id: Scalars['Int'];
};


export type QueryShipmentsArgs = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};


export type QueryShipmentsByDateArgs = {
  forDate: Scalars['String'];
  fromLocationId?: Maybe<Scalars['Int']>;
};


export type QueryTagsByTypeArgs = {
  type: Scalars['String'];
};


export type QueryTourRouteTemplatesArgs = {
  fetchBookmarked?: Maybe<Scalars['Boolean']>;
};


export type QueryTourTemplateArgs = {
  id: Scalars['Int'];
};

export enum Reason {
  CustomsIssues = 'CustomsIssues',
  DamagedItems = 'DamagedItems',
  DangerousGoods = 'DangerousGoods',
  DelayedFerry = 'DelayedFerry',
  LackOfCapacity = 'LackOfCapacity',
  LackOfDocuments = 'LackOfDocuments',
  LateArrivalToTerminal = 'LateArrivalToTerminal',
  LateDeparture = 'LateDeparture',
  LateProduction = 'LateProduction',
  LeftoverCargo = 'LeftoverCargo',
  MissingEdi = 'MissingEdi',
  MissingPallets = 'MissingPallets',
  Other = 'Other',
  PlannedOnNextDayRoutes = 'PlannedOnNextDayRoutes',
  PoliceControl = 'PoliceControl',
  RedChannel = 'RedChannel',
  TechnicalIssueOnEquipmentOrTruck = 'TechnicalIssueOnEquipmentOrTruck',
  TrafficIssues = 'TrafficIssues'
}

export enum RecievedStatus {
  HandedOverKipp = 'HandedOverKipp',
  None = 'None',
  PickupKipp = 'PickupKipp',
  ReceivedAndHandled = 'ReceivedAndHandled',
  ReceivedNotStarted = 'ReceivedNotStarted'
}

export type ReportToTerminalInboundOutboundRouteList = {
  __typename?: 'ReportToTerminalInboundOutboundRouteList';
  arrivalTime: Scalars['String'];
  capacity?: Maybe<Scalars['Int']>;
  departureTime?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  licensePlateAndRouteNote: Scalars['String'];
  routeEntityId: Scalars['Int'];
  routeId: Scalars['String'];
  subcontractorLocationId: Scalars['Int'];
  subcontractorLocationName: Scalars['String'];
};

export type ResponseUserDataWithLocation = {
  __typename?: 'ResponseUserDataWithLocation';
  locationId: Scalars['Float'];
  locationName: Scalars['String'];
  userFullName: Scalars['String'];
};

export type Route = {
  __typename?: 'Route';
  adr?: Maybe<Scalars['String']>;
  agreedPrice?: Maybe<Scalars['Float']>;
  amphoraTripId?: Maybe<Scalars['String']>;
  ansvBefraktare?: Maybe<Scalars['String']>;
  arrivalAddress?: Maybe<LocationEntity>;
  arrivalLocation?: Maybe<LocationEntity>;
  assigned?: Maybe<Scalars['Boolean']>;
  bpx?: Maybe<Scalars['Int']>;
  brev?: Maybe<Scalars['Int']>;
  capacity?: Maybe<Scalars['Int']>;
  carCarrierId?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['String']>;
  costAllocation?: Maybe<CostAllocation>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  createdByUserId: Scalars['String'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy: Scalars['String'];
  departureAddress?: Maybe<LocationEntity>;
  departureLocation?: Maybe<LocationEntity>;
  deviations: Array<Deviation>;
  dispatcher?: Maybe<CardContact>;
  dispatcherId?: Maybe<Scalars['Int']>;
  driverName: Scalars['String'];
  driverPhoneNumber: Scalars['String'];
  externalNote?: Maybe<Scalars['String']>;
  files: Array<DocumentFile>;
  ftl?: Maybe<RouteFtl>;
  fuel: FuelType;
  id: Scalars['Int'];
  inneholdsbeskrivelse?: Maybe<Scalars['String']>;
  invoiceNote?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  isCopyDriverPlateInfo: Scalars['Boolean'];
  isCreatedFromPlanned: Scalars['Boolean'];
  isCreatedFromTerminal: Scalars['Boolean'];
  isMODone: Scalars['Boolean'];
  isUnplannedRoute: Scalars['Boolean'];
  kilometer?: Maybe<Scalars['Int']>;
  lastUpdatedBy: Scalars['String'];
  legs: Array<RouteLeg>;
  licensePlate: Scalars['String'];
  multipleSporadicRouteId: Scalars['Int'];
  nameReceivedByTraffic?: Maybe<Scalars['String']>;
  note: Scalars['String'];
  parti?: Maybe<Scalars['Int']>;
  pip?: Maybe<Scalars['Int']>;
  pri03?: Maybe<Scalars['Int']>;
  pri49?: Maybe<Scalars['Int']>;
  pru?: Maybe<Scalars['Int']>;
  receivedByTraffic?: Maybe<Scalars['Boolean']>;
  routeAgreementNo?: Maybe<Scalars['Int']>;
  routeCarRegNumber?: Maybe<Scalars['String']>;
  routeDriverName?: Maybe<Scalars['String']>;
  routeDriverPhoneNumber?: Maybe<Scalars['String']>;
  routeGroupTag?: Maybe<Scalars['String']>;
  routeId: Scalars['String'];
  routeLegWrappers?: Maybe<Array<RouteLegWrapper>>;
  routeLock?: Maybe<RouteLock>;
  routeTag?: Maybe<Scalars['String']>;
  routeTrailerRegNumber?: Maybe<Scalars['String']>;
  rutekode?: Maybe<Scalars['String']>;
  subcontractor?: Maybe<Card>;
  subcontractorId?: Maybe<Scalars['Int']>;
  subcontractorLocation?: Maybe<LocationEntity>;
  subcontractorLocationId?: Maybe<Scalars['Int']>;
  terminalStatusLog?: Maybe<Array<Maybe<TerminalStatusLogEntry>>>;
  timeReceivedByTraffic?: Maybe<Scalars['String']>;
  timeWhenAssigned?: Maybe<Scalars['String']>;
  togref?: Maybe<Scalars['String']>;
  tom?: Maybe<Scalars['Boolean']>;
  tour?: Maybe<TourTemplate>;
  tourRoute?: Maybe<TourRouteTemplate>;
  trailerCarrierId?: Maybe<Scalars['String']>;
  trainNumber?: Maybe<Scalars['String']>;
  transits?: Maybe<Array<Transit>>;
  transportType?: Maybe<TransportType>;
  transportationDate: Scalars['String'];
  turnummer?: Maybe<Scalars['Int']>;
  type: RouteType;
  updatedAt: Scalars['DateTime'];
  upri03?: Maybe<Scalars['Int']>;
  upri49?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

export type RouteDeleteImpact = {
  __typename?: 'RouteDeleteImpact';
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  routes: Array<RouteDeletePreviewItem>;
  willDeleteCount: Scalars['Int'];
};

export type RouteDeletePreviewItem = {
  __typename?: 'RouteDeletePreviewItem';
  id: Scalars['Int'];
  routeId: Scalars['String'];
  transportationDate: Scalars['String'];
};

export type RouteDetailsInLl = {
  __typename?: 'RouteDetailsInLL';
  id?: Maybe<Scalars['Int']>;
  routeName?: Maybe<Scalars['String']>;
};

export type RouteFtl = {
  __typename?: 'RouteFTL';
  cdc: Scalars['String'];
  cmr: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  customer?: Maybe<Card>;
  customerId?: Maybe<Scalars['Int']>;
  customerNumber: Scalars['String'];
  customerReference: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  invoiceNote: Scalars['String'];
  location?: Maybe<LocationEntity>;
  locationId?: Maybe<Scalars['Int']>;
  price: Scalars['Float'];
  route: Route;
  updatedAt: Scalars['DateTime'];
};

export type RouteFtlInput = {
  cdc?: Maybe<Scalars['String']>;
  cmr?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['Int']>;
  customerNumber?: Maybe<Scalars['String']>;
  customerReference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invoiceNote?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type RouteGridUpdateSubscriptionPayload = {
  __typename?: 'RouteGridUpdateSubscriptionPayload';
  changedData?: Maybe<Scalars['JSONObject']>;
  eventType: Scalars['String'];
  routeId: Scalars['Int'];
  transportationDate: Scalars['String'];
};

export type RouteLeg = {
  __typename?: 'RouteLeg';
  actualArrivalDate?: Maybe<Scalars['String']>;
  actualArrivalTime?: Maybe<Scalars['String']>;
  actualCapacity?: Maybe<Scalars['Int']>;
  actualDepartureDate?: Maybe<Scalars['String']>;
  actualDepartureTime?: Maybe<Scalars['String']>;
  actualDockDate?: Maybe<Scalars['String']>;
  actualDockTime?: Maybe<Scalars['String']>;
  actualUndockDate?: Maybe<Scalars['String']>;
  actualUndockTime?: Maybe<Scalars['String']>;
  ansvBefraktare?: Maybe<Scalars['String']>;
  arrivalStatus?: Maybe<Scalars['String']>;
  arrivalTime: Scalars['String'];
  assigned?: Maybe<Scalars['Boolean']>;
  carDetails?: Maybe<RouteLegCarTask>;
  carRegistrationNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  departureTime?: Maybe<Scalars['String']>;
  dispatcher?: Maybe<CardContact>;
  dispatcherId?: Maybe<Scalars['Int']>;
  distanceInKM?: Maybe<Scalars['Float']>;
  files: Array<DocumentFile>;
  fuel: FuelType;
  gateNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isLoadingInCar?: Maybe<Scalars['Boolean']>;
  isLoadingInTrailer?: Maybe<Scalars['Boolean']>;
  isNewLegVariant: Scalars['Boolean'];
  isNonArrivalMarked: Scalars['Boolean'];
  isSealBroken?: Maybe<Scalars['Boolean']>;
  kippReceivedBy?: Maybe<Scalars['String']>;
  kippTimeWhenReceived?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  legTag?: Maybe<Scalars['String']>;
  load: Scalars['Boolean'];
  loadCages?: Maybe<Scalars['Int']>;
  loadCar?: Maybe<Scalars['Int']>;
  loadCarPPL?: Maybe<Scalars['Int']>;
  loadTrailer?: Maybe<Scalars['Int']>;
  loadTrailerPPL?: Maybe<Scalars['Int']>;
  loadingListItems: Array<LoadingListItem>;
  location?: Maybe<LocationEntity>;
  locationId: Scalars['Int'];
  nonArrivalMarkedAt?: Maybe<Scalars['String']>;
  nonArrivalMarkedByUserName?: Maybe<Scalars['String']>;
  nonArrivalMarkedFrom?: Maybe<Scalars['String']>;
  note: Scalars['String'];
  operator?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  priority?: Maybe<Scalars['String']>;
  productionDate: Scalars['String'];
  productionGroup: Scalars['String'];
  receivedBy?: Maybe<Scalars['String']>;
  receivedStatus?: Maybe<RecievedStatus>;
  route: Route;
  routeDetails: RouteObjectForProdApp;
  routeDriverEmail?: Maybe<Scalars['String']>;
  routeDriverName?: Maybe<Scalars['String']>;
  routeDriverPhoneNumber?: Maybe<Scalars['String']>;
  routeId: Scalars['Int'];
  sealNumber?: Maybe<Scalars['String']>;
  subcontractor?: Maybe<Card>;
  subcontractorId?: Maybe<Scalars['Int']>;
  subcontractorLocation?: Maybe<LocationEntity>;
  subcontractorLocationId?: Maybe<Scalars['Int']>;
  terminalNickname?: Maybe<Scalars['String']>;
  terminalNote: Scalars['String'];
  terminalResponsible?: Maybe<Scalars['String']>;
  terminalStatus?: Maybe<TerminalRouteStatus>;
  terminalStatusDescription?: Maybe<Scalars['String']>;
  terminalStatusLog?: Maybe<Array<Maybe<TerminalStatusLogEntry>>>;
  terminalStatusUpdatedAt?: Maybe<Scalars['String']>;
  timeWhenAssigned?: Maybe<Scalars['String']>;
  timeWhenReceived?: Maybe<Scalars['String']>;
  tom?: Maybe<Scalars['Boolean']>;
  tourRouteLeg?: Maybe<TourRouteLegTemplate>;
  trailerDetails?: Maybe<RouteLegTrailerTask>;
  trailerRegistrationNumber?: Maybe<Scalars['String']>;
  transitsFrom?: Maybe<Array<Transit>>;
  transitsTo?: Maybe<Array<Transit>>;
  transportationDate: Scalars['String'];
  transportationDateOffset: Scalars['Int'];
  tripStatus?: Maybe<Scalars['String']>;
  unload: Scalars['Boolean'];
  unloadCages?: Maybe<Scalars['Int']>;
  unloadCar?: Maybe<Scalars['Int']>;
  unloadCarPPL?: Maybe<Scalars['Int']>;
  unloadTrailer?: Maybe<Scalars['Int']>;
  unloadTrailerPPL?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  weight?: Maybe<Scalars['Float']>;
};

export type RouteLegCarTask = {
  __typename?: 'RouteLegCarTask';
  actualCapacity?: Maybe<Scalars['Int']>;
  actualDock?: Maybe<Scalars['String']>;
  actualUndock?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  estDock?: Maybe<Scalars['String']>;
  estUndock?: Maybe<Scalars['String']>;
  gateNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  leg: RouteLeg;
  legId?: Maybe<Scalars['Int']>;
  loadCages?: Maybe<Scalars['Int']>;
  loadPAL?: Maybe<Scalars['Int']>;
  loadPPL?: Maybe<Scalars['Int']>;
  loadingListItems: Array<LoadingListItem>;
  note?: Maybe<Scalars['String']>;
  operationType?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  seals: Array<SealInfo>;
  togref?: Maybe<Scalars['String']>;
  trainCompany?: Maybe<Scalars['String']>;
  tripEndDateTime?: Maybe<Scalars['String']>;
  tripStartDateTime?: Maybe<Scalars['String']>;
  tripStatus?: Maybe<Scalars['String']>;
  unloadCages?: Maybe<Scalars['Int']>;
  unloadPAL?: Maybe<Scalars['Int']>;
  unloadPPL?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RouteLegDataColumnInfo = {
  carRegistrationNumber?: Maybe<Scalars['String']>;
  trailerRegistrationNumber?: Maybe<Scalars['String']>;
};

export type RouteLegDriverDetailsBatchInput = {
  legs: Array<RouteLegDriverDetailsInput>;
};

export type RouteLegDriverDetailsInput = {
  carRegistrationNumber?: Maybe<Scalars['String']>;
  driverEmail?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  driverPhoneNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  trailerRegistrationNumber?: Maybe<Scalars['String']>;
};

export type RouteLegInput = {
  actualArrivalDate?: Maybe<Scalars['String']>;
  actualDepartureDate?: Maybe<Scalars['String']>;
  actualDepartureTime?: Maybe<Scalars['String']>;
  arrivalTime: Scalars['String'];
  carDetails: TaskDetails;
  carRegistrationNumber: Scalars['String'];
  departureTime?: Maybe<Scalars['String']>;
  dispatcherId?: Maybe<Scalars['Int']>;
  distanceInKM?: Maybe<Scalars['Float']>;
  fuel: FuelType;
  gateNumber: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  isLoadingInCar: Scalars['Boolean'];
  isLoadingInTrailer: Scalars['Boolean'];
  isNewLegVariant: Scalars['Boolean'];
  isNonArrivalMarked?: Maybe<Scalars['Boolean']>;
  legTag?: Maybe<Scalars['String']>;
  load: Scalars['Boolean'];
  loadCar?: Maybe<Scalars['Int']>;
  loadTrailer?: Maybe<Scalars['Int']>;
  loadingListItems: Array<LoadingListItemInput>;
  locationId: Scalars['Int'];
  note: Scalars['String'];
  position: Scalars['Int'];
  productionDate: Scalars['String'];
  routeDriverEmail?: Maybe<Scalars['String']>;
  routeDriverName: Scalars['String'];
  routeDriverPhoneNumber: Scalars['String'];
  subcontractorLocationId?: Maybe<Scalars['Int']>;
  terminalNickname?: Maybe<Scalars['String']>;
  trailerDetails?: Maybe<TaskDetails>;
  trailerRegistrationNumber: Scalars['String'];
  transportationDate: Scalars['String'];
  transportationDateOffset: Scalars['Int'];
  unload: Scalars['Boolean'];
};

export type RouteLegInputV2 = {
  actualArrivalDate?: Maybe<Scalars['String']>;
  actualDepartureDate?: Maybe<Scalars['String']>;
  actualDepartureTime?: Maybe<Scalars['String']>;
  arrivalTime: Scalars['String'];
  carDetails: TaskDetailsV2;
  departureTime?: Maybe<Scalars['String']>;
  dispatcherId?: Maybe<Scalars['Int']>;
  fuel: FuelType;
  id?: Maybe<Scalars['Int']>;
  isNewLegVariant: Scalars['Boolean'];
  isNonArrivalMarked?: Maybe<Scalars['Boolean']>;
  legTag?: Maybe<Scalars['String']>;
  load: Scalars['Boolean'];
  loadingListItems: Array<LoadingListItemInput>;
  locationId: Scalars['Int'];
  note: Scalars['String'];
  position: Scalars['Int'];
  productionDate: Scalars['String'];
  subcontractorLocationId?: Maybe<Scalars['Int']>;
  trailerDetails?: Maybe<TaskDetailsV2>;
  transportationDate: Scalars['String'];
  transportationDateOffset: Scalars['Int'];
  unload: Scalars['Boolean'];
};

export type RouteLegLcOperationV2Input = {
  arrivalTime?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  containerNumber?: Maybe<Scalars['String']>;
  departureTime?: Maybe<Scalars['String']>;
  gateNumber?: Maybe<Scalars['String']>;
  lcIndex: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  operationType?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  seals?: Maybe<Array<SealInfoInput>>;
};

export type RouteLegTrailerTask = {
  __typename?: 'RouteLegTrailerTask';
  actualCapacity?: Maybe<Scalars['Int']>;
  actualDock?: Maybe<Scalars['String']>;
  actualUndock?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  estDock?: Maybe<Scalars['String']>;
  estUndock?: Maybe<Scalars['String']>;
  gateNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  leg: RouteLeg;
  legId?: Maybe<Scalars['Int']>;
  loadCages?: Maybe<Scalars['Int']>;
  loadPAL?: Maybe<Scalars['Int']>;
  loadPPL?: Maybe<Scalars['Int']>;
  loadingListItems: Array<LoadingListItem>;
  note?: Maybe<Scalars['String']>;
  operationType?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  seals: Array<SealInfo>;
  togref?: Maybe<Scalars['String']>;
  trainCompany?: Maybe<Scalars['String']>;
  tripEndDateTime?: Maybe<Scalars['String']>;
  tripStartDateTime?: Maybe<Scalars['String']>;
  tripStatus?: Maybe<Scalars['String']>;
  unloadCages?: Maybe<Scalars['Int']>;
  unloadPAL?: Maybe<Scalars['Int']>;
  unloadPPL?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RouteLegWrapper = {
  __typename?: 'RouteLegWrapper';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy: Scalars['String'];
  driverEmail: Scalars['String'];
  driverName: Scalars['String'];
  driverPhoneNumber: Scalars['String'];
  endStop: RouteLeg;
  endStopId: Scalars['Int'];
  id: Scalars['Int'];
  route: Route;
  startStop: RouteLeg;
  startStopId: Scalars['Int'];
  tripId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type RouteLevelInfo = {
  dispatcherId?: Maybe<Scalars['Int']>;
  externalNote?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  routeId?: Maybe<Scalars['String']>;
  subcontractorLocationId?: Maybe<Scalars['Int']>;
};

export type RouteLock = {
  __typename?: 'RouteLock';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isChecklistLocked: Scalars['Boolean'];
  lockedAt?: Maybe<Scalars['DateTime']>;
  lockedBy: Scalars['String'];
  lockedByUserId?: Maybe<Scalars['String']>;
  route: Route;
  routeId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type RouteObjectForProdApp = {
  __typename?: 'RouteObjectForProdApp';
  arrivalCity: Scalars['String'];
  arrivalCountry: Scalars['String'];
  carCarrierId: Scalars['String'];
  departureCity: Scalars['String'];
  departureCountry: Scalars['String'];
  id: Scalars['Int'];
  routeId: Scalars['String'];
  trailerCarrierId: Scalars['String'];
  type: Scalars['String'];
};

export type RouteStartDateInput = {
  newEndDate?: Maybe<Scalars['String']>;
  newStartDate?: Maybe<Scalars['String']>;
  tourRouteId: Scalars['Int'];
};

export type RouteTransit = {
  dispatcherId?: Maybe<Scalars['Int']>;
  distanceKm?: Maybe<Scalars['Int']>;
  driverEmail?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  driverPhoneNumber?: Maybe<Scalars['String']>;
  durationMin?: Maybe<Scalars['Int']>;
  fromLegPosition: Scalars['Int'];
  fuelType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isBorderCrossing?: Maybe<Scalars['Boolean']>;
  subcontractorLocationId?: Maybe<Scalars['Int']>;
  toLegPosition: Scalars['Int'];
  trainNumber?: Maybe<Scalars['String']>;
  trainRef?: Maybe<Scalars['String']>;
  transitType: Scalars['String'];
};

export enum RouteType {
  Fixed = 'Fixed',
  Sporadic = 'Sporadic'
}

export type SaveRouteLegAndLoadingListV2Input = {
  costAllocation?: Maybe<UpdateCostAllocationInput>;
  legs?: Maybe<Array<DispatchRouteLegInput>>;
  routeId: Scalars['Int'];
  transits?: Maybe<Array<RouteTransit>>;
};

export type ScheduleDaysInput = {
  repeat: Scalars['Boolean'];
  repeatEvery: Scalars['Int'];
  repeatType: Scalars['String'];
};

export type ScheduleInput = {
  days?: Maybe<ScheduleDaysInput>;
  months?: Maybe<ScheduleMonthsInput>;
  multipleDates?: Maybe<ScheduleMultipleDatesInput>;
  weeks?: Maybe<ScheduleWeeksInput>;
};

export type ScheduleMonthsInput = {
  repeat: Scalars['Boolean'];
  repeatDataDay?: Maybe<MonthRepeatByDayInput>;
  repeatDataWeeks?: Maybe<MonthRepeatByWeeksInput>;
  repeatEvery: Scalars['Int'];
  repeatType: Scalars['String'];
};

export type ScheduleMultipleDatesInput = {
  dates: Array<Scalars['String']>;
  type: Scalars['String'];
};

export type ScheduleWeeksInput = {
  repeat: Scalars['Boolean'];
  repeatData: Array<Scalars['String']>;
  repeatEvery: Scalars['Int'];
  repeatType: Scalars['String'];
};

export type SealInfo = {
  __typename?: 'SealInfo';
  carTaskId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  sealNumber?: Maybe<Scalars['String']>;
  sealStatus?: Maybe<Scalars['String']>;
  trailerTaskId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type SealInfoInput = {
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  sealNumber: Scalars['String'];
  sealStatus?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Setting = {
  __typename?: 'Setting';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  version: Scalars['String'];
};

export type SettingInput = {
  lastUpdatedBy?: Maybe<Scalars['String']>;
  version: Scalars['String'];
};

export type ShipLoadingListSubType = {
  __typename?: 'ShipLoadingListSubType';
  createdFrom?: Maybe<Scalars['String']>;
  customCleared: Scalars['Boolean'];
  customClearedForImport: Scalars['Boolean'];
  customWaybillNo?: Maybe<Scalars['String']>;
  customsProcedure?: Maybe<CustomsProcedureNew>;
  id: Scalars['Int'];
  isImportedFromShipment: Scalars['Boolean'];
  isRemainingGoods: Scalars['Boolean'];
  linkedRouteName?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['Int']>;
  locationName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  terminalCleared: Scalars['Boolean'];
  weight?: Maybe<Scalars['Float']>;
};

export type Shipment = {
  __typename?: 'Shipment';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  createdFrom?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy: Scalars['String'];
  fromLocationId: Scalars['Int'];
  id: Scalars['Int'];
  lastUpdatedBy: Scalars['String'];
  loadingListItems: Array<LoadingListItem>;
  name: Scalars['String'];
  shipmentDate?: Maybe<Scalars['String']>;
  shipmentStatus?: Maybe<Scalars['String']>;
  toLocationId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  updatedFrom?: Maybe<Scalars['String']>;
};

export type ShipmentBulkOrderUpdateSubscription = {
  __typename?: 'ShipmentBulkOrderUpdateSubscription';
  byUserName: Scalars['String'];
  userId: Scalars['String'];
};

export type ShipmentEditInput = {
  fromLocationId: Scalars['Int'];
  id: Scalars['Int'];
  loadingListItems: Array<EditShipmentLoadingList>;
  name: Scalars['String'];
  shipmentDate?: Maybe<Scalars['String']>;
  toLocationId: Scalars['Int'];
  updatedFrom?: Maybe<Scalars['String']>;
};

export type ShipmentLinkUnlinkSubscription = {
  __typename?: 'ShipmentLinkUnlinkSubscription';
  isLink: Scalars['Boolean'];
  routeId: Scalars['Float'];
  terminalId: Scalars['Float'];
  transDate: Scalars['String'];
};

export type ShipmentListUpdateSubscription = {
  __typename?: 'ShipmentListUpdateSubscription';
  shipmentDate: Scalars['String'];
};

export type ShipmentLoadingList = {
  checked?: Maybe<Scalars['Boolean']>;
  classification?: Maybe<DangerousGoodsClassification>;
  cmrDate?: Maybe<Scalars['String']>;
  connectedNB?: Maybe<Scalars['String']>;
  customCleared?: Maybe<Scalars['Boolean']>;
  customClearedForImport?: Maybe<Scalars['Boolean']>;
  customCmrNo?: Maybe<Scalars['String']>;
  customInvoiceNo?: Maybe<Scalars['String']>;
  customMrnNo?: Maybe<Scalars['String']>;
  customNote?: Maybe<Scalars['String']>;
  customVOECId?: Maybe<Scalars['String']>;
  customWaybillNo?: Maybe<Scalars['String']>;
  customsProcedure?: Maybe<CustomsProcedureNew>;
  fromLocationId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isDangerous?: Maybe<Scalars['Boolean']>;
  isImportedFromShipment?: Maybe<Scalars['Boolean']>;
  isLimitedQty?: Maybe<Scalars['Boolean']>;
  isOrderHidden?: Maybe<Scalars['Boolean']>;
  isRemainingGoods?: Maybe<Scalars['Boolean']>;
  isVoecCustomer?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  preplannedRoute?: Maybe<Scalars['String']>;
  shipmentDate?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['Int']>>;
  templateName?: Maybe<Scalars['String']>;
  terminalCleared?: Maybe<Scalars['Boolean']>;
  terminalDevInfo?: Maybe<Scalars['String']>;
  terminalDevPackages?: Maybe<Scalars['Int']>;
  terminalDevPalletSpace?: Maybe<Scalars['Float']>;
  terminalDevPallets?: Maybe<Scalars['Int']>;
  terminalDevWeight?: Maybe<Scalars['Float']>;
  terminalNotCleared?: Maybe<Scalars['Boolean']>;
  terminalShipmentNotArrived?: Maybe<Scalars['Boolean']>;
  toLocationId?: Maybe<Scalars['Int']>;
  unNumber?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ShipmentNexusAddOrderSubscription = {
  __typename?: 'ShipmentNexusAddOrderSubscription';
  orders: Array<ShipmentUpdateSubscription>;
};

export type ShipmentOrderBulkUpdateInput = {
  customsProcedure?: Maybe<CustomsProcedureNew>;
  fromLocationId?: Maybe<Scalars['Int']>;
  loadingListItemIds: Array<Scalars['Int']>;
  newPreplannedRouteName?: Maybe<Scalars['String']>;
  newShipmentDate?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['Int']>>;
  toLocationId?: Maybe<Scalars['Int']>;
  updateFor: Scalars['String'];
};

export type ShipmentOrderDeleteSubscription = {
  __typename?: 'ShipmentOrderDeleteSubscription';
  loadingListItemId: Scalars['Float'];
  orderShipmentDate: Scalars['String'];
};

export type ShipmentPartialUpdateInput = {
  forFieldName: Scalars['String'];
  forFieldValue: Scalars['String'];
  orderId: Scalars['Int'];
  shipmentDate: Scalars['String'];
  shipmentId: Scalars['Int'];
};

export type ShipmentPartialUpdateSubscription = {
  __typename?: 'ShipmentPartialUpdateSubscription';
  forFieldName: Scalars['String'];
  forFieldValue: Scalars['String'];
  loadingListItems?: Maybe<Array<ShipLoadingListSubType>>;
  orderId: Scalars['Int'];
  shipmentId: Scalars['Int'];
  userId: Scalars['String'];
};

export type ShipmentTag = {
  __typename?: 'ShipmentTag';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt: Scalars['DateTime'];
  deletedBy: Scalars['String'];
  id: Scalars['Int'];
  loadingListItems?: Maybe<Array<LoadingListItem>>;
  title: Scalars['String'];
};

export type ShipmentUpdateSubscription = {
  __typename?: 'ShipmentUpdateSubscription';
  cmrDate?: Maybe<Scalars['String']>;
  createdFrom?: Maybe<Scalars['String']>;
  customCleared: Scalars['Boolean'];
  customClearedForImport: Scalars['Boolean'];
  customWaybillNo?: Maybe<Scalars['String']>;
  customsProcedure?: Maybe<CustomsProcedureNew>;
  fromLocationId?: Maybe<Scalars['Int']>;
  fromLocationName?: Maybe<Scalars['String']>;
  hiddenBy?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isImportedFromShipment: Scalars['Boolean'];
  isOrderHidden?: Maybe<Scalars['Boolean']>;
  isRemainingGoods: Scalars['Boolean'];
  linkedRouteName?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['Int']>;
  locationName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  preplannedRoute?: Maybe<Scalars['String']>;
  shipmentDate?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  terminalCleared: Scalars['Boolean'];
  toLocationId?: Maybe<Scalars['Int']>;
  toLocationName?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
};

export type SporadicRouteInput = {
  agreedPrice?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Int']>;
  costAllocation?: Maybe<CostAllocationInput>;
  currency: Scalars['String'];
  deviations?: Maybe<Array<DeviationInput>>;
  dispatcherId?: Maybe<Scalars['Int']>;
  driverEmail?: Maybe<Scalars['String']>;
  driverName: Scalars['String'];
  driverPhoneNumber: Scalars['String'];
  externalNote: Scalars['String'];
  files: Array<FileItemInput>;
  ftl?: Maybe<RouteFtlInput>;
  id?: Maybe<Scalars['Int']>;
  invoiceNote?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  isCopyDriverPlateInfo?: Maybe<Scalars['Boolean']>;
  isCreatedFromPlanned: Scalars['Boolean'];
  isCreatedFromTerminal: Scalars['Boolean'];
  isUnplannedRoute?: Maybe<Scalars['Boolean']>;
  kilometer?: Maybe<Scalars['Int']>;
  legs: Array<RouteLegInput>;
  licensePlate: Scalars['String'];
  note: Scalars['String'];
  routeCarRegNumber?: Maybe<Scalars['String']>;
  routeDriverName?: Maybe<Scalars['String']>;
  routeDriverPhoneNumber?: Maybe<Scalars['String']>;
  routeId: Scalars['String'];
  routeTag?: Maybe<Scalars['String']>;
  routeTrailerRegNumber?: Maybe<Scalars['String']>;
  rutekode?: Maybe<Scalars['String']>;
  subcontractorLocationId: Scalars['Int'];
  trainNumber?: Maybe<Scalars['String']>;
  transportationDate: Scalars['String'];
  turnummer?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

export type SporadicRouteInputV2 = {
  agreedPrice?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Int']>;
  costAllocation?: Maybe<CostAllocationInputV2>;
  currency: Scalars['String'];
  dispatcherId?: Maybe<Scalars['Int']>;
  driverName?: Maybe<Scalars['String']>;
  driverPhoneNumber?: Maybe<Scalars['String']>;
  externalNote: Scalars['String'];
  files: Array<FileItemInputV2>;
  id?: Maybe<Scalars['Int']>;
  isUnplannedRoute?: Maybe<Scalars['Boolean']>;
  kilometer?: Maybe<Scalars['Int']>;
  legs: Array<RouteLegInputV2>;
  licensePlate?: Maybe<Scalars['String']>;
  note: Scalars['String'];
  routeId: Scalars['String'];
  routeTag?: Maybe<Scalars['String']>;
  rutekode?: Maybe<Scalars['String']>;
  subcontractorLocationId?: Maybe<Scalars['Int']>;
  transits?: Maybe<Array<RouteTransit>>;
  transportationDate: Scalars['String'];
  turnummer?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

export type SporadicRouteLoadingListItemInput = {
  checked: Scalars['Boolean'];
  classification?: Maybe<DangerousGoodsClassification>;
  createdFrom?: Maybe<Scalars['String']>;
  customWaybillNo?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  customsProcedure?: Maybe<CustomsProcedureNew>;
  grossVolumeM3?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  isDangerous: Scalars['Boolean'];
  isLimitedQty: Scalars['Boolean'];
  lliEdiAdditionalDetails?: Maybe<LliEdiAdditionalDetailsInput>;
  locationId?: Maybe<Scalars['Int']>;
  note: Scalars['String'];
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  serviceCode?: Maybe<Scalars['String']>;
  toLocationId?: Maybe<Scalars['Int']>;
  unNumber?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  checklistReset: ChecklistResetSubscription;
  legsListUpdateSub: LegsListUpdateSubscription;
  routeGridUpdate: RouteGridUpdateSubscriptionPayload;
  routeLockPing: RouteLockPingSubscription;
  routeLockSub: RouteLockSubscription;
  shipmentBulkOrderUpdateSub: ShipmentBulkOrderUpdateSubscription;
  shipmentLinkUnlinkSub: ShipmentLinkUnlinkSubscription;
  shipmentListUpdateSub: ShipmentListUpdateSubscription;
  shipmentNexusAddOrderSub: ShipmentNexusAddOrderSubscription;
  shipmentOrderDeleteSub: ShipmentOrderDeleteSubscription;
  shipmentOrderUpdateSub: ShipmentUpdateSubscription;
  shipmentPartialUpdateSub: ShipmentPartialUpdateSubscription;
  templateRouteUpdate: TemplateRouteUpdateSubscriptionPayload;
  truckFillAndTimeUpdate: TruckFillAndTimeSubscription;
};


export type SubscriptionChecklistResetArgs = {
  forGroup: Scalars['String'];
  ownerUserId: Scalars['String'];
};


export type SubscriptionLegsListUpdateSubArgs = {
  legId: Scalars['Int'];
};


export type SubscriptionRouteLockPingArgs = {
  routeId: Scalars['Int'];
};


export type SubscriptionRouteLockSubArgs = {
  routeId: Scalars['Int'];
};


export type SubscriptionShipmentBulkOrderUpdateSubArgs = {
  userId: Scalars['String'];
};


export type SubscriptionShipmentLinkUnlinkSubArgs = {
  terminalId: Scalars['Int'];
  transDate: Scalars['String'];
};


export type SubscriptionShipmentListUpdateSubArgs = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};


export type SubscriptionShipmentNexusAddOrderSubArgs = {
  isNexusAdd: Scalars['Boolean'];
};


export type SubscriptionShipmentOrderDeleteSubArgs = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};


export type SubscriptionShipmentOrderUpdateSubArgs = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};


export type SubscriptionShipmentPartialUpdateSubArgs = {
  shipmentId: Scalars['Int'];
  userId: Scalars['String'];
};


export type SubscriptionTruckFillAndTimeUpdateArgs = {
  locationId: Scalars['Int'];
};

export type TaskDetails = {
  actualCapacity?: Maybe<Scalars['Int']>;
  containerId?: Maybe<Scalars['String']>;
  estDock?: Maybe<Scalars['String']>;
  estUndock?: Maybe<Scalars['String']>;
  gateNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  loadingListItems: Array<LoadingListItemInput>;
  operationType?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
};

export type TaskDetailsV2 = {
  actualCapacity?: Maybe<Scalars['Int']>;
  containerId?: Maybe<Scalars['String']>;
  estDock?: Maybe<Scalars['String']>;
  estUndock?: Maybe<Scalars['String']>;
  gateNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  loadingListItems: Array<SporadicRouteLoadingListItemInput>;
  note?: Maybe<Scalars['String']>;
  operationType?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  seals?: Maybe<Array<SealInfoInput>>;
};

export enum TaskName {
  Car = 'Car',
  Trailer = 'Trailer'
}

export type TemplateRouteUpdateSubscriptionPayload = {
  __typename?: 'TemplateRouteUpdateSubscriptionPayload';
  eventType: Scalars['String'];
  userId: Scalars['String'];
};

export type TerminalPostsDetail = {
  __typename?: 'TerminalPostsDetail';
  gridCount: Scalars['Int'];
  gridEntries: Array<InternalTerminalGridEntries>;
  infoCount: Scalars['Int'];
  infoPosts: Array<InternalTerminalReportInfo>;
  locationId: Scalars['Int'];
  locationName: Scalars['String'];
  startDate: Scalars['String'];
  valueBoxCount: Scalars['Int'];
  valueBoxEntries: Array<InternalTerminalValueBoxEntries>;
};

export enum TerminalRouteStatus {
  Arrived = 'Arrived',
  Departure = 'Departure',
  Done = 'Done',
  HandedOver = 'HandedOver',
  NonArrival = 'NonArrival',
  Ongoing = 'Ongoing',
  Pickup = 'Pickup',
  ReadyForPu = 'ReadyForPu',
  UnplannedRoute = 'UnplannedRoute'
}

export type TerminalStatusLogEntry = {
  __typename?: 'TerminalStatusLogEntry';
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<Scalars['String']>;
  gate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  legId: Scalars['Int'];
  locationId: Scalars['Int'];
  locationLabel: Scalars['String'];
  locationName: Scalars['String'];
  locationOrder: Scalars['Int'];
  status: TerminalRouteStatus;
  timeZone?: Maybe<Scalars['String']>;
  timestamp: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type TerminalStatusLogInput = {
  gate?: Maybe<Scalars['String']>;
  logId?: Maybe<Scalars['String']>;
  operation?: Maybe<TerminalStatusLogOperation>;
  status?: Maybe<TerminalRouteStatus>;
  timeZone?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
};

export enum TerminalStatusLogOperation {
  Delete = 'Delete',
  Upsert = 'Upsert'
}

export type TourRouteCostAllocationItem = {
  __typename?: 'TourRouteCostAllocationItem';
  additionalCost: Scalars['Boolean'];
  additionalDiscount: Scalars['Boolean'];
  bringCost: Scalars['Boolean'];
  comment: Scalars['String'];
  cost: Scalars['Float'];
  currency?: Maybe<Currency>;
  deletedAt: Scalars['DateTime'];
  department: Department;
  departmentId: Scalars['String'];
  id: Scalars['Int'];
  includedKpi: Scalars['Boolean'];
  includedPrice: Scalars['Boolean'];
  location?: Maybe<LocationEntity>;
  locationId?: Maybe<Scalars['Int']>;
  tags: Scalars['String'];
  tourRouteId: Scalars['Int'];
  type: CostAllocationItemType;
  updatedAt: Scalars['DateTime'];
};

export type TourRouteFtlInput = {
  cdc?: Maybe<Scalars['String']>;
  cmr?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['Int']>;
  customerNumber?: Maybe<Scalars['String']>;
  customerReference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invoiceNote?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type TourRouteLegCarTask = {
  __typename?: 'TourRouteLegCarTask';
  actualCapacity?: Maybe<Scalars['Int']>;
  containerId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  estDock?: Maybe<Scalars['String']>;
  estUndock?: Maybe<Scalars['String']>;
  gateNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  loadingListItems: Array<TourRouteLegLoadingListItemTemplate>;
  note?: Maybe<Scalars['String']>;
  operationType?: Maybe<Scalars['String']>;
  plannedPPL?: Maybe<Scalars['Int']>;
  registrationNumber?: Maybe<Scalars['String']>;
  togRef?: Maybe<Scalars['String']>;
  tourRouteLeg: TourRouteLegTemplate;
  trainCompany?: Maybe<Scalars['String']>;
};

export type TourRouteLegLoadingListItemTemplate = {
  __typename?: 'TourRouteLegLoadingListItemTemplate';
  carDetails: TourRouteLegCarTask;
  checked: Scalars['Boolean'];
  classification?: Maybe<DangerousGoodsClassification>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt: Scalars['DateTime'];
  deletedBy: Scalars['String'];
  id: Scalars['Int'];
  isDangerous: Scalars['Boolean'];
  isLimitedQty: Scalars['Boolean'];
  lastUpdatedBy: Scalars['String'];
  leg: TourRouteLegTemplate;
  location?: Maybe<LocationEntity>;
  locationId: Scalars['Int'];
  note: Scalars['String'];
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  trailerDetails: TourRouteLegTrailerTask;
  unNumber?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  weight?: Maybe<Scalars['Float']>;
};

export type TourRouteLegLoadingListItemTemplateInput = {
  checked: Scalars['Boolean'];
  classification?: Maybe<DangerousGoodsClassification>;
  createdFrom?: Maybe<Scalars['String']>;
  customWaybillNo?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  customsProcedure?: Maybe<CustomsProcedureNew>;
  fromLocationId?: Maybe<Scalars['Int']>;
  grossVolumeM3?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  isDangerous: Scalars['Boolean'];
  isLimitedQty: Scalars['Boolean'];
  lliEdiAdditionalDetails?: Maybe<LliEdiAdditionalDetailsInput>;
  locationId: Scalars['Int'];
  note: Scalars['String'];
  packages?: Maybe<Scalars['Int']>;
  palletSpace?: Maybe<Scalars['Float']>;
  pallets?: Maybe<Scalars['Int']>;
  serviceCode?: Maybe<Scalars['String']>;
  toLocationId?: Maybe<Scalars['Int']>;
  unNumber?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type TourRouteLegTaskDetails = {
  actualCapacity?: Maybe<Scalars['Int']>;
  containerId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  estDock?: Maybe<Scalars['String']>;
  estUndock?: Maybe<Scalars['String']>;
  gateNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  loadingListItems: Array<LoadingListItemInput>;
  note?: Maybe<Scalars['String']>;
  operationType?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  togRef?: Maybe<Scalars['String']>;
  trainCompany?: Maybe<Scalars['String']>;
};

export type TourRouteLegTemplate = {
  __typename?: 'TourRouteLegTemplate';
  arrivalTime?: Maybe<Scalars['String']>;
  carDetails?: Maybe<TourRouteLegCarTask>;
  carRegistrationNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  departureTime?: Maybe<Scalars['String']>;
  dispatcher?: Maybe<CardContact>;
  dispatcherId?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  fuel?: Maybe<FuelType>;
  gateNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isLoadingInCar: Scalars['Boolean'];
  isLoadingInTrailer: Scalars['Boolean'];
  isNewLegVariant: Scalars['Boolean'];
  kg?: Maybe<Scalars['Int']>;
  km?: Maybe<Scalars['Int']>;
  legTags?: Maybe<Scalars['String']>;
  load?: Maybe<Scalars['Boolean']>;
  loadingListItems: Array<TourRouteLegLoadingListItemTemplate>;
  location?: Maybe<LocationEntity>;
  locationId?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  routeDriverEmail?: Maybe<Scalars['String']>;
  routeDriverName?: Maybe<Scalars['String']>;
  routeDriverPhoneNumber?: Maybe<Scalars['String']>;
  routeId: Scalars['Int'];
  subcontractor?: Maybe<Card>;
  subcontractorLocation?: Maybe<LocationEntity>;
  subcontractorLocationId?: Maybe<Scalars['Int']>;
  trailerDetails?: Maybe<TourRouteLegTrailerTask>;
  trailerRegistrationNumber?: Maybe<Scalars['String']>;
  transportationDateOffset?: Maybe<Scalars['Int']>;
  unload?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type TourRouteLegTemplateInput = {
  arrivalTime?: Maybe<Scalars['String']>;
  carDetails?: Maybe<TourRouteLegTaskDetails>;
  carRegistrationNumber?: Maybe<Scalars['String']>;
  departureTime?: Maybe<Scalars['String']>;
  dispatcherId?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  fuel?: Maybe<FuelType>;
  gateNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isLoadingInCar?: Maybe<Scalars['Boolean']>;
  isLoadingInTrailer?: Maybe<Scalars['Boolean']>;
  isNewLegVariant?: Maybe<Scalars['Boolean']>;
  km?: Maybe<Scalars['Int']>;
  legTags?: Maybe<Scalars['String']>;
  load?: Maybe<Scalars['Boolean']>;
  loadingListItems?: Maybe<Array<TourRouteLegLoadingListItemTemplateInput>>;
  locationId?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  routeDriverEmail?: Maybe<Scalars['String']>;
  routeDriverName?: Maybe<Scalars['String']>;
  routeDriverPhoneNumber?: Maybe<Scalars['String']>;
  subcontractorLocationId?: Maybe<Scalars['Int']>;
  trailerDetails?: Maybe<TourRouteLegTaskDetails>;
  trailerRegistrationNumber?: Maybe<Scalars['String']>;
  transportationDateOffset?: Maybe<Scalars['Int']>;
  unload?: Maybe<Scalars['Boolean']>;
};

export type TourRouteLegTrailerTask = {
  __typename?: 'TourRouteLegTrailerTask';
  actualCapacity?: Maybe<Scalars['Int']>;
  containerId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  estDock?: Maybe<Scalars['String']>;
  estUndock?: Maybe<Scalars['String']>;
  gateNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  loadingListItems: Array<TourRouteLegLoadingListItemTemplate>;
  note?: Maybe<Scalars['String']>;
  operationType?: Maybe<Scalars['String']>;
  plannedPPL?: Maybe<Scalars['Int']>;
  registrationNumber?: Maybe<Scalars['String']>;
  togRef?: Maybe<Scalars['String']>;
  tourRouteLeg: TourRouteLegTemplate;
  trainCompany?: Maybe<Scalars['String']>;
};

export type TourRouteTemplate = {
  __typename?: 'TourRouteTemplate';
  arrivalLocation?: Maybe<LocationEntity>;
  bookmarkTourRouteTemplate?: Maybe<Array<BookmarkTourRouteTemplate>>;
  capacity?: Maybe<Scalars['Int']>;
  costAllocations: Array<TourRouteCostAllocationItem>;
  createdAt: Scalars['DateTime'];
  days: Array<Days>;
  deletedAt: Scalars['DateTime'];
  departureLocation?: Maybe<LocationEntity>;
  endDate?: Maybe<Scalars['String']>;
  endExceptionDate?: Maybe<Scalars['String']>;
  exceptionDates?: Maybe<Array<Scalars['String']>>;
  externalNote?: Maybe<Scalars['String']>;
  files: Array<DocumentFile>;
  id: Scalars['Int'];
  isCopyDriverPlateInfo: Scalars['Boolean'];
  kilometer?: Maybe<Scalars['Int']>;
  lc1DescriptionTags?: Maybe<Scalars['String']>;
  lc1TotalCapacity?: Maybe<Scalars['Int']>;
  lc2DescriptionTags?: Maybe<Scalars['String']>;
  lc2TotalCapacity?: Maybe<Scalars['Int']>;
  lc3DescriptionTags?: Maybe<Scalars['String']>;
  lc3TotalCapacity?: Maybe<Scalars['Int']>;
  legs: Array<TourRouteLegTemplate>;
  note: Scalars['String'];
  originalStartDate: Scalars['String'];
  position: Scalars['Int'];
  price: Scalars['Float'];
  routeCarRegNumber?: Maybe<Scalars['String']>;
  routeDateType?: Maybe<Scalars['String']>;
  routeDriverName?: Maybe<Scalars['String']>;
  routeDriverPhoneNumber?: Maybe<Scalars['String']>;
  routeId: Scalars['String'];
  routeTag?: Maybe<Scalars['String']>;
  routeTrailerRegNumber?: Maybe<Scalars['String']>;
  rutekode?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['JSON']>;
  startDate: Scalars['String'];
  startExceptionDate?: Maybe<Scalars['String']>;
  tour: TourTemplate;
  tourId: Scalars['Int'];
  tourRouteType: TourRouteType;
  trainNumber?: Maybe<Scalars['String']>;
  transits: Array<TourTransitTemplate>;
  turnummer?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  weight?: Maybe<Scalars['Int']>;
};

export type TourRouteTemplateFileItemInput = {
  id: Scalars['Float'];
};

export type TourRouteTemplateInput = {
  capacity?: Maybe<Scalars['Int']>;
  costAllocations?: Maybe<Array<CostAllocationItemInput>>;
  days?: Maybe<Array<Days>>;
  endDate?: Maybe<Scalars['String']>;
  endExceptionDate?: Maybe<Scalars['String']>;
  exceptionDates?: Maybe<Array<Scalars['String']>>;
  externalNote?: Maybe<Scalars['String']>;
  files?: Maybe<Array<TourRouteTemplateFileItemInput>>;
  ftl?: Maybe<TourRouteFtlInput>;
  id?: Maybe<Scalars['Int']>;
  isCopyDriverPlateInfo?: Maybe<Scalars['Boolean']>;
  kilometer?: Maybe<Scalars['Int']>;
  lc1TotalCapacity?: Maybe<Scalars['Int']>;
  lc2TotalCapacity?: Maybe<Scalars['Int']>;
  lc3TotalCapacity?: Maybe<Scalars['Int']>;
  legs?: Maybe<Array<TourRouteLegTemplateInput>>;
  note?: Maybe<Scalars['String']>;
  originalStartDate?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  routeCarRegNumber?: Maybe<Scalars['String']>;
  routeDateType?: Maybe<Scalars['String']>;
  routeDriverName?: Maybe<Scalars['String']>;
  routeDriverPhoneNumber?: Maybe<Scalars['String']>;
  routeId?: Maybe<Scalars['String']>;
  routeTag?: Maybe<Scalars['String']>;
  routeTrailerRegNumber?: Maybe<Scalars['String']>;
  rutekode?: Maybe<Scalars['String']>;
  schedule?: Maybe<ScheduleInput>;
  startDate?: Maybe<Scalars['String']>;
  startExceptionDate?: Maybe<Scalars['String']>;
  tourRouteType?: Maybe<TourRouteType>;
  trainNumber?: Maybe<Scalars['String']>;
  transits?: Maybe<Array<RouteTransit>>;
  turnummer?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

export enum TourRouteType {
  Fixed = 'Fixed',
  MultipleSporadic = 'MultipleSporadic',
  Old = 'Old',
  SingleSporadic = 'SingleSporadic'
}

export type TourTemplate = {
  __typename?: 'TourTemplate';
  capacity?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  currency: Scalars['String'];
  deletedAt: Scalars['DateTime'];
  deletedBy: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  dispatcher?: Maybe<CardContact>;
  dispatcherId?: Maybe<Scalars['Int']>;
  driverName: Scalars['String'];
  driverPhoneNumber: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  endExceptionDate?: Maybe<Scalars['String']>;
  exceptionDates?: Maybe<Array<Scalars['String']>>;
  fuel: FuelType;
  groupingTag?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDateActive: Scalars['Boolean'];
  /** Indicates whether this template is inactive (draft mode). Inactive templates are not used for route generation. */
  isInactive: Scalars['Boolean'];
  isNewVersion: Scalars['Boolean'];
  isPriceEquallyDivided: Scalars['Boolean'];
  lastUpdatedBy: Scalars['String'];
  licensePlate: Scalars['String'];
  name: Scalars['String'];
  note: Scalars['String'];
  originalStartDate?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  responsiblePerson?: Maybe<Scalars['String']>;
  routes: Array<TourRouteTemplate>;
  sameSubcontractorToAllRoutes?: Maybe<Scalars['Boolean']>;
  startDate: Scalars['String'];
  startExceptionDate?: Maybe<Scalars['String']>;
  subcontractor?: Maybe<Card>;
  subcontractorId?: Maybe<Scalars['Int']>;
  subcontractorLocation?: Maybe<LocationEntity>;
  subcontractorLocationId?: Maybe<Scalars['Int']>;
  templateType?: Maybe<Scalars['String']>;
  tourAgreementNo?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type TourTemplateInput = {
  capacity?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  dispatcherId?: Maybe<Scalars['Int']>;
  driverName: Scalars['String'];
  driverPhoneNumber: Scalars['String'];
  groupingTag?: Maybe<Scalars['String']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  isPriceEquallyDivided?: Maybe<Scalars['Boolean']>;
  licensePlate: Scalars['String'];
  name: Scalars['String'];
  note: Scalars['String'];
  price: Scalars['Float'];
  responsiblePerson?: Maybe<Scalars['String']>;
  routes: Array<TourRouteTemplateInput>;
  sameSubcontractorToAllRoutes?: Maybe<Scalars['Boolean']>;
  subcontractorLocationId?: Maybe<Scalars['Int']>;
  templateType?: Maybe<Scalars['String']>;
};

export type TourTransitTemplate = {
  __typename?: 'TourTransitTemplate';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  dispatcherId?: Maybe<Scalars['Int']>;
  distanceKm?: Maybe<Scalars['Int']>;
  driverEmail?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  driverPhoneNumber?: Maybe<Scalars['String']>;
  durationMin?: Maybe<Scalars['Int']>;
  fromLeg?: Maybe<TourRouteLegTemplate>;
  fromLegId?: Maybe<Scalars['Int']>;
  fuelType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastUpdatedBy: Scalars['String'];
  subcontractorLocationId?: Maybe<Scalars['Int']>;
  toLeg?: Maybe<TourRouteLegTemplate>;
  toLegId?: Maybe<Scalars['Int']>;
  tourRoute: TourRouteTemplate;
  tourRouteId: Scalars['Int'];
  trainNumber?: Maybe<Scalars['String']>;
  trainRef?: Maybe<Scalars['String']>;
  transitType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Transit = {
  __typename?: 'Transit';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  dispatcherId?: Maybe<Scalars['Int']>;
  distanceKm?: Maybe<Scalars['Int']>;
  driverEmail?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  driverPhoneNumber?: Maybe<Scalars['String']>;
  durationMin?: Maybe<Scalars['Int']>;
  fromLeg?: Maybe<RouteLeg>;
  fromLegId?: Maybe<Scalars['Int']>;
  fuelType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isBorderCrossing?: Maybe<Scalars['Boolean']>;
  lastUpdatedBy: Scalars['String'];
  route: Route;
  routeId: Scalars['Int'];
  subcontractorLocationId?: Maybe<Scalars['Int']>;
  toLeg?: Maybe<RouteLeg>;
  toLegId?: Maybe<Scalars['Int']>;
  trainNumber?: Maybe<Scalars['String']>;
  trainRef?: Maybe<Scalars['String']>;
  transitType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TruckFillAndTimeInput = {
  actualArrivalDate?: Maybe<Scalars['String']>;
  actualArrivalTime?: Maybe<Scalars['String']>;
  actualCarCapacity?: Maybe<Scalars['Int']>;
  actualDepartureDate?: Maybe<Scalars['String']>;
  actualDepartureTime?: Maybe<Scalars['String']>;
  actualTrailerCapacity?: Maybe<Scalars['Int']>;
  ansvBefraktare?: Maybe<Scalars['String']>;
  assigned?: Maybe<Scalars['Boolean']>;
  bpx?: Maybe<Scalars['Int']>;
  brev?: Maybe<Scalars['Int']>;
  carGateNumber?: Maybe<Scalars['String']>;
  carRegistrationNumber?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isNonArrivalMarked?: Maybe<Scalars['Boolean']>;
  isSealBroken?: Maybe<Scalars['Boolean']>;
  kippReceivedBy?: Maybe<Scalars['String']>;
  kippTimeWhenReceived?: Maybe<Scalars['String']>;
  loadCages?: Maybe<Scalars['Int']>;
  loadCar?: Maybe<Scalars['Int']>;
  loadCarPPL?: Maybe<Scalars['Int']>;
  loadTrailer?: Maybe<Scalars['Int']>;
  loadTrailerPPL?: Maybe<Scalars['Int']>;
  locationId: Scalars['Int'];
  operator?: Maybe<Scalars['String']>;
  parti?: Maybe<Scalars['Int']>;
  pip?: Maybe<Scalars['Int']>;
  pri03?: Maybe<Scalars['Int']>;
  pri49?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['String']>;
  productionGroup?: Maybe<Scalars['String']>;
  pru?: Maybe<Scalars['Int']>;
  receivedBy?: Maybe<Scalars['String']>;
  receivedStatus?: Maybe<RecievedStatus>;
  sealNumber?: Maybe<Scalars['String']>;
  terminalNickname?: Maybe<Scalars['String']>;
  terminalNote?: Maybe<Scalars['String']>;
  terminalResponsible?: Maybe<Scalars['String']>;
  terminalStatusInput?: Maybe<TerminalStatusLogInput>;
  timeWhenAssigned?: Maybe<Scalars['String']>;
  timeWhenReceived?: Maybe<Scalars['String']>;
  togref?: Maybe<Scalars['String']>;
  tom?: Maybe<Scalars['Boolean']>;
  trailerGateNumber?: Maybe<Scalars['String']>;
  trailerRegistrationNumber?: Maybe<Scalars['String']>;
  unloadCages?: Maybe<Scalars['Int']>;
  unloadCar?: Maybe<Scalars['Int']>;
  unloadCarPPL?: Maybe<Scalars['Int']>;
  unloadTrailer?: Maybe<Scalars['Int']>;
  unloadTrailerPPL?: Maybe<Scalars['Int']>;
  upri03?: Maybe<Scalars['Int']>;
  upri49?: Maybe<Scalars['Int']>;
};

export type TruckFillAndTimeSubscription = {
  __typename?: 'TruckFillAndTimeSubscription';
  locationId: Scalars['Int'];
  refreshWholeGrid?: Maybe<Scalars['Boolean']>;
  routeLeg: RouteLeg;
  updateType?: Maybe<Scalars['String']>;
};

export type UpdateBookMarkResponse = {
  __typename?: 'UpdateBookMarkResponse';
  bookmark: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type UpdateCardContactInput = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  tagIds: Array<Scalars['Int']>;
};

export type UpdateCostAllocationInput = {
  items: Array<CostAllocationItemInput>;
};

export type UpdateLoadingListInput = {
  carOrTrailer: TaskName;
  legId: Scalars['Int'];
  loadingList: Array<LoadingListItemInput>;
};

export type UpdateLocationInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  fromLocationId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isPromoted: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  locationGroup?: Maybe<Scalars['String']>;
  locationShortCode: Scalars['String'];
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  phLocationId: Scalars['String'];
  postalCode: Scalars['String'];
  tagIds?: Maybe<Array<Scalars['Int']>>;
  toLocationId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type UpdateMinimalRouteInput = {
  routes: Array<ChecklistRoutes>;
};

export type UpdateNoteInput = {
  id: Scalars['Float'];
  text: Scalars['String'];
  title: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  bookmarkTourRouteTemplate?: Maybe<Array<BookmarkTourRouteTemplate>>;
};

export type UserConfigurationInput = {
  configuration: Scalars['JSONObject'];
};

export type UserConfigurationInputWithTableName = {
  configuration: Scalars['JSONObject'];
  tableName: Scalars['String'];
};

export type ValueBoxForDayResponse = {
  __typename?: 'ValueBoxForDayResponse';
  boxId: Scalars['Int'];
  boxNameText: Scalars['String'];
  boxValue: Scalars['String'];
  entryId: Scalars['Int'];
  isAddedFromTerminal: Scalars['Boolean'];
  isAlphaNumeric: Scalars['Boolean'];
  isFixedBox: Scalars['Boolean'];
  isReadOnly: Scalars['Boolean'];
  isTimeBox: Scalars['Boolean'];
  isYesNoBox: Scalars['Boolean'];
};

export type Volume = {
  __typename?: 'Volume';
  bpx?: Maybe<Scalars['Int']>;
  brev?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  id?: Maybe<Scalars['Int']>;
  loadingListItem: LoadingListItem;
  loadingListItemId: Scalars['Int'];
  parti?: Maybe<Scalars['Int']>;
  pip?: Maybe<Scalars['Int']>;
  pri03?: Maybe<Scalars['Int']>;
  pri49?: Maybe<Scalars['Int']>;
  pru?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  upri03?: Maybe<Scalars['Int']>;
  upri49?: Maybe<Scalars['Int']>;
};

export type VolumeColumsInput = {
  bpx?: Maybe<Scalars['Int']>;
  brev?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parti?: Maybe<Scalars['Int']>;
  pip?: Maybe<Scalars['Int']>;
  pri03?: Maybe<Scalars['Int']>;
  pri49?: Maybe<Scalars['Int']>;
  pru?: Maybe<Scalars['Int']>;
  upri03?: Maybe<Scalars['Int']>;
  upri49?: Maybe<Scalars['Int']>;
};

export type ChecklistResetSubscription = {
  __typename?: 'checklistResetSubscription';
  forGroup: Scalars['String'];
  ownerUserId: Scalars['String'];
};

export type ExtraColumnInfo = {
  adr?: Maybe<Scalars['String']>;
  ansvBefraktare?: Maybe<Scalars['String']>;
  assigned?: Maybe<Scalars['Boolean']>;
  bpx?: Maybe<Scalars['Int']>;
  brev?: Maybe<Scalars['Int']>;
  containerId?: Maybe<Scalars['String']>;
  currentlyAtLegLocation?: Maybe<Scalars['Boolean']>;
  inneholdsbeskrivelse?: Maybe<Scalars['String']>;
  isMODone?: Maybe<Scalars['Boolean']>;
  nameReceivedByTraffic?: Maybe<Scalars['String']>;
  parti?: Maybe<Scalars['Int']>;
  pip?: Maybe<Scalars['Int']>;
  pri03?: Maybe<Scalars['Int']>;
  pri49?: Maybe<Scalars['Int']>;
  pru?: Maybe<Scalars['Int']>;
  receivedByTraffic?: Maybe<Scalars['Boolean']>;
  rutekode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  timeReceivedByTraffic?: Maybe<Scalars['String']>;
  timeWhenAssigned?: Maybe<Scalars['String']>;
  togref?: Maybe<Scalars['String']>;
  tom?: Maybe<Scalars['Boolean']>;
  trainNumber?: Maybe<Scalars['String']>;
  transportType?: Maybe<TransportType>;
  turnummer?: Maybe<Scalars['Int']>;
  upri03?: Maybe<Scalars['Int']>;
  upri49?: Maybe<Scalars['Int']>;
};

export type RouteLockPingSubscription = {
  __typename?: 'routeLockPingSubscription';
  lockedByUserId: Scalars['String'];
  pingedByUserName: Scalars['String'];
  routeId: Scalars['Float'];
};

export type RouteLockSubscription = {
  __typename?: 'routeLockSubscription';
  lock: Scalars['Float'];
  lockedAt: Scalars['String'];
  lockedBy: Scalars['String'];
  reload: Scalars['Float'];
  routeId: Scalars['Float'];
};

export enum TransportType {
  Car = 'Car',
  Module = 'Module',
  Trailer = 'Trailer',
  Train = 'Train'
}

export type CardContactFieldsFragment = (
  { __typename?: 'CardContact' }
  & Pick<CardContact, 'id' | 'name' | 'role' | 'email' | 'phoneNumber' | 'note' | 'lastUpdatedBy' | 'createdBy'>
  & { tags: Array<(
    { __typename?: 'CardContactTag' }
    & Pick<CardContactTag, 'id' | 'title'>
  )> }
);

export type LiveUpdateRouteLegFragment = (
  { __typename?: 'RouteLeg' }
  & Pick<RouteLeg, 'id' | 'fuel' | 'arrivalTime' | 'actualArrivalDate' | 'departureTime' | 'actualDepartureDate' | 'load' | 'unload' | 'loadCar' | 'loadCarPPL' | 'loadCages' | 'loadTrailer' | 'loadTrailerPPL' | 'unloadCar' | 'unloadCarPPL' | 'unloadCages' | 'unloadTrailer' | 'unloadTrailerPPL' | 'actualDepartureTime' | 'actualArrivalTime' | 'terminalNote' | 'isNonArrivalMarked' | 'actualCapacity' | 'lastUpdatedBy' | 'updatedAt' | 'transportationDate' | 'productionDate' | 'gateNumber' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'routeDriverEmail' | 'isSealBroken' | 'sealNumber' | 'terminalNickname' | 'productionGroup' | 'note' | 'arrivalStatus' | 'tom' | 'assigned' | 'ansvBefraktare' | 'timeWhenAssigned' | 'receivedStatus' | 'receivedBy' | 'timeWhenReceived' | 'kippReceivedBy' | 'kippTimeWhenReceived' | 'terminalResponsible' | 'operator' | 'priority'>
  & { files: Array<(
    { __typename?: 'DocumentFile' }
    & Pick<DocumentFile, 'id' | 'originalname' | 'mimetype' | 'path' | 'size'>
  )> }
);

export type LocationsFieldsFragment = (
  { __typename?: 'LocationEntity' }
  & Pick<LocationEntity, 'id' | 'type' | 'name' | 'address' | 'postalCode' | 'city' | 'country' | 'phLocationId' | 'locationShortCode' | 'countryLong' | 'createdAt' | 'updatedAt' | 'lastUpdatedBy' | 'createdBy' | 'locationGroup' | 'isPromoted'>
  & { tags?: Maybe<Array<(
    { __typename?: 'LocationTag' }
    & Pick<LocationTag, 'id' | 'title'>
  )>>, fromLocation: (
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'id' | 'name'>
  ), toLocation: (
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'id' | 'name'>
  ) }
);

export type RouteLegWrapperFieldsFragment = (
  { __typename?: 'RouteLegWrapper' }
  & Pick<RouteLegWrapper, 'id' | 'tripId' | 'startStopId' | 'endStopId' | 'driverName' | 'driverPhoneNumber' | 'driverEmail' | 'createdAt' | 'createdBy' | 'updatedAt' | 'updatedBy' | 'deletedAt' | 'deletedBy'>
);

export type TransportAgreementFieldsFragment = (
  { __typename?: 'Route' }
  & Pick<Route, 'id' | 'routeId' | 'transportationDate' | 'capacity' | 'kilometer' | 'weight' | 'currency' | 'agreedPrice' | 'note' | 'createdBy' | 'licensePlate'>
  & { subcontractorLocation?: Maybe<(
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'name' | 'address'>
  )>, dispatcher?: Maybe<(
    { __typename?: 'CardContact' }
    & Pick<CardContact, 'name'>
  )>, files: Array<(
    { __typename?: 'DocumentFile' }
    & Pick<DocumentFile, 'path'>
  )>, costAllocation?: Maybe<(
    { __typename?: 'CostAllocation' }
    & Pick<CostAllocation, 'id'>
    & { items: Array<(
      { __typename?: 'CostAllocationItem' }
      & Pick<CostAllocationItem, 'id' | 'departmentId' | 'cost' | 'includedKpi' | 'includedPrice' | 'bringCost' | 'additionalCost' | 'additionalDiscount' | 'type' | 'comment' | 'currency'>
    )> }
  )>, legs: Array<(
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'arrivalTime' | 'departureTime' | 'transportationDate' | 'transportationDateOffset' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'fuel' | 'note' | 'position'>
    & { location?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'name' | 'type' | 'address' | 'country' | 'postalCode' | 'city' | 'deletedBy'>
      & { tags?: Maybe<Array<(
        { __typename?: 'LocationTag' }
        & Pick<LocationTag, 'id' | 'title'>
      )>> }
    )> }
  )> }
);

export type CreateLocationContactMutationVariables = Exact<{
  locationId: Scalars['Int'];
  input: CreateCardContactInput;
}>;


export type CreateLocationContactMutation = (
  { __typename?: 'Mutation' }
  & { createLocationContact: (
    { __typename?: 'CardContact' }
    & Pick<CardContact, 'id' | 'name' | 'email' | 'phoneNumber' | 'updatedAt' | 'createdAt' | 'note' | 'lastUpdatedBy' | 'createdBy'>
    & { tags: Array<(
      { __typename?: 'CardContactTag' }
      & Pick<CardContactTag, 'id' | 'title'>
    )> }
  ) }
);

export type DeleteLocationContactMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLocationContactMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteLocationContact'>
);

export type UpdateContactMutationVariables = Exact<{
  input: UpdateCardContactInput;
}>;


export type UpdateContactMutation = (
  { __typename?: 'Mutation' }
  & { updateLocationContact: (
    { __typename?: 'CardContact' }
    & Pick<CardContact, 'id' | 'name' | 'email' | 'phoneNumber' | 'note' | 'lastUpdatedBy'>
    & { tags: Array<(
      { __typename?: 'CardContactTag' }
      & Pick<CardContactTag, 'id' | 'title'>
    )> }
  ) }
);

export type CreateContactTagMutationVariables = Exact<{
  input: CreateCardContactTagInput;
}>;


export type CreateContactTagMutation = (
  { __typename?: 'Mutation' }
  & { createContactTag: (
    { __typename?: 'CardContactTag' }
    & Pick<CardContactTag, 'id'>
  ) }
);

export type DeleteContactTagMutationVariables = Exact<{
  tagId: Scalars['Int'];
}>;


export type DeleteContactTagMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteContactTag'>
);

export type DeleteLocationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLocationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteLocation'>
);

export type DeleteLocationFileMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLocationFileMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteLocationFile'>
);

export type AddLocationNoteMutationVariables = Exact<{
  cardId: Scalars['Int'];
  input: CreateNoteInput;
}>;


export type AddLocationNoteMutation = (
  { __typename?: 'Mutation' }
  & { addLocationNote: (
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'id'>
    & { notes?: Maybe<Array<(
      { __typename?: 'CardNote' }
      & Pick<CardNote, 'id' | 'title' | 'text'>
    )>> }
  ) }
);

export type DeleteLocationNoteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLocationNoteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteLocationNote'>
);

export type UpdateLocationNoteMutationVariables = Exact<{
  input: UpdateNoteInput;
}>;


export type UpdateLocationNoteMutation = (
  { __typename?: 'Mutation' }
  & { updateLocationNote: (
    { __typename?: 'CardNote' }
    & Pick<CardNote, 'id' | 'title' | 'text'>
  ) }
);

export type CreateDeviationMutationVariables = Exact<{
  input: DeviationInput;
}>;


export type CreateDeviationMutation = (
  { __typename?: 'Mutation' }
  & { createDeviation: (
    { __typename?: 'Deviation' }
    & Pick<Deviation, 'id' | 'cause' | 'fault' | 'routeId' | 'note' | 'consequence' | 'actualArrivalTime' | 'createdBy'>
    & { faultLocation?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name' | 'address' | 'postalCode' | 'city' | 'country'>
    )> }
  ) }
);

export type CreateLocationDeviationMutationVariables = Exact<{
  input: Array<LocationDeviationInput> | LocationDeviationInput;
}>;


export type CreateLocationDeviationMutation = (
  { __typename?: 'Mutation' }
  & { createLocationDeviation: Array<(
    { __typename?: 'Deviation' }
    & Pick<Deviation, 'id'>
  )> }
);

export type DeleteDeviationMutationVariables = Exact<{
  id: Scalars['Int'];
  customerId?: Maybe<Scalars['Int']>;
}>;


export type DeleteDeviationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteDeviation'>
);

export type EditDeviationMutationVariables = Exact<{
  input: EditDeviationInput;
}>;


export type EditDeviationMutation = (
  { __typename?: 'Mutation' }
  & { editDeviation: (
    { __typename?: 'Deviation' }
    & Pick<Deviation, 'id' | 'cause' | 'fault' | 'routeId' | 'note' | 'consequence' | 'actualArrivalTime' | 'createdBy'>
    & { faultLocation?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name' | 'address' | 'postalCode' | 'city' | 'country'>
    )> }
  ) }
);

export type EditLocationDeviationMutationVariables = Exact<{
  input: EditLocationDeviationInput;
}>;


export type EditLocationDeviationMutation = (
  { __typename?: 'Mutation' }
  & { editLocationDeviation: (
    { __typename?: 'Deviation' }
    & Pick<Deviation, 'id'>
  ) }
);

export type DeleteAttachmentFileMutationVariables = Exact<{
  input: DeleteAttachmentFileDto;
}>;


export type DeleteAttachmentFileMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAttachmentFile'>
);

export type DeleteDocumentFileMutationVariables = Exact<{
  deleteDocumentFileId: Scalars['Int'];
}>;


export type DeleteDocumentFileMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteDocumentFile'>
);

export type ManageRouteFileMutationVariables = Exact<{
  isAttach: Scalars['Boolean'];
  routeId: Scalars['Int'];
  fileId: Scalars['Int'];
}>;


export type ManageRouteFileMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'manageFileOfRoute'>
);

export type AddManualRoutesGenLogMutationVariables = Exact<{
  input: ManualRoutesGenLogInput;
}>;


export type AddManualRoutesGenLogMutation = (
  { __typename?: 'Mutation' }
  & { addManualRoutesGenLog: (
    { __typename?: 'ManualRoutesGenLog' }
    & Pick<ManualRoutesGenLog, 'id'>
  ) }
);

export type AddFilterConfigMutationVariables = Exact<{
  input: FilterConfig;
}>;


export type AddFilterConfigMutation = (
  { __typename?: 'Mutation' }
  & { addFilterConfiguration: (
    { __typename?: 'GridFilter' }
    & Pick<GridFilter, 'id'>
  ) }
);

export type UpdateGridFilterMutationVariables = Exact<{
  id: Scalars['Int'];
  filterConfiguration: Scalars['JSONObject'];
}>;


export type UpdateGridFilterMutation = (
  { __typename?: 'Mutation' }
  & { updateFilterConfiguration: (
    { __typename?: 'GridFilter' }
    & Pick<GridFilter, 'id'>
  ) }
);

export type DeleteGridFilterMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteGridFilterMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteGridFilter'>
);

export type AddHolidayMutationVariables = Exact<{
  input: CreateHolidayInput;
}>;


export type AddHolidayMutation = (
  { __typename?: 'Mutation' }
  & { addHoliday: (
    { __typename?: 'Holiday' }
    & Pick<Holiday, 'id' | 'date'>
  ) }
);

export type DeleteHolidayMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteHolidayMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteHoliday'>
);

export type DeleteLegMutationVariables = Exact<{
  id: Scalars['Int'];
  routeId: Scalars['Int'];
}>;


export type DeleteLegMutation = (
  { __typename?: 'Mutation' }
  & { deleteLeg: Array<(
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id' | 'load' | 'unload' | 'gateNumber' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'actualCapacity' | 'arrivalTime' | 'actualArrivalTime' | 'actualDepartureTime' | 'actualArrivalDate' | 'actualDepartureDate' | 'departureTime' | 'fuel' | 'note' | 'position' | 'isNonArrivalMarked' | 'nonArrivalMarkedFrom' | 'productionDate' | 'transportationDate' | 'transportationDateOffset' | 'locationId' | 'isNewLegVariant' | 'isLoadingInCar' | 'isLoadingInTrailer'>
    & { location?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'name' | 'type' | 'address' | 'postalCode' | 'city' | 'country'>
    )> }
  )> }
);

export type LinkUnlinkLegWithShipmentMutationVariables = Exact<{
  input: OrderLinkUnlinkInput;
}>;


export type LinkUnlinkLegWithShipmentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'linkOrUnlinkOrderInLeg'>
);

export type TerminalStatusTftUpdateMutationVariables = Exact<{
  truckFillAndTimeInput: TruckFillAndTimeInput;
}>;


export type TerminalStatusTftUpdateMutation = (
  { __typename?: 'Mutation' }
  & { truckFillAndTime: (
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id' | 'actualArrivalDate' | 'actualArrivalTime' | 'actualDepartureDate' | 'actualDepartureTime' | 'actualDockDate' | 'actualDockTime' | 'actualUndockDate' | 'actualUndockTime' | 'terminalStatus' | 'terminalStatusDescription' | 'terminalStatusUpdatedAt' | 'updatedAt' | 'lastUpdatedBy'>
    & { terminalStatusLog?: Maybe<Array<Maybe<(
      { __typename?: 'TerminalStatusLogEntry' }
      & Pick<TerminalStatusLogEntry, 'id' | 'status' | 'timestamp' | 'timeZone' | 'legId' | 'locationId' | 'locationOrder' | 'locationLabel' | 'locationName' | 'createdBy' | 'updatedBy' | 'updatedAt' | 'gate'>
    )>>> }
  ) }
);

export type TruckFillAndTimeMutationVariables = Exact<{
  truckFillAndTimeInput: TruckFillAndTimeInput;
}>;


export type TruckFillAndTimeMutation = (
  { __typename?: 'Mutation' }
  & { truckFillAndTime: (
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id' | 'routeDriverName' | 'loadCar' | 'loadTrailer' | 'loadCarPPL' | 'loadTrailerPPL' | 'unloadCar' | 'unloadTrailer' | 'unloadCarPPL' | 'unloadTrailerPPL' | 'actualDepartureTime' | 'actualDepartureDate' | 'actualArrivalTime' | 'actualArrivalDate' | 'terminalNote' | 'lastUpdatedBy' | 'updatedAt' | 'gateNumber' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'terminalNickname' | 'isNonArrivalMarked' | 'actualCapacity' | 'sealNumber' | 'isSealBroken' | 'productionGroup' | 'arrivalStatus' | 'receivedStatus' | 'receivedBy' | 'timeWhenReceived' | 'kippReceivedBy' | 'kippTimeWhenReceived' | 'terminalResponsible' | 'operator' | 'priority'>
    & { carDetails?: Maybe<(
      { __typename?: 'RouteLegCarTask' }
      & Pick<RouteLegCarTask, 'actualCapacity'>
    )>, trailerDetails?: Maybe<(
      { __typename?: 'RouteLegTrailerTask' }
      & Pick<RouteLegTrailerTask, 'actualCapacity'>
    )>, files: Array<(
      { __typename?: 'DocumentFile' }
      & Pick<DocumentFile, 'id' | 'originalname' | 'mimetype' | 'path' | 'size'>
    )> }
  ) }
);

export type UpdateCarTrailerDetailsMutationVariables = Exact<{
  input: CarTrailerDetailsInput;
}>;


export type UpdateCarTrailerDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateCarTrailerDetails: (
    { __typename?: 'CarTrailerDetailsOutput' }
    & Pick<CarTrailerDetailsOutput, 'success' | 'id' | 'legId' | 'type' | 'registrationNumber' | 'actualCapacity' | 'gateNumber'>
  ) }
);

export type UpdateDriverAndRegistrationDetailsMutationVariables = Exact<{
  input: RouteLegDriverDetailsInput;
}>;


export type UpdateDriverAndRegistrationDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateDriverAndRegistrationDetails: (
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'routeDriverEmail' | 'carRegistrationNumber' | 'trailerRegistrationNumber'>
  ) }
);

export type UpdateDriverAndRegistrationDetailsBatchMutationVariables = Exact<{
  input: RouteLegDriverDetailsBatchInput;
}>;


export type UpdateDriverAndRegistrationDetailsBatchMutation = (
  { __typename?: 'Mutation' }
  & { updateDriverAndRegistrationDetailsBatch: Array<(
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'routeDriverEmail' | 'carRegistrationNumber' | 'trailerRegistrationNumber'>
  )> }
);

export type UpdateLegDetailsMutationVariables = Exact<{
  input: LegDetails;
}>;


export type UpdateLegDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateLegDetails: (
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id' | 'actualArrivalDate' | 'actualArrivalTime' | 'actualCapacity' | 'actualDepartureDate' | 'actualDepartureTime' | 'arrivalTime' | 'carRegistrationNumber' | 'departureTime' | 'distanceInKM' | 'fuel' | 'locationId' | 'note' | 'routeDriverEmail' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'terminalNote' | 'trailerRegistrationNumber' | 'transportationDate' | 'weight' | 'loadCarPPL' | 'loadTrailerPPL' | 'unloadCarPPL' | 'unloadTrailerPPL' | 'assigned' | 'ansvBefraktare' | 'timeWhenAssigned' | 'receivedStatus' | 'receivedBy' | 'timeWhenReceived' | 'kippReceivedBy' | 'kippTimeWhenReceived'>
  ) }
);

export type UpdateLegWithLoadingListMutationVariables = Exact<{
  input: LegLoadingListInput;
}>;


export type UpdateLegWithLoadingListMutation = (
  { __typename?: 'Mutation' }
  & { updateLegWithLoadingList: (
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id'>
    & { loadingListItems: Array<(
      { __typename?: 'LoadingListItem' }
      & Pick<LoadingListItem, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note'>
    )> }
  ) }
);

export type UpdateLegPositionMutationVariables = Exact<{
  input: Array<LegsPositionInput> | LegsPositionInput;
}>;


export type UpdateLegPositionMutation = (
  { __typename?: 'Mutation' }
  & { updateLegPosition: Array<(
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id' | 'load' | 'unload' | 'gateNumber' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'actualCapacity' | 'arrivalTime' | 'actualArrivalTime' | 'actualDepartureTime' | 'actualArrivalDate' | 'actualDepartureDate' | 'departureTime' | 'fuel' | 'note' | 'position' | 'isNonArrivalMarked' | 'nonArrivalMarkedFrom' | 'productionDate' | 'transportationDate' | 'transportationDateOffset' | 'locationId' | 'isNewLegVariant' | 'isLoadingInCar' | 'isLoadingInTrailer'>
    & { location?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'type' | 'name' | 'address' | 'postalCode' | 'city' | 'country'>
    )> }
  )> }
);

export type UpdateTripInfoMutationVariables = Exact<{
  legId: Scalars['Int'];
  updateFor: Scalars['String'];
  tripStatus: Scalars['String'];
  dateTimeStamp: Scalars['String'];
  gateNumber?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  carRegNumber?: Maybe<Scalars['String']>;
  trailerRegNumber?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  containerId?: Maybe<Scalars['String']>;
  items?: Maybe<Scalars['String']>;
  pallets?: Maybe<Scalars['String']>;
  palletPlaces?: Maybe<Scalars['String']>;
}>;


export type UpdateTripInfoMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateTripInfoFromProdApp'>
);

export type AddCustomerMappingDetailsMutationVariables = Exact<{
  input: CustomersMappingInput;
}>;


export type AddCustomerMappingDetailsMutation = (
  { __typename?: 'Mutation' }
  & { addCustomerMappingDetails: Array<(
    { __typename?: 'LoadingListItem' }
    & Pick<LoadingListItem, 'id'>
  )> }
);

export type AddNewLoadingListItemsMutationVariables = Exact<{
  input: LoadingListInput;
}>;


export type AddNewLoadingListItemsMutation = (
  { __typename?: 'Mutation' }
  & { addNewLoadingListItems: (
    { __typename?: 'AddLoadingListOutput' }
    & Pick<AddLoadingListOutput, 'legId' | 'carDetailsId' | 'trailerDetailsId'>
    & { loadingListItems?: Maybe<Array<(
      { __typename?: 'LoadingListItem' }
      & Pick<LoadingListItem, 'id' | 'locationId' | 'packages' | 'pallets' | 'note' | 'checked' | 'palletSpace' | 'weight' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'isImportedFromShipment'>
    )>> }
  ) }
);

export type AddNewVersionShipmentLliMutationVariables = Exact<{
  input: Array<NewVersionShipmentLli> | NewVersionShipmentLli;
}>;


export type AddNewVersionShipmentLliMutation = (
  { __typename?: 'Mutation' }
  & { addNewVersionShipmentLLI: Array<(
    { __typename?: 'LoadingListItem' }
    & Pick<LoadingListItem, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'customsProcedure' | 'customWaybillNo' | 'fromLocationId' | 'toLocationId' | 'shipmentDate' | 'cmrDate' | 'serviceCode' | 'isNewShipmentLLI' | 'createdFrom'>
    & { location?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'name'>
    )>, fromLocation?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'name'>
    )>, toLocation?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'name'>
    )>, tags?: Maybe<Array<(
      { __typename?: 'ShipmentTag' }
      & Pick<ShipmentTag, 'id' | 'title'>
    )>> }
  )> }
);

export type AddShipmentLliMutationVariables = Exact<{
  input: Array<LoadingList> | LoadingList;
  shipmentId: Scalars['Int'];
}>;


export type AddShipmentLliMutation = (
  { __typename?: 'Mutation' }
  & { addShipmentLLI: Array<(
    { __typename?: 'LoadingListItem' }
    & Pick<LoadingListItem, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'serviceCode' | 'customsProcedure' | 'customWaybillNo'>
    & { location?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'name'>
    )> }
  )> }
);

export type DeleteLoadingListItemMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type DeleteLoadingListItemMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteLoadingListItem'>
);

export type UpdateBulkNewShipmentLliMutationVariables = Exact<{
  input: ShipmentOrderBulkUpdateInput;
}>;


export type UpdateBulkNewShipmentLliMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateBulkShipmentLLI'>
);

export type UpdateLoadingListItemsMutationVariables = Exact<{
  input: UpdateLoadingListInput;
}>;


export type UpdateLoadingListItemsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateLoadingListItems'>
);

export type UpdateLoadingListItemMutationVariables = Exact<{
  input: ShipmentLoadingList;
  shipmentId?: Maybe<Scalars['Int']>;
  routeName?: Maybe<Scalars['String']>;
}>;


export type UpdateLoadingListItemMutation = (
  { __typename?: 'Mutation' }
  & { updateLoadingListItem: (
    { __typename?: 'LoadingListItem' }
    & Pick<LoadingListItem, 'id'>
  ) }
);

export type UpdateNewShipmentLliMutationVariables = Exact<{
  input: ShipmentLoadingList;
}>;


export type UpdateNewShipmentLliMutation = (
  { __typename?: 'Mutation' }
  & { updateNewshipmentLLI: (
    { __typename?: 'LoadingListItem' }
    & Pick<LoadingListItem, 'id' | 'locationId' | 'fromLocationId' | 'toLocationId' | 'shipmentDate' | 'cmrDate' | 'isNewShipmentLLI' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'customWaybillNo' | 'customsProcedure' | 'terminalCleared' | 'customCleared' | 'customClearedForImport' | 'isRemainingGoods' | 'note' | 'isImportedFromShipment' | 'isOrderHidden' | 'hiddenBy' | 'templateName' | 'preplannedRoute'>
    & { location?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'name'>
    )>, fromLocation?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'name'>
    )>, toLocation?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'name'>
    )>, routeDetail: (
      { __typename?: 'RouteDetailsInLL' }
      & Pick<RouteDetailsInLl, 'id' | 'routeName'>
    ), tags?: Maybe<Array<(
      { __typename?: 'ShipmentTag' }
      & Pick<ShipmentTag, 'id' | 'title'>
    )>> }
  ) }
);

export type UpdateVolumeDetailsMutationVariables = Exact<{
  input: VolumeColumsInput;
}>;


export type UpdateVolumeDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateVolumeDetails: (
    { __typename?: 'Volume' }
    & Pick<Volume, 'id' | 'bpx' | 'pri03' | 'pri49' | 'upri03' | 'upri49' | 'parti' | 'brev' | 'pru' | 'pip'>
  ) }
);

export type AddEditLocationValueBoxEntryMutationVariables = Exact<{
  boxEntry: EditValueBoxEntry;
}>;


export type AddEditLocationValueBoxEntryMutation = (
  { __typename?: 'Mutation' }
  & { editLocationValueBoxEntry: (
    { __typename?: 'InternalTerminalValueBoxEntries' }
    & Pick<InternalTerminalValueBoxEntries, 'id'>
  ) }
);

export type AddFixedValueBoxesMutationVariables = Exact<{
  locationId: Scalars['Int'];
}>;


export type AddFixedValueBoxesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addFixedValueBoxes'>
);

export type AddLocationGridValueMutationVariables = Exact<{
  gridValue: AddGridValueInput;
}>;


export type AddLocationGridValueMutation = (
  { __typename?: 'Mutation' }
  & { addLocationGridValue: (
    { __typename?: 'InternalTerminalGridEntries' }
    & Pick<InternalTerminalGridEntries, 'id'>
  ) }
);

export type AddLocationMasterGridMutationVariables = Exact<{
  gridData: AddMasterGridDataInput;
}>;


export type AddLocationMasterGridMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addLocationMasterGridBox'>
);

export type AddLocationMasterValueBoxMutationVariables = Exact<{
  boxData: AddMasterValueBoxInput;
}>;


export type AddLocationMasterValueBoxMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addLocationMasterValueBox'>
);

export type AddLocationReportInfoMutationVariables = Exact<{
  input: LocationReportInfoInput;
}>;


export type AddLocationReportInfoMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addLocationReportInfo'>
);

export type DeleteLocationMasterGridMutationVariables = Exact<{
  Id: Scalars['Int'];
}>;


export type DeleteLocationMasterGridMutation = (
  { __typename?: 'Mutation' }
  & { deleteLocationMasterGrid: (
    { __typename?: 'DeleteResult' }
    & Pick<DeleteResult, 'result'>
  ) }
);

export type DeleteLocationMasterValueBoxMutationVariables = Exact<{
  boxId: Scalars['Int'];
}>;


export type DeleteLocationMasterValueBoxMutation = (
  { __typename?: 'Mutation' }
  & { deleteLocationMasterValueBox: (
    { __typename?: 'DeleteResult' }
    & Pick<DeleteResult, 'result'>
  ) }
);

export type DeleteLocationReportInfoMutationVariables = Exact<{
  locationReportInfoId: Scalars['Int'];
}>;


export type DeleteLocationReportInfoMutation = (
  { __typename?: 'Mutation' }
  & { deleteLocationReportInfo: (
    { __typename?: 'DeleteResult' }
    & Pick<DeleteResult, 'result'>
  ) }
);

export type DeleteLocationValueBoxEntryMutationVariables = Exact<{
  entryId: Scalars['Int'];
}>;


export type DeleteLocationValueBoxEntryMutation = (
  { __typename?: 'Mutation' }
  & { deleteLocationValueBoxEntry: (
    { __typename?: 'DeleteResult' }
    & Pick<DeleteResult, 'result'>
  ) }
);

export type EditLocationMasterValueBoxMutationVariables = Exact<{
  boxData: EditMasterValueBoxInput;
}>;


export type EditLocationMasterValueBoxMutation = (
  { __typename?: 'Mutation' }
  & { editLocationMasterValueBox: (
    { __typename?: 'InternalTerminalValueBoxMaster' }
    & Pick<InternalTerminalValueBoxMaster, 'id'>
  ) }
);

export type EditLocationReportInfoMutationVariables = Exact<{
  input: EditLocationReportInfoInput;
}>;


export type EditLocationReportInfoMutation = (
  { __typename?: 'Mutation' }
  & { editLocationReportInfo: (
    { __typename?: 'InternalTerminalReportInfo' }
    & Pick<InternalTerminalReportInfo, 'id'>
  ) }
);

export type EditLocationReportInfoReplyMutationVariables = Exact<{
  input: EditLocationReportInfoReplyInput;
}>;


export type EditLocationReportInfoReplyMutation = (
  { __typename?: 'Mutation' }
  & { editLocationReportInfoReply: (
    { __typename?: 'InternalTerminalReportInfo' }
    & Pick<InternalTerminalReportInfo, 'id'>
  ) }
);

export type CreateLocationTagMutationVariables = Exact<{
  input: CreateLocationTagInput;
}>;


export type CreateLocationTagMutation = (
  { __typename?: 'Mutation' }
  & { createLocationTag: (
    { __typename?: 'LocationTag' }
    & Pick<LocationTag, 'id'>
  ) }
);

export type DeleteLocationTagMutationVariables = Exact<{
  tagId: Scalars['Int'];
}>;


export type DeleteLocationTagMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteLocationTag'>
);

export type ImportLocationMutationVariables = Exact<{
  input: Array<ExcelImportDataInput> | ExcelImportDataInput;
}>;


export type ImportLocationMutation = (
  { __typename?: 'Mutation' }
  & { importLocation: Array<(
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'id' | 'name'>
  )> }
);

export type PromoteLocationMutationVariables = Exact<{
  id: Scalars['Int'];
  isPromoted: Scalars['Boolean'];
}>;


export type PromoteLocationMutation = (
  { __typename?: 'Mutation' }
  & { promoteLocation: (
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'id' | 'isPromoted'>
  ) }
);

export type UpdateLocationMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
  address: Scalars['String'];
  postalCode: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  phLocationId: Scalars['String'];
  locationShortCode: Scalars['String'];
  tagIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  fromLocationId?: Maybe<Scalars['Int']>;
  toLocationId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  isPromoted: Scalars['Boolean'];
}>;


export type UpdateLocationMutation = (
  { __typename?: 'Mutation' }
  & { updateLocation: (
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'id' | 'name' | 'address' | 'postalCode' | 'city' | 'country' | 'type'>
    & { tags?: Maybe<Array<(
      { __typename?: 'LocationTag' }
      & Pick<LocationTag, 'id' | 'title'>
    )>> }
  ) }
);

export type CreateLocationMutationVariables = Exact<{
  name: Scalars['String'];
  address: Scalars['String'];
  postalCode: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  phLocationId: Scalars['String'];
  locationShortCode: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  isPromoted: Scalars['Boolean'];
}>;


export type CreateLocationMutation = (
  { __typename?: 'Mutation' }
  & { createLocation: (
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'id' | 'name' | 'address' | 'postalCode' | 'city' | 'country' | 'type'>
  ) }
);

export type AddLegToRouteMutationVariables = Exact<{
  id: Scalars['Int'];
  input: Array<RouteLegInput> | RouteLegInput;
}>;


export type AddLegToRouteMutation = (
  { __typename?: 'Mutation' }
  & { addLegToRoute: (
    { __typename?: 'Route' }
    & Pick<Route, 'id'>
  ) }
);

export type CreateMultipleSporadicRouteMutationVariables = Exact<{
  input: SporadicRouteInput;
  dates: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateMultipleSporadicRouteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createMultipleSporadicRoute'>
);

export type CreateSporadicRouteMutationVariables = Exact<{
  input: SporadicRouteInput;
  numberOfCopies?: Maybe<Scalars['Int']>;
}>;


export type CreateSporadicRouteMutation = (
  { __typename?: 'Mutation' }
  & { createSporadicRoute: (
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'routeId' | 'isUnplannedRoute'>
    & { legs: Array<(
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'locationId' | 'transportationDate' | 'position' | 'arrivalTime' | 'actualArrivalTime' | 'actualDepartureTime' | 'departureTime'>
    )> }
  ) }
);

export type CreateSporadicRouteV2MutationVariables = Exact<{
  input: SporadicRouteInputV2;
}>;


export type CreateSporadicRouteV2Mutation = (
  { __typename?: 'Mutation' }
  & { createSporadicRouteV2: (
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'routeId'>
  ) }
);

export type CreateSporadicRouteWithoutDispatcherMutationVariables = Exact<{
  input: SporadicRouteInput;
}>;


export type CreateSporadicRouteWithoutDispatcherMutation = (
  { __typename?: 'Mutation' }
  & { createSporadicRouteWithoutDispatcher: (
    { __typename?: 'Route' }
    & Pick<Route, 'id'>
  ) }
);

export type DeleteMultiplePlannedRouteMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type DeleteMultiplePlannedRouteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteMultipleRoute'>
);

export type DeleteSporadicRouteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteSporadicRouteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteRoute'>
);

export type UpdateCostAllocationMutationVariables = Exact<{
  id: Scalars['Int'];
  costAllocation: UpdateCostAllocationInput;
}>;


export type UpdateCostAllocationMutation = (
  { __typename?: 'Mutation' }
  & { updateCostAllocation: (
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'routeId' | 'agreedPrice' | 'currency'>
    & { costAllocation?: Maybe<(
      { __typename?: 'CostAllocation' }
      & Pick<CostAllocation, 'id'>
      & { items: Array<(
        { __typename?: 'CostAllocationItem' }
        & Pick<CostAllocationItem, 'id' | 'departmentId' | 'cost' | 'includedKpi' | 'includedPrice' | 'bringCost' | 'additionalCost' | 'additionalDiscount' | 'type' | 'comment' | 'tags' | 'currency'>
        & { location?: Maybe<(
          { __typename?: 'LocationEntity' }
          & Pick<LocationEntity, 'id' | 'name' | 'type'>
        )> }
      )> }
    )> }
  ) }
);

export type UpdateDriverMutationVariables = Exact<{
  id: Scalars['Int'];
  driverData: DriverInfo;
}>;


export type UpdateDriverMutation = (
  { __typename?: 'Mutation' }
  & { updateDriver: (
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'driverName' | 'driverPhoneNumber' | 'licensePlate'>
  ) }
);

export type UpdateExtraColumnsMutationVariables = Exact<{
  id: Scalars['Int'];
  extraColumnData: ExtraColumnInfo;
}>;


export type UpdateExtraColumnsMutation = (
  { __typename?: 'Mutation' }
  & { updateExtraColumns: (
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'adr' | 'turnummer' | 'togref' | 'bpx' | 'pri03' | 'pri49' | 'upri03' | 'upri49' | 'parti' | 'brev' | 'pru' | 'pip' | 'tom' | 'rutekode' | 'trainNumber' | 'inneholdsbeskrivelse' | 'containerId' | 'transportType' | 'assigned' | 'ansvBefraktare' | 'timeWhenAssigned' | 'receivedByTraffic' | 'nameReceivedByTraffic' | 'timeReceivedByTraffic' | 'lastUpdatedBy'>
  ) }
);

export type UpdateInvoiceMutationVariables = Exact<{
  id: Scalars['Int'];
  invoiceData: InvoiceDataInput;
}>;


export type UpdateInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { updateInvoice: (
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'invoiceNote' | 'invoiceNumber' | 'agreedPrice'>
  ) }
);

export type UpdateLockMutationVariables = Exact<{
  routeId: Scalars['Int'];
  lock: Scalars['Int'];
  reload: Scalars['Int'];
}>;


export type UpdateLockMutation = (
  { __typename?: 'Mutation' }
  & { updateLock: (
    { __typename?: 'RouteLock' }
    & Pick<RouteLock, 'routeId' | 'lockedAt' | 'lockedBy'>
  ) }
);

export type UpdateLockOnBulkRoutesMutationVariables = Exact<{
  routeIds: Array<Scalars['Int']> | Scalars['Int'];
  isLock: Scalars['Boolean'];
  forGroup: Scalars['String'];
}>;


export type UpdateLockOnBulkRoutesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateLockOnBulkRoutes'>
);

export type UpdateMinimalRouteMutationVariables = Exact<{
  input: UpdateMinimalRouteInput;
}>;


export type UpdateMinimalRouteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateMinimalRoutes'>
);

export type UpdateRouteMutationVariables = Exact<{
  routeId: Scalars['Int'];
  input: SporadicRouteInput;
}>;


export type UpdateRouteMutation = (
  { __typename?: 'Mutation' }
  & { updateRoute: (
    { __typename?: 'Route' }
    & Pick<Route, 'agreedPrice' | 'capacity' | 'currency' | 'driverName' | 'driverPhoneNumber' | 'id' | 'invoiceNote' | 'invoiceNumber' | 'licensePlate' | 'note' | 'externalNote' | 'routeId' | 'subcontractorLocationId' | 'transportationDate' | 'type' | 'isCreatedFromTerminal' | 'isCreatedFromPlanned' | 'rutekode' | 'turnummer' | 'routeTag'>
    & { dispatcher?: Maybe<(
      { __typename?: 'CardContact' }
      & Pick<CardContact, 'id' | 'email' | 'name' | 'phoneNumber'>
      & { tags: Array<(
        { __typename?: 'CardContactTag' }
        & Pick<CardContactTag, 'id' | 'title'>
      )> }
    )>, files: Array<(
      { __typename?: 'DocumentFile' }
      & Pick<DocumentFile, 'id' | 'mimetype' | 'originalname' | 'path' | 'size'>
      & { tags: Array<(
        { __typename?: 'DocumentFileTag' }
        & Pick<DocumentFileTag, 'id' | 'title'>
      )> }
    )>, ftl?: Maybe<(
      { __typename?: 'RouteFTL' }
      & Pick<RouteFtl, 'cdc' | 'cmr' | 'currency' | 'customerId' | 'customerNumber' | 'customerReference' | 'id' | 'invoiceNote' | 'price'>
    )>, legs: Array<(
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'gateNumber' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'arrivalTime' | 'departureTime' | 'id' | 'load' | 'note' | 'position' | 'unload' | 'locationId'>
    )> }
  ) }
);

export type UpdateRouteGroupTagMutationVariables = Exact<{
  id: Scalars['Int'];
  routeGroupTag: Scalars['String'];
}>;


export type UpdateRouteGroupTagMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateRouteGroupTag'>
);

export type UpdateRouteLegDataColumnsMutationVariables = Exact<{
  id: Scalars['Int'];
  routeLegData: RouteLegDataColumnInfo;
}>;


export type UpdateRouteLegDataColumnsMutation = (
  { __typename?: 'Mutation' }
  & { updateRouteLegDataColumns: (
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id' | 'carRegistrationNumber' | 'trailerRegistrationNumber'>
  ) }
);

export type UpdateRouteLevelColumnsMutationVariables = Exact<{
  id: Scalars['Int'];
  routeColumnData: RouteLevelInfo;
}>;


export type UpdateRouteLevelColumnsMutation = (
  { __typename?: 'Mutation' }
  & { updateRouteLevelColumns: (
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'routeId' | 'note' | 'externalNote' | 'lastUpdatedBy'>
  ) }
);

export type UpdateRouteV2MutationVariables = Exact<{
  id: Scalars['Int'];
  input: SporadicRouteInputV2;
}>;


export type UpdateRouteV2Mutation = (
  { __typename?: 'Mutation' }
  & { updateRouteV2: (
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'routeId' | 'transportationDate'>
  ) }
);

export type UpdateSporadicRouteMutationVariables = Exact<{
  routeId: Scalars['Int'];
  input: SporadicRouteInput;
}>;


export type UpdateSporadicRouteMutation = (
  { __typename?: 'Mutation' }
  & { updateSporadicRoute: (
    { __typename?: 'Route' }
    & Pick<Route, 'agreedPrice' | 'capacity' | 'currency' | 'driverName' | 'driverPhoneNumber' | 'id' | 'invoiceNote' | 'invoiceNumber' | 'licensePlate' | 'note' | 'externalNote' | 'routeId' | 'subcontractorLocationId' | 'transportationDate' | 'type' | 'isCreatedFromTerminal' | 'isCreatedFromPlanned'>
    & { dispatcher?: Maybe<(
      { __typename?: 'CardContact' }
      & Pick<CardContact, 'id' | 'email' | 'name' | 'phoneNumber'>
      & { tags: Array<(
        { __typename?: 'CardContactTag' }
        & Pick<CardContactTag, 'id' | 'title'>
      )> }
    )>, files: Array<(
      { __typename?: 'DocumentFile' }
      & Pick<DocumentFile, 'id' | 'mimetype' | 'originalname' | 'path' | 'size'>
      & { tags: Array<(
        { __typename?: 'DocumentFileTag' }
        & Pick<DocumentFileTag, 'id' | 'title'>
      )> }
    )>, ftl?: Maybe<(
      { __typename?: 'RouteFTL' }
      & Pick<RouteFtl, 'cdc' | 'cmr' | 'currency' | 'locationId' | 'customerNumber' | 'customerReference' | 'id' | 'invoiceNote' | 'price'>
    )>, legs: Array<(
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'gateNumber' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'arrivalTime' | 'departureTime' | 'id' | 'load' | 'note' | 'position' | 'unload' | 'locationId'>
    )> }
  ) }
);

export type UpdateSporadicRouteV2MutationVariables = Exact<{
  routeId: Scalars['Int'];
  input: SporadicRouteInputV2;
}>;


export type UpdateSporadicRouteV2Mutation = (
  { __typename?: 'Mutation' }
  & { updateSporadicRouteV2: (
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'routeId'>
  ) }
);

export type UpdateSettingMutationVariables = Exact<{
  id: Scalars['Int'];
  input: SettingInput;
}>;


export type UpdateSettingMutation = (
  { __typename?: 'Mutation' }
  & { updateSetting: (
    { __typename?: 'Setting' }
    & Pick<Setting, 'id' | 'version'>
  ) }
);

export type CreateShipmentMutationVariables = Exact<{
  input: CreateShipmentInput;
}>;


export type CreateShipmentMutation = (
  { __typename?: 'Mutation' }
  & { createShipment: (
    { __typename?: 'Shipment' }
    & Pick<Shipment, 'id'>
  ) }
);

export type DeleteShipmentMutationVariables = Exact<{
  id: Scalars['Int'];
  updatedFrom: Scalars['String'];
  shipmentDate: Scalars['String'];
}>;


export type DeleteShipmentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteShipment'>
);

export type GetShipmentQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type GetShipmentQuery = (
  { __typename?: 'Query' }
  & { shipments: Array<(
    { __typename?: 'Shipment' }
    & Pick<Shipment, 'id' | 'name' | 'shipmentDate' | 'createdFrom' | 'updatedFrom' | 'createdBy' | 'lastUpdatedBy' | 'updatedAt' | 'fromLocationId' | 'toLocationId'>
    & { loadingListItems: Array<(
      { __typename?: 'LoadingListItem' }
      & Pick<LoadingListItem, 'weight' | 'customClearedForImport' | 'isRemainingGoods' | 'isVoecCustomer' | 'customCleared' | 'terminalCleared' | 'isImportedFromShipment' | 'packages' | 'pallets' | 'palletSpace'>
    )> }
  )> }
);

export type GetShipmentByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetShipmentByIdQuery = (
  { __typename?: 'Query' }
  & { shipmentById: (
    { __typename?: 'Shipment' }
    & Pick<Shipment, 'id' | 'name' | 'shipmentDate' | 'fromLocationId' | 'toLocationId' | 'lastUpdatedBy' | 'createdFrom' | 'updatedFrom' | 'createdBy'>
    & { loadingListItems: Array<(
      { __typename?: 'LoadingListItem' }
      & Pick<LoadingListItem, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'customVOECId' | 'customInvoiceNo' | 'customMrnNo' | 'customWaybillNo' | 'customCmrNo' | 'customNote' | 'connectedNB' | 'customCleared' | 'customClearedForImport' | 'isRemainingGoods' | 'isVoecCustomer' | 'terminalShipmentNotArrived' | 'terminalCleared' | 'terminalNotCleared' | 'terminalDevPackages' | 'terminalDevPallets' | 'terminalDevPalletSpace' | 'terminalDevWeight' | 'terminalDevInfo' | 'isImportedFromShipment' | 'customsProcedure'>
      & { location?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'name'>
      )>, routeDetail: (
        { __typename?: 'RouteDetailsInLL' }
        & Pick<RouteDetailsInLl, 'id' | 'routeName'>
      ), tags?: Maybe<Array<(
        { __typename?: 'ShipmentTag' }
        & Pick<ShipmentTag, 'id' | 'title'>
      )>> }
    )> }
  ) }
);

export type GetShipmentTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShipmentTemplatesQuery = (
  { __typename?: 'Query' }
  & { shipmentTemplates: Array<(
    { __typename?: 'Shipment' }
    & Pick<Shipment, 'id' | 'name' | 'createdFrom' | 'updatedFrom' | 'createdBy' | 'lastUpdatedBy'>
  )> }
);

export type GetShipmentsByDateQueryVariables = Exact<{
  forDate: Scalars['String'];
  fromLocationId?: Maybe<Scalars['Int']>;
}>;


export type GetShipmentsByDateQuery = (
  { __typename?: 'Query' }
  & { shipmentsByDate: Array<(
    { __typename?: 'Shipment' }
    & Pick<Shipment, 'id' | 'name' | 'shipmentDate' | 'shipmentStatus' | 'fromLocationId' | 'toLocationId' | 'createdBy' | 'lastUpdatedBy' | 'createdFrom' | 'updatedFrom'>
    & { loadingListItems: Array<(
      { __typename?: 'LoadingListItem' }
      & Pick<LoadingListItem, 'id' | 'locationId' | 'checked' | 'isDangerous' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'note' | 'unNumber' | 'isLimitedQty' | 'classification' | 'isImportedFromShipment' | 'customVOECId' | 'customInvoiceNo' | 'customMrnNo' | 'customWaybillNo' | 'customCmrNo' | 'customNote' | 'connectedNB' | 'customCleared' | 'customClearedForImport' | 'isRemainingGoods' | 'isVoecCustomer' | 'terminalShipmentNotArrived' | 'terminalCleared' | 'terminalNotCleared' | 'terminalDevPackages' | 'terminalDevPallets' | 'terminalDevPalletSpace' | 'terminalDevWeight' | 'terminalDevInfo'>
      & { routeDetail: (
        { __typename?: 'RouteDetailsInLL' }
        & Pick<RouteDetailsInLl, 'id' | 'routeName'>
      ), files: Array<(
        { __typename?: 'DocumentFile' }
        & Pick<DocumentFile, 'id' | 'originalname' | 'mimetype' | 'path' | 'size'>
      )> }
    )> }
  )> }
);

export type UpdatePartialShipmentMutationVariables = Exact<{
  input: ShipmentPartialUpdateInput;
}>;


export type UpdatePartialShipmentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updatePartialShipment'>
);

export type EditShipmentMutationVariables = Exact<{
  input: ShipmentEditInput;
  orderListUnchanged?: Maybe<Scalars['Boolean']>;
}>;


export type EditShipmentMutation = (
  { __typename?: 'Mutation' }
  & { updateShipment: (
    { __typename?: 'Shipment' }
    & Pick<Shipment, 'id'>
  ) }
);

export type CreateShipmentTagMutationVariables = Exact<{
  title: Scalars['String'];
}>;


export type CreateShipmentTagMutation = (
  { __typename?: 'Mutation' }
  & { createShipmentTag: (
    { __typename?: 'ShipmentTag' }
    & Pick<ShipmentTag, 'id'>
  ) }
);

export type DeleteShipmentTagMutationVariables = Exact<{
  tagId: Scalars['Int'];
}>;


export type DeleteShipmentTagMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteShipmentTag'>
);

export type AddTagByTypeMutationVariables = Exact<{
  type: Scalars['String'];
  tag: Scalars['String'];
}>;


export type AddTagByTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addTagByType'>
);

export type CreateTourTemplateMutationVariables = Exact<{
  TourTemplateInput: TourTemplateInput;
}>;


export type CreateTourTemplateMutation = (
  { __typename?: 'Mutation' }
  & { createTourTemplate: (
    { __typename?: 'TourTemplate' }
    & Pick<TourTemplate, 'id'>
  ) }
);

export type DeleteTourTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTourTemplateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteTourTemplate'>
);

export type DispatchRouteMutationVariables = Exact<{
  input: FixedTourGenerateInput;
}>;


export type DispatchRouteMutation = (
  { __typename?: 'Mutation' }
  & { generateFixedTour: (
    { __typename?: 'FixedTourGenerateResponse' }
    & Pick<FixedTourGenerateResponse, 'status' | 'createdRouteId' | 'routeType' | 'date'>
  ) }
);

export type UpdateBookmarkMutationVariables = Exact<{
  id: Scalars['Int'];
  bookmark: Scalars['Boolean'];
}>;


export type UpdateBookmarkMutation = (
  { __typename?: 'Mutation' }
  & { updateBookmark: (
    { __typename?: 'UpdateBookMarkResponse' }
    & Pick<UpdateBookMarkResponse, 'id' | 'bookmark'>
  ) }
);

export type UpdateTourTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  input: TourTemplateInput;
}>;


export type UpdateTourTemplateMutation = (
  { __typename?: 'Mutation' }
  & { updateTourTemplate: (
    { __typename?: 'TourTemplate' }
    & Pick<TourTemplate, 'id' | 'name' | 'subcontractorLocationId' | 'dispatcherId' | 'capacity' | 'fuel' | 'price' | 'currency' | 'startDate' | 'endDate' | 'originalStartDate' | 'startExceptionDate' | 'endExceptionDate' | 'exceptionDates' | 'note' | 'driverName' | 'driverPhoneNumber' | 'licensePlate' | 'createdBy' | 'lastUpdatedBy' | 'createdAt' | 'updatedAt' | 'responsiblePerson' | 'groupingTag' | 'isPriceEquallyDivided' | 'sameSubcontractorToAllRoutes' | 'templateType' | 'country' | 'department' | 'isInactive'>
  ) }
);

export type ConnectLocationMutationVariables = Exact<{
  locationId: Scalars['Int'];
}>;


export type ConnectLocationMutation = (
  { __typename?: 'Mutation' }
  & { connectLocation: (
    { __typename?: 'PublicUser' }
    & Pick<PublicUser, 'roles' | 'lastName' | 'fullName' | 'firstName' | 'department' | 'createdAt' | 'id' | 'locationId'>
    & { location?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'name' | 'id'>
    )> }
  ) }
);

export type GetStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatusQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'status'>
);

export type SendManualAlertsOnSporadicRouteCreateQueryVariables = Exact<{
  emails: Scalars['String'];
  route: CreateRouteAlertInput;
}>;


export type SendManualAlertsOnSporadicRouteCreateQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'sendManualAlertsOnSporadicRouteCreate'>
);

export type SendDriverNotificationQueryVariables = Exact<{
  phoneNumber: Scalars['String'];
  message: Scalars['String'];
}>;


export type SendDriverNotificationQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'sendDriverNotification'>
);

export type GetAllLocationsWithSearchQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
}>;


export type GetAllLocationsWithSearchQuery = (
  { __typename?: 'Query' }
  & { allLocationWithSearch: Array<(
    { __typename?: 'LocationEntity' }
    & { contacts?: Maybe<Array<(
      { __typename?: 'CardContact' }
      & Pick<CardContact, 'id' | 'name'>
    )>> }
    & LocationsFieldsFragment
  )> }
);

export type GetLocationsWithContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsWithContactsQuery = (
  { __typename?: 'Query' }
  & { getLocationsWithContacts: Array<(
    { __typename?: 'LocationEntity' }
    & { contacts?: Maybe<Array<(
      { __typename?: 'CardContact' }
      & CardContactFieldsFragment
    )>> }
    & LocationsFieldsFragment
  )> }
);

export type GetContactQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetContactQuery = (
  { __typename?: 'Query' }
  & { locationContact: (
    { __typename?: 'CardContact' }
    & Pick<CardContact, 'id' | 'name' | 'role' | 'email' | 'phoneNumber' | 'note' | 'lastUpdatedBy' | 'createdBy' | 'updatedAt'>
    & { tags: Array<(
      { __typename?: 'CardContactTag' }
      & Pick<CardContactTag, 'id' | 'title'>
    )> }
  ) }
);

export type GetContactsForLocationQueryVariables = Exact<{
  locationId?: Maybe<Scalars['Int']>;
  contactId?: Maybe<Scalars['Int']>;
}>;


export type GetContactsForLocationQuery = (
  { __typename?: 'Query' }
  & { locationContacts: Array<(
    { __typename?: 'CardContact' }
    & Pick<CardContact, 'id' | 'name' | 'phoneNumber' | 'email' | 'note'>
    & { tags: Array<(
      { __typename?: 'CardContactTag' }
      & Pick<CardContactTag, 'title'>
    )> }
  )> }
);

export type GetDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepartmentsQuery = (
  { __typename?: 'Query' }
  & { departments: Array<(
    { __typename?: 'Department' }
    & Pick<Department, 'id' | 'name'>
  )> }
);

export type GetDeviationForEmailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetDeviationForEmailQuery = (
  { __typename?: 'Query' }
  & { deviation: (
    { __typename?: 'Deviation' }
    & Pick<Deviation, 'id' | 'localMessageCustomers' | 'englishMessageCustomers'>
    & { customers: Array<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name'>
      & { contacts?: Maybe<Array<(
        { __typename?: 'CardContact' }
        & Pick<CardContact, 'id' | 'name' | 'email'>
      )>> }
    )>, deviationToCustomer?: Maybe<Array<(
      { __typename?: 'DeviationToCustomer' }
      & Pick<DeviationToCustomer, 'locationId' | 'deviationId' | 'lastEmailSent'>
    )>>, deviationToLocation?: Maybe<Array<(
      { __typename?: 'DeviationToLocation' }
      & Pick<DeviationToLocation, 'reason' | 'deviationId' | 'lastEmailSent'>
      & { location: (
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'id'>
      ) }
    )>> }
  ) }
);

export type GetDeviationToLocationForDeviationIdQueryVariables = Exact<{
  deviationId: Scalars['Int'];
}>;


export type GetDeviationToLocationForDeviationIdQuery = (
  { __typename?: 'Query' }
  & { deviationToLocationForDeviationId: Array<(
    { __typename?: 'DeviationToLocation' }
    & Pick<DeviationToLocation, 'id' | 'deviationId' | 'locationId' | 'lastEmailSent' | 'pallets' | 'locationItemNote' | 'packages' | 'palletSpace' | 'weight' | 'reason' | 'otherReason' | 'newCustomer' | 'isDangerous'>
  )> }
);

export type GetDeviationsQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type GetDeviationsQuery = (
  { __typename?: 'Query' }
  & { deviations: Array<(
    { __typename?: 'Deviation' }
    & Pick<Deviation, 'id' | 'cause' | 'fault' | 'routeId' | 'note' | 'consequence' | 'actualArrivalTime' | 'createdBy'>
    & { route: (
      { __typename?: 'Route' }
      & Pick<Route, 'id' | 'routeId' | 'type' | 'licensePlate' | 'capacity' | 'transportationDate'>
      & { subcontractorLocation?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'id' | 'name' | 'address'>
      )>, legs: Array<(
        { __typename?: 'RouteLeg' }
        & Pick<RouteLeg, 'arrivalTime' | 'position'>
        & { location?: Maybe<(
          { __typename?: 'LocationEntity' }
          & Pick<LocationEntity, 'city' | 'country'>
        )> }
      )> }
    ), faultLocation?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name' | 'address' | 'postalCode' | 'city' | 'country'>
    )> }
  )> }
);

export type GetDeviationsForRouteQueryVariables = Exact<{
  routeId: Scalars['Int'];
}>;


export type GetDeviationsForRouteQuery = (
  { __typename?: 'Query' }
  & { deviationsForRoute: Array<(
    { __typename?: 'Deviation' }
    & Pick<Deviation, 'id' | 'cause' | 'fault' | 'routeId' | 'emailSent' | 'note' | 'consequence' | 'actualArrivalTime' | 'createdBy'>
    & { faultLocation?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name' | 'address' | 'postalCode' | 'city' | 'country'>
    )>, route: (
      { __typename?: 'Route' }
      & { legs: Array<(
        { __typename?: 'RouteLeg' }
        & Pick<RouteLeg, 'arrivalTime'>
      )> }
    ) }
  )> }
);

export type GetLocationDeviationsQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  searchTerm?: Maybe<Scalars['String']>;
  terminalIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetLocationDeviationsQuery = (
  { __typename?: 'Query' }
  & { getLocationDeviations: Array<(
    { __typename?: 'CustomerLevelDeviationResponse' }
    & Pick<CustomerLevelDeviationResponse, 'id' | 'deviationId' | 'routeId' | 'faultLocationId' | 'toLocationId' | 'deviationApplicableDate' | 'routeNameOrFaultLocation' | 'customerId' | 'customerName' | 'pallets' | 'packages' | 'palletSpace' | 'weight' | 'reason' | 'otherReason' | 'newCustomer' | 'locationItemNote' | 'cause' | 'fault' | 'faultLocation' | 'toLocation' | 'fromToToCountry' | 'toCity' | 'customerLocation' | 'type' | 'emailSent' | 'emailSentTimestamp' | 'consequence' | 'actualArrivalTime' | 'createdBy' | 'lastUpdatedBy' | 'isDangerous'>
  )> }
);

export type GetFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilesQuery = (
  { __typename?: 'Query' }
  & { files: Array<(
    { __typename?: 'DocumentFile' }
    & Pick<DocumentFile, 'id' | 'originalname' | 'mimetype' | 'path' | 'size' | 'createdAt' | 'createdBy'>
    & { tags: Array<(
      { __typename?: 'DocumentFileTag' }
      & Pick<DocumentFileTag, 'id' | 'title'>
    )> }
  )> }
);

export type GetFilesForRouteQueryVariables = Exact<{
  routeId: Scalars['Int'];
}>;


export type GetFilesForRouteQuery = (
  { __typename?: 'Query' }
  & { getFilesForRouteId: Array<(
    { __typename?: 'DocumentFile' }
    & Pick<DocumentFile, 'id' | 'originalname' | 'mimetype' | 'path' | 'size' | 'createdAt' | 'createdBy'>
    & { tags: Array<(
      { __typename?: 'DocumentFileTag' }
      & Pick<DocumentFileTag, 'id' | 'title'>
    )> }
  )> }
);

export type GetDocumentFileTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentFileTagsQuery = (
  { __typename?: 'Query' }
  & { documentFileTags: Array<(
    { __typename?: 'DocumentFileTag' }
    & Pick<DocumentFileTag, 'id' | 'title'>
  )> }
);

export type GetFixedTrafficLegsQueryVariables = Exact<{
  terminalId: Scalars['Int'];
}>;


export type GetFixedTrafficLegsQuery = (
  { __typename?: 'Query' }
  & { fixedTrafficLegs: Array<(
    { __typename?: 'FixedTrafficLeg' }
    & Pick<FixedTrafficLeg, 'id' | 'routeId' | 'tourId' | 'capacity' | 'days' | 'arrivalTime' | 'departureTime' | 'departureCity' | 'arrivalCity' | 'load' | 'unload' | 'note' | 'startDate'>
    & { subcontractorLocation: (
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name'>
    ) }
  )> }
);

export type GetPostsForTerminalQueryVariables = Exact<{
  startDate: Scalars['String'];
  locationName?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['Int']>;
}>;


export type GetPostsForTerminalQuery = (
  { __typename?: 'Query' }
  & { getPostsForTerminal?: Maybe<(
    { __typename?: 'TerminalPostsDetail' }
    & Pick<TerminalPostsDetail, 'startDate' | 'locationId' | 'locationName' | 'infoCount' | 'valueBoxCount' | 'gridCount'>
  )> }
);

export type GetPostsFromAllTerminalsQueryVariables = Exact<{
  startDate: Scalars['String'];
}>;


export type GetPostsFromAllTerminalsQuery = (
  { __typename?: 'Query' }
  & { getPostsFromAllTerminals: Array<(
    { __typename?: 'FrontPagePostsAvailability' }
    & Pick<FrontPagePostsAvailability, 'locationId' | 'locationName' | 'hasInfo' | 'hasValueBox' | 'hasGrid'>
  )> }
);

export type GetFiltersByUserIdQueryVariables = Exact<{
  tableName: Scalars['String'];
}>;


export type GetFiltersByUserIdQuery = (
  { __typename?: 'Query' }
  & { getFiltersByUserId: Array<(
    { __typename?: 'GridFilter' }
    & Pick<GridFilter, 'id' | 'tableName' | 'filterName' | 'filterConfiguration'>
  )> }
);

export type GetHolidayForCountryOnDateQueryVariables = Exact<{
  country: Scalars['String'];
  date: Scalars['String'];
}>;


export type GetHolidayForCountryOnDateQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'holidayForCountryOnDate'>
);

export type GetHolidaysQueryVariables = Exact<{
  country: Scalars['String'];
}>;


export type GetHolidaysQuery = (
  { __typename?: 'Query' }
  & { holidays: Array<(
    { __typename?: 'Holiday' }
    & Pick<Holiday, 'id' | 'title' | 'date' | 'endDate' | 'startTime' | 'endTime' | 'country' | 'alternateGenerateDate' | 'isStrictCancel'>
    & { locationDetails: (
      { __typename?: 'LocationDetails' }
      & Pick<LocationDetails, 'id' | 'fullAddress' | 'country'>
    ) }
  )> }
);

export type NewShipmentLoadingListQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  showHiddenOrders: Scalars['Boolean'];
}>;


export type NewShipmentLoadingListQuery = (
  { __typename?: 'Query' }
  & { newShipmentLoadingList: Array<(
    { __typename?: 'LoadingListItem' }
    & ShipmentLoadingListFieldsFragment
  )> }
);

export type NewShipmentLoadingListByIdsQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  showHiddenOrders: Scalars['Boolean'];
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type NewShipmentLoadingListByIdsQuery = (
  { __typename?: 'Query' }
  & { newShipmentLoadingList: Array<(
    { __typename?: 'LoadingListItem' }
    & ShipmentLoadingListFieldsFragment
  )> }
);

export type ShipmentLoadingListFieldsFragment = (
  { __typename?: 'LoadingListItem' }
  & Pick<LoadingListItem, 'id' | 'locationId' | 'fromLocationId' | 'toLocationId' | 'shipmentDate' | 'cmrDate' | 'serviceCode' | 'isNewShipmentLLI' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'customVOECId' | 'customInvoiceNo' | 'customMrnNo' | 'customWaybillNo' | 'customCmrNo' | 'customNote' | 'connectedNB' | 'customCleared' | 'customClearedForImport' | 'isRemainingGoods' | 'isVoecCustomer' | 'terminalShipmentNotArrived' | 'terminalCleared' | 'terminalNotCleared' | 'terminalDevPackages' | 'terminalDevPallets' | 'terminalDevPalletSpace' | 'terminalDevWeight' | 'terminalDevInfo' | 'isImportedFromShipment' | 'customsProcedure' | 'createdFrom' | 'isOrderHidden' | 'hiddenBy' | 'hiddenAt' | 'templateName' | 'preplannedRoute'>
  & { location?: Maybe<(
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'name'>
  )>, fromLocation?: Maybe<(
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'name'>
  )>, toLocation?: Maybe<(
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'name'>
  )>, routeDetail: (
    { __typename?: 'RouteDetailsInLL' }
    & Pick<RouteDetailsInLl, 'id' | 'routeName'>
  ), tags?: Maybe<Array<(
    { __typename?: 'ShipmentTag' }
    & Pick<ShipmentTag, 'id' | 'title'>
  )>>, customer?: Maybe<(
    { __typename?: 'Customers' }
    & Pick<Customers, 'customerId' | 'customerName' | 'partyId'>
  )> }
);

export type GetLocationGridValuesForDateQueryVariables = Exact<{
  locationId: Scalars['Int'];
  valueAddedDate: Scalars['String'];
  gridType: Scalars['String'];
}>;


export type GetLocationGridValuesForDateQuery = (
  { __typename?: 'Query' }
  & { locationGridValues: Array<(
    { __typename?: 'GridValues' }
    & Pick<GridValues, 'id' | 'gridEntryId' | 'gridEntries' | 'valueAddedDate' | 'columnHeaders' | 'rowHeaders' | 'gridName' | 'locationId' | 'isGridDeleted' | 'gridType' | 'isNumberGridWithTotal'>
  )> }
);

export type GetLocationGridValuesForTrafficQueryVariables = Exact<{
  locationId: Scalars['Int'];
  valueAddedDate: Scalars['String'];
  gridType: Scalars['String'];
}>;


export type GetLocationGridValuesForTrafficQuery = (
  { __typename?: 'Query' }
  & { locationGridValuesForTraffic: Array<(
    { __typename?: 'GridValues' }
    & Pick<GridValues, 'id' | 'gridName' | 'gridEntryId' | 'locationId' | 'columnHeaders' | 'rowHeaders' | 'gridEntries' | 'valueAddedDate' | 'location' | 'gridType' | 'isNumberGridWithTotal'>
  )> }
);

export type GetLocationMasterValueBoxQueryVariables = Exact<{
  locationId: Scalars['Int'];
  forTerminal: Scalars['Boolean'];
}>;


export type GetLocationMasterValueBoxQuery = (
  { __typename?: 'Query' }
  & { locationMasterValueBoxes: Array<(
    { __typename?: 'MasterValueBoxResponse' }
    & Pick<MasterValueBoxResponse, 'id' | 'locationId' | 'boxName' | 'frequency' | 'isFixedBox' | 'isYesNoBox' | 'isTimeBox' | 'isAlphaNumeric' | 'isAddedFromTerminal'>
  )> }
);

export type GetLocationReportInfoQueryVariables = Exact<{
  locationId: Scalars['Int'];
  dateForAddInfo: Scalars['String'];
  forTerminal: Scalars['Boolean'];
}>;


export type GetLocationReportInfoQuery = (
  { __typename?: 'Query' }
  & { locationReportInfo: Array<(
    { __typename?: 'LocationReportInfoResponse' }
    & Pick<LocationReportInfoResponse, 'id' | 'locationId' | 'dateForAddInfo' | 'info' | 'infoType' | 'isAddedFromTerminal' | 'replyInfo' | 'replyText'>
    & { files: Array<(
      { __typename?: 'DocumentFile' }
      & Pick<DocumentFile, 'id' | 'originalname' | 'mimetype' | 'path' | 'size'>
    )> }
  )> }
);

export type GetLocationValueBoxForDateQueryVariables = Exact<{
  locationId: Scalars['Int'];
  date: Scalars['String'];
  forTerminal: Scalars['Boolean'];
}>;


export type GetLocationValueBoxForDateQuery = (
  { __typename?: 'Query' }
  & { locationValueBoxesForDay: Array<(
    { __typename?: 'ValueBoxForDayResponse' }
    & Pick<ValueBoxForDayResponse, 'boxId' | 'entryId' | 'boxNameText' | 'boxValue' | 'isReadOnly' | 'isFixedBox' | 'isYesNoBox' | 'isTimeBox' | 'isAlphaNumeric' | 'isAddedFromTerminal'>
  )> }
);

export type GetActiveLocationByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetActiveLocationByIdQuery = (
  { __typename?: 'Query' }
  & { activeLocation: (
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'id' | 'type' | 'name' | 'address' | 'postalCode' | 'city' | 'country' | 'phLocationId' | 'locationShortCode' | 'countryLong' | 'createdAt' | 'updatedAt' | 'lastUpdatedBy' | 'createdBy' | 'locationGroup' | 'latitude' | 'longitude'>
    & { tags?: Maybe<Array<(
      { __typename?: 'LocationTag' }
      & Pick<LocationTag, 'id' | 'title'>
    )>>, customerFromLocation: (
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name'>
    ), customerToLocation: (
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name'>
    ), contacts?: Maybe<Array<(
      { __typename?: 'CardContact' }
      & CardContactFieldsFragment
    )>>, notes?: Maybe<Array<(
      { __typename?: 'CardNote' }
      & Pick<CardNote, 'id' | 'title' | 'text' | 'createdBy' | 'lastUpdatedBy' | 'updatedAt'>
    )>>, files?: Maybe<Array<(
      { __typename?: 'CardFile' }
      & Pick<CardFile, 'id' | 'originalname' | 'mimetype' | 'path' | 'size' | 'createdAt' | 'createdBy'>
    )>> }
  ) }
);

export type GetLocationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetLocationQuery = (
  { __typename?: 'Query' }
  & { location: (
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'id' | 'type' | 'name' | 'address' | 'postalCode' | 'city' | 'country' | 'phLocationId' | 'locationShortCode' | 'countryLong' | 'createdAt' | 'updatedAt' | 'lastUpdatedBy' | 'createdBy' | 'locationGroup' | 'isPromoted' | 'latitude' | 'longitude'>
    & { tags?: Maybe<Array<(
      { __typename?: 'LocationTag' }
      & Pick<LocationTag, 'id' | 'title'>
    )>>, customerFromLocation: (
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name'>
    ), customerToLocation: (
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name'>
    ), contacts?: Maybe<Array<(
      { __typename?: 'CardContact' }
      & CardContactFieldsFragment
    )>>, notes?: Maybe<Array<(
      { __typename?: 'CardNote' }
      & Pick<CardNote, 'id' | 'title' | 'text' | 'createdBy' | 'lastUpdatedBy' | 'updatedAt'>
    )>>, files?: Maybe<Array<(
      { __typename?: 'CardFile' }
      & Pick<CardFile, 'id' | 'originalname' | 'mimetype' | 'path' | 'size' | 'createdAt' | 'createdBy'>
    )>> }
  ) }
);

export type GetLocationByIdListQueryVariables = Exact<{
  idList: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GetLocationByIdListQuery = (
  { __typename?: 'Query' }
  & { locationsByIdList: Array<(
    { __typename?: 'LocationEntity' }
    & LocationsFieldsFragment
  )> }
);

export type GetLocationForSelectQueryVariables = Exact<{
  locationId: Scalars['Int'];
}>;


export type GetLocationForSelectQuery = (
  { __typename?: 'Query' }
  & { location: (
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'id' | 'type' | 'name' | 'address' | 'city' | 'country' | 'postalCode'>
    & { customerFromLocation: (
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name'>
    ), customerToLocation: (
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name'>
    ) }
  ) }
);

export type GetLocationTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationTagsQuery = (
  { __typename?: 'Query' }
  & { locationTags: Array<(
    { __typename?: 'LocationTag' }
    & Pick<LocationTag, 'id' | 'title'>
  )> }
);

export type GetLocationsForLegQueryVariables = Exact<{
  locationsSearch?: Maybe<Scalars['String']>;
  forCountryCode?: Maybe<Scalars['String']>;
}>;


export type GetLocationsForLegQuery = (
  { __typename?: 'Query' }
  & { locations: Array<(
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'id' | 'type' | 'name' | 'address' | 'city' | 'country' | 'postalCode'>
  )> }
);

export type SearchLocationIdAndNameQueryVariables = Exact<{
  locationSearch?: Maybe<Scalars['String']>;
}>;


export type SearchLocationIdAndNameQuery = (
  { __typename?: 'Query' }
  & { locationSearch: Array<(
    { __typename?: 'LocationEntity' }
    & Pick<LocationEntity, 'id' | 'name'>
    & { contacts?: Maybe<Array<(
      { __typename?: 'CardContact' }
      & Pick<CardContact, 'id' | 'name'>
    )>> }
  )> }
);

export type GetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsQuery = (
  { __typename?: 'Query' }
  & { locations: Array<(
    { __typename?: 'LocationEntity' }
    & LocationsFieldsFragment
  )> }
);

export type GetPromotedLocationsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
}>;


export type GetPromotedLocationsQuery = (
  { __typename?: 'Query' }
  & { getPromotedLocations: Array<(
    { __typename?: 'PromotedLocationResponse' }
    & Pick<PromotedLocationResponse, 'id' | 'name' | 'address' | 'postalCode' | 'city' | 'country' | 'isPromoted' | 'latitude' | 'longitude'>
    & { contacts?: Maybe<Array<(
      { __typename?: 'LocationContact' }
      & Pick<LocationContact, 'id' | 'name' | 'email'>
      & { tags?: Maybe<Array<(
        { __typename?: 'LocationContactTag' }
        & Pick<LocationContactTag, 'id' | 'title'>
      )>> }
    )>> }
  )> }
);

export type CheckLegsHaveAnyDangerGoodsQueryVariables = Exact<{
  legIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type CheckLegsHaveAnyDangerGoodsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'checkLegsHaveAnyDangerGoods'>
);

export type GetAllRouteGroupTagsQueryVariables = Exact<{
  transportDate: Scalars['String'];
}>;


export type GetAllRouteGroupTagsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getAllRouteGroupTags'>
);

export type GetCostAllocationsByRouteIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetCostAllocationsByRouteIdQuery = (
  { __typename?: 'Query' }
  & { route: (
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'agreedPrice' | 'currency' | 'routeId'>
    & { costAllocation?: Maybe<(
      { __typename?: 'CostAllocation' }
      & Pick<CostAllocation, 'id'>
      & { items: Array<(
        { __typename?: 'CostAllocationItem' }
        & Pick<CostAllocationItem, 'id' | 'departmentId' | 'cost' | 'includedKpi' | 'includedPrice' | 'bringCost' | 'additionalCost' | 'additionalDiscount' | 'type' | 'comment' | 'currency' | 'tags'>
        & { location?: Maybe<(
          { __typename?: 'LocationEntity' }
          & Pick<LocationEntity, 'id' | 'name' | 'type'>
        )> }
      )> }
    )> }
  ) }
);

export type GetLegsMatchingShipmentQueryVariables = Exact<{
  fromLocationId: Scalars['Int'];
  toLocationId: Scalars['Int'];
  transportDate: Scalars['String'];
  orderId: Scalars['Int'];
}>;


export type GetLegsMatchingShipmentQuery = (
  { __typename?: 'Query' }
  & { fetchLegsMatchingShipment: Array<(
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id' | 'position' | 'arrivalTime' | 'isLoadingInCar' | 'isLoadingInTrailer'>
    & { route: (
      { __typename?: 'Route' }
      & Pick<Route, 'id' | 'routeId' | 'type'>
      & { routeLock?: Maybe<(
        { __typename?: 'RouteLock' }
        & Pick<RouteLock, 'id' | 'lockedAt' | 'lockedBy' | 'lockedByUserId' | 'isChecklistLocked'>
      )> }
    ) }
  )> }
);

export type GetLoadingListQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetLoadingListQuery = (
  { __typename?: 'Query' }
  & { route: (
    { __typename?: 'Route' }
    & { legs: Array<(
      { __typename?: 'RouteLeg' }
      & { loadingListItems: Array<(
        { __typename?: 'LoadingListItem' }
        & Pick<LoadingListItem, 'id' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'unNumber' | 'customWaybillNo'>
      )>, carDetails?: Maybe<(
        { __typename?: 'RouteLegCarTask' }
        & { loadingListItems: Array<(
          { __typename?: 'LoadingListItem' }
          & Pick<LoadingListItem, 'id' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'unNumber' | 'customWaybillNo'>
        )> }
      )>, trailerDetails?: Maybe<(
        { __typename?: 'RouteLegTrailerTask' }
        & { loadingListItems: Array<(
          { __typename?: 'LoadingListItem' }
          & Pick<LoadingListItem, 'id' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'unNumber' | 'customWaybillNo'>
        )> }
      )> }
    )> }
  ) }
);

export type GetMultipleDatesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetMultipleDatesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'multipleDates'>
);

export type GetProductionGroupQueryVariables = Exact<{
  terminalId: Scalars['Int'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type GetProductionGroupQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getProductionGroup'>
);

export type GetRouteQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetRouteQuery = (
  { __typename?: 'Query' }
  & { route: (
    { __typename?: 'Route' }
    & Pick<Route, 'routeAgreementNo' | 'amphoraTripId' | 'agreedPrice' | 'isCreatedFromTerminal' | 'isCreatedFromPlanned' | 'capacity' | 'kilometer' | 'weight' | 'currency' | 'dispatcherId' | 'driverName' | 'driverPhoneNumber' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'routeCarRegNumber' | 'routeTrailerRegNumber' | 'isCopyDriverPlateInfo' | 'lastUpdatedBy' | 'updatedAt' | 'createdBy' | 'deletedAt' | 'deletedBy' | 'rutekode' | 'turnummer' | 'routeTag' | 'id' | 'invoiceNote' | 'invoiceNumber' | 'licensePlate' | 'note' | 'externalNote' | 'routeId' | 'subcontractorLocationId' | 'transportationDate' | 'type'>
    & { files: Array<(
      { __typename?: 'DocumentFile' }
      & Pick<DocumentFile, 'id' | 'mimetype' | 'originalname' | 'path' | 'size' | 'createdBy' | 'createdAt'>
      & { tags: Array<(
        { __typename?: 'DocumentFileTag' }
        & Pick<DocumentFileTag, 'id' | 'title'>
      )> }
    )>, ftl?: Maybe<(
      { __typename?: 'RouteFTL' }
      & Pick<RouteFtl, 'cdc' | 'cmr' | 'currency' | 'locationId' | 'customerNumber' | 'customerReference' | 'id' | 'invoiceNote' | 'price'>
    )>, routeLock?: Maybe<(
      { __typename?: 'RouteLock' }
      & Pick<RouteLock, 'id' | 'routeId' | 'lockedAt' | 'lockedBy' | 'isChecklistLocked'>
    )>, costAllocation?: Maybe<(
      { __typename?: 'CostAllocation' }
      & Pick<CostAllocation, 'id'>
      & { items: Array<(
        { __typename?: 'CostAllocationItem' }
        & Pick<CostAllocationItem, 'id' | 'departmentId' | 'cost' | 'includedKpi' | 'includedPrice' | 'bringCost' | 'additionalCost' | 'additionalDiscount' | 'type' | 'comment' | 'currency' | 'tags'>
        & { location?: Maybe<(
          { __typename?: 'LocationEntity' }
          & Pick<LocationEntity, 'id' | 'name' | 'city' | 'country'>
        )> }
      )> }
    )>, legs: Array<(
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'gateNumber' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'routeDriverEmail' | 'actualCapacity' | 'arrivalTime' | 'actualArrivalTime' | 'actualDepartureTime' | 'actualArrivalDate' | 'actualDepartureDate' | 'departureTime' | 'fuel' | 'id' | 'load' | 'note' | 'position' | 'unload' | 'isNonArrivalMarked' | 'nonArrivalMarkedFrom' | 'productionDate' | 'transportationDate' | 'transportationDateOffset' | 'locationId' | 'isNewLegVariant' | 'isLoadingInCar' | 'isLoadingInTrailer' | 'distanceInKM' | 'subcontractorLocationId' | 'dispatcherId' | 'legTag'>
      & { subcontractorLocation?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'id' | 'name'>
      )>, dispatcher?: Maybe<(
        { __typename?: 'CardContact' }
        & Pick<CardContact, 'id' | 'name' | 'email'>
      )>, location?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'id' | 'type' | 'address' | 'city' | 'country' | 'name' | 'postalCode' | 'deletedBy'>
      )>, carDetails?: Maybe<(
        { __typename?: 'RouteLegCarTask' }
        & Pick<RouteLegCarTask, 'id' | 'operationType' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'tripStartDateTime' | 'tripEndDateTime' | 'tripStatus' | 'estDock' | 'estUndock' | 'containerId'>
        & { loadingListItems: Array<(
          { __typename?: 'LoadingListItem' }
          & Pick<LoadingListItem, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'isImportedFromShipment' | 'customWaybillNo' | 'lastUpdatedBy' | 'createdBy' | 'updatedAt'>
          & { location?: Maybe<(
            { __typename?: 'LocationEntity' }
            & Pick<LocationEntity, 'id' | 'type' | 'name' | 'address' | 'postalCode' | 'city' | 'country'>
          )> }
        )> }
      )>, trailerDetails?: Maybe<(
        { __typename?: 'RouteLegTrailerTask' }
        & Pick<RouteLegTrailerTask, 'id' | 'operationType' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'tripStartDateTime' | 'tripEndDateTime' | 'tripStatus' | 'estDock' | 'estUndock' | 'containerId'>
        & { loadingListItems: Array<(
          { __typename?: 'LoadingListItem' }
          & Pick<LoadingListItem, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'isImportedFromShipment' | 'customWaybillNo' | 'lastUpdatedBy' | 'createdBy' | 'updatedAt'>
          & { location?: Maybe<(
            { __typename?: 'LocationEntity' }
            & Pick<LocationEntity, 'id' | 'type' | 'name' | 'address' | 'postalCode' | 'city' | 'country'>
          )> }
        )> }
      )>, loadingListItems: Array<(
        { __typename?: 'LoadingListItem' }
        & Pick<LoadingListItem, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'isImportedFromShipment' | 'customWaybillNo' | 'lastUpdatedBy' | 'createdBy' | 'updatedAt'>
        & { location?: Maybe<(
          { __typename?: 'LocationEntity' }
          & Pick<LocationEntity, 'id' | 'type' | 'name' | 'address' | 'postalCode' | 'city' | 'country'>
        )> }
      )> }
    )>, routeLegWrappers?: Maybe<Array<(
      { __typename?: 'RouteLegWrapper' }
      & Pick<RouteLegWrapper, 'id' | 'tripId' | 'startStopId' | 'endStopId' | 'driverName' | 'driverPhoneNumber' | 'driverEmail' | 'createdAt' | 'createdBy' | 'updatedAt' | 'updatedBy'>
    )>>, tourRoute?: Maybe<(
      { __typename?: 'TourRouteTemplate' }
      & Pick<TourRouteTemplate, 'id'>
      & { bookmarkTourRouteTemplate?: Maybe<Array<(
        { __typename?: 'BookmarkTourRouteTemplate' }
        & Pick<BookmarkTourRouteTemplate, 'bookmark'>
      )>> }
    )> }
    & TransportAgreementFieldsFragment
  ) }
);

export type GetRouteByIdV2QueryVariables = Exact<{
  routeId: Scalars['Int'];
}>;


export type GetRouteByIdV2Query = (
  { __typename?: 'Query' }
  & { getRouteByIdV2: (
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'amphoraTripId' | 'createdBy' | 'lastUpdatedBy' | 'transportationDate' | 'routeId' | 'subcontractorLocationId' | 'dispatcherId' | 'agreedPrice' | 'currency' | 'note' | 'externalNote' | 'driverName' | 'driverPhoneNumber' | 'licensePlate' | 'rutekode' | 'turnummer' | 'routeTag' | 'isUnplannedRoute'>
    & { costAllocation?: Maybe<(
      { __typename?: 'CostAllocation' }
      & Pick<CostAllocation, 'id'>
      & { items: Array<(
        { __typename?: 'CostAllocationItem' }
        & Pick<CostAllocationItem, 'id' | 'departmentId' | 'type' | 'includedKpi' | 'includedPrice' | 'bringCost' | 'additionalCost' | 'additionalDiscount' | 'cost' | 'comment' | 'tags' | 'currency'>
        & { location?: Maybe<(
          { __typename?: 'LocationEntity' }
          & Pick<LocationEntity, 'id'>
        )> }
      )> }
    )>, legs: Array<(
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'id' | 'locationId' | 'tripStatus' | 'position' | 'load' | 'unload' | 'fuel' | 'arrivalTime' | 'actualArrivalDate' | 'actualDepartureDate' | 'departureTime' | 'productionDate' | 'transportationDate' | 'transportationDateOffset' | 'note' | 'actualDepartureTime' | 'isNonArrivalMarked' | 'isNewLegVariant' | 'subcontractorLocationId' | 'dispatcherId' | 'legTag'>
      & { location?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'id' | 'name' | 'type' | 'address' | 'city' | 'country' | 'postalCode'>
      )>, carDetails?: Maybe<(
        { __typename?: 'RouteLegCarTask' }
        & Pick<RouteLegCarTask, 'id' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'estDock' | 'estUndock' | 'containerId' | 'operationType' | 'tripStatus' | 'note' | 'tripEndDateTime'>
        & { seals: Array<(
          { __typename?: 'SealInfo' }
          & Pick<SealInfo, 'id' | 'type' | 'sealNumber' | 'sealStatus' | 'updatedBy'>
        )>, loadingListItems: Array<(
          { __typename?: 'LoadingListItem' }
          & Pick<LoadingListItem, 'id' | 'locationId' | 'toLocationId' | 'note' | 'checked' | 'isDangerous' | 'classification' | 'customsProcedure' | 'unNumber' | 'isLimitedQty' | 'pallets' | 'packages' | 'palletSpace' | 'weight' | 'customWaybillNo' | 'serviceCode' | 'grossVolumeM3' | 'createdFrom' | 'isSystemGenerated'>
          & { location?: Maybe<(
            { __typename?: 'LocationEntity' }
            & Pick<LocationEntity, 'id'>
          )>, lliEdiAdditionalDetails?: Maybe<(
            { __typename?: 'LliEdiAdditionalDetails' }
            & Pick<LliEdiAdditionalDetails, 'id' | 'consignorName' | 'consignorPickupAddressLine1' | 'consignorPickupAddressLine2' | 'consignorStreet' | 'consignorPostalCode' | 'consignorCity' | 'consignorCountryCode' | 'consignorPhoneNumber' | 'consignorSenderRef' | 'consigneeName' | 'consigneeDeliveryAddressLine1' | 'consigneeDeliveryAddressLine2' | 'consigneeStreet' | 'consigneePostalCode' | 'consigneeCity' | 'consigneeCountryCode' | 'consigneePhoneNumber' | 'consigneeReceiverRef' | 'createdFrom' | 'consignmentUniqueId' | 'deliveryInstructions' | 'apiProvidedFields' | 'lliConsignmentItems'>
          )> }
        )> }
      )>, trailerDetails?: Maybe<(
        { __typename?: 'RouteLegTrailerTask' }
        & Pick<RouteLegTrailerTask, 'id' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'estDock' | 'estUndock' | 'containerId' | 'operationType' | 'tripStatus' | 'note' | 'tripEndDateTime'>
        & { seals: Array<(
          { __typename?: 'SealInfo' }
          & Pick<SealInfo, 'id' | 'type' | 'sealNumber' | 'sealStatus' | 'updatedBy'>
        )>, loadingListItems: Array<(
          { __typename?: 'LoadingListItem' }
          & Pick<LoadingListItem, 'id' | 'locationId' | 'toLocationId' | 'note' | 'checked' | 'isDangerous' | 'classification' | 'customsProcedure' | 'unNumber' | 'isLimitedQty' | 'pallets' | 'packages' | 'palletSpace' | 'weight' | 'customWaybillNo' | 'serviceCode' | 'grossVolumeM3' | 'createdFrom' | 'isSystemGenerated'>
          & { location?: Maybe<(
            { __typename?: 'LocationEntity' }
            & Pick<LocationEntity, 'id'>
          )>, lliEdiAdditionalDetails?: Maybe<(
            { __typename?: 'LliEdiAdditionalDetails' }
            & Pick<LliEdiAdditionalDetails, 'id' | 'consignorName' | 'consignorPickupAddressLine1' | 'consignorPickupAddressLine2' | 'consignorStreet' | 'consignorPostalCode' | 'consignorCity' | 'consignorCountryCode' | 'consignorPhoneNumber' | 'consignorSenderRef' | 'consigneeName' | 'consigneeDeliveryAddressLine1' | 'consigneeDeliveryAddressLine2' | 'consigneeStreet' | 'consigneePostalCode' | 'consigneeCity' | 'consigneeCountryCode' | 'consigneePhoneNumber' | 'consigneeReceiverRef' | 'createdFrom' | 'consignmentUniqueId' | 'deliveryInstructions' | 'apiProvidedFields' | 'lliConsignmentItems'>
          )> }
        )> }
      )> }
    )>, transits?: Maybe<Array<(
      { __typename?: 'Transit' }
      & Pick<Transit, 'id' | 'routeId' | 'fromLegId' | 'toLegId' | 'transitType' | 'distanceKm' | 'durationMin' | 'isBorderCrossing' | 'fuelType' | 'driverName' | 'driverPhoneNumber' | 'driverEmail' | 'subcontractorLocationId' | 'dispatcherId' | 'trainRef' | 'trainNumber'>
    )>>, files: Array<(
      { __typename?: 'DocumentFile' }
      & Pick<DocumentFile, 'id'>
    )> }
  ) }
);

export type GetRouteLegForViewLoadingListQueryVariables = Exact<{
  legId: Scalars['Int'];
}>;


export type GetRouteLegForViewLoadingListQuery = (
  { __typename?: 'Query' }
  & { routeLegForViewLoadingList: Array<(
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id' | 'load' | 'position' | 'locationId' | 'isNewLegVariant' | 'isLoadingInTrailer' | 'isLoadingInCar'>
    & { loadingListItems: Array<(
      { __typename?: 'LoadingListItem' }
      & Pick<LoadingListItem, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'isImportedFromShipment' | 'customWaybillNo'>
      & { lliEdiAdditionalDetails?: Maybe<(
        { __typename?: 'LliEdiAdditionalDetails' }
        & Pick<LliEdiAdditionalDetails, 'consignorName' | 'consignorStreet' | 'consignorPostalCode' | 'consignorCity' | 'consignorCountryCode' | 'consignorPickupAddressLine1' | 'consignorPickupAddressLine2'>
      )> }
    )>, carDetails?: Maybe<(
      { __typename?: 'RouteLegCarTask' }
      & Pick<RouteLegCarTask, 'id' | 'operationType'>
      & { loadingListItems: Array<(
        { __typename?: 'LoadingListItem' }
        & Pick<LoadingListItem, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'isImportedFromShipment' | 'customWaybillNo'>
        & { customer?: Maybe<(
          { __typename?: 'Customers' }
          & Pick<Customers, 'customerName'>
        )>, location?: Maybe<(
          { __typename?: 'LocationEntity' }
          & Pick<LocationEntity, 'name'>
        )>, lliEdiAdditionalDetails?: Maybe<(
          { __typename?: 'LliEdiAdditionalDetails' }
          & Pick<LliEdiAdditionalDetails, 'consignorName' | 'consignorStreet' | 'consignorPostalCode' | 'consignorCity' | 'consignorCountryCode' | 'consignorPickupAddressLine1' | 'consignorPickupAddressLine2'>
        )> }
      )> }
    )>, trailerDetails?: Maybe<(
      { __typename?: 'RouteLegTrailerTask' }
      & Pick<RouteLegTrailerTask, 'id' | 'operationType'>
      & { loadingListItems: Array<(
        { __typename?: 'LoadingListItem' }
        & Pick<LoadingListItem, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'isImportedFromShipment' | 'customWaybillNo'>
        & { customer?: Maybe<(
          { __typename?: 'Customers' }
          & Pick<Customers, 'customerName'>
        )>, lliEdiAdditionalDetails?: Maybe<(
          { __typename?: 'LliEdiAdditionalDetails' }
          & Pick<LliEdiAdditionalDetails, 'consignorName' | 'consignorStreet' | 'consignorPostalCode' | 'consignorCity' | 'consignorCountryCode' | 'consignorPickupAddressLine1' | 'consignorPickupAddressLine2'>
        )> }
      )> }
    )>, route: (
      { __typename?: 'Route' }
      & Pick<Route, 'createdBy' | 'updatedAt' | 'lastUpdatedBy' | 'deletedBy' | 'deletedAt'>
    ) }
  )> }
);

export type GetRouteLegWrappersByRouteIdQueryVariables = Exact<{
  routeId: Scalars['Int'];
}>;


export type GetRouteLegWrappersByRouteIdQuery = (
  { __typename?: 'Query' }
  & { routeLegWrappers: Array<(
    { __typename?: 'RouteLegWrapper' }
    & { startStop: (
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'id' | 'position' | 'arrivalTime' | 'departureTime'>
      & { location?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'id' | 'type' | 'name' | 'city' | 'country'>
      )> }
    ), endStop: (
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'id' | 'position' | 'arrivalTime' | 'departureTime'>
      & { location?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'id' | 'type' | 'name' | 'city' | 'country'>
      )> }
    ) }
    & RouteLegWrapperFieldsFragment
  )> }
);

export type GetRouteLegsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetRouteLegsQuery = (
  { __typename?: 'Query' }
  & { route: (
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'turnummer' | 'rutekode' | 'trainNumber'>
    & { legs: Array<(
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'gateNumber' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'actualCapacity' | 'arrivalTime' | 'actualArrivalTime' | 'actualDepartureTime' | 'actualArrivalDate' | 'actualDepartureDate' | 'departureTime' | 'fuel' | 'id' | 'load' | 'note' | 'position' | 'unload' | 'isNonArrivalMarked' | 'nonArrivalMarkedFrom' | 'productionDate' | 'transportationDate' | 'transportationDateOffset' | 'isNewLegVariant' | 'isLoadingInCar' | 'isLoadingInTrailer' | 'locationId' | 'distanceInKM' | 'weight' | 'receivedStatus' | 'receivedBy' | 'timeWhenReceived' | 'kippReceivedBy' | 'kippTimeWhenReceived' | 'assigned' | 'ansvBefraktare' | 'timeWhenAssigned' | 'tom' | 'routeDriverEmail' | 'lastUpdatedBy' | 'updatedAt'>
      & { location?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'id' | 'type' | 'name' | 'address' | 'city' | 'country' | 'postalCode'>
      )>, carDetails?: Maybe<(
        { __typename?: 'RouteLegCarTask' }
        & Pick<RouteLegCarTask, 'id' | 'operationType' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'tripStartDateTime' | 'tripEndDateTime' | 'togref' | 'containerId'>
        & { loadingListItems: Array<(
          { __typename?: 'LoadingListItem' }
          & Pick<LoadingListItem, 'id'>
          & { volume?: Maybe<(
            { __typename?: 'Volume' }
            & Pick<Volume, 'bpx' | 'pri03' | 'pri49' | 'upri03' | 'upri49' | 'parti' | 'brev' | 'pru' | 'pip'>
          )> }
        )> }
      )>, trailerDetails?: Maybe<(
        { __typename?: 'RouteLegTrailerTask' }
        & Pick<RouteLegTrailerTask, 'id' | 'operationType' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'tripStartDateTime' | 'tripEndDateTime'>
      )> }
    )>, transits?: Maybe<Array<(
      { __typename?: 'Transit' }
      & Pick<Transit, 'id' | 'routeId' | 'fromLegId' | 'toLegId' | 'transitType' | 'distanceKm' | 'durationMin' | 'isBorderCrossing' | 'fuelType' | 'driverName' | 'driverPhoneNumber' | 'driverEmail' | 'subcontractorLocationId' | 'dispatcherId' | 'trainRef' | 'trainNumber'>
    )>> }
  ) }
);

export type GetRouteLegsForProdAppQueryVariables = Exact<{
  unitId: Scalars['String'];
  event: Scalars['String'];
  futureHours: Scalars['Int'];
  cetDateTimeString: Scalars['String'];
  pastHours?: Maybe<Scalars['Int']>;
  gateNumbers?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  tripStatus?: Maybe<Scalars['String']>;
}>;


export type GetRouteLegsForProdAppQuery = (
  { __typename?: 'Query' }
  & { fetchRoutesForProdApp: Array<(
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id' | 'position' | 'transportationDate' | 'arrivalTime' | 'actualArrivalTime' | 'actualArrivalDate' | 'departureTime' | 'actualDepartureTime' | 'actualDepartureDate' | 'routeDriverName' | 'routeDriverEmail' | 'tripStatus' | 'isNewLegVariant' | 'isLoadingInCar' | 'isLoadingInTrailer'>
    & { carDetails?: Maybe<(
      { __typename?: 'RouteLegCarTask' }
      & Pick<RouteLegCarTask, 'id' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'tripStartDateTime' | 'tripEndDateTime' | 'tripStatus'>
    )>, trailerDetails?: Maybe<(
      { __typename?: 'RouteLegTrailerTask' }
      & Pick<RouteLegTrailerTask, 'id' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'tripStartDateTime' | 'tripEndDateTime' | 'tripStatus'>
    )>, route: (
      { __typename?: 'Route' }
      & Pick<Route, 'id' | 'routeId' | 'capacity' | 'kilometer' | 'type' | 'trailerCarrierId' | 'carCarrierId' | 'containerId'>
      & { departureAddress?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'city' | 'country'>
      )>, arrivalAddress?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'city' | 'country'>
      )> }
    ) }
  )> }
);

export type GetRouteLegsForProdAppWithTokenQueryVariables = Exact<{
  unitId: Scalars['String'];
  event: Scalars['String'];
  futureHours: Scalars['Int'];
  cetDateTimeString?: Maybe<Scalars['String']>;
  pastHours?: Maybe<Scalars['Int']>;
  gateNumbers?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  tripStatus?: Maybe<Scalars['String']>;
}>;


export type GetRouteLegsForProdAppWithTokenQuery = (
  { __typename?: 'Query' }
  & { fetchRoutesForProdAppWithToken: Array<(
    { __typename?: 'RouteLeg' }
    & Pick<RouteLeg, 'id' | 'position' | 'transportationDate' | 'arrivalTime' | 'actualArrivalTime' | 'actualArrivalDate' | 'departureTime' | 'actualDepartureTime' | 'actualDepartureDate' | 'routeDriverName' | 'routeDriverEmail' | 'tripStatus' | 'actualCapacity'>
    & { routeDetails: (
      { __typename?: 'RouteObjectForProdApp' }
      & Pick<RouteObjectForProdApp, 'id' | 'routeId' | 'type' | 'trailerCarrierId' | 'carCarrierId' | 'departureCity' | 'departureCountry' | 'arrivalCity' | 'arrivalCountry'>
    ), carDetails?: Maybe<(
      { __typename?: 'RouteLegCarTask' }
      & Pick<RouteLegCarTask, 'id' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'tripStartDateTime' | 'tripEndDateTime' | 'tripStatus'>
    )>, trailerDetails?: Maybe<(
      { __typename?: 'RouteLegTrailerTask' }
      & Pick<RouteLegTrailerTask, 'id' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'tripStartDateTime' | 'tripEndDateTime' | 'tripStatus'>
    )> }
  )> }
);

export type GetRouteLockQueryVariables = Exact<{
  routeId: Scalars['Int'];
}>;


export type GetRouteLockQuery = (
  { __typename?: 'Query' }
  & { routeLock: (
    { __typename?: 'RouteLock' }
    & Pick<RouteLock, 'lockedBy' | 'lockedAt' | 'isChecklistLocked'>
  ) }
);

export type GetTransportAgreementDataQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetTransportAgreementDataQuery = (
  { __typename?: 'Query' }
  & { route: (
    { __typename?: 'Route' }
    & TransportAgreementFieldsFragment
  ) }
);

export type ListAssociatedRoutesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ListAssociatedRoutesQuery = (
  { __typename?: 'Query' }
  & { associatedRoutes: Array<(
    { __typename?: 'AssociatedRoutesResponse' }
    & Pick<AssociatedRoutesResponse, 'id' | 'routeId' | 'routePosition' | 'tourId' | 'routeName' | 'tourName' | 'departureLocation' | 'departureTime' | 'arrivalLocation' | 'arrivalTime' | 'subContractorLocationName' | 'frequency'>
  )> }
);

export type ListRoutesQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type ListRoutesQuery = (
  { __typename?: 'Query' }
  & { routes: Array<(
    { __typename?: 'Route' }
    & Pick<Route, 'id' | 'isCreatedFromTerminal' | 'isCreatedFromPlanned' | 'routeId' | 'amphoraTripId' | 'invoiceNumber' | 'invoiceNote' | 'transportationDate' | 'agreedPrice' | 'currency' | 'driverName' | 'driverPhoneNumber' | 'licensePlate' | 'fuel' | 'capacity' | 'kilometer' | 'weight' | 'note' | 'externalNote'>
    & { dispatcher?: Maybe<(
      { __typename?: 'CardContact' }
      & Pick<CardContact, 'name'>
    )>, subcontractor?: Maybe<(
      { __typename?: 'Card' }
      & Pick<Card, 'name'>
    )>, legs: Array<(
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'isNonArrivalMarked' | 'arrivalTime' | 'departureTime' | 'position'>
      & { location?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'id' | 'type' | 'name' | 'city' | 'country'>
      )> }
    )>, ftl?: Maybe<(
      { __typename?: 'RouteFTL' }
      & Pick<RouteFtl, 'customerNumber' | 'price' | 'currency' | 'invoiceNote' | 'cmr' | 'cdc'>
    )>, tour?: Maybe<(
      { __typename?: 'TourTemplate' }
      & Pick<TourTemplate, 'name'>
    )> }
  )> }
);

export type PingRouteLockUserQueryVariables = Exact<{
  routeId: Scalars['Int'];
}>;


export type PingRouteLockUserQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'pingUser'>
);

export type RefetchRouteLegQueryVariables = Exact<{
  legId: Scalars['Int'];
  locationId: Scalars['Int'];
}>;


export type RefetchRouteLegQuery = (
  { __typename?: 'Query' }
  & { refetchLatestLeg: (
    { __typename?: 'RouteLeg' }
    & LiveUpdateRouteLegFragment
  ) }
);

export type GetClientAppVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientAppVersionQuery = (
  { __typename?: 'Query' }
  & { settings: Array<(
    { __typename?: 'Setting' }
    & Pick<Setting, 'id' | 'version'>
  )> }
);

export type GetShipmentTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShipmentTagsQuery = (
  { __typename?: 'Query' }
  & { getShipmentTags: Array<(
    { __typename?: 'ShipmentTag' }
    & Pick<ShipmentTag, 'id' | 'title'>
  )> }
);

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = (
  { __typename?: 'Query' }
  & { cardContactTags: Array<(
    { __typename?: 'CardContactTag' }
    & Pick<CardContactTag, 'id' | 'title'>
  )> }
);

export type TagsByTypeQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type TagsByTypeQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'tagsByType'>
);

export type BookmarkedDispatchedRoutesQueryVariables = Exact<{
  date?: Maybe<Scalars['String']>;
}>;


export type BookmarkedDispatchedRoutesQuery = (
  { __typename?: 'Query' }
  & { bookmarkedDispatchedRoutes: Array<(
    { __typename?: 'BookMarkItemResponse' }
    & Pick<BookMarkItemResponse, 'id' | 'routeId' | 'tourRouteId' | 'capacity' | 'truckLicencePlateNo' | 'status'>
    & { legs?: Maybe<Array<(
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'id'>
      & { loadingListItems: Array<(
        { __typename?: 'LoadingListItem' }
        & Pick<LoadingListItem, 'id' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'note' | 'checked'>
      )> }
    )>> }
  )> }
);

export type GetOneTourRouteQueryVariables = Exact<{
  routeId: Scalars['Int'];
}>;


export type GetOneTourRouteQuery = (
  { __typename?: 'Query' }
  & { getTourRoute: (
    { __typename?: 'TourRouteTemplate' }
    & Pick<TourRouteTemplate, 'id' | 'routeId' | 'note' | 'externalNote' | 'days' | 'schedule' | 'lc1TotalCapacity' | 'lc2TotalCapacity' | 'lc3TotalCapacity' | 'price' | 'createdAt' | 'updatedAt' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'routeCarRegNumber' | 'routeTrailerRegNumber' | 'isCopyDriverPlateInfo' | 'capacity' | 'kilometer' | 'weight' | 'startDate' | 'originalStartDate' | 'endDate' | 'startExceptionDate' | 'endExceptionDate' | 'exceptionDates' | 'routeDateType' | 'tourRouteType' | 'rutekode' | 'turnummer' | 'trainNumber'>
    & { files: Array<(
      { __typename?: 'DocumentFile' }
      & Pick<DocumentFile, 'originalname' | 'id' | 'path' | 'createdBy' | 'createdAt' | 'mimetype' | 'size'>
      & { tags: Array<(
        { __typename?: 'DocumentFileTag' }
        & Pick<DocumentFileTag, 'id' | 'title' | 'createdAt' | 'updatedAt'>
      )> }
    )>, legs: Array<(
      { __typename?: 'TourRouteLegTemplate' }
      & Pick<TourRouteLegTemplate, 'id' | 'fuel' | 'locationId' | 'gateNumber' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'routeDriverEmail' | 'note' | 'arrivalTime' | 'departureTime' | 'position' | 'load' | 'unload' | 'transportationDateOffset' | 'isNewLegVariant' | 'isLoadingInCar' | 'isLoadingInTrailer'>
      & { location?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'id' | 'type' | 'name' | 'city' | 'country'>
      )>, carDetails?: Maybe<(
        { __typename?: 'TourRouteLegCarTask' }
        & Pick<TourRouteLegCarTask, 'id' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'description'>
        & { loadingListItems: Array<(
          { __typename?: 'TourRouteLegLoadingListItemTemplate' }
          & Pick<TourRouteLegLoadingListItemTemplate, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'lastUpdatedBy' | 'createdBy' | 'updatedAt'>
        )> }
      )>, trailerDetails?: Maybe<(
        { __typename?: 'TourRouteLegTrailerTask' }
        & Pick<TourRouteLegTrailerTask, 'id' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'description'>
        & { loadingListItems: Array<(
          { __typename?: 'TourRouteLegLoadingListItemTemplate' }
          & Pick<TourRouteLegLoadingListItemTemplate, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'lastUpdatedBy' | 'createdBy' | 'updatedAt'>
        )> }
      )>, loadingListItems: Array<(
        { __typename?: 'TourRouteLegLoadingListItemTemplate' }
        & Pick<TourRouteLegLoadingListItemTemplate, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'lastUpdatedBy' | 'createdBy' | 'updatedAt'>
      )> }
    )>, costAllocations: Array<(
      { __typename?: 'TourRouteCostAllocationItem' }
      & Pick<TourRouteCostAllocationItem, 'id' | 'departmentId' | 'cost' | 'includedKpi' | 'includedPrice' | 'bringCost' | 'additionalCost' | 'additionalDiscount' | 'type' | 'comment'>
    )> }
  ) }
);

export type GetTourRouteTemplatesQueryVariables = Exact<{
  fetchBookmarked?: Maybe<Scalars['Boolean']>;
}>;


export type GetTourRouteTemplatesQuery = (
  { __typename?: 'Query' }
  & { tourRouteTemplates: Array<(
    { __typename?: 'TourRouteTemplate' }
    & Pick<TourRouteTemplate, 'id' | 'routeId' | 'price' | 'days' | 'schedule' | 'lc1TotalCapacity' | 'lc2TotalCapacity' | 'lc3TotalCapacity' | 'note' | 'externalNote' | 'position'>
    & { departureLocation?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'type' | 'city' | 'country'>
    )>, arrivalLocation?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'type' | 'city' | 'country'>
    )>, tour: (
      { __typename?: 'TourTemplate' }
      & Pick<TourTemplate, 'id' | 'name' | 'capacity' | 'currency' | 'isInactive' | 'isDateActive' | 'fuel' | 'startDate' | 'endDate' | 'startExceptionDate' | 'endExceptionDate' | 'createdBy' | 'lastUpdatedBy' | 'updatedAt'>
      & { subcontractor?: Maybe<(
        { __typename?: 'Card' }
        & Pick<Card, 'name'>
      )>, dispatcher?: Maybe<(
        { __typename?: 'CardContact' }
        & Pick<CardContact, 'name'>
      )> }
    ), legs: Array<(
      { __typename?: 'TourRouteLegTemplate' }
      & Pick<TourRouteLegTemplate, 'id' | 'locationId' | 'note' | 'arrivalTime' | 'departureTime' | 'position' | 'load' | 'unload' | 'transportationDateOffset'>
      & { location?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'id' | 'type' | 'name' | 'city' | 'country'>
      )>, loadingListItems: Array<(
        { __typename?: 'TourRouteLegLoadingListItemTemplate' }
        & Pick<TourRouteLegLoadingListItemTemplate, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'note' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'lastUpdatedBy' | 'createdBy' | 'updatedAt'>
      )> }
    )> }
  )> }
);

export type CheckRouteDeleteImpactQueryVariables = Exact<{
  tourId: Scalars['Int'];
  routeStartDates: Array<RouteStartDateInput> | RouteStartDateInput;
}>;


export type CheckRouteDeleteImpactQuery = (
  { __typename?: 'Query' }
  & { checkRouteDeleteImpact: (
    { __typename?: 'RouteDeleteImpact' }
    & Pick<RouteDeleteImpact, 'willDeleteCount' | 'dateFrom' | 'dateTo'>
    & { routes: Array<(
      { __typename?: 'RouteDeletePreviewItem' }
      & Pick<RouteDeletePreviewItem, 'id' | 'routeId' | 'transportationDate'>
    )> }
  ) }
);

export type GetDepartmentOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepartmentOptionsQuery = (
  { __typename?: 'Query' }
  & { getDepartmentOptions: Array<(
    { __typename?: 'CountryDepartmentGroup' }
    & Pick<CountryDepartmentGroup, 'country' | 'departments'>
  )> }
);

export type GetGroupingTagQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupingTagQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'tourTemplatesWithGroupTag'>
);

export type GetOtherToursQueryVariables = Exact<{
  excludeId: Scalars['Int'];
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type GetOtherToursQuery = (
  { __typename?: 'Query' }
  & { otherTours: Array<(
    { __typename?: 'TourTemplate' }
    & Pick<TourTemplate, 'id' | 'name' | 'subcontractorLocationId' | 'capacity' | 'fuel' | 'price' | 'currency' | 'startDate' | 'endDate' | 'isInactive' | 'isDateActive' | 'note' | 'createdBy' | 'lastUpdatedBy' | 'updatedAt' | 'startExceptionDate' | 'endExceptionDate'>
    & { subcontractor?: Maybe<(
      { __typename?: 'Card' }
      & Pick<Card, 'name'>
    )> }
  )> }
);

export type GetResponsiblePersonQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResponsiblePersonQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'tourTemplatesWithResponsiblePerson'>
);

export type GetTourTemplateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetTourTemplateQuery = (
  { __typename?: 'Query' }
  & { tourTemplate: (
    { __typename?: 'TourTemplate' }
    & Pick<TourTemplate, 'id' | 'name' | 'tourAgreementNo' | 'subcontractorLocationId' | 'dispatcherId' | 'createdBy' | 'capacity' | 'fuel' | 'price' | 'currency' | 'startDate' | 'endDate' | 'originalStartDate' | 'startExceptionDate' | 'endExceptionDate' | 'exceptionDates' | 'note' | 'driverName' | 'licensePlate' | 'driverPhoneNumber' | 'responsiblePerson' | 'groupingTag' | 'isPriceEquallyDivided' | 'isNewVersion' | 'country' | 'department' | 'templateType' | 'sameSubcontractorToAllRoutes' | 'isInactive' | 'isDateActive' | 'lastUpdatedBy' | 'createdAt' | 'updatedAt'>
    & { subcontractorLocation?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'name'>
    )>, dispatcher?: Maybe<(
      { __typename?: 'CardContact' }
      & Pick<CardContact, 'name'>
    )>, routes: Array<(
      { __typename?: 'TourRouteTemplate' }
      & Pick<TourRouteTemplate, 'id' | 'capacity' | 'kilometer' | 'weight' | 'startDate' | 'originalStartDate' | 'endDate' | 'startExceptionDate' | 'endExceptionDate' | 'exceptionDates' | 'routeDateType' | 'tourRouteType' | 'routeId' | 'routeTag' | 'rutekode' | 'turnummer' | 'trainNumber' | 'note' | 'externalNote' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'routeCarRegNumber' | 'routeTrailerRegNumber' | 'isCopyDriverPlateInfo' | 'days' | 'schedule' | 'lc1TotalCapacity' | 'lc2TotalCapacity' | 'lc3TotalCapacity' | 'price' | 'createdAt' | 'updatedAt'>
      & { files: Array<(
        { __typename?: 'DocumentFile' }
        & Pick<DocumentFile, 'originalname' | 'id' | 'path' | 'createdBy' | 'createdAt' | 'mimetype' | 'size'>
        & { tags: Array<(
          { __typename?: 'DocumentFileTag' }
          & Pick<DocumentFileTag, 'id' | 'title' | 'createdAt' | 'updatedAt'>
        )> }
      )>, transits: Array<(
        { __typename?: 'TourTransitTemplate' }
        & Pick<TourTransitTemplate, 'id' | 'tourRouteId' | 'fromLegId' | 'toLegId' | 'transitType' | 'fuelType' | 'driverName' | 'driverPhoneNumber' | 'driverEmail' | 'subcontractorLocationId' | 'dispatcherId' | 'trainNumber' | 'trainRef' | 'distanceKm' | 'durationMin'>
      )>, legs: Array<(
        { __typename?: 'TourRouteLegTemplate' }
        & Pick<TourRouteLegTemplate, 'id' | 'fuel' | 'locationId' | 'gateNumber' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'routeDriverEmail' | 'subcontractorLocationId' | 'dispatcherId' | 'note' | 'arrivalTime' | 'departureTime' | 'position' | 'load' | 'unload' | 'transportationDateOffset' | 'isNewLegVariant' | 'isLoadingInCar' | 'isLoadingInTrailer' | 'legTags' | 'km' | 'duration'>
        & { dispatcher?: Maybe<(
          { __typename?: 'CardContact' }
          & Pick<CardContact, 'id' | 'name' | 'email'>
        )>, subcontractorLocation?: Maybe<(
          { __typename?: 'LocationEntity' }
          & Pick<LocationEntity, 'id' | 'name'>
        )>, location?: Maybe<(
          { __typename?: 'LocationEntity' }
          & Pick<LocationEntity, 'name' | 'city' | 'country' | 'postalCode' | 'address' | 'deletedBy' | 'type'>
        )>, carDetails?: Maybe<(
          { __typename?: 'TourRouteLegCarTask' }
          & Pick<TourRouteLegCarTask, 'id' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'estDock' | 'estUndock' | 'togRef' | 'trainCompany' | 'containerId' | 'description' | 'operationType' | 'note'>
          & { loadingListItems: Array<(
            { __typename?: 'TourRouteLegLoadingListItemTemplate' }
            & Pick<TourRouteLegLoadingListItemTemplate, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'lastUpdatedBy' | 'createdBy' | 'updatedAt'>
          )> }
        )>, trailerDetails?: Maybe<(
          { __typename?: 'TourRouteLegTrailerTask' }
          & Pick<TourRouteLegTrailerTask, 'id' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'estDock' | 'estUndock' | 'togRef' | 'trainCompany' | 'containerId' | 'description' | 'operationType' | 'note'>
          & { loadingListItems: Array<(
            { __typename?: 'TourRouteLegLoadingListItemTemplate' }
            & Pick<TourRouteLegLoadingListItemTemplate, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'note' | 'lastUpdatedBy' | 'createdBy' | 'updatedAt'>
          )> }
        )>, loadingListItems: Array<(
          { __typename?: 'TourRouteLegLoadingListItemTemplate' }
          & Pick<TourRouteLegLoadingListItemTemplate, 'id' | 'locationId' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'note' | 'checked' | 'isDangerous' | 'classification' | 'unNumber' | 'isLimitedQty' | 'lastUpdatedBy' | 'createdBy' | 'updatedAt'>
        )> }
      )>, costAllocations: Array<(
        { __typename?: 'TourRouteCostAllocationItem' }
        & Pick<TourRouteCostAllocationItem, 'id' | 'departmentId' | 'cost' | 'includedKpi' | 'includedPrice' | 'bringCost' | 'additionalCost' | 'additionalDiscount' | 'type' | 'comment' | 'tags' | 'currency'>
        & { location?: Maybe<(
          { __typename?: 'LocationEntity' }
          & Pick<LocationEntity, 'id' | 'type' | 'name' | 'postalCode' | 'city' | 'country' | 'address'>
        )> }
      )> }
    )> }
  ) }
);

export type GetTourTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTourTemplatesQuery = (
  { __typename?: 'Query' }
  & { tourTemplates: Array<(
    { __typename?: 'TourTemplate' }
    & Pick<TourTemplate, 'id' | 'name' | 'subcontractorLocationId' | 'capacity' | 'fuel' | 'price' | 'currency' | 'startDate' | 'endDate' | 'originalStartDate' | 'isInactive' | 'isDateActive' | 'note' | 'createdBy' | 'lastUpdatedBy' | 'updatedAt' | 'startExceptionDate' | 'endExceptionDate' | 'exceptionDates' | 'responsiblePerson' | 'groupingTag' | 'isPriceEquallyDivided' | 'isNewVersion' | 'country' | 'department' | 'sameSubcontractorToAllRoutes' | 'templateType'>
    & { subcontractor?: Maybe<(
      { __typename?: 'Card' }
      & Pick<Card, 'name'>
    )>, dispatcher?: Maybe<(
      { __typename?: 'CardContact' }
      & Pick<CardContact, 'name'>
    )> }
  )> }
);

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'PublicUser' }
    & Pick<PublicUser, 'id' | 'createdAt' | 'department' | 'firstName' | 'fullName' | 'configuration' | 'trafficAccess' | 'terminalAccess' | 'customsAccess' | 'admin' | 'locationId' | 'lastName' | 'roles'>
    & { location?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name' | 'address' | 'city' | 'country'>
    )> }
  ) }
);

export type GetRouteGridConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRouteGridConfigQuery = (
  { __typename?: 'Query' }
  & { getRouteGridConfig: (
    { __typename?: 'PublicUser' }
    & Pick<PublicUser, 'id' | 'routesConfiguration'>
  ) }
);

export type GetTftConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTftConfigQuery = (
  { __typename?: 'Query' }
  & { getTftConfig: (
    { __typename?: 'PublicUser' }
    & Pick<PublicUser, 'id' | 'tftConfiguration'>
  ) }
);

export type GetTrafficGridsConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrafficGridsConfigQuery = (
  { __typename?: 'Query' }
  & { getTrafficGridsConfig: (
    { __typename?: 'PublicUser' }
    & Pick<PublicUser, 'id' | 'configuration'>
  ) }
);

export type GetUserWithTerminalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserWithTerminalQuery = (
  { __typename?: 'Query' }
  & { getUserLocationData: (
    { __typename?: 'ResponseUserDataWithLocation' }
    & Pick<ResponseUserDataWithLocation, 'locationId' | 'locationName' | 'userFullName'>
  ) }
);

export type UpdateRouteGridConfigMutationVariables = Exact<{
  input: UserConfigurationInput;
}>;


export type UpdateRouteGridConfigMutation = (
  { __typename?: 'Mutation' }
  & { updateRouteGridConfig: (
    { __typename?: 'PublicUser' }
    & Pick<PublicUser, 'id'>
  ) }
);

export type UpdateTftConfigurationMutationVariables = Exact<{
  input: UserConfigurationInput;
}>;


export type UpdateTftConfigurationMutation = (
  { __typename?: 'Mutation' }
  & { updateTftConfiguration: (
    { __typename?: 'PublicUser' }
    & Pick<PublicUser, 'id'>
  ) }
);

export type UpdateTrafficGridsConfigMutationVariables = Exact<{
  input: UserConfigurationInputWithTableName;
}>;


export type UpdateTrafficGridsConfigMutation = (
  { __typename?: 'Mutation' }
  & { updateTrafficGridsConfig: (
    { __typename?: 'PublicUser' }
    & Pick<PublicUser, 'id'>
  ) }
);

export type UpdateUserConfigurationMutationVariables = Exact<{
  input: UserConfigurationInput;
}>;


export type UpdateUserConfigurationMutation = (
  { __typename?: 'Mutation' }
  & { updateConfiguration: (
    { __typename?: 'PublicUser' }
    & Pick<PublicUser, 'id' | 'createdAt' | 'department' | 'firstName' | 'fullName' | 'configuration' | 'lastName' | 'roles' | 'locationId'>
    & { location?: Maybe<(
      { __typename?: 'LocationEntity' }
      & Pick<LocationEntity, 'id' | 'name'>
    )> }
  ) }
);

export type ChecklistResetSubSubscriptionVariables = Exact<{
  ownerUserId: Scalars['String'];
  forGroup: Scalars['String'];
}>;


export type ChecklistResetSubSubscription = (
  { __typename?: 'Subscription' }
  & { checklistReset: (
    { __typename?: 'checklistResetSubscription' }
    & Pick<ChecklistResetSubscription, 'ownerUserId' | 'forGroup'>
  ) }
);

export type LegsListUpdateSubSubscriptionVariables = Exact<{
  legId: Scalars['Int'];
}>;


export type LegsListUpdateSubSubscription = (
  { __typename?: 'Subscription' }
  & { legsListUpdateSub: (
    { __typename?: 'LegsListUpdateSubscription' }
    & Pick<LegsListUpdateSubscription, 'refreshWholeGrid' | 'legId'>
    & { routeLeg: (
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'id' | 'locationId' | 'arrivalTime' | 'departureTime' | 'actualArrivalTime' | 'actualDepartureTime' | 'actualArrivalDate' | 'actualDepartureDate' | 'arrivalStatus' | 'productionDate' | 'transportationDate' | 'actualCapacity' | 'position' | 'load' | 'unload' | 'loadCar' | 'loadTrailer' | 'loadCages' | 'unloadCar' | 'unloadTrailer' | 'unloadCages' | 'loadCarPPL' | 'loadTrailerPPL' | 'unloadCarPPL' | 'unloadTrailerPPL' | 'note' | 'terminalNote' | 'gateNumber' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'terminalNickname' | 'lastUpdatedBy' | 'updatedAt' | 'createdAt' | 'deletedAt' | 'isNonArrivalMarked' | 'nonArrivalMarkedFrom' | 'isSealBroken' | 'sealNumber' | 'productionGroup' | 'priority' | 'isLoadingInCar' | 'isLoadingInTrailer' | 'assigned' | 'ansvBefraktare' | 'timeWhenAssigned' | 'receivedStatus' | 'receivedBy' | 'timeWhenReceived' | 'kippReceivedBy' | 'kippTimeWhenReceived' | 'tom' | 'fuel' | 'routeDriverName' | 'routeDriverPhoneNumber' | 'terminalStatus' | 'terminalStatusDescription' | 'terminalStatusUpdatedAt'>
      & { terminalStatusLog?: Maybe<Array<Maybe<(
        { __typename?: 'TerminalStatusLogEntry' }
        & Pick<TerminalStatusLogEntry, 'id' | 'status' | 'timestamp' | 'timeZone' | 'locationId' | 'legId' | 'locationOrder' | 'locationLabel' | 'locationName' | 'createdBy' | 'updatedBy' | 'updatedAt' | 'gate'>
      )>>>, location?: Maybe<(
        { __typename?: 'LocationEntity' }
        & Pick<LocationEntity, 'id' | 'name' | 'city' | 'country'>
        & { tags?: Maybe<Array<(
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'id' | 'title'>
        )>> }
      )>, files: Array<(
        { __typename?: 'DocumentFile' }
        & Pick<DocumentFile, 'id' | 'size' | 'path' | 'mimetype' | 'originalname'>
      )>, carDetails?: Maybe<(
        { __typename?: 'RouteLegCarTask' }
        & Pick<RouteLegCarTask, 'id' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'togref' | 'containerId'>
        & { loadingListItems: Array<(
          { __typename?: 'LoadingListItem' }
          & Pick<LoadingListItem, 'id'>
          & { volume?: Maybe<(
            { __typename?: 'Volume' }
            & Pick<Volume, 'id' | 'bpx' | 'pri03' | 'pri49' | 'upri03' | 'upri49' | 'parti' | 'brev' | 'pru' | 'pip'>
          )> }
        )> }
      )>, trailerDetails?: Maybe<(
        { __typename?: 'RouteLegTrailerTask' }
        & Pick<RouteLegTrailerTask, 'id' | 'actualCapacity' | 'registrationNumber' | 'gateNumber' | 'togref' | 'containerId'>
      )>, route: (
        { __typename?: 'Route' }
        & Pick<Route, 'id' | 'routeId' | 'type' | 'capacity' | 'trailerCarrierId' | 'carCarrierId' | 'agreedPrice' | 'currency' | 'transportType' | 'trainNumber' | 'containerId' | 'togref' | 'turnummer' | 'rutekode' | 'inneholdsbeskrivelse' | 'adr' | 'transportationDate' | 'driverName' | 'isCreatedFromTerminal' | 'isCreatedFromPlanned'>
        & { subcontractor?: Maybe<(
          { __typename?: 'Card' }
          & Pick<Card, 'id' | 'name'>
        )>, legs: Array<(
          { __typename?: 'RouteLeg' }
          & Pick<RouteLeg, 'position' | 'load' | 'unload'>
          & { location?: Maybe<(
            { __typename?: 'LocationEntity' }
            & Pick<LocationEntity, 'name' | 'city' | 'country'>
          )> }
        )> }
      ) }
    ) }
  ) }
);

export type RouteGridUpdateSubSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RouteGridUpdateSubSubscription = (
  { __typename?: 'Subscription' }
  & { routeGridUpdate: (
    { __typename?: 'RouteGridUpdateSubscriptionPayload' }
    & Pick<RouteGridUpdateSubscriptionPayload, 'routeId' | 'transportationDate' | 'eventType' | 'changedData'>
  ) }
);

export type RouteLockSubSubscriptionVariables = Exact<{
  routeId: Scalars['Int'];
}>;


export type RouteLockSubSubscription = (
  { __typename?: 'Subscription' }
  & { routeLockSub: (
    { __typename?: 'routeLockSubscription' }
    & Pick<RouteLockSubscription, 'lockedBy' | 'lockedAt' | 'lock' | 'routeId' | 'reload'>
  ) }
);

export type RouteLockPingSubSubscriptionVariables = Exact<{
  routeId: Scalars['Int'];
}>;


export type RouteLockPingSubSubscription = (
  { __typename?: 'Subscription' }
  & { routeLockPing: (
    { __typename?: 'routeLockPingSubscription' }
    & Pick<RouteLockPingSubscription, 'lockedByUserId' | 'pingedByUserName' | 'routeId'>
  ) }
);

export type ShipmentAddNexusOrderSubSubscriptionVariables = Exact<{
  isNexusAdd: Scalars['Boolean'];
}>;


export type ShipmentAddNexusOrderSubSubscription = (
  { __typename?: 'Subscription' }
  & { shipmentNexusAddOrderSub: (
    { __typename?: 'ShipmentNexusAddOrderSubscription' }
    & { orders: Array<(
      { __typename?: 'ShipmentUpdateSubscription' }
      & Pick<ShipmentUpdateSubscription, 'id' | 'shipmentDate' | 'cmrDate' | 'note' | 'customsProcedure' | 'pallets' | 'packages' | 'palletSpace' | 'weight' | 'customCleared' | 'terminalCleared' | 'customClearedForImport' | 'isRemainingGoods' | 'customWaybillNo' | 'templateName' | 'preplannedRoute' | 'isImportedFromShipment' | 'locationId' | 'fromLocationId' | 'toLocationId' | 'locationName' | 'fromLocationName' | 'toLocationName'>
    )> }
  ) }
);

export type ShipmentBulkOrderUpdateSubSubscriptionVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ShipmentBulkOrderUpdateSubSubscription = (
  { __typename?: 'Subscription' }
  & { shipmentBulkOrderUpdateSub: (
    { __typename?: 'ShipmentBulkOrderUpdateSubscription' }
    & Pick<ShipmentBulkOrderUpdateSubscription, 'byUserName' | 'userId'>
  ) }
);

export type ShipmentLinkUnlinkSubSubscriptionVariables = Exact<{
  terminalId: Scalars['Int'];
  transDate: Scalars['String'];
}>;


export type ShipmentLinkUnlinkSubSubscription = (
  { __typename?: 'Subscription' }
  & { shipmentLinkUnlinkSub: (
    { __typename?: 'ShipmentLinkUnlinkSubscription' }
    & Pick<ShipmentLinkUnlinkSubscription, 'terminalId' | 'transDate' | 'isLink' | 'routeId'>
  ) }
);

export type ShipmentListUpdateSubSubscriptionVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type ShipmentListUpdateSubSubscription = (
  { __typename?: 'Subscription' }
  & { shipmentListUpdateSub: (
    { __typename?: 'ShipmentListUpdateSubscription' }
    & Pick<ShipmentListUpdateSubscription, 'shipmentDate'>
  ) }
);

export type ShipmentOrderDeleteSubSubscriptionVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type ShipmentOrderDeleteSubSubscription = (
  { __typename?: 'Subscription' }
  & { shipmentOrderDeleteSub: (
    { __typename?: 'ShipmentOrderDeleteSubscription' }
    & Pick<ShipmentOrderDeleteSubscription, 'loadingListItemId' | 'orderShipmentDate'>
  ) }
);

export type ShipmentPartialUpdateSubSubscriptionVariables = Exact<{
  shipmentId: Scalars['Int'];
  userId: Scalars['String'];
}>;


export type ShipmentPartialUpdateSubSubscription = (
  { __typename?: 'Subscription' }
  & { shipmentPartialUpdateSub: (
    { __typename?: 'ShipmentPartialUpdateSubscription' }
    & Pick<ShipmentPartialUpdateSubscription, 'shipmentId' | 'orderId' | 'forFieldName' | 'forFieldValue' | 'userId'>
    & { loadingListItems?: Maybe<Array<(
      { __typename?: 'ShipLoadingListSubType' }
      & Pick<ShipLoadingListSubType, 'id' | 'locationId' | 'note' | 'customsProcedure' | 'packages' | 'pallets' | 'palletSpace' | 'weight' | 'customCleared' | 'terminalCleared' | 'customClearedForImport' | 'isRemainingGoods' | 'customWaybillNo' | 'locationName' | 'isImportedFromShipment' | 'linkedRouteName' | 'createdFrom'>
    )>> }
  ) }
);

export type ShipmentOrderUpdateSubSubscriptionVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type ShipmentOrderUpdateSubSubscription = (
  { __typename?: 'Subscription' }
  & { shipmentOrderUpdateSub: (
    { __typename?: 'ShipmentUpdateSubscription' }
    & Pick<ShipmentUpdateSubscription, 'id' | 'isOrderHidden' | 'hiddenBy' | 'shipmentDate' | 'cmrDate' | 'note' | 'customsProcedure' | 'pallets' | 'packages' | 'palletSpace' | 'weight' | 'customCleared' | 'terminalCleared' | 'customClearedForImport' | 'isRemainingGoods' | 'customWaybillNo' | 'templateName' | 'preplannedRoute' | 'isImportedFromShipment' | 'locationId' | 'fromLocationId' | 'toLocationId' | 'locationName' | 'fromLocationName' | 'toLocationName'>
  ) }
);

export type TemplateRouteUpdateSubSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TemplateRouteUpdateSubSubscription = (
  { __typename?: 'Subscription' }
  & { templateRouteUpdate: (
    { __typename?: 'TemplateRouteUpdateSubscriptionPayload' }
    & Pick<TemplateRouteUpdateSubscriptionPayload, 'eventType' | 'userId'>
  ) }
);

export type TerminalStatusTruckFillAndTimeUpdateSubscriptionVariables = Exact<{
  locationId: Scalars['Int'];
}>;


export type TerminalStatusTruckFillAndTimeUpdateSubscription = (
  { __typename?: 'Subscription' }
  & { truckFillAndTimeUpdate: (
    { __typename?: 'TruckFillAndTimeSubscription' }
    & Pick<TruckFillAndTimeSubscription, 'refreshWholeGrid' | 'locationId' | 'updateType'>
    & { routeLeg: (
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'id' | 'actualArrivalTime' | 'actualArrivalDate' | 'actualDepartureTime' | 'actualDepartureDate' | 'actualDockTime' | 'actualDockDate' | 'actualUndockTime' | 'actualUndockDate' | 'loadCar' | 'loadCarPPL' | 'loadTrailer' | 'loadTrailerPPL' | 'loadCages' | 'actualCapacity' | 'gateNumber' | 'carRegistrationNumber' | 'trailerRegistrationNumber' | 'unloadCar' | 'unloadCarPPL' | 'unloadTrailer' | 'unloadTrailerPPL' | 'unloadCages' | 'isNonArrivalMarked' | 'isSealBroken' | 'sealNumber' | 'terminalNickname' | 'terminalNote' | 'productionGroup' | 'terminalResponsible' | 'operator' | 'arrivalStatus' | 'note' | 'priority' | 'updatedAt' | 'lastUpdatedBy' | 'receivedStatus' | 'receivedBy' | 'timeWhenReceived' | 'kippReceivedBy' | 'kippTimeWhenReceived' | 'assigned' | 'ansvBefraktare' | 'timeWhenAssigned' | 'routeDriverName' | 'tom' | 'terminalStatus' | 'terminalStatusDescription' | 'terminalStatusUpdatedAt'>
      & { files: Array<(
        { __typename?: 'DocumentFile' }
        & Pick<DocumentFile, 'id' | 'originalname' | 'mimetype' | 'path' | 'size'>
      )>, terminalStatusLog?: Maybe<Array<Maybe<(
        { __typename?: 'TerminalStatusLogEntry' }
        & Pick<TerminalStatusLogEntry, 'id' | 'status' | 'timestamp' | 'timeZone' | 'locationId' | 'legId' | 'locationOrder' | 'locationLabel' | 'locationName' | 'createdBy' | 'updatedBy' | 'updatedAt' | 'gate'>
      )>>>, carDetails?: Maybe<(
        { __typename?: 'RouteLegCarTask' }
        & Pick<RouteLegCarTask, 'actualCapacity' | 'gateNumber' | 'registrationNumber' | 'togref' | 'containerId'>
        & { loadingListItems: Array<(
          { __typename?: 'LoadingListItem' }
          & { volume?: Maybe<(
            { __typename?: 'Volume' }
            & Pick<Volume, 'id' | 'bpx' | 'pri03' | 'pri49' | 'upri03' | 'upri49' | 'parti' | 'brev' | 'pru' | 'pip'>
          )> }
        )> }
      )>, trailerDetails?: Maybe<(
        { __typename?: 'RouteLegTrailerTask' }
        & Pick<RouteLegTrailerTask, 'actualCapacity' | 'gateNumber' | 'registrationNumber'>
      )>, route: (
        { __typename?: 'Route' }
        & Pick<Route, 'id' | 'rutekode' | 'turnummer' | 'trainNumber' | 'adr' | 'inneholdsbeskrivelse'>
      ) }
    ) }
  ) }
);

export type TruckFillAndTimeUpdateSubscriptionVariables = Exact<{
  locationId: Scalars['Int'];
}>;


export type TruckFillAndTimeUpdateSubscription = (
  { __typename?: 'Subscription' }
  & { truckFillAndTimeUpdate: (
    { __typename?: 'TruckFillAndTimeSubscription' }
    & Pick<TruckFillAndTimeSubscription, 'refreshWholeGrid' | 'locationId' | 'updateType'>
    & { routeLeg: (
      { __typename?: 'RouteLeg' }
      & Pick<RouteLeg, 'operator'>
      & { route: (
        { __typename?: 'Route' }
        & Pick<Route, 'id' | 'rutekode' | 'turnummer' | 'trainNumber' | 'adr' | 'inneholdsbeskrivelse'>
      ), carDetails?: Maybe<(
        { __typename?: 'RouteLegCarTask' }
        & Pick<RouteLegCarTask, 'actualCapacity' | 'gateNumber' | 'registrationNumber' | 'togref' | 'containerId'>
        & { loadingListItems: Array<(
          { __typename?: 'LoadingListItem' }
          & { volume?: Maybe<(
            { __typename?: 'Volume' }
            & Pick<Volume, 'id' | 'bpx' | 'pri03' | 'pri49' | 'upri03' | 'upri49' | 'parti' | 'brev' | 'pru' | 'pip'>
          )> }
        )> }
      )>, trailerDetails?: Maybe<(
        { __typename?: 'RouteLegTrailerTask' }
        & Pick<RouteLegTrailerTask, 'actualCapacity' | 'gateNumber' | 'registrationNumber'>
      )> }
      & LiveUpdateRouteLegFragment
    ) }
  ) }
);

export const CardContactFieldsFragmentDoc = gql`
    fragment CardContactFields on CardContact {
  id
  name
  role
  email
  phoneNumber
  tags {
    id
    title
  }
  note
  lastUpdatedBy
  createdBy
}
    `;
export const LiveUpdateRouteLegFragmentDoc = gql`
    fragment LiveUpdateRouteLeg on RouteLeg {
  id
  fuel
  arrivalTime
  actualArrivalDate
  departureTime
  actualDepartureDate
  load
  unload
  loadCar
  loadCarPPL
  loadCages
  loadTrailer
  loadTrailerPPL
  unloadCar
  unloadCarPPL
  unloadCages
  unloadTrailer
  unloadTrailerPPL
  actualDepartureTime
  actualArrivalTime
  terminalNote
  isNonArrivalMarked
  actualCapacity
  lastUpdatedBy
  updatedAt
  transportationDate
  productionDate
  gateNumber
  carRegistrationNumber
  trailerRegistrationNumber
  routeDriverName
  routeDriverPhoneNumber
  routeDriverEmail
  isSealBroken
  sealNumber
  terminalNickname
  productionGroup
  note
  arrivalStatus
  tom
  assigned
  ansvBefraktare
  timeWhenAssigned
  receivedStatus
  receivedBy
  timeWhenReceived
  kippReceivedBy
  kippTimeWhenReceived
  files {
    id
    originalname
    mimetype
    path
    size
  }
  terminalResponsible
  operator
  priority
}
    `;
export const LocationsFieldsFragmentDoc = gql`
    fragment LocationsFields on LocationEntity {
  id
  type
  name
  address
  postalCode
  city
  country
  phLocationId
  locationShortCode
  countryLong @client
  createdAt
  updatedAt
  lastUpdatedBy
  createdBy
  locationGroup
  isPromoted
  tags {
    id
    title
  }
  fromLocation {
    id
    name
  }
  toLocation {
    id
    name
  }
}
    `;
export const RouteLegWrapperFieldsFragmentDoc = gql`
    fragment RouteLegWrapperFields on RouteLegWrapper {
  id
  tripId
  startStopId
  endStopId
  driverName
  driverPhoneNumber
  driverEmail
  createdAt
  createdBy
  updatedAt
  updatedBy
  deletedAt
  deletedBy
}
    `;
export const TransportAgreementFieldsFragmentDoc = gql`
    fragment TransportAgreementFields on Route {
  id
  routeId
  transportationDate
  capacity
  kilometer
  weight
  currency
  agreedPrice
  note
  createdBy
  subcontractorLocation {
    name
    address
  }
  licensePlate
  dispatcher {
    name
  }
  files {
    path
  }
  costAllocation {
    id
    items {
      id
      departmentId
      cost
      includedKpi
      includedPrice
      bringCost
      additionalCost
      additionalDiscount
      type
      comment
      currency
    }
  }
  legs {
    arrivalTime
    departureTime
    transportationDate
    transportationDateOffset
    carRegistrationNumber
    trailerRegistrationNumber
    fuel
    note
    position
    location {
      name
      type
      address
      country
      postalCode
      city
      deletedBy
      tags {
        id
        title
      }
    }
  }
}
    `;
export const ShipmentLoadingListFieldsFragmentDoc = gql`
    fragment ShipmentLoadingListFields on LoadingListItem {
  id
  locationId
  location {
    name
  }
  fromLocationId
  toLocationId
  fromLocation {
    name
  }
  toLocation {
    name
  }
  shipmentDate
  cmrDate
  serviceCode
  isNewShipmentLLI
  packages
  pallets
  palletSpace
  weight
  checked
  isDangerous
  classification
  unNumber
  isLimitedQty
  note
  customVOECId
  customInvoiceNo
  customMrnNo
  customWaybillNo
  customCmrNo
  customNote
  connectedNB
  customCleared
  customClearedForImport
  isRemainingGoods
  isVoecCustomer
  terminalShipmentNotArrived
  terminalCleared
  terminalNotCleared
  terminalDevPackages
  terminalDevPallets
  terminalDevPalletSpace
  terminalDevWeight
  terminalDevInfo
  isImportedFromShipment
  customsProcedure
  createdFrom
  isOrderHidden
  hiddenBy
  hiddenAt
  templateName
  preplannedRoute
  routeDetail {
    id
    routeName
  }
  tags {
    id
    title
  }
  customer {
    customerId
    customerName
    partyId
  }
}
    `;
export const CreateLocationContactDocument = gql`
    mutation CreateLocationContact($locationId: Int!, $input: CreateCardContactInput!) {
  createLocationContact(locationId: $locationId, input: $input) {
    id
    name
    email
    phoneNumber
    tags {
      id
      title
    }
    updatedAt
    createdAt
    note
    lastUpdatedBy
    createdBy
  }
}
    `;
export type CreateLocationContactMutationFn = Apollo.MutationFunction<CreateLocationContactMutation, CreateLocationContactMutationVariables>;

/**
 * __useCreateLocationContactMutation__
 *
 * To run a mutation, you first call `useCreateLocationContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationContactMutation, { data, loading, error }] = useCreateLocationContactMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationContactMutation, CreateLocationContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationContactMutation, CreateLocationContactMutationVariables>(CreateLocationContactDocument, options);
      }
export type CreateLocationContactMutationHookResult = ReturnType<typeof useCreateLocationContactMutation>;
export type CreateLocationContactMutationResult = Apollo.MutationResult<CreateLocationContactMutation>;
export type CreateLocationContactMutationOptions = Apollo.BaseMutationOptions<CreateLocationContactMutation, CreateLocationContactMutationVariables>;
export const DeleteLocationContactDocument = gql`
    mutation DeleteLocationContact($id: Int!) {
  deleteLocationContact(id: $id)
}
    `;
export type DeleteLocationContactMutationFn = Apollo.MutationFunction<DeleteLocationContactMutation, DeleteLocationContactMutationVariables>;

/**
 * __useDeleteLocationContactMutation__
 *
 * To run a mutation, you first call `useDeleteLocationContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationContactMutation, { data, loading, error }] = useDeleteLocationContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationContactMutation, DeleteLocationContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationContactMutation, DeleteLocationContactMutationVariables>(DeleteLocationContactDocument, options);
      }
export type DeleteLocationContactMutationHookResult = ReturnType<typeof useDeleteLocationContactMutation>;
export type DeleteLocationContactMutationResult = Apollo.MutationResult<DeleteLocationContactMutation>;
export type DeleteLocationContactMutationOptions = Apollo.BaseMutationOptions<DeleteLocationContactMutation, DeleteLocationContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation UpdateContact($input: UpdateCardContactInput!) {
  updateLocationContact(input: $input) {
    id
    name
    email
    phoneNumber
    tags {
      id
      title
    }
    note
    lastUpdatedBy
  }
}
    `;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const CreateContactTagDocument = gql`
    mutation CreateContactTag($input: CreateCardContactTagInput!) {
  createContactTag(input: $input) {
    id
  }
}
    `;
export type CreateContactTagMutationFn = Apollo.MutationFunction<CreateContactTagMutation, CreateContactTagMutationVariables>;

/**
 * __useCreateContactTagMutation__
 *
 * To run a mutation, you first call `useCreateContactTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactTagMutation, { data, loading, error }] = useCreateContactTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactTagMutation, CreateContactTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactTagMutation, CreateContactTagMutationVariables>(CreateContactTagDocument, options);
      }
export type CreateContactTagMutationHookResult = ReturnType<typeof useCreateContactTagMutation>;
export type CreateContactTagMutationResult = Apollo.MutationResult<CreateContactTagMutation>;
export type CreateContactTagMutationOptions = Apollo.BaseMutationOptions<CreateContactTagMutation, CreateContactTagMutationVariables>;
export const DeleteContactTagDocument = gql`
    mutation DeleteContactTag($tagId: Int!) {
  deleteContactTag(tagId: $tagId)
}
    `;
export type DeleteContactTagMutationFn = Apollo.MutationFunction<DeleteContactTagMutation, DeleteContactTagMutationVariables>;

/**
 * __useDeleteContactTagMutation__
 *
 * To run a mutation, you first call `useDeleteContactTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactTagMutation, { data, loading, error }] = useDeleteContactTagMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useDeleteContactTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactTagMutation, DeleteContactTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactTagMutation, DeleteContactTagMutationVariables>(DeleteContactTagDocument, options);
      }
export type DeleteContactTagMutationHookResult = ReturnType<typeof useDeleteContactTagMutation>;
export type DeleteContactTagMutationResult = Apollo.MutationResult<DeleteContactTagMutation>;
export type DeleteContactTagMutationOptions = Apollo.BaseMutationOptions<DeleteContactTagMutation, DeleteContactTagMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($id: Int!) {
  deleteLocation(id: $id)
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const DeleteLocationFileDocument = gql`
    mutation DeleteLocationFile($id: Int!) {
  deleteLocationFile(id: $id)
}
    `;
export type DeleteLocationFileMutationFn = Apollo.MutationFunction<DeleteLocationFileMutation, DeleteLocationFileMutationVariables>;

/**
 * __useDeleteLocationFileMutation__
 *
 * To run a mutation, you first call `useDeleteLocationFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationFileMutation, { data, loading, error }] = useDeleteLocationFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationFileMutation, DeleteLocationFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationFileMutation, DeleteLocationFileMutationVariables>(DeleteLocationFileDocument, options);
      }
export type DeleteLocationFileMutationHookResult = ReturnType<typeof useDeleteLocationFileMutation>;
export type DeleteLocationFileMutationResult = Apollo.MutationResult<DeleteLocationFileMutation>;
export type DeleteLocationFileMutationOptions = Apollo.BaseMutationOptions<DeleteLocationFileMutation, DeleteLocationFileMutationVariables>;
export const AddLocationNoteDocument = gql`
    mutation AddLocationNote($cardId: Int!, $input: CreateNoteInput!) {
  addLocationNote(id: $cardId, input: $input) {
    id
    notes {
      id
      title
      text
    }
  }
}
    `;
export type AddLocationNoteMutationFn = Apollo.MutationFunction<AddLocationNoteMutation, AddLocationNoteMutationVariables>;

/**
 * __useAddLocationNoteMutation__
 *
 * To run a mutation, you first call `useAddLocationNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocationNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocationNoteMutation, { data, loading, error }] = useAddLocationNoteMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLocationNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddLocationNoteMutation, AddLocationNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLocationNoteMutation, AddLocationNoteMutationVariables>(AddLocationNoteDocument, options);
      }
export type AddLocationNoteMutationHookResult = ReturnType<typeof useAddLocationNoteMutation>;
export type AddLocationNoteMutationResult = Apollo.MutationResult<AddLocationNoteMutation>;
export type AddLocationNoteMutationOptions = Apollo.BaseMutationOptions<AddLocationNoteMutation, AddLocationNoteMutationVariables>;
export const DeleteLocationNoteDocument = gql`
    mutation DeleteLocationNote($id: Int!) {
  deleteLocationNote(id: $id)
}
    `;
export type DeleteLocationNoteMutationFn = Apollo.MutationFunction<DeleteLocationNoteMutation, DeleteLocationNoteMutationVariables>;

/**
 * __useDeleteLocationNoteMutation__
 *
 * To run a mutation, you first call `useDeleteLocationNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationNoteMutation, { data, loading, error }] = useDeleteLocationNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationNoteMutation, DeleteLocationNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationNoteMutation, DeleteLocationNoteMutationVariables>(DeleteLocationNoteDocument, options);
      }
export type DeleteLocationNoteMutationHookResult = ReturnType<typeof useDeleteLocationNoteMutation>;
export type DeleteLocationNoteMutationResult = Apollo.MutationResult<DeleteLocationNoteMutation>;
export type DeleteLocationNoteMutationOptions = Apollo.BaseMutationOptions<DeleteLocationNoteMutation, DeleteLocationNoteMutationVariables>;
export const UpdateLocationNoteDocument = gql`
    mutation UpdateLocationNote($input: UpdateNoteInput!) {
  updateLocationNote(input: $input) {
    id
    title
    text
  }
}
    `;
export type UpdateLocationNoteMutationFn = Apollo.MutationFunction<UpdateLocationNoteMutation, UpdateLocationNoteMutationVariables>;

/**
 * __useUpdateLocationNoteMutation__
 *
 * To run a mutation, you first call `useUpdateLocationNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationNoteMutation, { data, loading, error }] = useUpdateLocationNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationNoteMutation, UpdateLocationNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationNoteMutation, UpdateLocationNoteMutationVariables>(UpdateLocationNoteDocument, options);
      }
export type UpdateLocationNoteMutationHookResult = ReturnType<typeof useUpdateLocationNoteMutation>;
export type UpdateLocationNoteMutationResult = Apollo.MutationResult<UpdateLocationNoteMutation>;
export type UpdateLocationNoteMutationOptions = Apollo.BaseMutationOptions<UpdateLocationNoteMutation, UpdateLocationNoteMutationVariables>;
export const CreateDeviationDocument = gql`
    mutation CreateDeviation($input: DeviationInput!) {
  createDeviation(input: $input) {
    id
    cause
    fault
    routeId
    faultLocation {
      id
      name
      address
      postalCode
      city
      country
    }
    note
    consequence
    actualArrivalTime
    createdBy
  }
}
    `;
export type CreateDeviationMutationFn = Apollo.MutationFunction<CreateDeviationMutation, CreateDeviationMutationVariables>;

/**
 * __useCreateDeviationMutation__
 *
 * To run a mutation, you first call `useCreateDeviationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviationMutation, { data, loading, error }] = useCreateDeviationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeviationMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeviationMutation, CreateDeviationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeviationMutation, CreateDeviationMutationVariables>(CreateDeviationDocument, options);
      }
export type CreateDeviationMutationHookResult = ReturnType<typeof useCreateDeviationMutation>;
export type CreateDeviationMutationResult = Apollo.MutationResult<CreateDeviationMutation>;
export type CreateDeviationMutationOptions = Apollo.BaseMutationOptions<CreateDeviationMutation, CreateDeviationMutationVariables>;
export const CreateLocationDeviationDocument = gql`
    mutation CreateLocationDeviation($input: [LocationDeviationInput!]!) {
  createLocationDeviation(input: $input) {
    id
  }
}
    `;
export type CreateLocationDeviationMutationFn = Apollo.MutationFunction<CreateLocationDeviationMutation, CreateLocationDeviationMutationVariables>;

/**
 * __useCreateLocationDeviationMutation__
 *
 * To run a mutation, you first call `useCreateLocationDeviationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationDeviationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationDeviationMutation, { data, loading, error }] = useCreateLocationDeviationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationDeviationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationDeviationMutation, CreateLocationDeviationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationDeviationMutation, CreateLocationDeviationMutationVariables>(CreateLocationDeviationDocument, options);
      }
export type CreateLocationDeviationMutationHookResult = ReturnType<typeof useCreateLocationDeviationMutation>;
export type CreateLocationDeviationMutationResult = Apollo.MutationResult<CreateLocationDeviationMutation>;
export type CreateLocationDeviationMutationOptions = Apollo.BaseMutationOptions<CreateLocationDeviationMutation, CreateLocationDeviationMutationVariables>;
export const DeleteDeviationDocument = gql`
    mutation DeleteDeviation($id: Int!, $customerId: Int) {
  deleteDeviation(id: $id, customerId: $customerId)
}
    `;
export type DeleteDeviationMutationFn = Apollo.MutationFunction<DeleteDeviationMutation, DeleteDeviationMutationVariables>;

/**
 * __useDeleteDeviationMutation__
 *
 * To run a mutation, you first call `useDeleteDeviationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviationMutation, { data, loading, error }] = useDeleteDeviationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useDeleteDeviationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviationMutation, DeleteDeviationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviationMutation, DeleteDeviationMutationVariables>(DeleteDeviationDocument, options);
      }
export type DeleteDeviationMutationHookResult = ReturnType<typeof useDeleteDeviationMutation>;
export type DeleteDeviationMutationResult = Apollo.MutationResult<DeleteDeviationMutation>;
export type DeleteDeviationMutationOptions = Apollo.BaseMutationOptions<DeleteDeviationMutation, DeleteDeviationMutationVariables>;
export const EditDeviationDocument = gql`
    mutation EditDeviation($input: EditDeviationInput!) {
  editDeviation(input: $input) {
    id
    cause
    fault
    routeId
    faultLocation {
      id
      name
      address
      postalCode
      city
      country
    }
    note
    consequence
    actualArrivalTime
    createdBy
  }
}
    `;
export type EditDeviationMutationFn = Apollo.MutationFunction<EditDeviationMutation, EditDeviationMutationVariables>;

/**
 * __useEditDeviationMutation__
 *
 * To run a mutation, you first call `useEditDeviationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeviationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeviationMutation, { data, loading, error }] = useEditDeviationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDeviationMutation(baseOptions?: Apollo.MutationHookOptions<EditDeviationMutation, EditDeviationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDeviationMutation, EditDeviationMutationVariables>(EditDeviationDocument, options);
      }
export type EditDeviationMutationHookResult = ReturnType<typeof useEditDeviationMutation>;
export type EditDeviationMutationResult = Apollo.MutationResult<EditDeviationMutation>;
export type EditDeviationMutationOptions = Apollo.BaseMutationOptions<EditDeviationMutation, EditDeviationMutationVariables>;
export const EditLocationDeviationDocument = gql`
    mutation EditLocationDeviation($input: EditLocationDeviationInput!) {
  editLocationDeviation(input: $input) {
    id
  }
}
    `;
export type EditLocationDeviationMutationFn = Apollo.MutationFunction<EditLocationDeviationMutation, EditLocationDeviationMutationVariables>;

/**
 * __useEditLocationDeviationMutation__
 *
 * To run a mutation, you first call `useEditLocationDeviationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLocationDeviationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLocationDeviationMutation, { data, loading, error }] = useEditLocationDeviationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditLocationDeviationMutation(baseOptions?: Apollo.MutationHookOptions<EditLocationDeviationMutation, EditLocationDeviationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLocationDeviationMutation, EditLocationDeviationMutationVariables>(EditLocationDeviationDocument, options);
      }
export type EditLocationDeviationMutationHookResult = ReturnType<typeof useEditLocationDeviationMutation>;
export type EditLocationDeviationMutationResult = Apollo.MutationResult<EditLocationDeviationMutation>;
export type EditLocationDeviationMutationOptions = Apollo.BaseMutationOptions<EditLocationDeviationMutation, EditLocationDeviationMutationVariables>;
export const DeleteAttachmentFileDocument = gql`
    mutation DeleteAttachmentFile($input: DeleteAttachmentFileDto!) {
  deleteAttachmentFile(input: $input)
}
    `;
export type DeleteAttachmentFileMutationFn = Apollo.MutationFunction<DeleteAttachmentFileMutation, DeleteAttachmentFileMutationVariables>;

/**
 * __useDeleteAttachmentFileMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentFileMutation, { data, loading, error }] = useDeleteAttachmentFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAttachmentFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttachmentFileMutation, DeleteAttachmentFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttachmentFileMutation, DeleteAttachmentFileMutationVariables>(DeleteAttachmentFileDocument, options);
      }
export type DeleteAttachmentFileMutationHookResult = ReturnType<typeof useDeleteAttachmentFileMutation>;
export type DeleteAttachmentFileMutationResult = Apollo.MutationResult<DeleteAttachmentFileMutation>;
export type DeleteAttachmentFileMutationOptions = Apollo.BaseMutationOptions<DeleteAttachmentFileMutation, DeleteAttachmentFileMutationVariables>;
export const DeleteDocumentFileDocument = gql`
    mutation DeleteDocumentFile($deleteDocumentFileId: Int!) {
  deleteDocumentFile(id: $deleteDocumentFileId)
}
    `;
export type DeleteDocumentFileMutationFn = Apollo.MutationFunction<DeleteDocumentFileMutation, DeleteDocumentFileMutationVariables>;

/**
 * __useDeleteDocumentFileMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentFileMutation, { data, loading, error }] = useDeleteDocumentFileMutation({
 *   variables: {
 *      deleteDocumentFileId: // value for 'deleteDocumentFileId'
 *   },
 * });
 */
export function useDeleteDocumentFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentFileMutation, DeleteDocumentFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentFileMutation, DeleteDocumentFileMutationVariables>(DeleteDocumentFileDocument, options);
      }
export type DeleteDocumentFileMutationHookResult = ReturnType<typeof useDeleteDocumentFileMutation>;
export type DeleteDocumentFileMutationResult = Apollo.MutationResult<DeleteDocumentFileMutation>;
export type DeleteDocumentFileMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentFileMutation, DeleteDocumentFileMutationVariables>;
export const ManageRouteFileDocument = gql`
    mutation ManageRouteFile($isAttach: Boolean!, $routeId: Int!, $fileId: Int!) {
  manageFileOfRoute(isAttach: $isAttach, routeId: $routeId, fileId: $fileId)
}
    `;
export type ManageRouteFileMutationFn = Apollo.MutationFunction<ManageRouteFileMutation, ManageRouteFileMutationVariables>;

/**
 * __useManageRouteFileMutation__
 *
 * To run a mutation, you first call `useManageRouteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageRouteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageRouteFileMutation, { data, loading, error }] = useManageRouteFileMutation({
 *   variables: {
 *      isAttach: // value for 'isAttach'
 *      routeId: // value for 'routeId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useManageRouteFileMutation(baseOptions?: Apollo.MutationHookOptions<ManageRouteFileMutation, ManageRouteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageRouteFileMutation, ManageRouteFileMutationVariables>(ManageRouteFileDocument, options);
      }
export type ManageRouteFileMutationHookResult = ReturnType<typeof useManageRouteFileMutation>;
export type ManageRouteFileMutationResult = Apollo.MutationResult<ManageRouteFileMutation>;
export type ManageRouteFileMutationOptions = Apollo.BaseMutationOptions<ManageRouteFileMutation, ManageRouteFileMutationVariables>;
export const AddManualRoutesGenLogDocument = gql`
    mutation AddManualRoutesGenLog($input: ManualRoutesGenLogInput!) {
  addManualRoutesGenLog(input: $input) {
    id
  }
}
    `;
export type AddManualRoutesGenLogMutationFn = Apollo.MutationFunction<AddManualRoutesGenLogMutation, AddManualRoutesGenLogMutationVariables>;

/**
 * __useAddManualRoutesGenLogMutation__
 *
 * To run a mutation, you first call `useAddManualRoutesGenLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddManualRoutesGenLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addManualRoutesGenLogMutation, { data, loading, error }] = useAddManualRoutesGenLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddManualRoutesGenLogMutation(baseOptions?: Apollo.MutationHookOptions<AddManualRoutesGenLogMutation, AddManualRoutesGenLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddManualRoutesGenLogMutation, AddManualRoutesGenLogMutationVariables>(AddManualRoutesGenLogDocument, options);
      }
export type AddManualRoutesGenLogMutationHookResult = ReturnType<typeof useAddManualRoutesGenLogMutation>;
export type AddManualRoutesGenLogMutationResult = Apollo.MutationResult<AddManualRoutesGenLogMutation>;
export type AddManualRoutesGenLogMutationOptions = Apollo.BaseMutationOptions<AddManualRoutesGenLogMutation, AddManualRoutesGenLogMutationVariables>;
export const AddFilterConfigDocument = gql`
    mutation AddFilterConfig($input: FilterConfig!) {
  addFilterConfiguration(input: $input) {
    id
  }
}
    `;
export type AddFilterConfigMutationFn = Apollo.MutationFunction<AddFilterConfigMutation, AddFilterConfigMutationVariables>;

/**
 * __useAddFilterConfigMutation__
 *
 * To run a mutation, you first call `useAddFilterConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFilterConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFilterConfigMutation, { data, loading, error }] = useAddFilterConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFilterConfigMutation(baseOptions?: Apollo.MutationHookOptions<AddFilterConfigMutation, AddFilterConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFilterConfigMutation, AddFilterConfigMutationVariables>(AddFilterConfigDocument, options);
      }
export type AddFilterConfigMutationHookResult = ReturnType<typeof useAddFilterConfigMutation>;
export type AddFilterConfigMutationResult = Apollo.MutationResult<AddFilterConfigMutation>;
export type AddFilterConfigMutationOptions = Apollo.BaseMutationOptions<AddFilterConfigMutation, AddFilterConfigMutationVariables>;
export const UpdateGridFilterDocument = gql`
    mutation UpdateGridFilter($id: Int!, $filterConfiguration: JSONObject!) {
  updateFilterConfiguration(id: $id, filterConfiguration: $filterConfiguration) {
    id
  }
}
    `;
export type UpdateGridFilterMutationFn = Apollo.MutationFunction<UpdateGridFilterMutation, UpdateGridFilterMutationVariables>;

/**
 * __useUpdateGridFilterMutation__
 *
 * To run a mutation, you first call `useUpdateGridFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGridFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGridFilterMutation, { data, loading, error }] = useUpdateGridFilterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      filterConfiguration: // value for 'filterConfiguration'
 *   },
 * });
 */
export function useUpdateGridFilterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGridFilterMutation, UpdateGridFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGridFilterMutation, UpdateGridFilterMutationVariables>(UpdateGridFilterDocument, options);
      }
export type UpdateGridFilterMutationHookResult = ReturnType<typeof useUpdateGridFilterMutation>;
export type UpdateGridFilterMutationResult = Apollo.MutationResult<UpdateGridFilterMutation>;
export type UpdateGridFilterMutationOptions = Apollo.BaseMutationOptions<UpdateGridFilterMutation, UpdateGridFilterMutationVariables>;
export const DeleteGridFilterDocument = gql`
    mutation DeleteGridFilter($id: Int!) {
  deleteGridFilter(id: $id)
}
    `;
export type DeleteGridFilterMutationFn = Apollo.MutationFunction<DeleteGridFilterMutation, DeleteGridFilterMutationVariables>;

/**
 * __useDeleteGridFilterMutation__
 *
 * To run a mutation, you first call `useDeleteGridFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGridFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGridFilterMutation, { data, loading, error }] = useDeleteGridFilterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGridFilterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGridFilterMutation, DeleteGridFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGridFilterMutation, DeleteGridFilterMutationVariables>(DeleteGridFilterDocument, options);
      }
export type DeleteGridFilterMutationHookResult = ReturnType<typeof useDeleteGridFilterMutation>;
export type DeleteGridFilterMutationResult = Apollo.MutationResult<DeleteGridFilterMutation>;
export type DeleteGridFilterMutationOptions = Apollo.BaseMutationOptions<DeleteGridFilterMutation, DeleteGridFilterMutationVariables>;
export const AddHolidayDocument = gql`
    mutation AddHoliday($input: CreateHolidayInput!) {
  addHoliday(input: $input) {
    id
    date
  }
}
    `;
export type AddHolidayMutationFn = Apollo.MutationFunction<AddHolidayMutation, AddHolidayMutationVariables>;

/**
 * __useAddHolidayMutation__
 *
 * To run a mutation, you first call `useAddHolidayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHolidayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHolidayMutation, { data, loading, error }] = useAddHolidayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddHolidayMutation(baseOptions?: Apollo.MutationHookOptions<AddHolidayMutation, AddHolidayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddHolidayMutation, AddHolidayMutationVariables>(AddHolidayDocument, options);
      }
export type AddHolidayMutationHookResult = ReturnType<typeof useAddHolidayMutation>;
export type AddHolidayMutationResult = Apollo.MutationResult<AddHolidayMutation>;
export type AddHolidayMutationOptions = Apollo.BaseMutationOptions<AddHolidayMutation, AddHolidayMutationVariables>;
export const DeleteHolidayDocument = gql`
    mutation DeleteHoliday($id: Int!) {
  deleteHoliday(id: $id)
}
    `;
export type DeleteHolidayMutationFn = Apollo.MutationFunction<DeleteHolidayMutation, DeleteHolidayMutationVariables>;

/**
 * __useDeleteHolidayMutation__
 *
 * To run a mutation, you first call `useDeleteHolidayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHolidayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHolidayMutation, { data, loading, error }] = useDeleteHolidayMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHolidayMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHolidayMutation, DeleteHolidayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHolidayMutation, DeleteHolidayMutationVariables>(DeleteHolidayDocument, options);
      }
export type DeleteHolidayMutationHookResult = ReturnType<typeof useDeleteHolidayMutation>;
export type DeleteHolidayMutationResult = Apollo.MutationResult<DeleteHolidayMutation>;
export type DeleteHolidayMutationOptions = Apollo.BaseMutationOptions<DeleteHolidayMutation, DeleteHolidayMutationVariables>;
export const DeleteLegDocument = gql`
    mutation DeleteLeg($id: Int!, $routeId: Int!) {
  deleteLeg(id: $id, routeId: $routeId) {
    id
    load
    unload
    gateNumber
    carRegistrationNumber
    trailerRegistrationNumber
    routeDriverName
    routeDriverPhoneNumber
    actualCapacity
    arrivalTime
    actualArrivalTime
    actualDepartureTime
    actualArrivalDate
    actualDepartureDate
    departureTime
    fuel
    note
    position
    isNonArrivalMarked
    nonArrivalMarkedFrom
    productionDate
    transportationDate
    transportationDateOffset
    locationId
    isNewLegVariant
    isLoadingInCar
    isLoadingInTrailer
    location {
      name
      type
      address
      postalCode
      city
      country
    }
  }
}
    `;
export type DeleteLegMutationFn = Apollo.MutationFunction<DeleteLegMutation, DeleteLegMutationVariables>;

/**
 * __useDeleteLegMutation__
 *
 * To run a mutation, you first call `useDeleteLegMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLegMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLegMutation, { data, loading, error }] = useDeleteLegMutation({
 *   variables: {
 *      id: // value for 'id'
 *      routeId: // value for 'routeId'
 *   },
 * });
 */
export function useDeleteLegMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLegMutation, DeleteLegMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLegMutation, DeleteLegMutationVariables>(DeleteLegDocument, options);
      }
export type DeleteLegMutationHookResult = ReturnType<typeof useDeleteLegMutation>;
export type DeleteLegMutationResult = Apollo.MutationResult<DeleteLegMutation>;
export type DeleteLegMutationOptions = Apollo.BaseMutationOptions<DeleteLegMutation, DeleteLegMutationVariables>;
export const LinkUnlinkLegWithShipmentDocument = gql`
    mutation LinkUnlinkLegWithShipment($input: OrderLinkUnlinkInput!) {
  linkOrUnlinkOrderInLeg(input: $input)
}
    `;
export type LinkUnlinkLegWithShipmentMutationFn = Apollo.MutationFunction<LinkUnlinkLegWithShipmentMutation, LinkUnlinkLegWithShipmentMutationVariables>;

/**
 * __useLinkUnlinkLegWithShipmentMutation__
 *
 * To run a mutation, you first call `useLinkUnlinkLegWithShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkUnlinkLegWithShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkUnlinkLegWithShipmentMutation, { data, loading, error }] = useLinkUnlinkLegWithShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkUnlinkLegWithShipmentMutation(baseOptions?: Apollo.MutationHookOptions<LinkUnlinkLegWithShipmentMutation, LinkUnlinkLegWithShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkUnlinkLegWithShipmentMutation, LinkUnlinkLegWithShipmentMutationVariables>(LinkUnlinkLegWithShipmentDocument, options);
      }
export type LinkUnlinkLegWithShipmentMutationHookResult = ReturnType<typeof useLinkUnlinkLegWithShipmentMutation>;
export type LinkUnlinkLegWithShipmentMutationResult = Apollo.MutationResult<LinkUnlinkLegWithShipmentMutation>;
export type LinkUnlinkLegWithShipmentMutationOptions = Apollo.BaseMutationOptions<LinkUnlinkLegWithShipmentMutation, LinkUnlinkLegWithShipmentMutationVariables>;
export const TerminalStatusTftUpdateDocument = gql`
    mutation TerminalStatusTftUpdate($truckFillAndTimeInput: TruckFillAndTimeInput!) {
  truckFillAndTime(input: $truckFillAndTimeInput) {
    id
    actualArrivalDate
    actualArrivalTime
    actualDepartureDate
    actualDepartureTime
    actualDockDate
    actualDockTime
    actualUndockDate
    actualUndockTime
    terminalStatus
    terminalStatusDescription
    terminalStatusUpdatedAt
    terminalStatusLog {
      id
      status
      timestamp
      timeZone
      legId
      locationId
      locationOrder
      locationLabel
      locationName
      createdBy
      updatedBy
      updatedAt
      gate
    }
    updatedAt
    lastUpdatedBy
  }
}
    `;
export type TerminalStatusTftUpdateMutationFn = Apollo.MutationFunction<TerminalStatusTftUpdateMutation, TerminalStatusTftUpdateMutationVariables>;

/**
 * __useTerminalStatusTftUpdateMutation__
 *
 * To run a mutation, you first call `useTerminalStatusTftUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminalStatusTftUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminalStatusTftUpdateMutation, { data, loading, error }] = useTerminalStatusTftUpdateMutation({
 *   variables: {
 *      truckFillAndTimeInput: // value for 'truckFillAndTimeInput'
 *   },
 * });
 */
export function useTerminalStatusTftUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TerminalStatusTftUpdateMutation, TerminalStatusTftUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TerminalStatusTftUpdateMutation, TerminalStatusTftUpdateMutationVariables>(TerminalStatusTftUpdateDocument, options);
      }
export type TerminalStatusTftUpdateMutationHookResult = ReturnType<typeof useTerminalStatusTftUpdateMutation>;
export type TerminalStatusTftUpdateMutationResult = Apollo.MutationResult<TerminalStatusTftUpdateMutation>;
export type TerminalStatusTftUpdateMutationOptions = Apollo.BaseMutationOptions<TerminalStatusTftUpdateMutation, TerminalStatusTftUpdateMutationVariables>;
export const TruckFillAndTimeDocument = gql`
    mutation TruckFillAndTime($truckFillAndTimeInput: TruckFillAndTimeInput!) {
  truckFillAndTime(input: $truckFillAndTimeInput) {
    id
    routeDriverName
    loadCar
    loadTrailer
    loadCarPPL
    loadTrailerPPL
    unloadCar
    unloadTrailer
    unloadCarPPL
    unloadTrailerPPL
    actualDepartureTime
    actualDepartureDate
    actualArrivalTime
    actualArrivalDate
    terminalNote
    lastUpdatedBy
    updatedAt
    gateNumber
    carRegistrationNumber
    trailerRegistrationNumber
    terminalNickname
    isNonArrivalMarked
    actualCapacity
    sealNumber
    isSealBroken
    productionGroup
    arrivalStatus
    receivedStatus
    receivedBy
    timeWhenReceived
    kippReceivedBy
    kippTimeWhenReceived
    carDetails {
      actualCapacity
    }
    trailerDetails {
      actualCapacity
    }
    files {
      id
      originalname
      mimetype
      path
      size
    }
    terminalResponsible
    operator
    priority
  }
}
    `;
export type TruckFillAndTimeMutationFn = Apollo.MutationFunction<TruckFillAndTimeMutation, TruckFillAndTimeMutationVariables>;

/**
 * __useTruckFillAndTimeMutation__
 *
 * To run a mutation, you first call `useTruckFillAndTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTruckFillAndTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [truckFillAndTimeMutation, { data, loading, error }] = useTruckFillAndTimeMutation({
 *   variables: {
 *      truckFillAndTimeInput: // value for 'truckFillAndTimeInput'
 *   },
 * });
 */
export function useTruckFillAndTimeMutation(baseOptions?: Apollo.MutationHookOptions<TruckFillAndTimeMutation, TruckFillAndTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TruckFillAndTimeMutation, TruckFillAndTimeMutationVariables>(TruckFillAndTimeDocument, options);
      }
export type TruckFillAndTimeMutationHookResult = ReturnType<typeof useTruckFillAndTimeMutation>;
export type TruckFillAndTimeMutationResult = Apollo.MutationResult<TruckFillAndTimeMutation>;
export type TruckFillAndTimeMutationOptions = Apollo.BaseMutationOptions<TruckFillAndTimeMutation, TruckFillAndTimeMutationVariables>;
export const UpdateCarTrailerDetailsDocument = gql`
    mutation UpdateCarTrailerDetails($input: CarTrailerDetailsInput!) {
  updateCarTrailerDetails(input: $input) {
    success
    id
    legId
    type
    registrationNumber
    actualCapacity
    gateNumber
  }
}
    `;
export type UpdateCarTrailerDetailsMutationFn = Apollo.MutationFunction<UpdateCarTrailerDetailsMutation, UpdateCarTrailerDetailsMutationVariables>;

/**
 * __useUpdateCarTrailerDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateCarTrailerDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarTrailerDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarTrailerDetailsMutation, { data, loading, error }] = useUpdateCarTrailerDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCarTrailerDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarTrailerDetailsMutation, UpdateCarTrailerDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarTrailerDetailsMutation, UpdateCarTrailerDetailsMutationVariables>(UpdateCarTrailerDetailsDocument, options);
      }
export type UpdateCarTrailerDetailsMutationHookResult = ReturnType<typeof useUpdateCarTrailerDetailsMutation>;
export type UpdateCarTrailerDetailsMutationResult = Apollo.MutationResult<UpdateCarTrailerDetailsMutation>;
export type UpdateCarTrailerDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateCarTrailerDetailsMutation, UpdateCarTrailerDetailsMutationVariables>;
export const UpdateDriverAndRegistrationDetailsDocument = gql`
    mutation UpdateDriverAndRegistrationDetails($input: RouteLegDriverDetailsInput!) {
  updateDriverAndRegistrationDetails(input: $input) {
    id
    routeDriverName
    routeDriverPhoneNumber
    routeDriverEmail
    carRegistrationNumber
    trailerRegistrationNumber
  }
}
    `;
export type UpdateDriverAndRegistrationDetailsMutationFn = Apollo.MutationFunction<UpdateDriverAndRegistrationDetailsMutation, UpdateDriverAndRegistrationDetailsMutationVariables>;

/**
 * __useUpdateDriverAndRegistrationDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateDriverAndRegistrationDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverAndRegistrationDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverAndRegistrationDetailsMutation, { data, loading, error }] = useUpdateDriverAndRegistrationDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDriverAndRegistrationDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverAndRegistrationDetailsMutation, UpdateDriverAndRegistrationDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverAndRegistrationDetailsMutation, UpdateDriverAndRegistrationDetailsMutationVariables>(UpdateDriverAndRegistrationDetailsDocument, options);
      }
export type UpdateDriverAndRegistrationDetailsMutationHookResult = ReturnType<typeof useUpdateDriverAndRegistrationDetailsMutation>;
export type UpdateDriverAndRegistrationDetailsMutationResult = Apollo.MutationResult<UpdateDriverAndRegistrationDetailsMutation>;
export type UpdateDriverAndRegistrationDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateDriverAndRegistrationDetailsMutation, UpdateDriverAndRegistrationDetailsMutationVariables>;
export const UpdateDriverAndRegistrationDetailsBatchDocument = gql`
    mutation UpdateDriverAndRegistrationDetailsBatch($input: RouteLegDriverDetailsBatchInput!) {
  updateDriverAndRegistrationDetailsBatch(input: $input) {
    id
    routeDriverName
    routeDriverPhoneNumber
    routeDriverEmail
    carRegistrationNumber
    trailerRegistrationNumber
  }
}
    `;
export type UpdateDriverAndRegistrationDetailsBatchMutationFn = Apollo.MutationFunction<UpdateDriverAndRegistrationDetailsBatchMutation, UpdateDriverAndRegistrationDetailsBatchMutationVariables>;

/**
 * __useUpdateDriverAndRegistrationDetailsBatchMutation__
 *
 * To run a mutation, you first call `useUpdateDriverAndRegistrationDetailsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverAndRegistrationDetailsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverAndRegistrationDetailsBatchMutation, { data, loading, error }] = useUpdateDriverAndRegistrationDetailsBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDriverAndRegistrationDetailsBatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverAndRegistrationDetailsBatchMutation, UpdateDriverAndRegistrationDetailsBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverAndRegistrationDetailsBatchMutation, UpdateDriverAndRegistrationDetailsBatchMutationVariables>(UpdateDriverAndRegistrationDetailsBatchDocument, options);
      }
export type UpdateDriverAndRegistrationDetailsBatchMutationHookResult = ReturnType<typeof useUpdateDriverAndRegistrationDetailsBatchMutation>;
export type UpdateDriverAndRegistrationDetailsBatchMutationResult = Apollo.MutationResult<UpdateDriverAndRegistrationDetailsBatchMutation>;
export type UpdateDriverAndRegistrationDetailsBatchMutationOptions = Apollo.BaseMutationOptions<UpdateDriverAndRegistrationDetailsBatchMutation, UpdateDriverAndRegistrationDetailsBatchMutationVariables>;
export const UpdateLegDetailsDocument = gql`
    mutation UpdateLegDetails($input: LegDetails!) {
  updateLegDetails(input: $input) {
    id
    actualArrivalDate
    actualArrivalTime
    actualCapacity
    actualDepartureDate
    actualDepartureTime
    arrivalTime
    carRegistrationNumber
    departureTime
    distanceInKM
    fuel
    locationId
    note
    routeDriverEmail
    routeDriverName
    routeDriverPhoneNumber
    terminalNote
    trailerRegistrationNumber
    transportationDate
    weight
    loadCarPPL
    loadTrailerPPL
    unloadCarPPL
    unloadTrailerPPL
    assigned
    ansvBefraktare
    timeWhenAssigned
    receivedStatus
    receivedBy
    timeWhenReceived
    kippReceivedBy
    kippTimeWhenReceived
  }
}
    `;
export type UpdateLegDetailsMutationFn = Apollo.MutationFunction<UpdateLegDetailsMutation, UpdateLegDetailsMutationVariables>;

/**
 * __useUpdateLegDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateLegDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLegDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLegDetailsMutation, { data, loading, error }] = useUpdateLegDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLegDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLegDetailsMutation, UpdateLegDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLegDetailsMutation, UpdateLegDetailsMutationVariables>(UpdateLegDetailsDocument, options);
      }
export type UpdateLegDetailsMutationHookResult = ReturnType<typeof useUpdateLegDetailsMutation>;
export type UpdateLegDetailsMutationResult = Apollo.MutationResult<UpdateLegDetailsMutation>;
export type UpdateLegDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateLegDetailsMutation, UpdateLegDetailsMutationVariables>;
export const UpdateLegWithLoadingListDocument = gql`
    mutation UpdateLegWithLoadingList($input: LegLoadingListInput!) {
  updateLegWithLoadingList(input: $input) {
    id
    loadingListItems {
      id
      locationId
      packages
      pallets
      palletSpace
      weight
      checked
      isDangerous
      classification
      unNumber
      isLimitedQty
      note
    }
  }
}
    `;
export type UpdateLegWithLoadingListMutationFn = Apollo.MutationFunction<UpdateLegWithLoadingListMutation, UpdateLegWithLoadingListMutationVariables>;

/**
 * __useUpdateLegWithLoadingListMutation__
 *
 * To run a mutation, you first call `useUpdateLegWithLoadingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLegWithLoadingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLegWithLoadingListMutation, { data, loading, error }] = useUpdateLegWithLoadingListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLegWithLoadingListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLegWithLoadingListMutation, UpdateLegWithLoadingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLegWithLoadingListMutation, UpdateLegWithLoadingListMutationVariables>(UpdateLegWithLoadingListDocument, options);
      }
export type UpdateLegWithLoadingListMutationHookResult = ReturnType<typeof useUpdateLegWithLoadingListMutation>;
export type UpdateLegWithLoadingListMutationResult = Apollo.MutationResult<UpdateLegWithLoadingListMutation>;
export type UpdateLegWithLoadingListMutationOptions = Apollo.BaseMutationOptions<UpdateLegWithLoadingListMutation, UpdateLegWithLoadingListMutationVariables>;
export const UpdateLegPositionDocument = gql`
    mutation UpdateLegPosition($input: [LegsPositionInput!]!) {
  updateLegPosition(input: $input) {
    id
    load
    unload
    gateNumber
    carRegistrationNumber
    trailerRegistrationNumber
    routeDriverName
    routeDriverPhoneNumber
    actualCapacity
    arrivalTime
    actualArrivalTime
    actualDepartureTime
    actualArrivalDate
    actualDepartureDate
    departureTime
    fuel
    note
    position
    isNonArrivalMarked
    nonArrivalMarkedFrom
    productionDate
    transportationDate
    transportationDateOffset
    locationId
    isNewLegVariant
    isLoadingInCar
    isLoadingInTrailer
    location {
      type
      name
      address
      postalCode
      city
      country
    }
  }
}
    `;
export type UpdateLegPositionMutationFn = Apollo.MutationFunction<UpdateLegPositionMutation, UpdateLegPositionMutationVariables>;

/**
 * __useUpdateLegPositionMutation__
 *
 * To run a mutation, you first call `useUpdateLegPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLegPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLegPositionMutation, { data, loading, error }] = useUpdateLegPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLegPositionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLegPositionMutation, UpdateLegPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLegPositionMutation, UpdateLegPositionMutationVariables>(UpdateLegPositionDocument, options);
      }
export type UpdateLegPositionMutationHookResult = ReturnType<typeof useUpdateLegPositionMutation>;
export type UpdateLegPositionMutationResult = Apollo.MutationResult<UpdateLegPositionMutation>;
export type UpdateLegPositionMutationOptions = Apollo.BaseMutationOptions<UpdateLegPositionMutation, UpdateLegPositionMutationVariables>;
export const UpdateTripInfoDocument = gql`
    mutation UpdateTripInfo($legId: Int!, $updateFor: String!, $tripStatus: String!, $dateTimeStamp: String!, $gateNumber: String, $driverName: String, $carRegNumber: String, $trailerRegNumber: String, $capacity: Int, $containerId: String, $items: String, $pallets: String, $palletPlaces: String) {
  updateTripInfoFromProdApp(
    legId: $legId
    updateFor: $updateFor
    tripStatus: $tripStatus
    dateTimeStamp: $dateTimeStamp
    gateNumber: $gateNumber
    driverName: $driverName
    carRegNumber: $carRegNumber
    trailerRegNumber: $trailerRegNumber
    capacity: $capacity
    containerId: $containerId
    items: $items
    pallets: $pallets
    palletPlaces: $palletPlaces
  )
}
    `;
export type UpdateTripInfoMutationFn = Apollo.MutationFunction<UpdateTripInfoMutation, UpdateTripInfoMutationVariables>;

/**
 * __useUpdateTripInfoMutation__
 *
 * To run a mutation, you first call `useUpdateTripInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTripInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTripInfoMutation, { data, loading, error }] = useUpdateTripInfoMutation({
 *   variables: {
 *      legId: // value for 'legId'
 *      updateFor: // value for 'updateFor'
 *      tripStatus: // value for 'tripStatus'
 *      dateTimeStamp: // value for 'dateTimeStamp'
 *      gateNumber: // value for 'gateNumber'
 *      driverName: // value for 'driverName'
 *      carRegNumber: // value for 'carRegNumber'
 *      trailerRegNumber: // value for 'trailerRegNumber'
 *      capacity: // value for 'capacity'
 *      containerId: // value for 'containerId'
 *      items: // value for 'items'
 *      pallets: // value for 'pallets'
 *      palletPlaces: // value for 'palletPlaces'
 *   },
 * });
 */
export function useUpdateTripInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTripInfoMutation, UpdateTripInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTripInfoMutation, UpdateTripInfoMutationVariables>(UpdateTripInfoDocument, options);
      }
export type UpdateTripInfoMutationHookResult = ReturnType<typeof useUpdateTripInfoMutation>;
export type UpdateTripInfoMutationResult = Apollo.MutationResult<UpdateTripInfoMutation>;
export type UpdateTripInfoMutationOptions = Apollo.BaseMutationOptions<UpdateTripInfoMutation, UpdateTripInfoMutationVariables>;
export const AddCustomerMappingDetailsDocument = gql`
    mutation AddCustomerMappingDetails($input: CustomersMappingInput!) {
  addCustomerMappingDetails(input: $input) {
    id
  }
}
    `;
export type AddCustomerMappingDetailsMutationFn = Apollo.MutationFunction<AddCustomerMappingDetailsMutation, AddCustomerMappingDetailsMutationVariables>;

/**
 * __useAddCustomerMappingDetailsMutation__
 *
 * To run a mutation, you first call `useAddCustomerMappingDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomerMappingDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomerMappingDetailsMutation, { data, loading, error }] = useAddCustomerMappingDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCustomerMappingDetailsMutation(baseOptions?: Apollo.MutationHookOptions<AddCustomerMappingDetailsMutation, AddCustomerMappingDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCustomerMappingDetailsMutation, AddCustomerMappingDetailsMutationVariables>(AddCustomerMappingDetailsDocument, options);
      }
export type AddCustomerMappingDetailsMutationHookResult = ReturnType<typeof useAddCustomerMappingDetailsMutation>;
export type AddCustomerMappingDetailsMutationResult = Apollo.MutationResult<AddCustomerMappingDetailsMutation>;
export type AddCustomerMappingDetailsMutationOptions = Apollo.BaseMutationOptions<AddCustomerMappingDetailsMutation, AddCustomerMappingDetailsMutationVariables>;
export const AddNewLoadingListItemsDocument = gql`
    mutation AddNewLoadingListItems($input: LoadingListInput!) {
  addNewLoadingListItems(input: $input) {
    legId
    carDetailsId
    trailerDetailsId
    loadingListItems {
      id
      locationId
      packages
      pallets
      note
      checked
      palletSpace
      weight
      isDangerous
      classification
      unNumber
      isLimitedQty
      isImportedFromShipment
    }
  }
}
    `;
export type AddNewLoadingListItemsMutationFn = Apollo.MutationFunction<AddNewLoadingListItemsMutation, AddNewLoadingListItemsMutationVariables>;

/**
 * __useAddNewLoadingListItemsMutation__
 *
 * To run a mutation, you first call `useAddNewLoadingListItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewLoadingListItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewLoadingListItemsMutation, { data, loading, error }] = useAddNewLoadingListItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNewLoadingListItemsMutation(baseOptions?: Apollo.MutationHookOptions<AddNewLoadingListItemsMutation, AddNewLoadingListItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewLoadingListItemsMutation, AddNewLoadingListItemsMutationVariables>(AddNewLoadingListItemsDocument, options);
      }
export type AddNewLoadingListItemsMutationHookResult = ReturnType<typeof useAddNewLoadingListItemsMutation>;
export type AddNewLoadingListItemsMutationResult = Apollo.MutationResult<AddNewLoadingListItemsMutation>;
export type AddNewLoadingListItemsMutationOptions = Apollo.BaseMutationOptions<AddNewLoadingListItemsMutation, AddNewLoadingListItemsMutationVariables>;
export const AddNewVersionShipmentLliDocument = gql`
    mutation AddNewVersionShipmentLLI($input: [NewVersionShipmentLLI!]!) {
  addNewVersionShipmentLLI(input: $input) {
    id
    locationId
    location {
      name
    }
    packages
    pallets
    palletSpace
    weight
    checked
    isDangerous
    classification
    unNumber
    isLimitedQty
    note
    customsProcedure
    customWaybillNo
    fromLocationId
    fromLocation {
      name
    }
    toLocation {
      name
    }
    toLocationId
    shipmentDate
    cmrDate
    serviceCode
    isNewShipmentLLI
    createdFrom
    tags {
      id
      title
    }
  }
}
    `;
export type AddNewVersionShipmentLliMutationFn = Apollo.MutationFunction<AddNewVersionShipmentLliMutation, AddNewVersionShipmentLliMutationVariables>;

/**
 * __useAddNewVersionShipmentLliMutation__
 *
 * To run a mutation, you first call `useAddNewVersionShipmentLliMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewVersionShipmentLliMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewVersionShipmentLliMutation, { data, loading, error }] = useAddNewVersionShipmentLliMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNewVersionShipmentLliMutation(baseOptions?: Apollo.MutationHookOptions<AddNewVersionShipmentLliMutation, AddNewVersionShipmentLliMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewVersionShipmentLliMutation, AddNewVersionShipmentLliMutationVariables>(AddNewVersionShipmentLliDocument, options);
      }
export type AddNewVersionShipmentLliMutationHookResult = ReturnType<typeof useAddNewVersionShipmentLliMutation>;
export type AddNewVersionShipmentLliMutationResult = Apollo.MutationResult<AddNewVersionShipmentLliMutation>;
export type AddNewVersionShipmentLliMutationOptions = Apollo.BaseMutationOptions<AddNewVersionShipmentLliMutation, AddNewVersionShipmentLliMutationVariables>;
export const AddShipmentLliDocument = gql`
    mutation AddShipmentLLI($input: [LoadingList!]!, $shipmentId: Int!) {
  addShipmentLLI(input: $input, shipmentId: $shipmentId) {
    id
    locationId
    location {
      name
    }
    packages
    pallets
    palletSpace
    weight
    checked
    isDangerous
    classification
    unNumber
    isLimitedQty
    note
    serviceCode
    customsProcedure
    customWaybillNo
  }
}
    `;
export type AddShipmentLliMutationFn = Apollo.MutationFunction<AddShipmentLliMutation, AddShipmentLliMutationVariables>;

/**
 * __useAddShipmentLliMutation__
 *
 * To run a mutation, you first call `useAddShipmentLliMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShipmentLliMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShipmentLliMutation, { data, loading, error }] = useAddShipmentLliMutation({
 *   variables: {
 *      input: // value for 'input'
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useAddShipmentLliMutation(baseOptions?: Apollo.MutationHookOptions<AddShipmentLliMutation, AddShipmentLliMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddShipmentLliMutation, AddShipmentLliMutationVariables>(AddShipmentLliDocument, options);
      }
export type AddShipmentLliMutationHookResult = ReturnType<typeof useAddShipmentLliMutation>;
export type AddShipmentLliMutationResult = Apollo.MutationResult<AddShipmentLliMutation>;
export type AddShipmentLliMutationOptions = Apollo.BaseMutationOptions<AddShipmentLliMutation, AddShipmentLliMutationVariables>;
export const DeleteLoadingListItemDocument = gql`
    mutation deleteLoadingListItem($ids: [Int!]!) {
  deleteLoadingListItem(ids: $ids)
}
    `;
export type DeleteLoadingListItemMutationFn = Apollo.MutationFunction<DeleteLoadingListItemMutation, DeleteLoadingListItemMutationVariables>;

/**
 * __useDeleteLoadingListItemMutation__
 *
 * To run a mutation, you first call `useDeleteLoadingListItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoadingListItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoadingListItemMutation, { data, loading, error }] = useDeleteLoadingListItemMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteLoadingListItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLoadingListItemMutation, DeleteLoadingListItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLoadingListItemMutation, DeleteLoadingListItemMutationVariables>(DeleteLoadingListItemDocument, options);
      }
export type DeleteLoadingListItemMutationHookResult = ReturnType<typeof useDeleteLoadingListItemMutation>;
export type DeleteLoadingListItemMutationResult = Apollo.MutationResult<DeleteLoadingListItemMutation>;
export type DeleteLoadingListItemMutationOptions = Apollo.BaseMutationOptions<DeleteLoadingListItemMutation, DeleteLoadingListItemMutationVariables>;
export const UpdateBulkNewShipmentLliDocument = gql`
    mutation UpdateBulkNewShipmentLLI($input: ShipmentOrderBulkUpdateInput!) {
  updateBulkShipmentLLI(input: $input)
}
    `;
export type UpdateBulkNewShipmentLliMutationFn = Apollo.MutationFunction<UpdateBulkNewShipmentLliMutation, UpdateBulkNewShipmentLliMutationVariables>;

/**
 * __useUpdateBulkNewShipmentLliMutation__
 *
 * To run a mutation, you first call `useUpdateBulkNewShipmentLliMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBulkNewShipmentLliMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBulkNewShipmentLliMutation, { data, loading, error }] = useUpdateBulkNewShipmentLliMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBulkNewShipmentLliMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBulkNewShipmentLliMutation, UpdateBulkNewShipmentLliMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBulkNewShipmentLliMutation, UpdateBulkNewShipmentLliMutationVariables>(UpdateBulkNewShipmentLliDocument, options);
      }
export type UpdateBulkNewShipmentLliMutationHookResult = ReturnType<typeof useUpdateBulkNewShipmentLliMutation>;
export type UpdateBulkNewShipmentLliMutationResult = Apollo.MutationResult<UpdateBulkNewShipmentLliMutation>;
export type UpdateBulkNewShipmentLliMutationOptions = Apollo.BaseMutationOptions<UpdateBulkNewShipmentLliMutation, UpdateBulkNewShipmentLliMutationVariables>;
export const UpdateLoadingListItemsDocument = gql`
    mutation UpdateLoadingListItems($input: UpdateLoadingListInput!) {
  updateLoadingListItems(input: $input)
}
    `;
export type UpdateLoadingListItemsMutationFn = Apollo.MutationFunction<UpdateLoadingListItemsMutation, UpdateLoadingListItemsMutationVariables>;

/**
 * __useUpdateLoadingListItemsMutation__
 *
 * To run a mutation, you first call `useUpdateLoadingListItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoadingListItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoadingListItemsMutation, { data, loading, error }] = useUpdateLoadingListItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLoadingListItemsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoadingListItemsMutation, UpdateLoadingListItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoadingListItemsMutation, UpdateLoadingListItemsMutationVariables>(UpdateLoadingListItemsDocument, options);
      }
export type UpdateLoadingListItemsMutationHookResult = ReturnType<typeof useUpdateLoadingListItemsMutation>;
export type UpdateLoadingListItemsMutationResult = Apollo.MutationResult<UpdateLoadingListItemsMutation>;
export type UpdateLoadingListItemsMutationOptions = Apollo.BaseMutationOptions<UpdateLoadingListItemsMutation, UpdateLoadingListItemsMutationVariables>;
export const UpdateLoadingListItemDocument = gql`
    mutation UpdateLoadingListItem($input: ShipmentLoadingList!, $shipmentId: Int, $routeName: String) {
  updateLoadingListItem(
    input: $input
    shipmentId: $shipmentId
    routeName: $routeName
  ) {
    id
  }
}
    `;
export type UpdateLoadingListItemMutationFn = Apollo.MutationFunction<UpdateLoadingListItemMutation, UpdateLoadingListItemMutationVariables>;

/**
 * __useUpdateLoadingListItemMutation__
 *
 * To run a mutation, you first call `useUpdateLoadingListItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoadingListItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoadingListItemMutation, { data, loading, error }] = useUpdateLoadingListItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *      shipmentId: // value for 'shipmentId'
 *      routeName: // value for 'routeName'
 *   },
 * });
 */
export function useUpdateLoadingListItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoadingListItemMutation, UpdateLoadingListItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoadingListItemMutation, UpdateLoadingListItemMutationVariables>(UpdateLoadingListItemDocument, options);
      }
export type UpdateLoadingListItemMutationHookResult = ReturnType<typeof useUpdateLoadingListItemMutation>;
export type UpdateLoadingListItemMutationResult = Apollo.MutationResult<UpdateLoadingListItemMutation>;
export type UpdateLoadingListItemMutationOptions = Apollo.BaseMutationOptions<UpdateLoadingListItemMutation, UpdateLoadingListItemMutationVariables>;
export const UpdateNewShipmentLliDocument = gql`
    mutation UpdateNewShipmentLLI($input: ShipmentLoadingList!) {
  updateNewshipmentLLI(input: $input) {
    id
    locationId
    location {
      name
    }
    fromLocationId
    fromLocation {
      name
    }
    toLocationId
    toLocation {
      name
    }
    shipmentDate
    cmrDate
    isNewShipmentLLI
    packages
    pallets
    palletSpace
    weight
    customWaybillNo
    customsProcedure
    terminalCleared
    customCleared
    customClearedForImport
    isRemainingGoods
    note
    isImportedFromShipment
    shipmentDate
    isOrderHidden
    hiddenBy
    routeDetail {
      id
      routeName
    }
    templateName
    preplannedRoute
    tags {
      id
      title
    }
  }
}
    `;
export type UpdateNewShipmentLliMutationFn = Apollo.MutationFunction<UpdateNewShipmentLliMutation, UpdateNewShipmentLliMutationVariables>;

/**
 * __useUpdateNewShipmentLliMutation__
 *
 * To run a mutation, you first call `useUpdateNewShipmentLliMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewShipmentLliMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewShipmentLliMutation, { data, loading, error }] = useUpdateNewShipmentLliMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNewShipmentLliMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewShipmentLliMutation, UpdateNewShipmentLliMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewShipmentLliMutation, UpdateNewShipmentLliMutationVariables>(UpdateNewShipmentLliDocument, options);
      }
export type UpdateNewShipmentLliMutationHookResult = ReturnType<typeof useUpdateNewShipmentLliMutation>;
export type UpdateNewShipmentLliMutationResult = Apollo.MutationResult<UpdateNewShipmentLliMutation>;
export type UpdateNewShipmentLliMutationOptions = Apollo.BaseMutationOptions<UpdateNewShipmentLliMutation, UpdateNewShipmentLliMutationVariables>;
export const UpdateVolumeDetailsDocument = gql`
    mutation UpdateVolumeDetails($input: VolumeColumsInput!) {
  updateVolumeDetails(input: $input) {
    id
    bpx
    pri03
    pri49
    upri03
    upri49
    parti
    brev
    pru
    pip
  }
}
    `;
export type UpdateVolumeDetailsMutationFn = Apollo.MutationFunction<UpdateVolumeDetailsMutation, UpdateVolumeDetailsMutationVariables>;

/**
 * __useUpdateVolumeDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateVolumeDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVolumeDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVolumeDetailsMutation, { data, loading, error }] = useUpdateVolumeDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVolumeDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVolumeDetailsMutation, UpdateVolumeDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVolumeDetailsMutation, UpdateVolumeDetailsMutationVariables>(UpdateVolumeDetailsDocument, options);
      }
export type UpdateVolumeDetailsMutationHookResult = ReturnType<typeof useUpdateVolumeDetailsMutation>;
export type UpdateVolumeDetailsMutationResult = Apollo.MutationResult<UpdateVolumeDetailsMutation>;
export type UpdateVolumeDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateVolumeDetailsMutation, UpdateVolumeDetailsMutationVariables>;
export const AddEditLocationValueBoxEntryDocument = gql`
    mutation AddEditLocationValueBoxEntry($boxEntry: EditValueBoxEntry!) {
  editLocationValueBoxEntry(boxEntry: $boxEntry) {
    id
  }
}
    `;
export type AddEditLocationValueBoxEntryMutationFn = Apollo.MutationFunction<AddEditLocationValueBoxEntryMutation, AddEditLocationValueBoxEntryMutationVariables>;

/**
 * __useAddEditLocationValueBoxEntryMutation__
 *
 * To run a mutation, you first call `useAddEditLocationValueBoxEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditLocationValueBoxEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditLocationValueBoxEntryMutation, { data, loading, error }] = useAddEditLocationValueBoxEntryMutation({
 *   variables: {
 *      boxEntry: // value for 'boxEntry'
 *   },
 * });
 */
export function useAddEditLocationValueBoxEntryMutation(baseOptions?: Apollo.MutationHookOptions<AddEditLocationValueBoxEntryMutation, AddEditLocationValueBoxEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEditLocationValueBoxEntryMutation, AddEditLocationValueBoxEntryMutationVariables>(AddEditLocationValueBoxEntryDocument, options);
      }
export type AddEditLocationValueBoxEntryMutationHookResult = ReturnType<typeof useAddEditLocationValueBoxEntryMutation>;
export type AddEditLocationValueBoxEntryMutationResult = Apollo.MutationResult<AddEditLocationValueBoxEntryMutation>;
export type AddEditLocationValueBoxEntryMutationOptions = Apollo.BaseMutationOptions<AddEditLocationValueBoxEntryMutation, AddEditLocationValueBoxEntryMutationVariables>;
export const AddFixedValueBoxesDocument = gql`
    mutation AddFixedValueBoxes($locationId: Int!) {
  addFixedValueBoxes(locationId: $locationId)
}
    `;
export type AddFixedValueBoxesMutationFn = Apollo.MutationFunction<AddFixedValueBoxesMutation, AddFixedValueBoxesMutationVariables>;

/**
 * __useAddFixedValueBoxesMutation__
 *
 * To run a mutation, you first call `useAddFixedValueBoxesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFixedValueBoxesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFixedValueBoxesMutation, { data, loading, error }] = useAddFixedValueBoxesMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useAddFixedValueBoxesMutation(baseOptions?: Apollo.MutationHookOptions<AddFixedValueBoxesMutation, AddFixedValueBoxesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFixedValueBoxesMutation, AddFixedValueBoxesMutationVariables>(AddFixedValueBoxesDocument, options);
      }
export type AddFixedValueBoxesMutationHookResult = ReturnType<typeof useAddFixedValueBoxesMutation>;
export type AddFixedValueBoxesMutationResult = Apollo.MutationResult<AddFixedValueBoxesMutation>;
export type AddFixedValueBoxesMutationOptions = Apollo.BaseMutationOptions<AddFixedValueBoxesMutation, AddFixedValueBoxesMutationVariables>;
export const AddLocationGridValueDocument = gql`
    mutation AddLocationGridValue($gridValue: AddGridValueInput!) {
  addLocationGridValue(gridValue: $gridValue) {
    id
  }
}
    `;
export type AddLocationGridValueMutationFn = Apollo.MutationFunction<AddLocationGridValueMutation, AddLocationGridValueMutationVariables>;

/**
 * __useAddLocationGridValueMutation__
 *
 * To run a mutation, you first call `useAddLocationGridValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocationGridValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocationGridValueMutation, { data, loading, error }] = useAddLocationGridValueMutation({
 *   variables: {
 *      gridValue: // value for 'gridValue'
 *   },
 * });
 */
export function useAddLocationGridValueMutation(baseOptions?: Apollo.MutationHookOptions<AddLocationGridValueMutation, AddLocationGridValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLocationGridValueMutation, AddLocationGridValueMutationVariables>(AddLocationGridValueDocument, options);
      }
export type AddLocationGridValueMutationHookResult = ReturnType<typeof useAddLocationGridValueMutation>;
export type AddLocationGridValueMutationResult = Apollo.MutationResult<AddLocationGridValueMutation>;
export type AddLocationGridValueMutationOptions = Apollo.BaseMutationOptions<AddLocationGridValueMutation, AddLocationGridValueMutationVariables>;
export const AddLocationMasterGridDocument = gql`
    mutation AddLocationMasterGrid($gridData: AddMasterGridDataInput!) {
  addLocationMasterGridBox(gridData: $gridData)
}
    `;
export type AddLocationMasterGridMutationFn = Apollo.MutationFunction<AddLocationMasterGridMutation, AddLocationMasterGridMutationVariables>;

/**
 * __useAddLocationMasterGridMutation__
 *
 * To run a mutation, you first call `useAddLocationMasterGridMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocationMasterGridMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocationMasterGridMutation, { data, loading, error }] = useAddLocationMasterGridMutation({
 *   variables: {
 *      gridData: // value for 'gridData'
 *   },
 * });
 */
export function useAddLocationMasterGridMutation(baseOptions?: Apollo.MutationHookOptions<AddLocationMasterGridMutation, AddLocationMasterGridMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLocationMasterGridMutation, AddLocationMasterGridMutationVariables>(AddLocationMasterGridDocument, options);
      }
export type AddLocationMasterGridMutationHookResult = ReturnType<typeof useAddLocationMasterGridMutation>;
export type AddLocationMasterGridMutationResult = Apollo.MutationResult<AddLocationMasterGridMutation>;
export type AddLocationMasterGridMutationOptions = Apollo.BaseMutationOptions<AddLocationMasterGridMutation, AddLocationMasterGridMutationVariables>;
export const AddLocationMasterValueBoxDocument = gql`
    mutation AddLocationMasterValueBox($boxData: AddMasterValueBoxInput!) {
  addLocationMasterValueBox(boxData: $boxData)
}
    `;
export type AddLocationMasterValueBoxMutationFn = Apollo.MutationFunction<AddLocationMasterValueBoxMutation, AddLocationMasterValueBoxMutationVariables>;

/**
 * __useAddLocationMasterValueBoxMutation__
 *
 * To run a mutation, you first call `useAddLocationMasterValueBoxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocationMasterValueBoxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocationMasterValueBoxMutation, { data, loading, error }] = useAddLocationMasterValueBoxMutation({
 *   variables: {
 *      boxData: // value for 'boxData'
 *   },
 * });
 */
export function useAddLocationMasterValueBoxMutation(baseOptions?: Apollo.MutationHookOptions<AddLocationMasterValueBoxMutation, AddLocationMasterValueBoxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLocationMasterValueBoxMutation, AddLocationMasterValueBoxMutationVariables>(AddLocationMasterValueBoxDocument, options);
      }
export type AddLocationMasterValueBoxMutationHookResult = ReturnType<typeof useAddLocationMasterValueBoxMutation>;
export type AddLocationMasterValueBoxMutationResult = Apollo.MutationResult<AddLocationMasterValueBoxMutation>;
export type AddLocationMasterValueBoxMutationOptions = Apollo.BaseMutationOptions<AddLocationMasterValueBoxMutation, AddLocationMasterValueBoxMutationVariables>;
export const AddLocationReportInfoDocument = gql`
    mutation AddLocationReportInfo($input: LocationReportInfoInput!) {
  addLocationReportInfo(input: $input)
}
    `;
export type AddLocationReportInfoMutationFn = Apollo.MutationFunction<AddLocationReportInfoMutation, AddLocationReportInfoMutationVariables>;

/**
 * __useAddLocationReportInfoMutation__
 *
 * To run a mutation, you first call `useAddLocationReportInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocationReportInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocationReportInfoMutation, { data, loading, error }] = useAddLocationReportInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLocationReportInfoMutation(baseOptions?: Apollo.MutationHookOptions<AddLocationReportInfoMutation, AddLocationReportInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLocationReportInfoMutation, AddLocationReportInfoMutationVariables>(AddLocationReportInfoDocument, options);
      }
export type AddLocationReportInfoMutationHookResult = ReturnType<typeof useAddLocationReportInfoMutation>;
export type AddLocationReportInfoMutationResult = Apollo.MutationResult<AddLocationReportInfoMutation>;
export type AddLocationReportInfoMutationOptions = Apollo.BaseMutationOptions<AddLocationReportInfoMutation, AddLocationReportInfoMutationVariables>;
export const DeleteLocationMasterGridDocument = gql`
    mutation DeleteLocationMasterGrid($Id: Int!) {
  deleteLocationMasterGrid(Id: $Id) {
    result
  }
}
    `;
export type DeleteLocationMasterGridMutationFn = Apollo.MutationFunction<DeleteLocationMasterGridMutation, DeleteLocationMasterGridMutationVariables>;

/**
 * __useDeleteLocationMasterGridMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMasterGridMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMasterGridMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMasterGridMutation, { data, loading, error }] = useDeleteLocationMasterGridMutation({
 *   variables: {
 *      Id: // value for 'Id'
 *   },
 * });
 */
export function useDeleteLocationMasterGridMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMasterGridMutation, DeleteLocationMasterGridMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMasterGridMutation, DeleteLocationMasterGridMutationVariables>(DeleteLocationMasterGridDocument, options);
      }
export type DeleteLocationMasterGridMutationHookResult = ReturnType<typeof useDeleteLocationMasterGridMutation>;
export type DeleteLocationMasterGridMutationResult = Apollo.MutationResult<DeleteLocationMasterGridMutation>;
export type DeleteLocationMasterGridMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMasterGridMutation, DeleteLocationMasterGridMutationVariables>;
export const DeleteLocationMasterValueBoxDocument = gql`
    mutation DeleteLocationMasterValueBox($boxId: Int!) {
  deleteLocationMasterValueBox(boxId: $boxId) {
    result
  }
}
    `;
export type DeleteLocationMasterValueBoxMutationFn = Apollo.MutationFunction<DeleteLocationMasterValueBoxMutation, DeleteLocationMasterValueBoxMutationVariables>;

/**
 * __useDeleteLocationMasterValueBoxMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMasterValueBoxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMasterValueBoxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMasterValueBoxMutation, { data, loading, error }] = useDeleteLocationMasterValueBoxMutation({
 *   variables: {
 *      boxId: // value for 'boxId'
 *   },
 * });
 */
export function useDeleteLocationMasterValueBoxMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMasterValueBoxMutation, DeleteLocationMasterValueBoxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMasterValueBoxMutation, DeleteLocationMasterValueBoxMutationVariables>(DeleteLocationMasterValueBoxDocument, options);
      }
export type DeleteLocationMasterValueBoxMutationHookResult = ReturnType<typeof useDeleteLocationMasterValueBoxMutation>;
export type DeleteLocationMasterValueBoxMutationResult = Apollo.MutationResult<DeleteLocationMasterValueBoxMutation>;
export type DeleteLocationMasterValueBoxMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMasterValueBoxMutation, DeleteLocationMasterValueBoxMutationVariables>;
export const DeleteLocationReportInfoDocument = gql`
    mutation DeleteLocationReportInfo($locationReportInfoId: Int!) {
  deleteLocationReportInfo(locationReportInfoId: $locationReportInfoId) {
    result
  }
}
    `;
export type DeleteLocationReportInfoMutationFn = Apollo.MutationFunction<DeleteLocationReportInfoMutation, DeleteLocationReportInfoMutationVariables>;

/**
 * __useDeleteLocationReportInfoMutation__
 *
 * To run a mutation, you first call `useDeleteLocationReportInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationReportInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationReportInfoMutation, { data, loading, error }] = useDeleteLocationReportInfoMutation({
 *   variables: {
 *      locationReportInfoId: // value for 'locationReportInfoId'
 *   },
 * });
 */
export function useDeleteLocationReportInfoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationReportInfoMutation, DeleteLocationReportInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationReportInfoMutation, DeleteLocationReportInfoMutationVariables>(DeleteLocationReportInfoDocument, options);
      }
export type DeleteLocationReportInfoMutationHookResult = ReturnType<typeof useDeleteLocationReportInfoMutation>;
export type DeleteLocationReportInfoMutationResult = Apollo.MutationResult<DeleteLocationReportInfoMutation>;
export type DeleteLocationReportInfoMutationOptions = Apollo.BaseMutationOptions<DeleteLocationReportInfoMutation, DeleteLocationReportInfoMutationVariables>;
export const DeleteLocationValueBoxEntryDocument = gql`
    mutation DeleteLocationValueBoxEntry($entryId: Int!) {
  deleteLocationValueBoxEntry(entryId: $entryId) {
    result
  }
}
    `;
export type DeleteLocationValueBoxEntryMutationFn = Apollo.MutationFunction<DeleteLocationValueBoxEntryMutation, DeleteLocationValueBoxEntryMutationVariables>;

/**
 * __useDeleteLocationValueBoxEntryMutation__
 *
 * To run a mutation, you first call `useDeleteLocationValueBoxEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationValueBoxEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationValueBoxEntryMutation, { data, loading, error }] = useDeleteLocationValueBoxEntryMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useDeleteLocationValueBoxEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationValueBoxEntryMutation, DeleteLocationValueBoxEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationValueBoxEntryMutation, DeleteLocationValueBoxEntryMutationVariables>(DeleteLocationValueBoxEntryDocument, options);
      }
export type DeleteLocationValueBoxEntryMutationHookResult = ReturnType<typeof useDeleteLocationValueBoxEntryMutation>;
export type DeleteLocationValueBoxEntryMutationResult = Apollo.MutationResult<DeleteLocationValueBoxEntryMutation>;
export type DeleteLocationValueBoxEntryMutationOptions = Apollo.BaseMutationOptions<DeleteLocationValueBoxEntryMutation, DeleteLocationValueBoxEntryMutationVariables>;
export const EditLocationMasterValueBoxDocument = gql`
    mutation EditLocationMasterValueBox($boxData: EditMasterValueBoxInput!) {
  editLocationMasterValueBox(boxData: $boxData) {
    id
  }
}
    `;
export type EditLocationMasterValueBoxMutationFn = Apollo.MutationFunction<EditLocationMasterValueBoxMutation, EditLocationMasterValueBoxMutationVariables>;

/**
 * __useEditLocationMasterValueBoxMutation__
 *
 * To run a mutation, you first call `useEditLocationMasterValueBoxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLocationMasterValueBoxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLocationMasterValueBoxMutation, { data, loading, error }] = useEditLocationMasterValueBoxMutation({
 *   variables: {
 *      boxData: // value for 'boxData'
 *   },
 * });
 */
export function useEditLocationMasterValueBoxMutation(baseOptions?: Apollo.MutationHookOptions<EditLocationMasterValueBoxMutation, EditLocationMasterValueBoxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLocationMasterValueBoxMutation, EditLocationMasterValueBoxMutationVariables>(EditLocationMasterValueBoxDocument, options);
      }
export type EditLocationMasterValueBoxMutationHookResult = ReturnType<typeof useEditLocationMasterValueBoxMutation>;
export type EditLocationMasterValueBoxMutationResult = Apollo.MutationResult<EditLocationMasterValueBoxMutation>;
export type EditLocationMasterValueBoxMutationOptions = Apollo.BaseMutationOptions<EditLocationMasterValueBoxMutation, EditLocationMasterValueBoxMutationVariables>;
export const EditLocationReportInfoDocument = gql`
    mutation EditLocationReportInfo($input: EditLocationReportInfoInput!) {
  editLocationReportInfo(input: $input) {
    id
  }
}
    `;
export type EditLocationReportInfoMutationFn = Apollo.MutationFunction<EditLocationReportInfoMutation, EditLocationReportInfoMutationVariables>;

/**
 * __useEditLocationReportInfoMutation__
 *
 * To run a mutation, you first call `useEditLocationReportInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLocationReportInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLocationReportInfoMutation, { data, loading, error }] = useEditLocationReportInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditLocationReportInfoMutation(baseOptions?: Apollo.MutationHookOptions<EditLocationReportInfoMutation, EditLocationReportInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLocationReportInfoMutation, EditLocationReportInfoMutationVariables>(EditLocationReportInfoDocument, options);
      }
export type EditLocationReportInfoMutationHookResult = ReturnType<typeof useEditLocationReportInfoMutation>;
export type EditLocationReportInfoMutationResult = Apollo.MutationResult<EditLocationReportInfoMutation>;
export type EditLocationReportInfoMutationOptions = Apollo.BaseMutationOptions<EditLocationReportInfoMutation, EditLocationReportInfoMutationVariables>;
export const EditLocationReportInfoReplyDocument = gql`
    mutation EditLocationReportInfoReply($input: EditLocationReportInfoReplyInput!) {
  editLocationReportInfoReply(input: $input) {
    id
  }
}
    `;
export type EditLocationReportInfoReplyMutationFn = Apollo.MutationFunction<EditLocationReportInfoReplyMutation, EditLocationReportInfoReplyMutationVariables>;

/**
 * __useEditLocationReportInfoReplyMutation__
 *
 * To run a mutation, you first call `useEditLocationReportInfoReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLocationReportInfoReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLocationReportInfoReplyMutation, { data, loading, error }] = useEditLocationReportInfoReplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditLocationReportInfoReplyMutation(baseOptions?: Apollo.MutationHookOptions<EditLocationReportInfoReplyMutation, EditLocationReportInfoReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLocationReportInfoReplyMutation, EditLocationReportInfoReplyMutationVariables>(EditLocationReportInfoReplyDocument, options);
      }
export type EditLocationReportInfoReplyMutationHookResult = ReturnType<typeof useEditLocationReportInfoReplyMutation>;
export type EditLocationReportInfoReplyMutationResult = Apollo.MutationResult<EditLocationReportInfoReplyMutation>;
export type EditLocationReportInfoReplyMutationOptions = Apollo.BaseMutationOptions<EditLocationReportInfoReplyMutation, EditLocationReportInfoReplyMutationVariables>;
export const CreateLocationTagDocument = gql`
    mutation CreateLocationTag($input: CreateLocationTagInput!) {
  createLocationTag(input: $input) {
    id
  }
}
    `;
export type CreateLocationTagMutationFn = Apollo.MutationFunction<CreateLocationTagMutation, CreateLocationTagMutationVariables>;

/**
 * __useCreateLocationTagMutation__
 *
 * To run a mutation, you first call `useCreateLocationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationTagMutation, { data, loading, error }] = useCreateLocationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationTagMutation, CreateLocationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationTagMutation, CreateLocationTagMutationVariables>(CreateLocationTagDocument, options);
      }
export type CreateLocationTagMutationHookResult = ReturnType<typeof useCreateLocationTagMutation>;
export type CreateLocationTagMutationResult = Apollo.MutationResult<CreateLocationTagMutation>;
export type CreateLocationTagMutationOptions = Apollo.BaseMutationOptions<CreateLocationTagMutation, CreateLocationTagMutationVariables>;
export const DeleteLocationTagDocument = gql`
    mutation DeleteLocationTag($tagId: Int!) {
  deleteLocationTag(tagId: $tagId)
}
    `;
export type DeleteLocationTagMutationFn = Apollo.MutationFunction<DeleteLocationTagMutation, DeleteLocationTagMutationVariables>;

/**
 * __useDeleteLocationTagMutation__
 *
 * To run a mutation, you first call `useDeleteLocationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationTagMutation, { data, loading, error }] = useDeleteLocationTagMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useDeleteLocationTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationTagMutation, DeleteLocationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationTagMutation, DeleteLocationTagMutationVariables>(DeleteLocationTagDocument, options);
      }
export type DeleteLocationTagMutationHookResult = ReturnType<typeof useDeleteLocationTagMutation>;
export type DeleteLocationTagMutationResult = Apollo.MutationResult<DeleteLocationTagMutation>;
export type DeleteLocationTagMutationOptions = Apollo.BaseMutationOptions<DeleteLocationTagMutation, DeleteLocationTagMutationVariables>;
export const ImportLocationDocument = gql`
    mutation ImportLocation($input: [ExcelImportDataInput!]!) {
  importLocation(input: $input) {
    id
    name
  }
}
    `;
export type ImportLocationMutationFn = Apollo.MutationFunction<ImportLocationMutation, ImportLocationMutationVariables>;

/**
 * __useImportLocationMutation__
 *
 * To run a mutation, you first call `useImportLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importLocationMutation, { data, loading, error }] = useImportLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportLocationMutation(baseOptions?: Apollo.MutationHookOptions<ImportLocationMutation, ImportLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportLocationMutation, ImportLocationMutationVariables>(ImportLocationDocument, options);
      }
export type ImportLocationMutationHookResult = ReturnType<typeof useImportLocationMutation>;
export type ImportLocationMutationResult = Apollo.MutationResult<ImportLocationMutation>;
export type ImportLocationMutationOptions = Apollo.BaseMutationOptions<ImportLocationMutation, ImportLocationMutationVariables>;
export const PromoteLocationDocument = gql`
    mutation PromoteLocation($id: Int!, $isPromoted: Boolean!) {
  promoteLocation(id: $id, isPromoted: $isPromoted) {
    id
    isPromoted
  }
}
    `;
export type PromoteLocationMutationFn = Apollo.MutationFunction<PromoteLocationMutation, PromoteLocationMutationVariables>;

/**
 * __usePromoteLocationMutation__
 *
 * To run a mutation, you first call `usePromoteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteLocationMutation, { data, loading, error }] = usePromoteLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isPromoted: // value for 'isPromoted'
 *   },
 * });
 */
export function usePromoteLocationMutation(baseOptions?: Apollo.MutationHookOptions<PromoteLocationMutation, PromoteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoteLocationMutation, PromoteLocationMutationVariables>(PromoteLocationDocument, options);
      }
export type PromoteLocationMutationHookResult = ReturnType<typeof usePromoteLocationMutation>;
export type PromoteLocationMutationResult = Apollo.MutationResult<PromoteLocationMutation>;
export type PromoteLocationMutationOptions = Apollo.BaseMutationOptions<PromoteLocationMutation, PromoteLocationMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($id: Int!, $name: String!, $address: String!, $postalCode: String!, $city: String!, $country: String!, $phLocationId: String!, $locationShortCode: String!, $tagIds: [Int!], $fromLocationId: Int, $toLocationId: Int, $type: String, $isPromoted: Boolean!) {
  updateLocation(
    input: {id: $id, name: $name, address: $address, postalCode: $postalCode, city: $city, country: $country, phLocationId: $phLocationId, locationShortCode: $locationShortCode, tagIds: $tagIds, fromLocationId: $fromLocationId, toLocationId: $toLocationId, type: $type, isPromoted: $isPromoted}
  ) {
    id
    name
    address
    postalCode
    city
    country
    type
    tags {
      id
      title
    }
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      address: // value for 'address'
 *      postalCode: // value for 'postalCode'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *      phLocationId: // value for 'phLocationId'
 *      locationShortCode: // value for 'locationShortCode'
 *      tagIds: // value for 'tagIds'
 *      fromLocationId: // value for 'fromLocationId'
 *      toLocationId: // value for 'toLocationId'
 *      type: // value for 'type'
 *      isPromoted: // value for 'isPromoted'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($name: String!, $address: String!, $postalCode: String!, $city: String!, $country: String!, $phLocationId: String!, $locationShortCode: String!, $type: String, $isPromoted: Boolean!) {
  createLocation(
    input: {name: $name, address: $address, postalCode: $postalCode, city: $city, country: $country, phLocationId: $phLocationId, locationShortCode: $locationShortCode, type: $type, isPromoted: $isPromoted}
  ) {
    id
    name
    address
    postalCode
    city
    country
    type
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      address: // value for 'address'
 *      postalCode: // value for 'postalCode'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *      phLocationId: // value for 'phLocationId'
 *      locationShortCode: // value for 'locationShortCode'
 *      type: // value for 'type'
 *      isPromoted: // value for 'isPromoted'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const AddLegToRouteDocument = gql`
    mutation AddLegToRoute($id: Int!, $input: [RouteLegInput!]!) {
  addLegToRoute(id: $id, input: $input) {
    id
  }
}
    `;
export type AddLegToRouteMutationFn = Apollo.MutationFunction<AddLegToRouteMutation, AddLegToRouteMutationVariables>;

/**
 * __useAddLegToRouteMutation__
 *
 * To run a mutation, you first call `useAddLegToRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLegToRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLegToRouteMutation, { data, loading, error }] = useAddLegToRouteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLegToRouteMutation(baseOptions?: Apollo.MutationHookOptions<AddLegToRouteMutation, AddLegToRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLegToRouteMutation, AddLegToRouteMutationVariables>(AddLegToRouteDocument, options);
      }
export type AddLegToRouteMutationHookResult = ReturnType<typeof useAddLegToRouteMutation>;
export type AddLegToRouteMutationResult = Apollo.MutationResult<AddLegToRouteMutation>;
export type AddLegToRouteMutationOptions = Apollo.BaseMutationOptions<AddLegToRouteMutation, AddLegToRouteMutationVariables>;
export const CreateMultipleSporadicRouteDocument = gql`
    mutation CreateMultipleSporadicRoute($input: SporadicRouteInput!, $dates: [String!]!) {
  createMultipleSporadicRoute(input: $input, dates: $dates)
}
    `;
export type CreateMultipleSporadicRouteMutationFn = Apollo.MutationFunction<CreateMultipleSporadicRouteMutation, CreateMultipleSporadicRouteMutationVariables>;

/**
 * __useCreateMultipleSporadicRouteMutation__
 *
 * To run a mutation, you first call `useCreateMultipleSporadicRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultipleSporadicRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultipleSporadicRouteMutation, { data, loading, error }] = useCreateMultipleSporadicRouteMutation({
 *   variables: {
 *      input: // value for 'input'
 *      dates: // value for 'dates'
 *   },
 * });
 */
export function useCreateMultipleSporadicRouteMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultipleSporadicRouteMutation, CreateMultipleSporadicRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultipleSporadicRouteMutation, CreateMultipleSporadicRouteMutationVariables>(CreateMultipleSporadicRouteDocument, options);
      }
export type CreateMultipleSporadicRouteMutationHookResult = ReturnType<typeof useCreateMultipleSporadicRouteMutation>;
export type CreateMultipleSporadicRouteMutationResult = Apollo.MutationResult<CreateMultipleSporadicRouteMutation>;
export type CreateMultipleSporadicRouteMutationOptions = Apollo.BaseMutationOptions<CreateMultipleSporadicRouteMutation, CreateMultipleSporadicRouteMutationVariables>;
export const CreateSporadicRouteDocument = gql`
    mutation CreateSporadicRoute($input: SporadicRouteInput!, $numberOfCopies: Int) {
  createSporadicRoute(input: $input, numberOfCopies: $numberOfCopies) {
    id
    routeId
    isUnplannedRoute
    legs {
      locationId
      transportationDate
      position
      arrivalTime
      actualArrivalTime
      actualDepartureTime
      departureTime
    }
  }
}
    `;
export type CreateSporadicRouteMutationFn = Apollo.MutationFunction<CreateSporadicRouteMutation, CreateSporadicRouteMutationVariables>;

/**
 * __useCreateSporadicRouteMutation__
 *
 * To run a mutation, you first call `useCreateSporadicRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSporadicRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSporadicRouteMutation, { data, loading, error }] = useCreateSporadicRouteMutation({
 *   variables: {
 *      input: // value for 'input'
 *      numberOfCopies: // value for 'numberOfCopies'
 *   },
 * });
 */
export function useCreateSporadicRouteMutation(baseOptions?: Apollo.MutationHookOptions<CreateSporadicRouteMutation, CreateSporadicRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSporadicRouteMutation, CreateSporadicRouteMutationVariables>(CreateSporadicRouteDocument, options);
      }
export type CreateSporadicRouteMutationHookResult = ReturnType<typeof useCreateSporadicRouteMutation>;
export type CreateSporadicRouteMutationResult = Apollo.MutationResult<CreateSporadicRouteMutation>;
export type CreateSporadicRouteMutationOptions = Apollo.BaseMutationOptions<CreateSporadicRouteMutation, CreateSporadicRouteMutationVariables>;
export const CreateSporadicRouteV2Document = gql`
    mutation CreateSporadicRouteV2($input: SporadicRouteInputV2!) {
  createSporadicRouteV2(input: $input) {
    id
    routeId
  }
}
    `;
export type CreateSporadicRouteV2MutationFn = Apollo.MutationFunction<CreateSporadicRouteV2Mutation, CreateSporadicRouteV2MutationVariables>;

/**
 * __useCreateSporadicRouteV2Mutation__
 *
 * To run a mutation, you first call `useCreateSporadicRouteV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSporadicRouteV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSporadicRouteV2Mutation, { data, loading, error }] = useCreateSporadicRouteV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSporadicRouteV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateSporadicRouteV2Mutation, CreateSporadicRouteV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSporadicRouteV2Mutation, CreateSporadicRouteV2MutationVariables>(CreateSporadicRouteV2Document, options);
      }
export type CreateSporadicRouteV2MutationHookResult = ReturnType<typeof useCreateSporadicRouteV2Mutation>;
export type CreateSporadicRouteV2MutationResult = Apollo.MutationResult<CreateSporadicRouteV2Mutation>;
export type CreateSporadicRouteV2MutationOptions = Apollo.BaseMutationOptions<CreateSporadicRouteV2Mutation, CreateSporadicRouteV2MutationVariables>;
export const CreateSporadicRouteWithoutDispatcherDocument = gql`
    mutation CreateSporadicRouteWithoutDispatcher($input: SporadicRouteInput!) {
  createSporadicRouteWithoutDispatcher(input: $input) {
    id
  }
}
    `;
export type CreateSporadicRouteWithoutDispatcherMutationFn = Apollo.MutationFunction<CreateSporadicRouteWithoutDispatcherMutation, CreateSporadicRouteWithoutDispatcherMutationVariables>;

/**
 * __useCreateSporadicRouteWithoutDispatcherMutation__
 *
 * To run a mutation, you first call `useCreateSporadicRouteWithoutDispatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSporadicRouteWithoutDispatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSporadicRouteWithoutDispatcherMutation, { data, loading, error }] = useCreateSporadicRouteWithoutDispatcherMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSporadicRouteWithoutDispatcherMutation(baseOptions?: Apollo.MutationHookOptions<CreateSporadicRouteWithoutDispatcherMutation, CreateSporadicRouteWithoutDispatcherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSporadicRouteWithoutDispatcherMutation, CreateSporadicRouteWithoutDispatcherMutationVariables>(CreateSporadicRouteWithoutDispatcherDocument, options);
      }
export type CreateSporadicRouteWithoutDispatcherMutationHookResult = ReturnType<typeof useCreateSporadicRouteWithoutDispatcherMutation>;
export type CreateSporadicRouteWithoutDispatcherMutationResult = Apollo.MutationResult<CreateSporadicRouteWithoutDispatcherMutation>;
export type CreateSporadicRouteWithoutDispatcherMutationOptions = Apollo.BaseMutationOptions<CreateSporadicRouteWithoutDispatcherMutation, CreateSporadicRouteWithoutDispatcherMutationVariables>;
export const DeleteMultiplePlannedRouteDocument = gql`
    mutation DeleteMultiplePlannedRoute($ids: [Int!]!) {
  deleteMultipleRoute(ids: $ids)
}
    `;
export type DeleteMultiplePlannedRouteMutationFn = Apollo.MutationFunction<DeleteMultiplePlannedRouteMutation, DeleteMultiplePlannedRouteMutationVariables>;

/**
 * __useDeleteMultiplePlannedRouteMutation__
 *
 * To run a mutation, you first call `useDeleteMultiplePlannedRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMultiplePlannedRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMultiplePlannedRouteMutation, { data, loading, error }] = useDeleteMultiplePlannedRouteMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteMultiplePlannedRouteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMultiplePlannedRouteMutation, DeleteMultiplePlannedRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMultiplePlannedRouteMutation, DeleteMultiplePlannedRouteMutationVariables>(DeleteMultiplePlannedRouteDocument, options);
      }
export type DeleteMultiplePlannedRouteMutationHookResult = ReturnType<typeof useDeleteMultiplePlannedRouteMutation>;
export type DeleteMultiplePlannedRouteMutationResult = Apollo.MutationResult<DeleteMultiplePlannedRouteMutation>;
export type DeleteMultiplePlannedRouteMutationOptions = Apollo.BaseMutationOptions<DeleteMultiplePlannedRouteMutation, DeleteMultiplePlannedRouteMutationVariables>;
export const DeleteSporadicRouteDocument = gql`
    mutation DeleteSporadicRoute($id: Int!) {
  deleteRoute(id: $id)
}
    `;
export type DeleteSporadicRouteMutationFn = Apollo.MutationFunction<DeleteSporadicRouteMutation, DeleteSporadicRouteMutationVariables>;

/**
 * __useDeleteSporadicRouteMutation__
 *
 * To run a mutation, you first call `useDeleteSporadicRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSporadicRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSporadicRouteMutation, { data, loading, error }] = useDeleteSporadicRouteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSporadicRouteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSporadicRouteMutation, DeleteSporadicRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSporadicRouteMutation, DeleteSporadicRouteMutationVariables>(DeleteSporadicRouteDocument, options);
      }
export type DeleteSporadicRouteMutationHookResult = ReturnType<typeof useDeleteSporadicRouteMutation>;
export type DeleteSporadicRouteMutationResult = Apollo.MutationResult<DeleteSporadicRouteMutation>;
export type DeleteSporadicRouteMutationOptions = Apollo.BaseMutationOptions<DeleteSporadicRouteMutation, DeleteSporadicRouteMutationVariables>;
export const UpdateCostAllocationDocument = gql`
    mutation UpdateCostAllocation($id: Int!, $costAllocation: UpdateCostAllocationInput!) {
  updateCostAllocation(id: $id, costAllocation: $costAllocation) {
    id
    routeId
    agreedPrice
    currency
    costAllocation {
      id
      items {
        id
        departmentId
        cost
        includedKpi
        includedPrice
        bringCost
        additionalCost
        additionalDiscount
        type
        comment
        tags
        currency
        location {
          id
          name
          type
        }
      }
    }
  }
}
    `;
export type UpdateCostAllocationMutationFn = Apollo.MutationFunction<UpdateCostAllocationMutation, UpdateCostAllocationMutationVariables>;

/**
 * __useUpdateCostAllocationMutation__
 *
 * To run a mutation, you first call `useUpdateCostAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCostAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCostAllocationMutation, { data, loading, error }] = useUpdateCostAllocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      costAllocation: // value for 'costAllocation'
 *   },
 * });
 */
export function useUpdateCostAllocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCostAllocationMutation, UpdateCostAllocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCostAllocationMutation, UpdateCostAllocationMutationVariables>(UpdateCostAllocationDocument, options);
      }
export type UpdateCostAllocationMutationHookResult = ReturnType<typeof useUpdateCostAllocationMutation>;
export type UpdateCostAllocationMutationResult = Apollo.MutationResult<UpdateCostAllocationMutation>;
export type UpdateCostAllocationMutationOptions = Apollo.BaseMutationOptions<UpdateCostAllocationMutation, UpdateCostAllocationMutationVariables>;
export const UpdateDriverDocument = gql`
    mutation UpdateDriver($id: Int!, $driverData: DriverInfo!) {
  updateDriver(id: $id, driverData: $driverData) {
    id
    driverName
    driverPhoneNumber
    licensePlate
  }
}
    `;
export type UpdateDriverMutationFn = Apollo.MutationFunction<UpdateDriverMutation, UpdateDriverMutationVariables>;

/**
 * __useUpdateDriverMutation__
 *
 * To run a mutation, you first call `useUpdateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverMutation, { data, loading, error }] = useUpdateDriverMutation({
 *   variables: {
 *      id: // value for 'id'
 *      driverData: // value for 'driverData'
 *   },
 * });
 */
export function useUpdateDriverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverMutation, UpdateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverMutation, UpdateDriverMutationVariables>(UpdateDriverDocument, options);
      }
export type UpdateDriverMutationHookResult = ReturnType<typeof useUpdateDriverMutation>;
export type UpdateDriverMutationResult = Apollo.MutationResult<UpdateDriverMutation>;
export type UpdateDriverMutationOptions = Apollo.BaseMutationOptions<UpdateDriverMutation, UpdateDriverMutationVariables>;
export const UpdateExtraColumnsDocument = gql`
    mutation UpdateExtraColumns($id: Int!, $extraColumnData: extraColumnInfo!) {
  updateExtraColumns(id: $id, extraColumnData: $extraColumnData) {
    id
    adr
    turnummer
    togref
    bpx
    pri03
    pri49
    upri03
    upri49
    parti
    brev
    pru
    pip
    tom
    rutekode
    trainNumber
    inneholdsbeskrivelse
    containerId
    transportType
    assigned
    ansvBefraktare
    timeWhenAssigned
    receivedByTraffic
    nameReceivedByTraffic
    timeReceivedByTraffic
    lastUpdatedBy
  }
}
    `;
export type UpdateExtraColumnsMutationFn = Apollo.MutationFunction<UpdateExtraColumnsMutation, UpdateExtraColumnsMutationVariables>;

/**
 * __useUpdateExtraColumnsMutation__
 *
 * To run a mutation, you first call `useUpdateExtraColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtraColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExtraColumnsMutation, { data, loading, error }] = useUpdateExtraColumnsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      extraColumnData: // value for 'extraColumnData'
 *   },
 * });
 */
export function useUpdateExtraColumnsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExtraColumnsMutation, UpdateExtraColumnsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExtraColumnsMutation, UpdateExtraColumnsMutationVariables>(UpdateExtraColumnsDocument, options);
      }
export type UpdateExtraColumnsMutationHookResult = ReturnType<typeof useUpdateExtraColumnsMutation>;
export type UpdateExtraColumnsMutationResult = Apollo.MutationResult<UpdateExtraColumnsMutation>;
export type UpdateExtraColumnsMutationOptions = Apollo.BaseMutationOptions<UpdateExtraColumnsMutation, UpdateExtraColumnsMutationVariables>;
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($id: Int!, $invoiceData: InvoiceDataInput!) {
  updateInvoice(id: $id, invoiceData: $invoiceData) {
    id
    invoiceNote
    invoiceNumber
    agreedPrice
  }
}
    `;
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      invoiceData: // value for 'invoiceData'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
      }
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const UpdateLockDocument = gql`
    mutation updateLock($routeId: Int!, $lock: Int!, $reload: Int!) {
  updateLock(routeId: $routeId, lock: $lock, reload: $reload) {
    routeId
    lockedAt
    lockedBy
  }
}
    `;
export type UpdateLockMutationFn = Apollo.MutationFunction<UpdateLockMutation, UpdateLockMutationVariables>;

/**
 * __useUpdateLockMutation__
 *
 * To run a mutation, you first call `useUpdateLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLockMutation, { data, loading, error }] = useUpdateLockMutation({
 *   variables: {
 *      routeId: // value for 'routeId'
 *      lock: // value for 'lock'
 *      reload: // value for 'reload'
 *   },
 * });
 */
export function useUpdateLockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLockMutation, UpdateLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLockMutation, UpdateLockMutationVariables>(UpdateLockDocument, options);
      }
export type UpdateLockMutationHookResult = ReturnType<typeof useUpdateLockMutation>;
export type UpdateLockMutationResult = Apollo.MutationResult<UpdateLockMutation>;
export type UpdateLockMutationOptions = Apollo.BaseMutationOptions<UpdateLockMutation, UpdateLockMutationVariables>;
export const UpdateLockOnBulkRoutesDocument = gql`
    mutation UpdateLockOnBulkRoutes($routeIds: [Int!]!, $isLock: Boolean!, $forGroup: String!) {
  updateLockOnBulkRoutes(
    routeIds: $routeIds
    isLock: $isLock
    forGroup: $forGroup
  )
}
    `;
export type UpdateLockOnBulkRoutesMutationFn = Apollo.MutationFunction<UpdateLockOnBulkRoutesMutation, UpdateLockOnBulkRoutesMutationVariables>;

/**
 * __useUpdateLockOnBulkRoutesMutation__
 *
 * To run a mutation, you first call `useUpdateLockOnBulkRoutesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLockOnBulkRoutesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLockOnBulkRoutesMutation, { data, loading, error }] = useUpdateLockOnBulkRoutesMutation({
 *   variables: {
 *      routeIds: // value for 'routeIds'
 *      isLock: // value for 'isLock'
 *      forGroup: // value for 'forGroup'
 *   },
 * });
 */
export function useUpdateLockOnBulkRoutesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLockOnBulkRoutesMutation, UpdateLockOnBulkRoutesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLockOnBulkRoutesMutation, UpdateLockOnBulkRoutesMutationVariables>(UpdateLockOnBulkRoutesDocument, options);
      }
export type UpdateLockOnBulkRoutesMutationHookResult = ReturnType<typeof useUpdateLockOnBulkRoutesMutation>;
export type UpdateLockOnBulkRoutesMutationResult = Apollo.MutationResult<UpdateLockOnBulkRoutesMutation>;
export type UpdateLockOnBulkRoutesMutationOptions = Apollo.BaseMutationOptions<UpdateLockOnBulkRoutesMutation, UpdateLockOnBulkRoutesMutationVariables>;
export const UpdateMinimalRouteDocument = gql`
    mutation UpdateMinimalRoute($input: UpdateMinimalRouteInput!) {
  updateMinimalRoutes(input: $input)
}
    `;
export type UpdateMinimalRouteMutationFn = Apollo.MutationFunction<UpdateMinimalRouteMutation, UpdateMinimalRouteMutationVariables>;

/**
 * __useUpdateMinimalRouteMutation__
 *
 * To run a mutation, you first call `useUpdateMinimalRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMinimalRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMinimalRouteMutation, { data, loading, error }] = useUpdateMinimalRouteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMinimalRouteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMinimalRouteMutation, UpdateMinimalRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMinimalRouteMutation, UpdateMinimalRouteMutationVariables>(UpdateMinimalRouteDocument, options);
      }
export type UpdateMinimalRouteMutationHookResult = ReturnType<typeof useUpdateMinimalRouteMutation>;
export type UpdateMinimalRouteMutationResult = Apollo.MutationResult<UpdateMinimalRouteMutation>;
export type UpdateMinimalRouteMutationOptions = Apollo.BaseMutationOptions<UpdateMinimalRouteMutation, UpdateMinimalRouteMutationVariables>;
export const UpdateRouteDocument = gql`
    mutation UpdateRoute($routeId: Int!, $input: SporadicRouteInput!) {
  updateRoute(id: $routeId, input: $input) {
    agreedPrice
    capacity
    currency
    dispatcher {
      id
      email
      name
      phoneNumber
      tags {
        id
        title
      }
    }
    driverName
    driverPhoneNumber
    files {
      id
      mimetype
      originalname
      path
      size
      tags {
        id
        title
      }
    }
    ftl {
      cdc
      cmr
      currency
      customerId
      customerNumber
      customerReference
      id
      invoiceNote
      price
    }
    id
    invoiceNote
    invoiceNumber
    legs {
      gateNumber
      carRegistrationNumber
      trailerRegistrationNumber
      routeDriverName
      routeDriverPhoneNumber
      arrivalTime
      departureTime
      id
      load
      note
      position
      unload
      locationId
    }
    licensePlate
    note
    externalNote
    routeId
    subcontractorLocationId
    transportationDate
    type
    isCreatedFromTerminal
    isCreatedFromPlanned
    rutekode
    turnummer
    routeTag
  }
}
    `;
export type UpdateRouteMutationFn = Apollo.MutationFunction<UpdateRouteMutation, UpdateRouteMutationVariables>;

/**
 * __useUpdateRouteMutation__
 *
 * To run a mutation, you first call `useUpdateRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRouteMutation, { data, loading, error }] = useUpdateRouteMutation({
 *   variables: {
 *      routeId: // value for 'routeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRouteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRouteMutation, UpdateRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRouteMutation, UpdateRouteMutationVariables>(UpdateRouteDocument, options);
      }
export type UpdateRouteMutationHookResult = ReturnType<typeof useUpdateRouteMutation>;
export type UpdateRouteMutationResult = Apollo.MutationResult<UpdateRouteMutation>;
export type UpdateRouteMutationOptions = Apollo.BaseMutationOptions<UpdateRouteMutation, UpdateRouteMutationVariables>;
export const UpdateRouteGroupTagDocument = gql`
    mutation UpdateRouteGroupTag($id: Int!, $routeGroupTag: String!) {
  updateRouteGroupTag(id: $id, routeGroupTag: $routeGroupTag)
}
    `;
export type UpdateRouteGroupTagMutationFn = Apollo.MutationFunction<UpdateRouteGroupTagMutation, UpdateRouteGroupTagMutationVariables>;

/**
 * __useUpdateRouteGroupTagMutation__
 *
 * To run a mutation, you first call `useUpdateRouteGroupTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRouteGroupTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRouteGroupTagMutation, { data, loading, error }] = useUpdateRouteGroupTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      routeGroupTag: // value for 'routeGroupTag'
 *   },
 * });
 */
export function useUpdateRouteGroupTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRouteGroupTagMutation, UpdateRouteGroupTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRouteGroupTagMutation, UpdateRouteGroupTagMutationVariables>(UpdateRouteGroupTagDocument, options);
      }
export type UpdateRouteGroupTagMutationHookResult = ReturnType<typeof useUpdateRouteGroupTagMutation>;
export type UpdateRouteGroupTagMutationResult = Apollo.MutationResult<UpdateRouteGroupTagMutation>;
export type UpdateRouteGroupTagMutationOptions = Apollo.BaseMutationOptions<UpdateRouteGroupTagMutation, UpdateRouteGroupTagMutationVariables>;
export const UpdateRouteLegDataColumnsDocument = gql`
    mutation updateRouteLegDataColumns($id: Int!, $routeLegData: RouteLegDataColumnInfo!) {
  updateRouteLegDataColumns(id: $id, routeLegData: $routeLegData) {
    id
    carRegistrationNumber
    trailerRegistrationNumber
  }
}
    `;
export type UpdateRouteLegDataColumnsMutationFn = Apollo.MutationFunction<UpdateRouteLegDataColumnsMutation, UpdateRouteLegDataColumnsMutationVariables>;

/**
 * __useUpdateRouteLegDataColumnsMutation__
 *
 * To run a mutation, you first call `useUpdateRouteLegDataColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRouteLegDataColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRouteLegDataColumnsMutation, { data, loading, error }] = useUpdateRouteLegDataColumnsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      routeLegData: // value for 'routeLegData'
 *   },
 * });
 */
export function useUpdateRouteLegDataColumnsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRouteLegDataColumnsMutation, UpdateRouteLegDataColumnsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRouteLegDataColumnsMutation, UpdateRouteLegDataColumnsMutationVariables>(UpdateRouteLegDataColumnsDocument, options);
      }
export type UpdateRouteLegDataColumnsMutationHookResult = ReturnType<typeof useUpdateRouteLegDataColumnsMutation>;
export type UpdateRouteLegDataColumnsMutationResult = Apollo.MutationResult<UpdateRouteLegDataColumnsMutation>;
export type UpdateRouteLegDataColumnsMutationOptions = Apollo.BaseMutationOptions<UpdateRouteLegDataColumnsMutation, UpdateRouteLegDataColumnsMutationVariables>;
export const UpdateRouteLevelColumnsDocument = gql`
    mutation UpdateRouteLevelColumns($id: Int!, $routeColumnData: RouteLevelInfo!) {
  updateRouteLevelColumns(id: $id, routeColumnData: $routeColumnData) {
    id
    routeId
    note
    externalNote
    lastUpdatedBy
  }
}
    `;
export type UpdateRouteLevelColumnsMutationFn = Apollo.MutationFunction<UpdateRouteLevelColumnsMutation, UpdateRouteLevelColumnsMutationVariables>;

/**
 * __useUpdateRouteLevelColumnsMutation__
 *
 * To run a mutation, you first call `useUpdateRouteLevelColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRouteLevelColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRouteLevelColumnsMutation, { data, loading, error }] = useUpdateRouteLevelColumnsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      routeColumnData: // value for 'routeColumnData'
 *   },
 * });
 */
export function useUpdateRouteLevelColumnsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRouteLevelColumnsMutation, UpdateRouteLevelColumnsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRouteLevelColumnsMutation, UpdateRouteLevelColumnsMutationVariables>(UpdateRouteLevelColumnsDocument, options);
      }
export type UpdateRouteLevelColumnsMutationHookResult = ReturnType<typeof useUpdateRouteLevelColumnsMutation>;
export type UpdateRouteLevelColumnsMutationResult = Apollo.MutationResult<UpdateRouteLevelColumnsMutation>;
export type UpdateRouteLevelColumnsMutationOptions = Apollo.BaseMutationOptions<UpdateRouteLevelColumnsMutation, UpdateRouteLevelColumnsMutationVariables>;
export const UpdateRouteV2Document = gql`
    mutation UpdateRouteV2($id: Int!, $input: SporadicRouteInputV2!) {
  updateRouteV2(id: $id, input: $input) {
    id
    routeId
    transportationDate
  }
}
    `;
export type UpdateRouteV2MutationFn = Apollo.MutationFunction<UpdateRouteV2Mutation, UpdateRouteV2MutationVariables>;

/**
 * __useUpdateRouteV2Mutation__
 *
 * To run a mutation, you first call `useUpdateRouteV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRouteV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRouteV2Mutation, { data, loading, error }] = useUpdateRouteV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRouteV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateRouteV2Mutation, UpdateRouteV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRouteV2Mutation, UpdateRouteV2MutationVariables>(UpdateRouteV2Document, options);
      }
export type UpdateRouteV2MutationHookResult = ReturnType<typeof useUpdateRouteV2Mutation>;
export type UpdateRouteV2MutationResult = Apollo.MutationResult<UpdateRouteV2Mutation>;
export type UpdateRouteV2MutationOptions = Apollo.BaseMutationOptions<UpdateRouteV2Mutation, UpdateRouteV2MutationVariables>;
export const UpdateSporadicRouteDocument = gql`
    mutation UpdateSporadicRoute($routeId: Int!, $input: SporadicRouteInput!) {
  updateSporadicRoute(id: $routeId, input: $input) {
    agreedPrice
    capacity
    currency
    dispatcher {
      id
      email
      name
      phoneNumber
      tags {
        id
        title
      }
    }
    driverName
    driverPhoneNumber
    files {
      id
      mimetype
      originalname
      path
      size
      tags {
        id
        title
      }
    }
    ftl {
      cdc
      cmr
      currency
      locationId
      customerNumber
      customerReference
      id
      invoiceNote
      price
    }
    id
    invoiceNote
    invoiceNumber
    legs {
      gateNumber
      carRegistrationNumber
      trailerRegistrationNumber
      routeDriverName
      routeDriverPhoneNumber
      arrivalTime
      departureTime
      id
      load
      note
      position
      unload
      locationId
    }
    licensePlate
    note
    externalNote
    routeId
    subcontractorLocationId
    transportationDate
    type
    isCreatedFromTerminal
    isCreatedFromPlanned
  }
}
    `;
export type UpdateSporadicRouteMutationFn = Apollo.MutationFunction<UpdateSporadicRouteMutation, UpdateSporadicRouteMutationVariables>;

/**
 * __useUpdateSporadicRouteMutation__
 *
 * To run a mutation, you first call `useUpdateSporadicRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSporadicRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSporadicRouteMutation, { data, loading, error }] = useUpdateSporadicRouteMutation({
 *   variables: {
 *      routeId: // value for 'routeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSporadicRouteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSporadicRouteMutation, UpdateSporadicRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSporadicRouteMutation, UpdateSporadicRouteMutationVariables>(UpdateSporadicRouteDocument, options);
      }
export type UpdateSporadicRouteMutationHookResult = ReturnType<typeof useUpdateSporadicRouteMutation>;
export type UpdateSporadicRouteMutationResult = Apollo.MutationResult<UpdateSporadicRouteMutation>;
export type UpdateSporadicRouteMutationOptions = Apollo.BaseMutationOptions<UpdateSporadicRouteMutation, UpdateSporadicRouteMutationVariables>;
export const UpdateSporadicRouteV2Document = gql`
    mutation UpdateSporadicRouteV2($routeId: Int!, $input: SporadicRouteInputV2!) {
  updateSporadicRouteV2(id: $routeId, input: $input) {
    id
    routeId
  }
}
    `;
export type UpdateSporadicRouteV2MutationFn = Apollo.MutationFunction<UpdateSporadicRouteV2Mutation, UpdateSporadicRouteV2MutationVariables>;

/**
 * __useUpdateSporadicRouteV2Mutation__
 *
 * To run a mutation, you first call `useUpdateSporadicRouteV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSporadicRouteV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSporadicRouteV2Mutation, { data, loading, error }] = useUpdateSporadicRouteV2Mutation({
 *   variables: {
 *      routeId: // value for 'routeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSporadicRouteV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateSporadicRouteV2Mutation, UpdateSporadicRouteV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSporadicRouteV2Mutation, UpdateSporadicRouteV2MutationVariables>(UpdateSporadicRouteV2Document, options);
      }
export type UpdateSporadicRouteV2MutationHookResult = ReturnType<typeof useUpdateSporadicRouteV2Mutation>;
export type UpdateSporadicRouteV2MutationResult = Apollo.MutationResult<UpdateSporadicRouteV2Mutation>;
export type UpdateSporadicRouteV2MutationOptions = Apollo.BaseMutationOptions<UpdateSporadicRouteV2Mutation, UpdateSporadicRouteV2MutationVariables>;
export const UpdateSettingDocument = gql`
    mutation updateSetting($id: Int!, $input: SettingInput!) {
  updateSetting(id: $id, input: $input) {
    id
    version
  }
}
    `;
export type UpdateSettingMutationFn = Apollo.MutationFunction<UpdateSettingMutation, UpdateSettingMutationVariables>;

/**
 * __useUpdateSettingMutation__
 *
 * To run a mutation, you first call `useUpdateSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingMutation, { data, loading, error }] = useUpdateSettingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingMutation, UpdateSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingMutation, UpdateSettingMutationVariables>(UpdateSettingDocument, options);
      }
export type UpdateSettingMutationHookResult = ReturnType<typeof useUpdateSettingMutation>;
export type UpdateSettingMutationResult = Apollo.MutationResult<UpdateSettingMutation>;
export type UpdateSettingMutationOptions = Apollo.BaseMutationOptions<UpdateSettingMutation, UpdateSettingMutationVariables>;
export const CreateShipmentDocument = gql`
    mutation CreateShipment($input: CreateShipmentInput!) {
  createShipment(input: $input) {
    id
  }
}
    `;
export type CreateShipmentMutationFn = Apollo.MutationFunction<CreateShipmentMutation, CreateShipmentMutationVariables>;

/**
 * __useCreateShipmentMutation__
 *
 * To run a mutation, you first call `useCreateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentMutation, { data, loading, error }] = useCreateShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShipmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateShipmentMutation, CreateShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShipmentMutation, CreateShipmentMutationVariables>(CreateShipmentDocument, options);
      }
export type CreateShipmentMutationHookResult = ReturnType<typeof useCreateShipmentMutation>;
export type CreateShipmentMutationResult = Apollo.MutationResult<CreateShipmentMutation>;
export type CreateShipmentMutationOptions = Apollo.BaseMutationOptions<CreateShipmentMutation, CreateShipmentMutationVariables>;
export const DeleteShipmentDocument = gql`
    mutation DeleteShipment($id: Int!, $updatedFrom: String!, $shipmentDate: String!) {
  deleteShipment(id: $id, updatedFrom: $updatedFrom, shipmentDate: $shipmentDate)
}
    `;
export type DeleteShipmentMutationFn = Apollo.MutationFunction<DeleteShipmentMutation, DeleteShipmentMutationVariables>;

/**
 * __useDeleteShipmentMutation__
 *
 * To run a mutation, you first call `useDeleteShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShipmentMutation, { data, loading, error }] = useDeleteShipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedFrom: // value for 'updatedFrom'
 *      shipmentDate: // value for 'shipmentDate'
 *   },
 * });
 */
export function useDeleteShipmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShipmentMutation, DeleteShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShipmentMutation, DeleteShipmentMutationVariables>(DeleteShipmentDocument, options);
      }
export type DeleteShipmentMutationHookResult = ReturnType<typeof useDeleteShipmentMutation>;
export type DeleteShipmentMutationResult = Apollo.MutationResult<DeleteShipmentMutation>;
export type DeleteShipmentMutationOptions = Apollo.BaseMutationOptions<DeleteShipmentMutation, DeleteShipmentMutationVariables>;
export const GetShipmentDocument = gql`
    query GetShipment($startDate: String!, $endDate: String!) {
  shipments(startDate: $startDate, endDate: $endDate) {
    id
    name
    shipmentDate
    createdFrom
    updatedFrom
    createdBy
    lastUpdatedBy
    updatedAt
    fromLocationId
    toLocationId
    loadingListItems {
      weight
      customClearedForImport
      isRemainingGoods
      isVoecCustomer
      customCleared
      terminalCleared
      isImportedFromShipment
      packages
      pallets
      palletSpace
    }
  }
}
    `;

/**
 * __useGetShipmentQuery__
 *
 * To run a query within a React component, call `useGetShipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetShipmentQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentQuery, GetShipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, options);
      }
export function useGetShipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentQuery, GetShipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, options);
        }
export type GetShipmentQueryHookResult = ReturnType<typeof useGetShipmentQuery>;
export type GetShipmentLazyQueryHookResult = ReturnType<typeof useGetShipmentLazyQuery>;
export type GetShipmentQueryResult = Apollo.QueryResult<GetShipmentQuery, GetShipmentQueryVariables>;
export const GetShipmentByIdDocument = gql`
    query GetShipmentById($id: Int!) {
  shipmentById(id: $id) {
    id
    name
    shipmentDate
    fromLocationId
    toLocationId
    lastUpdatedBy
    createdFrom
    updatedFrom
    createdBy
    lastUpdatedBy
    loadingListItems {
      id
      locationId
      location {
        name
      }
      packages
      pallets
      palletSpace
      weight
      checked
      isDangerous
      classification
      unNumber
      isLimitedQty
      note
      customVOECId
      customInvoiceNo
      customMrnNo
      customWaybillNo
      customCmrNo
      customNote
      connectedNB
      customCleared
      customClearedForImport
      isRemainingGoods
      isVoecCustomer
      terminalShipmentNotArrived
      terminalCleared
      terminalNotCleared
      terminalDevPackages
      terminalDevPallets
      terminalDevPalletSpace
      terminalDevWeight
      terminalDevInfo
      isImportedFromShipment
      customsProcedure
      routeDetail {
        id
        routeName
      }
      tags {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetShipmentByIdQuery__
 *
 * To run a query within a React component, call `useGetShipmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShipmentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentByIdQuery, GetShipmentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentByIdQuery, GetShipmentByIdQueryVariables>(GetShipmentByIdDocument, options);
      }
export function useGetShipmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentByIdQuery, GetShipmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentByIdQuery, GetShipmentByIdQueryVariables>(GetShipmentByIdDocument, options);
        }
export type GetShipmentByIdQueryHookResult = ReturnType<typeof useGetShipmentByIdQuery>;
export type GetShipmentByIdLazyQueryHookResult = ReturnType<typeof useGetShipmentByIdLazyQuery>;
export type GetShipmentByIdQueryResult = Apollo.QueryResult<GetShipmentByIdQuery, GetShipmentByIdQueryVariables>;
export const GetShipmentTemplatesDocument = gql`
    query GetShipmentTemplates {
  shipmentTemplates {
    id
    name
    createdFrom
    updatedFrom
    createdBy
    lastUpdatedBy
  }
}
    `;

/**
 * __useGetShipmentTemplatesQuery__
 *
 * To run a query within a React component, call `useGetShipmentTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShipmentTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetShipmentTemplatesQuery, GetShipmentTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentTemplatesQuery, GetShipmentTemplatesQueryVariables>(GetShipmentTemplatesDocument, options);
      }
export function useGetShipmentTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentTemplatesQuery, GetShipmentTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentTemplatesQuery, GetShipmentTemplatesQueryVariables>(GetShipmentTemplatesDocument, options);
        }
export type GetShipmentTemplatesQueryHookResult = ReturnType<typeof useGetShipmentTemplatesQuery>;
export type GetShipmentTemplatesLazyQueryHookResult = ReturnType<typeof useGetShipmentTemplatesLazyQuery>;
export type GetShipmentTemplatesQueryResult = Apollo.QueryResult<GetShipmentTemplatesQuery, GetShipmentTemplatesQueryVariables>;
export const GetShipmentsByDateDocument = gql`
    query GetShipmentsByDate($forDate: String!, $fromLocationId: Int) {
  shipmentsByDate(forDate: $forDate, fromLocationId: $fromLocationId) {
    id
    name
    shipmentDate
    shipmentStatus
    fromLocationId
    toLocationId
    createdBy
    lastUpdatedBy
    createdFrom
    updatedFrom
    loadingListItems {
      id
      locationId
      checked
      isDangerous
      packages
      pallets
      palletSpace
      weight
      note
      unNumber
      isLimitedQty
      classification
      isImportedFromShipment
      routeDetail {
        id
        routeName
      }
      customVOECId
      customInvoiceNo
      customMrnNo
      customWaybillNo
      customCmrNo
      customNote
      connectedNB
      customCleared
      customClearedForImport
      isRemainingGoods
      isVoecCustomer
      terminalShipmentNotArrived
      terminalCleared
      terminalNotCleared
      terminalDevPackages
      terminalDevPallets
      terminalDevPalletSpace
      terminalDevWeight
      terminalDevInfo
      files {
        id
        originalname
        mimetype
        path
        size
      }
    }
  }
}
    `;

/**
 * __useGetShipmentsByDateQuery__
 *
 * To run a query within a React component, call `useGetShipmentsByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentsByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentsByDateQuery({
 *   variables: {
 *      forDate: // value for 'forDate'
 *      fromLocationId: // value for 'fromLocationId'
 *   },
 * });
 */
export function useGetShipmentsByDateQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentsByDateQuery, GetShipmentsByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentsByDateQuery, GetShipmentsByDateQueryVariables>(GetShipmentsByDateDocument, options);
      }
export function useGetShipmentsByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentsByDateQuery, GetShipmentsByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentsByDateQuery, GetShipmentsByDateQueryVariables>(GetShipmentsByDateDocument, options);
        }
export type GetShipmentsByDateQueryHookResult = ReturnType<typeof useGetShipmentsByDateQuery>;
export type GetShipmentsByDateLazyQueryHookResult = ReturnType<typeof useGetShipmentsByDateLazyQuery>;
export type GetShipmentsByDateQueryResult = Apollo.QueryResult<GetShipmentsByDateQuery, GetShipmentsByDateQueryVariables>;
export const UpdatePartialShipmentDocument = gql`
    mutation UpdatePartialShipment($input: ShipmentPartialUpdateInput!) {
  updatePartialShipment(input: $input)
}
    `;
export type UpdatePartialShipmentMutationFn = Apollo.MutationFunction<UpdatePartialShipmentMutation, UpdatePartialShipmentMutationVariables>;

/**
 * __useUpdatePartialShipmentMutation__
 *
 * To run a mutation, you first call `useUpdatePartialShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartialShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartialShipmentMutation, { data, loading, error }] = useUpdatePartialShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePartialShipmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartialShipmentMutation, UpdatePartialShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartialShipmentMutation, UpdatePartialShipmentMutationVariables>(UpdatePartialShipmentDocument, options);
      }
export type UpdatePartialShipmentMutationHookResult = ReturnType<typeof useUpdatePartialShipmentMutation>;
export type UpdatePartialShipmentMutationResult = Apollo.MutationResult<UpdatePartialShipmentMutation>;
export type UpdatePartialShipmentMutationOptions = Apollo.BaseMutationOptions<UpdatePartialShipmentMutation, UpdatePartialShipmentMutationVariables>;
export const EditShipmentDocument = gql`
    mutation EditShipment($input: ShipmentEditInput!, $orderListUnchanged: Boolean) {
  updateShipment(input: $input, orderListUnchanged: $orderListUnchanged) {
    id
  }
}
    `;
export type EditShipmentMutationFn = Apollo.MutationFunction<EditShipmentMutation, EditShipmentMutationVariables>;

/**
 * __useEditShipmentMutation__
 *
 * To run a mutation, you first call `useEditShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editShipmentMutation, { data, loading, error }] = useEditShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      orderListUnchanged: // value for 'orderListUnchanged'
 *   },
 * });
 */
export function useEditShipmentMutation(baseOptions?: Apollo.MutationHookOptions<EditShipmentMutation, EditShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditShipmentMutation, EditShipmentMutationVariables>(EditShipmentDocument, options);
      }
export type EditShipmentMutationHookResult = ReturnType<typeof useEditShipmentMutation>;
export type EditShipmentMutationResult = Apollo.MutationResult<EditShipmentMutation>;
export type EditShipmentMutationOptions = Apollo.BaseMutationOptions<EditShipmentMutation, EditShipmentMutationVariables>;
export const CreateShipmentTagDocument = gql`
    mutation CreateShipmentTag($title: String!) {
  createShipmentTag(title: $title) {
    id
  }
}
    `;
export type CreateShipmentTagMutationFn = Apollo.MutationFunction<CreateShipmentTagMutation, CreateShipmentTagMutationVariables>;

/**
 * __useCreateShipmentTagMutation__
 *
 * To run a mutation, you first call `useCreateShipmentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipmentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentTagMutation, { data, loading, error }] = useCreateShipmentTagMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateShipmentTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateShipmentTagMutation, CreateShipmentTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShipmentTagMutation, CreateShipmentTagMutationVariables>(CreateShipmentTagDocument, options);
      }
export type CreateShipmentTagMutationHookResult = ReturnType<typeof useCreateShipmentTagMutation>;
export type CreateShipmentTagMutationResult = Apollo.MutationResult<CreateShipmentTagMutation>;
export type CreateShipmentTagMutationOptions = Apollo.BaseMutationOptions<CreateShipmentTagMutation, CreateShipmentTagMutationVariables>;
export const DeleteShipmentTagDocument = gql`
    mutation DeleteShipmentTag($tagId: Int!) {
  deleteShipmentTag(tagId: $tagId)
}
    `;
export type DeleteShipmentTagMutationFn = Apollo.MutationFunction<DeleteShipmentTagMutation, DeleteShipmentTagMutationVariables>;

/**
 * __useDeleteShipmentTagMutation__
 *
 * To run a mutation, you first call `useDeleteShipmentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShipmentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShipmentTagMutation, { data, loading, error }] = useDeleteShipmentTagMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useDeleteShipmentTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShipmentTagMutation, DeleteShipmentTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShipmentTagMutation, DeleteShipmentTagMutationVariables>(DeleteShipmentTagDocument, options);
      }
export type DeleteShipmentTagMutationHookResult = ReturnType<typeof useDeleteShipmentTagMutation>;
export type DeleteShipmentTagMutationResult = Apollo.MutationResult<DeleteShipmentTagMutation>;
export type DeleteShipmentTagMutationOptions = Apollo.BaseMutationOptions<DeleteShipmentTagMutation, DeleteShipmentTagMutationVariables>;
export const AddTagByTypeDocument = gql`
    mutation AddTagByType($type: String!, $tag: String!) {
  addTagByType(type: $type, tag: $tag)
}
    `;
export type AddTagByTypeMutationFn = Apollo.MutationFunction<AddTagByTypeMutation, AddTagByTypeMutationVariables>;

/**
 * __useAddTagByTypeMutation__
 *
 * To run a mutation, you first call `useAddTagByTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagByTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagByTypeMutation, { data, loading, error }] = useAddTagByTypeMutation({
 *   variables: {
 *      type: // value for 'type'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useAddTagByTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddTagByTypeMutation, AddTagByTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagByTypeMutation, AddTagByTypeMutationVariables>(AddTagByTypeDocument, options);
      }
export type AddTagByTypeMutationHookResult = ReturnType<typeof useAddTagByTypeMutation>;
export type AddTagByTypeMutationResult = Apollo.MutationResult<AddTagByTypeMutation>;
export type AddTagByTypeMutationOptions = Apollo.BaseMutationOptions<AddTagByTypeMutation, AddTagByTypeMutationVariables>;
export const CreateTourTemplateDocument = gql`
    mutation CreateTourTemplate($TourTemplateInput: TourTemplateInput!) {
  createTourTemplate(input: $TourTemplateInput) {
    id
  }
}
    `;
export type CreateTourTemplateMutationFn = Apollo.MutationFunction<CreateTourTemplateMutation, CreateTourTemplateMutationVariables>;

/**
 * __useCreateTourTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTourTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTourTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTourTemplateMutation, { data, loading, error }] = useCreateTourTemplateMutation({
 *   variables: {
 *      TourTemplateInput: // value for 'TourTemplateInput'
 *   },
 * });
 */
export function useCreateTourTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateTourTemplateMutation, CreateTourTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTourTemplateMutation, CreateTourTemplateMutationVariables>(CreateTourTemplateDocument, options);
      }
export type CreateTourTemplateMutationHookResult = ReturnType<typeof useCreateTourTemplateMutation>;
export type CreateTourTemplateMutationResult = Apollo.MutationResult<CreateTourTemplateMutation>;
export type CreateTourTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTourTemplateMutation, CreateTourTemplateMutationVariables>;
export const DeleteTourTemplateDocument = gql`
    mutation DeleteTourTemplate($id: Int!) {
  deleteTourTemplate(id: $id)
}
    `;
export type DeleteTourTemplateMutationFn = Apollo.MutationFunction<DeleteTourTemplateMutation, DeleteTourTemplateMutationVariables>;

/**
 * __useDeleteTourTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTourTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTourTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTourTemplateMutation, { data, loading, error }] = useDeleteTourTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTourTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTourTemplateMutation, DeleteTourTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTourTemplateMutation, DeleteTourTemplateMutationVariables>(DeleteTourTemplateDocument, options);
      }
export type DeleteTourTemplateMutationHookResult = ReturnType<typeof useDeleteTourTemplateMutation>;
export type DeleteTourTemplateMutationResult = Apollo.MutationResult<DeleteTourTemplateMutation>;
export type DeleteTourTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteTourTemplateMutation, DeleteTourTemplateMutationVariables>;
export const DispatchRouteDocument = gql`
    mutation DispatchRoute($input: FixedTourGenerateInput!) {
  generateFixedTour(input: $input) {
    status
    createdRouteId
    routeType
    date
  }
}
    `;
export type DispatchRouteMutationFn = Apollo.MutationFunction<DispatchRouteMutation, DispatchRouteMutationVariables>;

/**
 * __useDispatchRouteMutation__
 *
 * To run a mutation, you first call `useDispatchRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispatchRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispatchRouteMutation, { data, loading, error }] = useDispatchRouteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDispatchRouteMutation(baseOptions?: Apollo.MutationHookOptions<DispatchRouteMutation, DispatchRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DispatchRouteMutation, DispatchRouteMutationVariables>(DispatchRouteDocument, options);
      }
export type DispatchRouteMutationHookResult = ReturnType<typeof useDispatchRouteMutation>;
export type DispatchRouteMutationResult = Apollo.MutationResult<DispatchRouteMutation>;
export type DispatchRouteMutationOptions = Apollo.BaseMutationOptions<DispatchRouteMutation, DispatchRouteMutationVariables>;
export const UpdateBookmarkDocument = gql`
    mutation UpdateBookmark($id: Int!, $bookmark: Boolean!) {
  updateBookmark(id: $id, bookmark: $bookmark) {
    id
    bookmark
  }
}
    `;
export type UpdateBookmarkMutationFn = Apollo.MutationFunction<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>;

/**
 * __useUpdateBookmarkMutation__
 *
 * To run a mutation, you first call `useUpdateBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookmarkMutation, { data, loading, error }] = useUpdateBookmarkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      bookmark: // value for 'bookmark'
 *   },
 * });
 */
export function useUpdateBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>(UpdateBookmarkDocument, options);
      }
export type UpdateBookmarkMutationHookResult = ReturnType<typeof useUpdateBookmarkMutation>;
export type UpdateBookmarkMutationResult = Apollo.MutationResult<UpdateBookmarkMutation>;
export type UpdateBookmarkMutationOptions = Apollo.BaseMutationOptions<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>;
export const UpdateTourTemplateDocument = gql`
    mutation UpdateTourTemplate($id: Int!, $input: TourTemplateInput!) {
  updateTourTemplate(id: $id, input: $input) {
    id
    name
    subcontractorLocationId
    dispatcherId
    capacity
    fuel
    price
    currency
    startDate
    endDate
    originalStartDate
    startExceptionDate
    endExceptionDate
    exceptionDates
    note
    driverName
    driverPhoneNumber
    licensePlate
    createdBy
    lastUpdatedBy
    createdAt
    updatedAt
    responsiblePerson
    groupingTag
    isPriceEquallyDivided
    sameSubcontractorToAllRoutes
    templateType
    country
    department
    isInactive
  }
}
    `;
export type UpdateTourTemplateMutationFn = Apollo.MutationFunction<UpdateTourTemplateMutation, UpdateTourTemplateMutationVariables>;

/**
 * __useUpdateTourTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTourTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTourTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTourTemplateMutation, { data, loading, error }] = useUpdateTourTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTourTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTourTemplateMutation, UpdateTourTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTourTemplateMutation, UpdateTourTemplateMutationVariables>(UpdateTourTemplateDocument, options);
      }
export type UpdateTourTemplateMutationHookResult = ReturnType<typeof useUpdateTourTemplateMutation>;
export type UpdateTourTemplateMutationResult = Apollo.MutationResult<UpdateTourTemplateMutation>;
export type UpdateTourTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTourTemplateMutation, UpdateTourTemplateMutationVariables>;
export const ConnectLocationDocument = gql`
    mutation ConnectLocation($locationId: Int!) {
  connectLocation(locationId: $locationId) {
    roles
    lastName
    fullName
    firstName
    department
    createdAt
    id
    locationId
    location {
      name
      id
    }
  }
}
    `;
export type ConnectLocationMutationFn = Apollo.MutationFunction<ConnectLocationMutation, ConnectLocationMutationVariables>;

/**
 * __useConnectLocationMutation__
 *
 * To run a mutation, you first call `useConnectLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectLocationMutation, { data, loading, error }] = useConnectLocationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useConnectLocationMutation(baseOptions?: Apollo.MutationHookOptions<ConnectLocationMutation, ConnectLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectLocationMutation, ConnectLocationMutationVariables>(ConnectLocationDocument, options);
      }
export type ConnectLocationMutationHookResult = ReturnType<typeof useConnectLocationMutation>;
export type ConnectLocationMutationResult = Apollo.MutationResult<ConnectLocationMutation>;
export type ConnectLocationMutationOptions = Apollo.BaseMutationOptions<ConnectLocationMutation, ConnectLocationMutationVariables>;
export const GetStatusDocument = gql`
    query GetStatus {
  status
}
    `;

/**
 * __useGetStatusQuery__
 *
 * To run a query within a React component, call `useGetStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetStatusQuery, GetStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusQuery, GetStatusQueryVariables>(GetStatusDocument, options);
      }
export function useGetStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusQuery, GetStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusQuery, GetStatusQueryVariables>(GetStatusDocument, options);
        }
export type GetStatusQueryHookResult = ReturnType<typeof useGetStatusQuery>;
export type GetStatusLazyQueryHookResult = ReturnType<typeof useGetStatusLazyQuery>;
export type GetStatusQueryResult = Apollo.QueryResult<GetStatusQuery, GetStatusQueryVariables>;
export const SendManualAlertsOnSporadicRouteCreateDocument = gql`
    query SendManualAlertsOnSporadicRouteCreate($emails: String!, $route: CreateRouteAlertInput!) {
  sendManualAlertsOnSporadicRouteCreate(emails: $emails, route: $route)
}
    `;

/**
 * __useSendManualAlertsOnSporadicRouteCreateQuery__
 *
 * To run a query within a React component, call `useSendManualAlertsOnSporadicRouteCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendManualAlertsOnSporadicRouteCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendManualAlertsOnSporadicRouteCreateQuery({
 *   variables: {
 *      emails: // value for 'emails'
 *      route: // value for 'route'
 *   },
 * });
 */
export function useSendManualAlertsOnSporadicRouteCreateQuery(baseOptions: Apollo.QueryHookOptions<SendManualAlertsOnSporadicRouteCreateQuery, SendManualAlertsOnSporadicRouteCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendManualAlertsOnSporadicRouteCreateQuery, SendManualAlertsOnSporadicRouteCreateQueryVariables>(SendManualAlertsOnSporadicRouteCreateDocument, options);
      }
export function useSendManualAlertsOnSporadicRouteCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendManualAlertsOnSporadicRouteCreateQuery, SendManualAlertsOnSporadicRouteCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendManualAlertsOnSporadicRouteCreateQuery, SendManualAlertsOnSporadicRouteCreateQueryVariables>(SendManualAlertsOnSporadicRouteCreateDocument, options);
        }
export type SendManualAlertsOnSporadicRouteCreateQueryHookResult = ReturnType<typeof useSendManualAlertsOnSporadicRouteCreateQuery>;
export type SendManualAlertsOnSporadicRouteCreateLazyQueryHookResult = ReturnType<typeof useSendManualAlertsOnSporadicRouteCreateLazyQuery>;
export type SendManualAlertsOnSporadicRouteCreateQueryResult = Apollo.QueryResult<SendManualAlertsOnSporadicRouteCreateQuery, SendManualAlertsOnSporadicRouteCreateQueryVariables>;
export const SendDriverNotificationDocument = gql`
    query SendDriverNotification($phoneNumber: String!, $message: String!) {
  sendDriverNotification(phoneNumber: $phoneNumber, message: $message)
}
    `;

/**
 * __useSendDriverNotificationQuery__
 *
 * To run a query within a React component, call `useSendDriverNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendDriverNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendDriverNotificationQuery({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendDriverNotificationQuery(baseOptions: Apollo.QueryHookOptions<SendDriverNotificationQuery, SendDriverNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendDriverNotificationQuery, SendDriverNotificationQueryVariables>(SendDriverNotificationDocument, options);
      }
export function useSendDriverNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendDriverNotificationQuery, SendDriverNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendDriverNotificationQuery, SendDriverNotificationQueryVariables>(SendDriverNotificationDocument, options);
        }
export type SendDriverNotificationQueryHookResult = ReturnType<typeof useSendDriverNotificationQuery>;
export type SendDriverNotificationLazyQueryHookResult = ReturnType<typeof useSendDriverNotificationLazyQuery>;
export type SendDriverNotificationQueryResult = Apollo.QueryResult<SendDriverNotificationQuery, SendDriverNotificationQueryVariables>;
export const GetAllLocationsWithSearchDocument = gql`
    query getAllLocationsWithSearch($search: String) {
  allLocationWithSearch(search: $search) {
    ...LocationsFields
    contacts {
      id
      name
    }
  }
}
    ${LocationsFieldsFragmentDoc}`;

/**
 * __useGetAllLocationsWithSearchQuery__
 *
 * To run a query within a React component, call `useGetAllLocationsWithSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationsWithSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocationsWithSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAllLocationsWithSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLocationsWithSearchQuery, GetAllLocationsWithSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLocationsWithSearchQuery, GetAllLocationsWithSearchQueryVariables>(GetAllLocationsWithSearchDocument, options);
      }
export function useGetAllLocationsWithSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLocationsWithSearchQuery, GetAllLocationsWithSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLocationsWithSearchQuery, GetAllLocationsWithSearchQueryVariables>(GetAllLocationsWithSearchDocument, options);
        }
export type GetAllLocationsWithSearchQueryHookResult = ReturnType<typeof useGetAllLocationsWithSearchQuery>;
export type GetAllLocationsWithSearchLazyQueryHookResult = ReturnType<typeof useGetAllLocationsWithSearchLazyQuery>;
export type GetAllLocationsWithSearchQueryResult = Apollo.QueryResult<GetAllLocationsWithSearchQuery, GetAllLocationsWithSearchQueryVariables>;
export const GetLocationsWithContactsDocument = gql`
    query GetLocationsWithContacts {
  getLocationsWithContacts {
    ...LocationsFields
    contacts {
      ...CardContactFields
    }
  }
}
    ${LocationsFieldsFragmentDoc}
${CardContactFieldsFragmentDoc}`;

/**
 * __useGetLocationsWithContactsQuery__
 *
 * To run a query within a React component, call `useGetLocationsWithContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsWithContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsWithContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsWithContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationsWithContactsQuery, GetLocationsWithContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsWithContactsQuery, GetLocationsWithContactsQueryVariables>(GetLocationsWithContactsDocument, options);
      }
export function useGetLocationsWithContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsWithContactsQuery, GetLocationsWithContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsWithContactsQuery, GetLocationsWithContactsQueryVariables>(GetLocationsWithContactsDocument, options);
        }
export type GetLocationsWithContactsQueryHookResult = ReturnType<typeof useGetLocationsWithContactsQuery>;
export type GetLocationsWithContactsLazyQueryHookResult = ReturnType<typeof useGetLocationsWithContactsLazyQuery>;
export type GetLocationsWithContactsQueryResult = Apollo.QueryResult<GetLocationsWithContactsQuery, GetLocationsWithContactsQueryVariables>;
export const GetContactDocument = gql`
    query GetContact($id: Int!) {
  locationContact(id: $id) {
    id
    name
    role
    email
    phoneNumber
    tags {
      id
      title
    }
    note
    lastUpdatedBy
    createdBy
    updatedAt
  }
}
    `;

/**
 * __useGetContactQuery__
 *
 * To run a query within a React component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactQuery(baseOptions: Apollo.QueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
      }
export function useGetContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
export type GetContactQueryHookResult = ReturnType<typeof useGetContactQuery>;
export type GetContactLazyQueryHookResult = ReturnType<typeof useGetContactLazyQuery>;
export type GetContactQueryResult = Apollo.QueryResult<GetContactQuery, GetContactQueryVariables>;
export const GetContactsForLocationDocument = gql`
    query GetContactsForLocation($locationId: Int, $contactId: Int) {
  locationContacts(locationId: $locationId, contactId: $contactId) {
    id
    name
    tags {
      title
    }
    phoneNumber
    email
    note
  }
}
    `;

/**
 * __useGetContactsForLocationQuery__
 *
 * To run a query within a React component, call `useGetContactsForLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsForLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsForLocationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactsForLocationQuery(baseOptions?: Apollo.QueryHookOptions<GetContactsForLocationQuery, GetContactsForLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsForLocationQuery, GetContactsForLocationQueryVariables>(GetContactsForLocationDocument, options);
      }
export function useGetContactsForLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsForLocationQuery, GetContactsForLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsForLocationQuery, GetContactsForLocationQueryVariables>(GetContactsForLocationDocument, options);
        }
export type GetContactsForLocationQueryHookResult = ReturnType<typeof useGetContactsForLocationQuery>;
export type GetContactsForLocationLazyQueryHookResult = ReturnType<typeof useGetContactsForLocationLazyQuery>;
export type GetContactsForLocationQueryResult = Apollo.QueryResult<GetContactsForLocationQuery, GetContactsForLocationQueryVariables>;
export const GetDepartmentsDocument = gql`
    query GetDepartments {
  departments {
    id
    name
  }
}
    `;

/**
 * __useGetDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, options);
      }
export function useGetDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, options);
        }
export type GetDepartmentsQueryHookResult = ReturnType<typeof useGetDepartmentsQuery>;
export type GetDepartmentsLazyQueryHookResult = ReturnType<typeof useGetDepartmentsLazyQuery>;
export type GetDepartmentsQueryResult = Apollo.QueryResult<GetDepartmentsQuery, GetDepartmentsQueryVariables>;
export const GetDeviationForEmailDocument = gql`
    query GetDeviationForEmail($id: Int!) {
  deviation(id: $id) {
    id
    localMessageCustomers
    englishMessageCustomers
    customers {
      id
      name
      contacts {
        id
        name
        email
      }
    }
    deviationToCustomer {
      locationId
      deviationId
      lastEmailSent
    }
    deviationToLocation {
      location {
        id
      }
      reason
      deviationId
      lastEmailSent
    }
  }
}
    `;

/**
 * __useGetDeviationForEmailQuery__
 *
 * To run a query within a React component, call `useGetDeviationForEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviationForEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviationForEmailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDeviationForEmailQuery(baseOptions: Apollo.QueryHookOptions<GetDeviationForEmailQuery, GetDeviationForEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviationForEmailQuery, GetDeviationForEmailQueryVariables>(GetDeviationForEmailDocument, options);
      }
export function useGetDeviationForEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviationForEmailQuery, GetDeviationForEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviationForEmailQuery, GetDeviationForEmailQueryVariables>(GetDeviationForEmailDocument, options);
        }
export type GetDeviationForEmailQueryHookResult = ReturnType<typeof useGetDeviationForEmailQuery>;
export type GetDeviationForEmailLazyQueryHookResult = ReturnType<typeof useGetDeviationForEmailLazyQuery>;
export type GetDeviationForEmailQueryResult = Apollo.QueryResult<GetDeviationForEmailQuery, GetDeviationForEmailQueryVariables>;
export const GetDeviationToLocationForDeviationIdDocument = gql`
    query GetDeviationToLocationForDeviationId($deviationId: Int!) {
  deviationToLocationForDeviationId(deviationId: $deviationId) {
    id
    deviationId
    locationId
    lastEmailSent
    pallets
    locationItemNote
    packages
    palletSpace
    weight
    reason
    otherReason
    newCustomer
    isDangerous
  }
}
    `;

/**
 * __useGetDeviationToLocationForDeviationIdQuery__
 *
 * To run a query within a React component, call `useGetDeviationToLocationForDeviationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviationToLocationForDeviationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviationToLocationForDeviationIdQuery({
 *   variables: {
 *      deviationId: // value for 'deviationId'
 *   },
 * });
 */
export function useGetDeviationToLocationForDeviationIdQuery(baseOptions: Apollo.QueryHookOptions<GetDeviationToLocationForDeviationIdQuery, GetDeviationToLocationForDeviationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviationToLocationForDeviationIdQuery, GetDeviationToLocationForDeviationIdQueryVariables>(GetDeviationToLocationForDeviationIdDocument, options);
      }
export function useGetDeviationToLocationForDeviationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviationToLocationForDeviationIdQuery, GetDeviationToLocationForDeviationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviationToLocationForDeviationIdQuery, GetDeviationToLocationForDeviationIdQueryVariables>(GetDeviationToLocationForDeviationIdDocument, options);
        }
export type GetDeviationToLocationForDeviationIdQueryHookResult = ReturnType<typeof useGetDeviationToLocationForDeviationIdQuery>;
export type GetDeviationToLocationForDeviationIdLazyQueryHookResult = ReturnType<typeof useGetDeviationToLocationForDeviationIdLazyQuery>;
export type GetDeviationToLocationForDeviationIdQueryResult = Apollo.QueryResult<GetDeviationToLocationForDeviationIdQuery, GetDeviationToLocationForDeviationIdQueryVariables>;
export const GetDeviationsDocument = gql`
    query GetDeviations($startDate: String!, $endDate: String!, $searchTerm: String) {
  deviations(startDate: $startDate, endDate: $endDate, searchTerm: $searchTerm) {
    id
    cause
    fault
    routeId
    route {
      id
      routeId
      type
      licensePlate
      capacity
      transportationDate
      subcontractorLocation {
        id
        name
        address
      }
      legs {
        arrivalTime
        position
        location {
          city
          country
        }
      }
    }
    faultLocation {
      id
      name
      address
      postalCode
      city
      country
    }
    note
    consequence
    actualArrivalTime
    createdBy
  }
}
    `;

/**
 * __useGetDeviationsQuery__
 *
 * To run a query within a React component, call `useGetDeviationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviationsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetDeviationsQuery(baseOptions: Apollo.QueryHookOptions<GetDeviationsQuery, GetDeviationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviationsQuery, GetDeviationsQueryVariables>(GetDeviationsDocument, options);
      }
export function useGetDeviationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviationsQuery, GetDeviationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviationsQuery, GetDeviationsQueryVariables>(GetDeviationsDocument, options);
        }
export type GetDeviationsQueryHookResult = ReturnType<typeof useGetDeviationsQuery>;
export type GetDeviationsLazyQueryHookResult = ReturnType<typeof useGetDeviationsLazyQuery>;
export type GetDeviationsQueryResult = Apollo.QueryResult<GetDeviationsQuery, GetDeviationsQueryVariables>;
export const GetDeviationsForRouteDocument = gql`
    query GetDeviationsForRoute($routeId: Int!) {
  deviationsForRoute(routeId: $routeId) {
    id
    cause
    fault
    routeId
    emailSent
    faultLocation {
      id
      name
      address
      postalCode
      city
      country
    }
    route {
      legs {
        arrivalTime
      }
    }
    note
    consequence
    actualArrivalTime
    createdBy
  }
}
    `;

/**
 * __useGetDeviationsForRouteQuery__
 *
 * To run a query within a React component, call `useGetDeviationsForRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviationsForRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviationsForRouteQuery({
 *   variables: {
 *      routeId: // value for 'routeId'
 *   },
 * });
 */
export function useGetDeviationsForRouteQuery(baseOptions: Apollo.QueryHookOptions<GetDeviationsForRouteQuery, GetDeviationsForRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviationsForRouteQuery, GetDeviationsForRouteQueryVariables>(GetDeviationsForRouteDocument, options);
      }
export function useGetDeviationsForRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviationsForRouteQuery, GetDeviationsForRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviationsForRouteQuery, GetDeviationsForRouteQueryVariables>(GetDeviationsForRouteDocument, options);
        }
export type GetDeviationsForRouteQueryHookResult = ReturnType<typeof useGetDeviationsForRouteQuery>;
export type GetDeviationsForRouteLazyQueryHookResult = ReturnType<typeof useGetDeviationsForRouteLazyQuery>;
export type GetDeviationsForRouteQueryResult = Apollo.QueryResult<GetDeviationsForRouteQuery, GetDeviationsForRouteQueryVariables>;
export const GetLocationDeviationsDocument = gql`
    query GetLocationDeviations($startDate: String!, $endDate: String!, $searchTerm: String, $terminalIds: [Int!]) {
  getLocationDeviations(
    startDate: $startDate
    endDate: $endDate
    searchTerm: $searchTerm
    terminalIds: $terminalIds
  ) {
    id
    deviationId
    routeId
    faultLocationId
    toLocationId
    deviationApplicableDate
    routeNameOrFaultLocation
    customerId
    customerName
    pallets
    packages
    palletSpace
    weight
    reason
    otherReason
    newCustomer
    locationItemNote
    cause
    fault
    faultLocation
    toLocation
    fromToToCountry
    toCity
    customerLocation
    type
    emailSent
    emailSentTimestamp
    consequence
    actualArrivalTime
    createdBy
    lastUpdatedBy
    isDangerous
  }
}
    `;

/**
 * __useGetLocationDeviationsQuery__
 *
 * To run a query within a React component, call `useGetLocationDeviationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationDeviationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationDeviationsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      searchTerm: // value for 'searchTerm'
 *      terminalIds: // value for 'terminalIds'
 *   },
 * });
 */
export function useGetLocationDeviationsQuery(baseOptions: Apollo.QueryHookOptions<GetLocationDeviationsQuery, GetLocationDeviationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationDeviationsQuery, GetLocationDeviationsQueryVariables>(GetLocationDeviationsDocument, options);
      }
export function useGetLocationDeviationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationDeviationsQuery, GetLocationDeviationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationDeviationsQuery, GetLocationDeviationsQueryVariables>(GetLocationDeviationsDocument, options);
        }
export type GetLocationDeviationsQueryHookResult = ReturnType<typeof useGetLocationDeviationsQuery>;
export type GetLocationDeviationsLazyQueryHookResult = ReturnType<typeof useGetLocationDeviationsLazyQuery>;
export type GetLocationDeviationsQueryResult = Apollo.QueryResult<GetLocationDeviationsQuery, GetLocationDeviationsQueryVariables>;
export const GetFilesDocument = gql`
    query GetFiles {
  files {
    id
    originalname
    mimetype
    path
    size
    createdAt
    createdBy
    tags {
      id
      title
    }
  }
}
    `;

/**
 * __useGetFilesQuery__
 *
 * To run a query within a React component, call `useGetFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetFilesQuery, GetFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
      }
export function useGetFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesQuery, GetFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
        }
export type GetFilesQueryHookResult = ReturnType<typeof useGetFilesQuery>;
export type GetFilesLazyQueryHookResult = ReturnType<typeof useGetFilesLazyQuery>;
export type GetFilesQueryResult = Apollo.QueryResult<GetFilesQuery, GetFilesQueryVariables>;
export const GetFilesForRouteDocument = gql`
    query GetFilesForRoute($routeId: Int!) {
  getFilesForRouteId(routeId: $routeId) {
    id
    originalname
    mimetype
    path
    size
    createdAt
    createdBy
    tags {
      id
      title
    }
  }
}
    `;

/**
 * __useGetFilesForRouteQuery__
 *
 * To run a query within a React component, call `useGetFilesForRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesForRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesForRouteQuery({
 *   variables: {
 *      routeId: // value for 'routeId'
 *   },
 * });
 */
export function useGetFilesForRouteQuery(baseOptions: Apollo.QueryHookOptions<GetFilesForRouteQuery, GetFilesForRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesForRouteQuery, GetFilesForRouteQueryVariables>(GetFilesForRouteDocument, options);
      }
export function useGetFilesForRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesForRouteQuery, GetFilesForRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesForRouteQuery, GetFilesForRouteQueryVariables>(GetFilesForRouteDocument, options);
        }
export type GetFilesForRouteQueryHookResult = ReturnType<typeof useGetFilesForRouteQuery>;
export type GetFilesForRouteLazyQueryHookResult = ReturnType<typeof useGetFilesForRouteLazyQuery>;
export type GetFilesForRouteQueryResult = Apollo.QueryResult<GetFilesForRouteQuery, GetFilesForRouteQueryVariables>;
export const GetDocumentFileTagsDocument = gql`
    query GetDocumentFileTags {
  documentFileTags {
    id
    title
  }
}
    `;

/**
 * __useGetDocumentFileTagsQuery__
 *
 * To run a query within a React component, call `useGetDocumentFileTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentFileTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentFileTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocumentFileTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentFileTagsQuery, GetDocumentFileTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentFileTagsQuery, GetDocumentFileTagsQueryVariables>(GetDocumentFileTagsDocument, options);
      }
export function useGetDocumentFileTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentFileTagsQuery, GetDocumentFileTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentFileTagsQuery, GetDocumentFileTagsQueryVariables>(GetDocumentFileTagsDocument, options);
        }
export type GetDocumentFileTagsQueryHookResult = ReturnType<typeof useGetDocumentFileTagsQuery>;
export type GetDocumentFileTagsLazyQueryHookResult = ReturnType<typeof useGetDocumentFileTagsLazyQuery>;
export type GetDocumentFileTagsQueryResult = Apollo.QueryResult<GetDocumentFileTagsQuery, GetDocumentFileTagsQueryVariables>;
export const GetFixedTrafficLegsDocument = gql`
    query GetFixedTrafficLegs($terminalId: Int!) {
  fixedTrafficLegs(terminalId: $terminalId) {
    id
    routeId
    tourId
    capacity
    days
    arrivalTime
    departureTime
    departureCity
    arrivalCity
    subcontractorLocation {
      id
      name
    }
    load
    unload
    note
    startDate
  }
}
    `;

/**
 * __useGetFixedTrafficLegsQuery__
 *
 * To run a query within a React component, call `useGetFixedTrafficLegsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFixedTrafficLegsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFixedTrafficLegsQuery({
 *   variables: {
 *      terminalId: // value for 'terminalId'
 *   },
 * });
 */
export function useGetFixedTrafficLegsQuery(baseOptions: Apollo.QueryHookOptions<GetFixedTrafficLegsQuery, GetFixedTrafficLegsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFixedTrafficLegsQuery, GetFixedTrafficLegsQueryVariables>(GetFixedTrafficLegsDocument, options);
      }
export function useGetFixedTrafficLegsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFixedTrafficLegsQuery, GetFixedTrafficLegsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFixedTrafficLegsQuery, GetFixedTrafficLegsQueryVariables>(GetFixedTrafficLegsDocument, options);
        }
export type GetFixedTrafficLegsQueryHookResult = ReturnType<typeof useGetFixedTrafficLegsQuery>;
export type GetFixedTrafficLegsLazyQueryHookResult = ReturnType<typeof useGetFixedTrafficLegsLazyQuery>;
export type GetFixedTrafficLegsQueryResult = Apollo.QueryResult<GetFixedTrafficLegsQuery, GetFixedTrafficLegsQueryVariables>;
export const GetPostsForTerminalDocument = gql`
    query GetPostsForTerminal($startDate: String!, $locationName: String, $locationId: Int) {
  getPostsForTerminal(
    startDate: $startDate
    locationName: $locationName
    locationId: $locationId
  ) {
    startDate
    locationId
    locationName
    infoCount
    valueBoxCount
    gridCount
  }
}
    `;

/**
 * __useGetPostsForTerminalQuery__
 *
 * To run a query within a React component, call `useGetPostsForTerminalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsForTerminalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsForTerminalQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      locationName: // value for 'locationName'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetPostsForTerminalQuery(baseOptions: Apollo.QueryHookOptions<GetPostsForTerminalQuery, GetPostsForTerminalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsForTerminalQuery, GetPostsForTerminalQueryVariables>(GetPostsForTerminalDocument, options);
      }
export function useGetPostsForTerminalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsForTerminalQuery, GetPostsForTerminalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsForTerminalQuery, GetPostsForTerminalQueryVariables>(GetPostsForTerminalDocument, options);
        }
export type GetPostsForTerminalQueryHookResult = ReturnType<typeof useGetPostsForTerminalQuery>;
export type GetPostsForTerminalLazyQueryHookResult = ReturnType<typeof useGetPostsForTerminalLazyQuery>;
export type GetPostsForTerminalQueryResult = Apollo.QueryResult<GetPostsForTerminalQuery, GetPostsForTerminalQueryVariables>;
export const GetPostsFromAllTerminalsDocument = gql`
    query GetPostsFromAllTerminals($startDate: String!) {
  getPostsFromAllTerminals(startDate: $startDate) {
    locationId
    locationName
    hasInfo
    hasValueBox
    hasGrid
  }
}
    `;

/**
 * __useGetPostsFromAllTerminalsQuery__
 *
 * To run a query within a React component, call `useGetPostsFromAllTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsFromAllTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsFromAllTerminalsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetPostsFromAllTerminalsQuery(baseOptions: Apollo.QueryHookOptions<GetPostsFromAllTerminalsQuery, GetPostsFromAllTerminalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsFromAllTerminalsQuery, GetPostsFromAllTerminalsQueryVariables>(GetPostsFromAllTerminalsDocument, options);
      }
export function useGetPostsFromAllTerminalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsFromAllTerminalsQuery, GetPostsFromAllTerminalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsFromAllTerminalsQuery, GetPostsFromAllTerminalsQueryVariables>(GetPostsFromAllTerminalsDocument, options);
        }
export type GetPostsFromAllTerminalsQueryHookResult = ReturnType<typeof useGetPostsFromAllTerminalsQuery>;
export type GetPostsFromAllTerminalsLazyQueryHookResult = ReturnType<typeof useGetPostsFromAllTerminalsLazyQuery>;
export type GetPostsFromAllTerminalsQueryResult = Apollo.QueryResult<GetPostsFromAllTerminalsQuery, GetPostsFromAllTerminalsQueryVariables>;
export const GetFiltersByUserIdDocument = gql`
    query GetFiltersByUserID($tableName: String!) {
  getFiltersByUserId(tableName: $tableName) {
    id
    tableName
    filterName
    filterConfiguration
  }
}
    `;

/**
 * __useGetFiltersByUserIdQuery__
 *
 * To run a query within a React component, call `useGetFiltersByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiltersByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiltersByUserIdQuery({
 *   variables: {
 *      tableName: // value for 'tableName'
 *   },
 * });
 */
export function useGetFiltersByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetFiltersByUserIdQuery, GetFiltersByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFiltersByUserIdQuery, GetFiltersByUserIdQueryVariables>(GetFiltersByUserIdDocument, options);
      }
export function useGetFiltersByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFiltersByUserIdQuery, GetFiltersByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFiltersByUserIdQuery, GetFiltersByUserIdQueryVariables>(GetFiltersByUserIdDocument, options);
        }
export type GetFiltersByUserIdQueryHookResult = ReturnType<typeof useGetFiltersByUserIdQuery>;
export type GetFiltersByUserIdLazyQueryHookResult = ReturnType<typeof useGetFiltersByUserIdLazyQuery>;
export type GetFiltersByUserIdQueryResult = Apollo.QueryResult<GetFiltersByUserIdQuery, GetFiltersByUserIdQueryVariables>;
export const GetHolidayForCountryOnDateDocument = gql`
    query GetHolidayForCountryOnDate($country: String!, $date: String!) {
  holidayForCountryOnDate(country: $country, date: $date)
}
    `;

/**
 * __useGetHolidayForCountryOnDateQuery__
 *
 * To run a query within a React component, call `useGetHolidayForCountryOnDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHolidayForCountryOnDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHolidayForCountryOnDateQuery({
 *   variables: {
 *      country: // value for 'country'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetHolidayForCountryOnDateQuery(baseOptions: Apollo.QueryHookOptions<GetHolidayForCountryOnDateQuery, GetHolidayForCountryOnDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHolidayForCountryOnDateQuery, GetHolidayForCountryOnDateQueryVariables>(GetHolidayForCountryOnDateDocument, options);
      }
export function useGetHolidayForCountryOnDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHolidayForCountryOnDateQuery, GetHolidayForCountryOnDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHolidayForCountryOnDateQuery, GetHolidayForCountryOnDateQueryVariables>(GetHolidayForCountryOnDateDocument, options);
        }
export type GetHolidayForCountryOnDateQueryHookResult = ReturnType<typeof useGetHolidayForCountryOnDateQuery>;
export type GetHolidayForCountryOnDateLazyQueryHookResult = ReturnType<typeof useGetHolidayForCountryOnDateLazyQuery>;
export type GetHolidayForCountryOnDateQueryResult = Apollo.QueryResult<GetHolidayForCountryOnDateQuery, GetHolidayForCountryOnDateQueryVariables>;
export const GetHolidaysDocument = gql`
    query GetHolidays($country: String!) {
  holidays(country: $country) {
    id
    title
    date
    endDate
    startTime
    endTime
    country
    alternateGenerateDate
    isStrictCancel
    locationDetails {
      id
      fullAddress
      country
    }
  }
}
    `;

/**
 * __useGetHolidaysQuery__
 *
 * To run a query within a React component, call `useGetHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHolidaysQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetHolidaysQuery(baseOptions: Apollo.QueryHookOptions<GetHolidaysQuery, GetHolidaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHolidaysQuery, GetHolidaysQueryVariables>(GetHolidaysDocument, options);
      }
export function useGetHolidaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHolidaysQuery, GetHolidaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHolidaysQuery, GetHolidaysQueryVariables>(GetHolidaysDocument, options);
        }
export type GetHolidaysQueryHookResult = ReturnType<typeof useGetHolidaysQuery>;
export type GetHolidaysLazyQueryHookResult = ReturnType<typeof useGetHolidaysLazyQuery>;
export type GetHolidaysQueryResult = Apollo.QueryResult<GetHolidaysQuery, GetHolidaysQueryVariables>;
export const NewShipmentLoadingListDocument = gql`
    query NewShipmentLoadingList($startDate: String!, $endDate: String!, $showHiddenOrders: Boolean!) {
  newShipmentLoadingList(
    startDate: $startDate
    endDate: $endDate
    showHiddenOrders: $showHiddenOrders
  ) {
    ...ShipmentLoadingListFields
  }
}
    ${ShipmentLoadingListFieldsFragmentDoc}`;

/**
 * __useNewShipmentLoadingListQuery__
 *
 * To run a query within a React component, call `useNewShipmentLoadingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewShipmentLoadingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewShipmentLoadingListQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      showHiddenOrders: // value for 'showHiddenOrders'
 *   },
 * });
 */
export function useNewShipmentLoadingListQuery(baseOptions: Apollo.QueryHookOptions<NewShipmentLoadingListQuery, NewShipmentLoadingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewShipmentLoadingListQuery, NewShipmentLoadingListQueryVariables>(NewShipmentLoadingListDocument, options);
      }
export function useNewShipmentLoadingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewShipmentLoadingListQuery, NewShipmentLoadingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewShipmentLoadingListQuery, NewShipmentLoadingListQueryVariables>(NewShipmentLoadingListDocument, options);
        }
export type NewShipmentLoadingListQueryHookResult = ReturnType<typeof useNewShipmentLoadingListQuery>;
export type NewShipmentLoadingListLazyQueryHookResult = ReturnType<typeof useNewShipmentLoadingListLazyQuery>;
export type NewShipmentLoadingListQueryResult = Apollo.QueryResult<NewShipmentLoadingListQuery, NewShipmentLoadingListQueryVariables>;
export const NewShipmentLoadingListByIdsDocument = gql`
    query NewShipmentLoadingListByIds($startDate: String!, $endDate: String!, $showHiddenOrders: Boolean!, $ids: [Int!]!) {
  newShipmentLoadingList(
    startDate: $startDate
    endDate: $endDate
    showHiddenOrders: $showHiddenOrders
    ids: $ids
  ) {
    ...ShipmentLoadingListFields
  }
}
    ${ShipmentLoadingListFieldsFragmentDoc}`;

/**
 * __useNewShipmentLoadingListByIdsQuery__
 *
 * To run a query within a React component, call `useNewShipmentLoadingListByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewShipmentLoadingListByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewShipmentLoadingListByIdsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      showHiddenOrders: // value for 'showHiddenOrders'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useNewShipmentLoadingListByIdsQuery(baseOptions: Apollo.QueryHookOptions<NewShipmentLoadingListByIdsQuery, NewShipmentLoadingListByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewShipmentLoadingListByIdsQuery, NewShipmentLoadingListByIdsQueryVariables>(NewShipmentLoadingListByIdsDocument, options);
      }
export function useNewShipmentLoadingListByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewShipmentLoadingListByIdsQuery, NewShipmentLoadingListByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewShipmentLoadingListByIdsQuery, NewShipmentLoadingListByIdsQueryVariables>(NewShipmentLoadingListByIdsDocument, options);
        }
export type NewShipmentLoadingListByIdsQueryHookResult = ReturnType<typeof useNewShipmentLoadingListByIdsQuery>;
export type NewShipmentLoadingListByIdsLazyQueryHookResult = ReturnType<typeof useNewShipmentLoadingListByIdsLazyQuery>;
export type NewShipmentLoadingListByIdsQueryResult = Apollo.QueryResult<NewShipmentLoadingListByIdsQuery, NewShipmentLoadingListByIdsQueryVariables>;
export const GetLocationGridValuesForDateDocument = gql`
    query GetLocationGridValuesForDate($locationId: Int!, $valueAddedDate: String!, $gridType: String!) {
  locationGridValues(
    locationId: $locationId
    valueAddedDate: $valueAddedDate
    gridType: $gridType
  ) {
    id
    gridEntryId
    gridEntries
    valueAddedDate
    columnHeaders
    rowHeaders
    gridName
    locationId
    isGridDeleted
    gridType
    isNumberGridWithTotal
  }
}
    `;

/**
 * __useGetLocationGridValuesForDateQuery__
 *
 * To run a query within a React component, call `useGetLocationGridValuesForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationGridValuesForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationGridValuesForDateQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      valueAddedDate: // value for 'valueAddedDate'
 *      gridType: // value for 'gridType'
 *   },
 * });
 */
export function useGetLocationGridValuesForDateQuery(baseOptions: Apollo.QueryHookOptions<GetLocationGridValuesForDateQuery, GetLocationGridValuesForDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationGridValuesForDateQuery, GetLocationGridValuesForDateQueryVariables>(GetLocationGridValuesForDateDocument, options);
      }
export function useGetLocationGridValuesForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationGridValuesForDateQuery, GetLocationGridValuesForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationGridValuesForDateQuery, GetLocationGridValuesForDateQueryVariables>(GetLocationGridValuesForDateDocument, options);
        }
export type GetLocationGridValuesForDateQueryHookResult = ReturnType<typeof useGetLocationGridValuesForDateQuery>;
export type GetLocationGridValuesForDateLazyQueryHookResult = ReturnType<typeof useGetLocationGridValuesForDateLazyQuery>;
export type GetLocationGridValuesForDateQueryResult = Apollo.QueryResult<GetLocationGridValuesForDateQuery, GetLocationGridValuesForDateQueryVariables>;
export const GetLocationGridValuesForTrafficDocument = gql`
    query GetLocationGridValuesForTraffic($locationId: Int!, $valueAddedDate: String!, $gridType: String!) {
  locationGridValuesForTraffic(
    locationId: $locationId
    valueAddedDate: $valueAddedDate
    gridType: $gridType
  ) {
    id
    gridName
    gridEntryId
    locationId
    columnHeaders
    rowHeaders
    gridEntries
    valueAddedDate
    location
    gridType
    isNumberGridWithTotal
  }
}
    `;

/**
 * __useGetLocationGridValuesForTrafficQuery__
 *
 * To run a query within a React component, call `useGetLocationGridValuesForTrafficQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationGridValuesForTrafficQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationGridValuesForTrafficQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      valueAddedDate: // value for 'valueAddedDate'
 *      gridType: // value for 'gridType'
 *   },
 * });
 */
export function useGetLocationGridValuesForTrafficQuery(baseOptions: Apollo.QueryHookOptions<GetLocationGridValuesForTrafficQuery, GetLocationGridValuesForTrafficQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationGridValuesForTrafficQuery, GetLocationGridValuesForTrafficQueryVariables>(GetLocationGridValuesForTrafficDocument, options);
      }
export function useGetLocationGridValuesForTrafficLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationGridValuesForTrafficQuery, GetLocationGridValuesForTrafficQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationGridValuesForTrafficQuery, GetLocationGridValuesForTrafficQueryVariables>(GetLocationGridValuesForTrafficDocument, options);
        }
export type GetLocationGridValuesForTrafficQueryHookResult = ReturnType<typeof useGetLocationGridValuesForTrafficQuery>;
export type GetLocationGridValuesForTrafficLazyQueryHookResult = ReturnType<typeof useGetLocationGridValuesForTrafficLazyQuery>;
export type GetLocationGridValuesForTrafficQueryResult = Apollo.QueryResult<GetLocationGridValuesForTrafficQuery, GetLocationGridValuesForTrafficQueryVariables>;
export const GetLocationMasterValueBoxDocument = gql`
    query GetLocationMasterValueBox($locationId: Int!, $forTerminal: Boolean!) {
  locationMasterValueBoxes(locationId: $locationId, forTerminal: $forTerminal) {
    id
    locationId
    boxName
    frequency
    isFixedBox
    isYesNoBox
    isTimeBox
    isAlphaNumeric
    isAddedFromTerminal
  }
}
    `;

/**
 * __useGetLocationMasterValueBoxQuery__
 *
 * To run a query within a React component, call `useGetLocationMasterValueBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationMasterValueBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationMasterValueBoxQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      forTerminal: // value for 'forTerminal'
 *   },
 * });
 */
export function useGetLocationMasterValueBoxQuery(baseOptions: Apollo.QueryHookOptions<GetLocationMasterValueBoxQuery, GetLocationMasterValueBoxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationMasterValueBoxQuery, GetLocationMasterValueBoxQueryVariables>(GetLocationMasterValueBoxDocument, options);
      }
export function useGetLocationMasterValueBoxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationMasterValueBoxQuery, GetLocationMasterValueBoxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationMasterValueBoxQuery, GetLocationMasterValueBoxQueryVariables>(GetLocationMasterValueBoxDocument, options);
        }
export type GetLocationMasterValueBoxQueryHookResult = ReturnType<typeof useGetLocationMasterValueBoxQuery>;
export type GetLocationMasterValueBoxLazyQueryHookResult = ReturnType<typeof useGetLocationMasterValueBoxLazyQuery>;
export type GetLocationMasterValueBoxQueryResult = Apollo.QueryResult<GetLocationMasterValueBoxQuery, GetLocationMasterValueBoxQueryVariables>;
export const GetLocationReportInfoDocument = gql`
    query GetLocationReportInfo($locationId: Int!, $dateForAddInfo: String!, $forTerminal: Boolean!) {
  locationReportInfo(
    locationId: $locationId
    dateForAddInfo: $dateForAddInfo
    forTerminal: $forTerminal
  ) {
    id
    locationId
    dateForAddInfo
    info
    infoType
    isAddedFromTerminal
    replyInfo
    replyText
    files {
      id
      originalname
      mimetype
      path
      size
    }
  }
}
    `;

/**
 * __useGetLocationReportInfoQuery__
 *
 * To run a query within a React component, call `useGetLocationReportInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationReportInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationReportInfoQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      dateForAddInfo: // value for 'dateForAddInfo'
 *      forTerminal: // value for 'forTerminal'
 *   },
 * });
 */
export function useGetLocationReportInfoQuery(baseOptions: Apollo.QueryHookOptions<GetLocationReportInfoQuery, GetLocationReportInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationReportInfoQuery, GetLocationReportInfoQueryVariables>(GetLocationReportInfoDocument, options);
      }
export function useGetLocationReportInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationReportInfoQuery, GetLocationReportInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationReportInfoQuery, GetLocationReportInfoQueryVariables>(GetLocationReportInfoDocument, options);
        }
export type GetLocationReportInfoQueryHookResult = ReturnType<typeof useGetLocationReportInfoQuery>;
export type GetLocationReportInfoLazyQueryHookResult = ReturnType<typeof useGetLocationReportInfoLazyQuery>;
export type GetLocationReportInfoQueryResult = Apollo.QueryResult<GetLocationReportInfoQuery, GetLocationReportInfoQueryVariables>;
export const GetLocationValueBoxForDateDocument = gql`
    query GetLocationValueBoxForDate($locationId: Int!, $date: String!, $forTerminal: Boolean!) {
  locationValueBoxesForDay(
    locationId: $locationId
    date: $date
    forTerminal: $forTerminal
  ) {
    boxId
    entryId
    boxNameText
    boxValue
    isReadOnly
    isFixedBox
    isYesNoBox
    isTimeBox
    isAlphaNumeric
    isAddedFromTerminal
  }
}
    `;

/**
 * __useGetLocationValueBoxForDateQuery__
 *
 * To run a query within a React component, call `useGetLocationValueBoxForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationValueBoxForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationValueBoxForDateQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      date: // value for 'date'
 *      forTerminal: // value for 'forTerminal'
 *   },
 * });
 */
export function useGetLocationValueBoxForDateQuery(baseOptions: Apollo.QueryHookOptions<GetLocationValueBoxForDateQuery, GetLocationValueBoxForDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationValueBoxForDateQuery, GetLocationValueBoxForDateQueryVariables>(GetLocationValueBoxForDateDocument, options);
      }
export function useGetLocationValueBoxForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationValueBoxForDateQuery, GetLocationValueBoxForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationValueBoxForDateQuery, GetLocationValueBoxForDateQueryVariables>(GetLocationValueBoxForDateDocument, options);
        }
export type GetLocationValueBoxForDateQueryHookResult = ReturnType<typeof useGetLocationValueBoxForDateQuery>;
export type GetLocationValueBoxForDateLazyQueryHookResult = ReturnType<typeof useGetLocationValueBoxForDateLazyQuery>;
export type GetLocationValueBoxForDateQueryResult = Apollo.QueryResult<GetLocationValueBoxForDateQuery, GetLocationValueBoxForDateQueryVariables>;
export const GetActiveLocationByIdDocument = gql`
    query GetActiveLocationById($id: Int!) {
  activeLocation(id: $id) {
    id
    type
    name
    address
    postalCode
    city
    country
    phLocationId
    locationShortCode
    countryLong @client
    createdAt
    updatedAt
    lastUpdatedBy
    createdBy
    locationGroup
    latitude
    longitude
    tags {
      id
      title
    }
    customerFromLocation {
      id
      name
    }
    customerToLocation {
      id
      name
    }
    contacts {
      ...CardContactFields
    }
    notes {
      id
      title
      text
      createdBy
      lastUpdatedBy
      updatedAt
    }
    files {
      id
      originalname
      mimetype
      path
      size
      createdAt
      createdBy
    }
  }
}
    ${CardContactFieldsFragmentDoc}`;

/**
 * __useGetActiveLocationByIdQuery__
 *
 * To run a query within a React component, call `useGetActiveLocationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveLocationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveLocationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActiveLocationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetActiveLocationByIdQuery, GetActiveLocationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveLocationByIdQuery, GetActiveLocationByIdQueryVariables>(GetActiveLocationByIdDocument, options);
      }
export function useGetActiveLocationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveLocationByIdQuery, GetActiveLocationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveLocationByIdQuery, GetActiveLocationByIdQueryVariables>(GetActiveLocationByIdDocument, options);
        }
export type GetActiveLocationByIdQueryHookResult = ReturnType<typeof useGetActiveLocationByIdQuery>;
export type GetActiveLocationByIdLazyQueryHookResult = ReturnType<typeof useGetActiveLocationByIdLazyQuery>;
export type GetActiveLocationByIdQueryResult = Apollo.QueryResult<GetActiveLocationByIdQuery, GetActiveLocationByIdQueryVariables>;
export const GetLocationDocument = gql`
    query GetLocation($id: Int!) {
  location(id: $id) {
    id
    type
    name
    address
    postalCode
    city
    country
    phLocationId
    locationShortCode
    countryLong @client
    createdAt
    updatedAt
    lastUpdatedBy
    createdBy
    locationGroup
    isPromoted
    latitude
    longitude
    tags {
      id
      title
    }
    customerFromLocation {
      id
      name
    }
    customerToLocation {
      id
      name
    }
    contacts {
      ...CardContactFields
    }
    notes {
      id
      title
      text
      createdBy
      lastUpdatedBy
      updatedAt
    }
    files {
      id
      originalname
      mimetype
      path
      size
      createdAt
      createdBy
    }
  }
}
    ${CardContactFieldsFragmentDoc}`;

/**
 * __useGetLocationQuery__
 *
 * To run a query within a React component, call `useGetLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationQuery(baseOptions: Apollo.QueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
      }
export function useGetLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
        }
export type GetLocationQueryHookResult = ReturnType<typeof useGetLocationQuery>;
export type GetLocationLazyQueryHookResult = ReturnType<typeof useGetLocationLazyQuery>;
export type GetLocationQueryResult = Apollo.QueryResult<GetLocationQuery, GetLocationQueryVariables>;
export const GetLocationByIdListDocument = gql`
    query GetLocationByIdList($idList: [Int!]!) {
  locationsByIdList(idList: $idList) {
    ...LocationsFields
  }
}
    ${LocationsFieldsFragmentDoc}`;

/**
 * __useGetLocationByIdListQuery__
 *
 * To run a query within a React component, call `useGetLocationByIdListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationByIdListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationByIdListQuery({
 *   variables: {
 *      idList: // value for 'idList'
 *   },
 * });
 */
export function useGetLocationByIdListQuery(baseOptions: Apollo.QueryHookOptions<GetLocationByIdListQuery, GetLocationByIdListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationByIdListQuery, GetLocationByIdListQueryVariables>(GetLocationByIdListDocument, options);
      }
export function useGetLocationByIdListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationByIdListQuery, GetLocationByIdListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationByIdListQuery, GetLocationByIdListQueryVariables>(GetLocationByIdListDocument, options);
        }
export type GetLocationByIdListQueryHookResult = ReturnType<typeof useGetLocationByIdListQuery>;
export type GetLocationByIdListLazyQueryHookResult = ReturnType<typeof useGetLocationByIdListLazyQuery>;
export type GetLocationByIdListQueryResult = Apollo.QueryResult<GetLocationByIdListQuery, GetLocationByIdListQueryVariables>;
export const GetLocationForSelectDocument = gql`
    query GetLocationForSelect($locationId: Int!) {
  location(id: $locationId) {
    id
    type
    name
    address
    city
    country
    postalCode
    customerFromLocation {
      id
      name
    }
    customerToLocation {
      id
      name
    }
  }
}
    `;

/**
 * __useGetLocationForSelectQuery__
 *
 * To run a query within a React component, call `useGetLocationForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationForSelectQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationForSelectQuery(baseOptions: Apollo.QueryHookOptions<GetLocationForSelectQuery, GetLocationForSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationForSelectQuery, GetLocationForSelectQueryVariables>(GetLocationForSelectDocument, options);
      }
export function useGetLocationForSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationForSelectQuery, GetLocationForSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationForSelectQuery, GetLocationForSelectQueryVariables>(GetLocationForSelectDocument, options);
        }
export type GetLocationForSelectQueryHookResult = ReturnType<typeof useGetLocationForSelectQuery>;
export type GetLocationForSelectLazyQueryHookResult = ReturnType<typeof useGetLocationForSelectLazyQuery>;
export type GetLocationForSelectQueryResult = Apollo.QueryResult<GetLocationForSelectQuery, GetLocationForSelectQueryVariables>;
export const GetLocationTagsDocument = gql`
    query GetLocationTags {
  locationTags {
    id
    title
  }
}
    `;

/**
 * __useGetLocationTagsQuery__
 *
 * To run a query within a React component, call `useGetLocationTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationTagsQuery, GetLocationTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationTagsQuery, GetLocationTagsQueryVariables>(GetLocationTagsDocument, options);
      }
export function useGetLocationTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationTagsQuery, GetLocationTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationTagsQuery, GetLocationTagsQueryVariables>(GetLocationTagsDocument, options);
        }
export type GetLocationTagsQueryHookResult = ReturnType<typeof useGetLocationTagsQuery>;
export type GetLocationTagsLazyQueryHookResult = ReturnType<typeof useGetLocationTagsLazyQuery>;
export type GetLocationTagsQueryResult = Apollo.QueryResult<GetLocationTagsQuery, GetLocationTagsQueryVariables>;
export const GetLocationsForLegDocument = gql`
    query GetLocationsForLeg($locationsSearch: String, $forCountryCode: String) {
  locations(search: $locationsSearch, forCountryCode: $forCountryCode) {
    id
    type
    name
    address
    city
    country
    postalCode
  }
}
    `;

/**
 * __useGetLocationsForLegQuery__
 *
 * To run a query within a React component, call `useGetLocationsForLegQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsForLegQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsForLegQuery({
 *   variables: {
 *      locationsSearch: // value for 'locationsSearch'
 *      forCountryCode: // value for 'forCountryCode'
 *   },
 * });
 */
export function useGetLocationsForLegQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationsForLegQuery, GetLocationsForLegQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsForLegQuery, GetLocationsForLegQueryVariables>(GetLocationsForLegDocument, options);
      }
export function useGetLocationsForLegLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsForLegQuery, GetLocationsForLegQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsForLegQuery, GetLocationsForLegQueryVariables>(GetLocationsForLegDocument, options);
        }
export type GetLocationsForLegQueryHookResult = ReturnType<typeof useGetLocationsForLegQuery>;
export type GetLocationsForLegLazyQueryHookResult = ReturnType<typeof useGetLocationsForLegLazyQuery>;
export type GetLocationsForLegQueryResult = Apollo.QueryResult<GetLocationsForLegQuery, GetLocationsForLegQueryVariables>;
export const SearchLocationIdAndNameDocument = gql`
    query SearchLocationIdAndName($locationSearch: String) {
  locationSearch(search: $locationSearch) {
    id
    name
    contacts {
      id
      name
    }
  }
}
    `;

/**
 * __useSearchLocationIdAndNameQuery__
 *
 * To run a query within a React component, call `useSearchLocationIdAndNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLocationIdAndNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLocationIdAndNameQuery({
 *   variables: {
 *      locationSearch: // value for 'locationSearch'
 *   },
 * });
 */
export function useSearchLocationIdAndNameQuery(baseOptions?: Apollo.QueryHookOptions<SearchLocationIdAndNameQuery, SearchLocationIdAndNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLocationIdAndNameQuery, SearchLocationIdAndNameQueryVariables>(SearchLocationIdAndNameDocument, options);
      }
export function useSearchLocationIdAndNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLocationIdAndNameQuery, SearchLocationIdAndNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLocationIdAndNameQuery, SearchLocationIdAndNameQueryVariables>(SearchLocationIdAndNameDocument, options);
        }
export type SearchLocationIdAndNameQueryHookResult = ReturnType<typeof useSearchLocationIdAndNameQuery>;
export type SearchLocationIdAndNameLazyQueryHookResult = ReturnType<typeof useSearchLocationIdAndNameLazyQuery>;
export type SearchLocationIdAndNameQueryResult = Apollo.QueryResult<SearchLocationIdAndNameQuery, SearchLocationIdAndNameQueryVariables>;
export const GetLocationsDocument = gql`
    query GetLocations {
  locations {
    ...LocationsFields
  }
}
    ${LocationsFieldsFragmentDoc}`;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
      }
export function useGetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsQueryResult = Apollo.QueryResult<GetLocationsQuery, GetLocationsQueryVariables>;
export const GetPromotedLocationsDocument = gql`
    query GetPromotedLocations($search: String) {
  getPromotedLocations(search: $search) {
    id
    name
    address
    postalCode
    city
    country
    isPromoted
    latitude
    longitude
    contacts {
      id
      name
      email
      tags {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetPromotedLocationsQuery__
 *
 * To run a query within a React component, call `useGetPromotedLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotedLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotedLocationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPromotedLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetPromotedLocationsQuery, GetPromotedLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromotedLocationsQuery, GetPromotedLocationsQueryVariables>(GetPromotedLocationsDocument, options);
      }
export function useGetPromotedLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromotedLocationsQuery, GetPromotedLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromotedLocationsQuery, GetPromotedLocationsQueryVariables>(GetPromotedLocationsDocument, options);
        }
export type GetPromotedLocationsQueryHookResult = ReturnType<typeof useGetPromotedLocationsQuery>;
export type GetPromotedLocationsLazyQueryHookResult = ReturnType<typeof useGetPromotedLocationsLazyQuery>;
export type GetPromotedLocationsQueryResult = Apollo.QueryResult<GetPromotedLocationsQuery, GetPromotedLocationsQueryVariables>;
export const CheckLegsHaveAnyDangerGoodsDocument = gql`
    query CheckLegsHaveAnyDangerGoods($legIds: [Int!]!) {
  checkLegsHaveAnyDangerGoods(legIds: $legIds)
}
    `;

/**
 * __useCheckLegsHaveAnyDangerGoodsQuery__
 *
 * To run a query within a React component, call `useCheckLegsHaveAnyDangerGoodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckLegsHaveAnyDangerGoodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckLegsHaveAnyDangerGoodsQuery({
 *   variables: {
 *      legIds: // value for 'legIds'
 *   },
 * });
 */
export function useCheckLegsHaveAnyDangerGoodsQuery(baseOptions: Apollo.QueryHookOptions<CheckLegsHaveAnyDangerGoodsQuery, CheckLegsHaveAnyDangerGoodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckLegsHaveAnyDangerGoodsQuery, CheckLegsHaveAnyDangerGoodsQueryVariables>(CheckLegsHaveAnyDangerGoodsDocument, options);
      }
export function useCheckLegsHaveAnyDangerGoodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckLegsHaveAnyDangerGoodsQuery, CheckLegsHaveAnyDangerGoodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckLegsHaveAnyDangerGoodsQuery, CheckLegsHaveAnyDangerGoodsQueryVariables>(CheckLegsHaveAnyDangerGoodsDocument, options);
        }
export type CheckLegsHaveAnyDangerGoodsQueryHookResult = ReturnType<typeof useCheckLegsHaveAnyDangerGoodsQuery>;
export type CheckLegsHaveAnyDangerGoodsLazyQueryHookResult = ReturnType<typeof useCheckLegsHaveAnyDangerGoodsLazyQuery>;
export type CheckLegsHaveAnyDangerGoodsQueryResult = Apollo.QueryResult<CheckLegsHaveAnyDangerGoodsQuery, CheckLegsHaveAnyDangerGoodsQueryVariables>;
export const GetAllRouteGroupTagsDocument = gql`
    query GetAllRouteGroupTags($transportDate: String!) {
  getAllRouteGroupTags(transportDate: $transportDate)
}
    `;

/**
 * __useGetAllRouteGroupTagsQuery__
 *
 * To run a query within a React component, call `useGetAllRouteGroupTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRouteGroupTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRouteGroupTagsQuery({
 *   variables: {
 *      transportDate: // value for 'transportDate'
 *   },
 * });
 */
export function useGetAllRouteGroupTagsQuery(baseOptions: Apollo.QueryHookOptions<GetAllRouteGroupTagsQuery, GetAllRouteGroupTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRouteGroupTagsQuery, GetAllRouteGroupTagsQueryVariables>(GetAllRouteGroupTagsDocument, options);
      }
export function useGetAllRouteGroupTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRouteGroupTagsQuery, GetAllRouteGroupTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRouteGroupTagsQuery, GetAllRouteGroupTagsQueryVariables>(GetAllRouteGroupTagsDocument, options);
        }
export type GetAllRouteGroupTagsQueryHookResult = ReturnType<typeof useGetAllRouteGroupTagsQuery>;
export type GetAllRouteGroupTagsLazyQueryHookResult = ReturnType<typeof useGetAllRouteGroupTagsLazyQuery>;
export type GetAllRouteGroupTagsQueryResult = Apollo.QueryResult<GetAllRouteGroupTagsQuery, GetAllRouteGroupTagsQueryVariables>;
export const GetCostAllocationsByRouteIdDocument = gql`
    query GetCostAllocationsByRouteId($id: Int!) {
  route(id: $id) {
    id
    agreedPrice
    currency
    routeId
    costAllocation {
      id
      items {
        id
        departmentId
        cost
        includedKpi
        includedPrice
        bringCost
        additionalCost
        additionalDiscount
        type
        comment
        currency
        tags
        location {
          id
          name
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetCostAllocationsByRouteIdQuery__
 *
 * To run a query within a React component, call `useGetCostAllocationsByRouteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCostAllocationsByRouteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCostAllocationsByRouteIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCostAllocationsByRouteIdQuery(baseOptions: Apollo.QueryHookOptions<GetCostAllocationsByRouteIdQuery, GetCostAllocationsByRouteIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCostAllocationsByRouteIdQuery, GetCostAllocationsByRouteIdQueryVariables>(GetCostAllocationsByRouteIdDocument, options);
      }
export function useGetCostAllocationsByRouteIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCostAllocationsByRouteIdQuery, GetCostAllocationsByRouteIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCostAllocationsByRouteIdQuery, GetCostAllocationsByRouteIdQueryVariables>(GetCostAllocationsByRouteIdDocument, options);
        }
export type GetCostAllocationsByRouteIdQueryHookResult = ReturnType<typeof useGetCostAllocationsByRouteIdQuery>;
export type GetCostAllocationsByRouteIdLazyQueryHookResult = ReturnType<typeof useGetCostAllocationsByRouteIdLazyQuery>;
export type GetCostAllocationsByRouteIdQueryResult = Apollo.QueryResult<GetCostAllocationsByRouteIdQuery, GetCostAllocationsByRouteIdQueryVariables>;
export const GetLegsMatchingShipmentDocument = gql`
    query GetLegsMatchingShipment($fromLocationId: Int!, $toLocationId: Int!, $transportDate: String!, $orderId: Int!) {
  fetchLegsMatchingShipment(
    fromLocationId: $fromLocationId
    toLocationId: $toLocationId
    transportDate: $transportDate
    orderId: $orderId
  ) {
    id
    position
    arrivalTime
    isLoadingInCar
    isLoadingInTrailer
    route {
      id
      routeId
      type
      routeLock {
        id
        lockedAt
        lockedBy
        lockedByUserId
        isChecklistLocked
      }
    }
  }
}
    `;

/**
 * __useGetLegsMatchingShipmentQuery__
 *
 * To run a query within a React component, call `useGetLegsMatchingShipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLegsMatchingShipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLegsMatchingShipmentQuery({
 *   variables: {
 *      fromLocationId: // value for 'fromLocationId'
 *      toLocationId: // value for 'toLocationId'
 *      transportDate: // value for 'transportDate'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetLegsMatchingShipmentQuery(baseOptions: Apollo.QueryHookOptions<GetLegsMatchingShipmentQuery, GetLegsMatchingShipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLegsMatchingShipmentQuery, GetLegsMatchingShipmentQueryVariables>(GetLegsMatchingShipmentDocument, options);
      }
export function useGetLegsMatchingShipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLegsMatchingShipmentQuery, GetLegsMatchingShipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLegsMatchingShipmentQuery, GetLegsMatchingShipmentQueryVariables>(GetLegsMatchingShipmentDocument, options);
        }
export type GetLegsMatchingShipmentQueryHookResult = ReturnType<typeof useGetLegsMatchingShipmentQuery>;
export type GetLegsMatchingShipmentLazyQueryHookResult = ReturnType<typeof useGetLegsMatchingShipmentLazyQuery>;
export type GetLegsMatchingShipmentQueryResult = Apollo.QueryResult<GetLegsMatchingShipmentQuery, GetLegsMatchingShipmentQueryVariables>;
export const GetLoadingListDocument = gql`
    query GetLoadingList($id: Int!) {
  route(id: $id) {
    legs {
      loadingListItems {
        id
        packages
        pallets
        palletSpace
        weight
        unNumber
        customWaybillNo
      }
      carDetails {
        loadingListItems {
          id
          packages
          pallets
          palletSpace
          weight
          unNumber
          customWaybillNo
        }
      }
      trailerDetails {
        loadingListItems {
          id
          packages
          pallets
          palletSpace
          weight
          unNumber
          customWaybillNo
        }
      }
    }
  }
}
    `;

/**
 * __useGetLoadingListQuery__
 *
 * To run a query within a React component, call `useGetLoadingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoadingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoadingListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLoadingListQuery(baseOptions: Apollo.QueryHookOptions<GetLoadingListQuery, GetLoadingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoadingListQuery, GetLoadingListQueryVariables>(GetLoadingListDocument, options);
      }
export function useGetLoadingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoadingListQuery, GetLoadingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoadingListQuery, GetLoadingListQueryVariables>(GetLoadingListDocument, options);
        }
export type GetLoadingListQueryHookResult = ReturnType<typeof useGetLoadingListQuery>;
export type GetLoadingListLazyQueryHookResult = ReturnType<typeof useGetLoadingListLazyQuery>;
export type GetLoadingListQueryResult = Apollo.QueryResult<GetLoadingListQuery, GetLoadingListQueryVariables>;
export const GetMultipleDatesDocument = gql`
    query GetMultipleDates($id: Int!) {
  multipleDates(id: $id)
}
    `;

/**
 * __useGetMultipleDatesQuery__
 *
 * To run a query within a React component, call `useGetMultipleDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultipleDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultipleDatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMultipleDatesQuery(baseOptions: Apollo.QueryHookOptions<GetMultipleDatesQuery, GetMultipleDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultipleDatesQuery, GetMultipleDatesQueryVariables>(GetMultipleDatesDocument, options);
      }
export function useGetMultipleDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultipleDatesQuery, GetMultipleDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultipleDatesQuery, GetMultipleDatesQueryVariables>(GetMultipleDatesDocument, options);
        }
export type GetMultipleDatesQueryHookResult = ReturnType<typeof useGetMultipleDatesQuery>;
export type GetMultipleDatesLazyQueryHookResult = ReturnType<typeof useGetMultipleDatesLazyQuery>;
export type GetMultipleDatesQueryResult = Apollo.QueryResult<GetMultipleDatesQuery, GetMultipleDatesQueryVariables>;
export const GetProductionGroupDocument = gql`
    query GetProductionGroup($terminalId: Int!, $startDate: String!, $endDate: String!) {
  getProductionGroup(
    terminalId: $terminalId
    startDate: $startDate
    endDate: $endDate
  )
}
    `;

/**
 * __useGetProductionGroupQuery__
 *
 * To run a query within a React component, call `useGetProductionGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionGroupQuery({
 *   variables: {
 *      terminalId: // value for 'terminalId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetProductionGroupQuery(baseOptions: Apollo.QueryHookOptions<GetProductionGroupQuery, GetProductionGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionGroupQuery, GetProductionGroupQueryVariables>(GetProductionGroupDocument, options);
      }
export function useGetProductionGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionGroupQuery, GetProductionGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionGroupQuery, GetProductionGroupQueryVariables>(GetProductionGroupDocument, options);
        }
export type GetProductionGroupQueryHookResult = ReturnType<typeof useGetProductionGroupQuery>;
export type GetProductionGroupLazyQueryHookResult = ReturnType<typeof useGetProductionGroupLazyQuery>;
export type GetProductionGroupQueryResult = Apollo.QueryResult<GetProductionGroupQuery, GetProductionGroupQueryVariables>;
export const GetRouteDocument = gql`
    query GetRoute($id: Int!) {
  route(id: $id) {
    ...TransportAgreementFields
    routeAgreementNo
    amphoraTripId
    agreedPrice
    isCreatedFromTerminal
    isCreatedFromPlanned
    capacity
    kilometer
    weight
    currency
    dispatcherId
    driverName
    driverPhoneNumber
    routeDriverName
    routeDriverPhoneNumber
    routeCarRegNumber
    routeTrailerRegNumber
    isCopyDriverPlateInfo
    lastUpdatedBy
    updatedAt
    createdBy
    deletedAt
    deletedBy
    rutekode
    turnummer
    routeTag
    files {
      id
      mimetype
      originalname
      path
      size
      createdBy
      createdAt
      tags {
        id
        title
      }
    }
    ftl {
      cdc
      cmr
      currency
      locationId
      customerNumber
      customerReference
      id
      invoiceNote
      price
    }
    routeLock {
      id
      routeId
      lockedAt
      lockedBy
      isChecklistLocked
    }
    costAllocation {
      id
      items {
        id
        departmentId
        cost
        includedKpi
        includedPrice
        bringCost
        additionalCost
        additionalDiscount
        type
        comment
        currency
        tags
        location {
          id
          name
          city
          country
        }
      }
    }
    id
    invoiceNote
    invoiceNumber
    legs {
      gateNumber
      carRegistrationNumber
      trailerRegistrationNumber
      routeDriverName
      routeDriverPhoneNumber
      routeDriverEmail
      actualCapacity
      arrivalTime
      actualArrivalTime
      actualDepartureTime
      actualArrivalDate
      actualDepartureDate
      departureTime
      fuel
      id
      load
      note
      position
      unload
      isNonArrivalMarked
      nonArrivalMarkedFrom
      productionDate
      transportationDate
      transportationDateOffset
      locationId
      isNewLegVariant
      isLoadingInCar
      isLoadingInTrailer
      distanceInKM
      subcontractorLocationId
      subcontractorLocation {
        id
        name
      }
      dispatcherId
      dispatcher {
        id
        name
        email
      }
      legTag
      location {
        id
        type
        address
        city
        country
        name
        postalCode
        deletedBy
      }
      carDetails {
        id
        operationType
        loadingListItems {
          id
          locationId
          packages
          pallets
          palletSpace
          weight
          checked
          isDangerous
          classification
          unNumber
          isLimitedQty
          note
          isImportedFromShipment
          customWaybillNo
          lastUpdatedBy
          createdBy
          updatedAt
          location {
            id
            type
            name
            address
            postalCode
            city
            country
          }
        }
        actualCapacity
        registrationNumber
        gateNumber
        tripStartDateTime
        tripEndDateTime
        tripStatus
        estDock
        estUndock
        containerId
      }
      trailerDetails {
        id
        operationType
        loadingListItems {
          id
          locationId
          packages
          pallets
          palletSpace
          weight
          checked
          isDangerous
          classification
          unNumber
          isLimitedQty
          note
          isImportedFromShipment
          customWaybillNo
          lastUpdatedBy
          createdBy
          updatedAt
          location {
            id
            type
            name
            address
            postalCode
            city
            country
          }
        }
        actualCapacity
        registrationNumber
        gateNumber
        tripStartDateTime
        tripEndDateTime
        tripStatus
        estDock
        estUndock
        containerId
      }
      loadingListItems {
        id
        location {
          id
          type
          name
          address
          postalCode
          city
          country
        }
        locationId
        packages
        pallets
        palletSpace
        weight
        checked
        isDangerous
        classification
        unNumber
        isLimitedQty
        note
        isImportedFromShipment
        customWaybillNo
        lastUpdatedBy
        createdBy
        updatedAt
      }
    }
    routeLegWrappers {
      id
      tripId
      startStopId
      endStopId
      driverName
      driverPhoneNumber
      driverEmail
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
    licensePlate
    note
    externalNote
    routeId
    subcontractorLocationId
    transportationDate
    type
    tourRoute {
      id
      bookmarkTourRouteTemplate {
        bookmark
      }
    }
  }
}
    ${TransportAgreementFieldsFragmentDoc}`;

/**
 * __useGetRouteQuery__
 *
 * To run a query within a React component, call `useGetRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRouteQuery(baseOptions: Apollo.QueryHookOptions<GetRouteQuery, GetRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRouteQuery, GetRouteQueryVariables>(GetRouteDocument, options);
      }
export function useGetRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRouteQuery, GetRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRouteQuery, GetRouteQueryVariables>(GetRouteDocument, options);
        }
export type GetRouteQueryHookResult = ReturnType<typeof useGetRouteQuery>;
export type GetRouteLazyQueryHookResult = ReturnType<typeof useGetRouteLazyQuery>;
export type GetRouteQueryResult = Apollo.QueryResult<GetRouteQuery, GetRouteQueryVariables>;
export const GetRouteByIdV2Document = gql`
    query GetRouteByIdV2($routeId: Int!) {
  getRouteByIdV2(routeId: $routeId) {
    id
    amphoraTripId
    createdBy
    lastUpdatedBy
    transportationDate
    routeId
    subcontractorLocationId
    dispatcherId
    agreedPrice
    currency
    note
    externalNote
    driverName
    driverPhoneNumber
    licensePlate
    rutekode
    turnummer
    routeTag
    isUnplannedRoute
    costAllocation {
      id
      items {
        id
        departmentId
        type
        includedKpi
        includedPrice
        bringCost
        additionalCost
        additionalDiscount
        cost
        comment
        tags
        currency
        location {
          id
        }
      }
    }
    legs {
      id
      locationId
      location {
        id
        name
        type
        address
        city
        country
        postalCode
      }
      tripStatus
      position
      load
      unload
      fuel
      arrivalTime
      actualArrivalDate
      actualDepartureDate
      departureTime
      productionDate
      transportationDate
      transportationDateOffset
      note
      actualDepartureTime
      isNonArrivalMarked
      isNewLegVariant
      subcontractorLocationId
      dispatcherId
      legTag
      carDetails {
        id
        seals {
          id
          type
          sealNumber
          sealStatus
          updatedBy
        }
        actualCapacity
        registrationNumber
        gateNumber
        estDock
        estUndock
        containerId
        operationType
        tripStatus
        note
        tripEndDateTime
        loadingListItems {
          id
          locationId
          toLocationId
          location {
            id
          }
          note
          checked
          isDangerous
          classification
          customsProcedure
          unNumber
          isLimitedQty
          pallets
          packages
          palletSpace
          weight
          customWaybillNo
          serviceCode
          grossVolumeM3
          createdFrom
          isSystemGenerated
          lliEdiAdditionalDetails {
            id
            consignorName
            consignorPickupAddressLine1
            consignorPickupAddressLine2
            consignorStreet
            consignorPostalCode
            consignorCity
            consignorCountryCode
            consignorPhoneNumber
            consignorSenderRef
            consigneeName
            consigneeDeliveryAddressLine1
            consigneeDeliveryAddressLine2
            consigneeStreet
            consigneePostalCode
            consigneeCity
            consigneeCountryCode
            consigneePhoneNumber
            consigneeReceiverRef
            createdFrom
            consignmentUniqueId
            deliveryInstructions
            apiProvidedFields
            lliConsignmentItems
          }
        }
      }
      trailerDetails {
        id
        seals {
          id
          type
          sealNumber
          sealStatus
          updatedBy
        }
        actualCapacity
        registrationNumber
        gateNumber
        estDock
        estUndock
        containerId
        operationType
        tripStatus
        note
        tripEndDateTime
        loadingListItems {
          id
          locationId
          toLocationId
          location {
            id
          }
          note
          checked
          isDangerous
          classification
          customsProcedure
          unNumber
          isLimitedQty
          pallets
          packages
          palletSpace
          weight
          customWaybillNo
          serviceCode
          grossVolumeM3
          createdFrom
          isSystemGenerated
          lliEdiAdditionalDetails {
            id
            consignorName
            consignorPickupAddressLine1
            consignorPickupAddressLine2
            consignorStreet
            consignorPostalCode
            consignorCity
            consignorCountryCode
            consignorPhoneNumber
            consignorSenderRef
            consigneeName
            consigneeDeliveryAddressLine1
            consigneeDeliveryAddressLine2
            consigneeStreet
            consigneePostalCode
            consigneeCity
            consigneeCountryCode
            consigneePhoneNumber
            consigneeReceiverRef
            createdFrom
            consignmentUniqueId
            deliveryInstructions
            apiProvidedFields
            lliConsignmentItems
          }
        }
      }
    }
    transits {
      id
      routeId
      fromLegId
      toLegId
      transitType
      distanceKm
      durationMin
      isBorderCrossing
      fuelType
      driverName
      driverPhoneNumber
      driverEmail
      subcontractorLocationId
      dispatcherId
      trainRef
      trainNumber
    }
    files {
      id
    }
  }
}
    `;

/**
 * __useGetRouteByIdV2Query__
 *
 * To run a query within a React component, call `useGetRouteByIdV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteByIdV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteByIdV2Query({
 *   variables: {
 *      routeId: // value for 'routeId'
 *   },
 * });
 */
export function useGetRouteByIdV2Query(baseOptions: Apollo.QueryHookOptions<GetRouteByIdV2Query, GetRouteByIdV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRouteByIdV2Query, GetRouteByIdV2QueryVariables>(GetRouteByIdV2Document, options);
      }
export function useGetRouteByIdV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRouteByIdV2Query, GetRouteByIdV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRouteByIdV2Query, GetRouteByIdV2QueryVariables>(GetRouteByIdV2Document, options);
        }
export type GetRouteByIdV2QueryHookResult = ReturnType<typeof useGetRouteByIdV2Query>;
export type GetRouteByIdV2LazyQueryHookResult = ReturnType<typeof useGetRouteByIdV2LazyQuery>;
export type GetRouteByIdV2QueryResult = Apollo.QueryResult<GetRouteByIdV2Query, GetRouteByIdV2QueryVariables>;
export const GetRouteLegForViewLoadingListDocument = gql`
    query GetRouteLegForViewLoadingList($legId: Int!) {
  routeLegForViewLoadingList(legId: $legId) {
    id
    load
    position
    locationId
    isNewLegVariant
    isLoadingInTrailer
    isLoadingInCar
    loadingListItems {
      id
      locationId
      packages
      pallets
      palletSpace
      weight
      checked
      isDangerous
      classification
      unNumber
      isLimitedQty
      note
      isImportedFromShipment
      customWaybillNo
      lliEdiAdditionalDetails {
        consignorName
        consignorStreet
        consignorPostalCode
        consignorCity
        consignorCountryCode
        consignorPickupAddressLine1
        consignorPickupAddressLine2
      }
    }
    carDetails {
      id
      operationType
      loadingListItems {
        id
        locationId
        packages
        pallets
        palletSpace
        weight
        checked
        isDangerous
        classification
        unNumber
        isLimitedQty
        note
        isImportedFromShipment
        customWaybillNo
        customer {
          customerName
        }
        location {
          name
        }
        lliEdiAdditionalDetails {
          consignorName
          consignorStreet
          consignorPostalCode
          consignorCity
          consignorCountryCode
          consignorPickupAddressLine1
          consignorPickupAddressLine2
        }
      }
    }
    trailerDetails {
      id
      operationType
      loadingListItems {
        id
        locationId
        packages
        pallets
        palletSpace
        weight
        checked
        isDangerous
        classification
        unNumber
        isLimitedQty
        note
        isImportedFromShipment
        customWaybillNo
        customer {
          customerName
        }
        lliEdiAdditionalDetails {
          consignorName
          consignorStreet
          consignorPostalCode
          consignorCity
          consignorCountryCode
          consignorPickupAddressLine1
          consignorPickupAddressLine2
        }
      }
    }
    route {
      createdBy
      updatedAt
      lastUpdatedBy
      deletedBy
      deletedAt
    }
  }
}
    `;

/**
 * __useGetRouteLegForViewLoadingListQuery__
 *
 * To run a query within a React component, call `useGetRouteLegForViewLoadingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteLegForViewLoadingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteLegForViewLoadingListQuery({
 *   variables: {
 *      legId: // value for 'legId'
 *   },
 * });
 */
export function useGetRouteLegForViewLoadingListQuery(baseOptions: Apollo.QueryHookOptions<GetRouteLegForViewLoadingListQuery, GetRouteLegForViewLoadingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRouteLegForViewLoadingListQuery, GetRouteLegForViewLoadingListQueryVariables>(GetRouteLegForViewLoadingListDocument, options);
      }
export function useGetRouteLegForViewLoadingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRouteLegForViewLoadingListQuery, GetRouteLegForViewLoadingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRouteLegForViewLoadingListQuery, GetRouteLegForViewLoadingListQueryVariables>(GetRouteLegForViewLoadingListDocument, options);
        }
export type GetRouteLegForViewLoadingListQueryHookResult = ReturnType<typeof useGetRouteLegForViewLoadingListQuery>;
export type GetRouteLegForViewLoadingListLazyQueryHookResult = ReturnType<typeof useGetRouteLegForViewLoadingListLazyQuery>;
export type GetRouteLegForViewLoadingListQueryResult = Apollo.QueryResult<GetRouteLegForViewLoadingListQuery, GetRouteLegForViewLoadingListQueryVariables>;
export const GetRouteLegWrappersByRouteIdDocument = gql`
    query GetRouteLegWrappersByRouteId($routeId: Int!) {
  routeLegWrappers(routeId: $routeId) {
    ...RouteLegWrapperFields
    startStop {
      id
      position
      arrivalTime
      departureTime
      location {
        id
        type
        name
        city
        country
      }
    }
    endStop {
      id
      position
      arrivalTime
      departureTime
      location {
        id
        type
        name
        city
        country
      }
    }
  }
}
    ${RouteLegWrapperFieldsFragmentDoc}`;

/**
 * __useGetRouteLegWrappersByRouteIdQuery__
 *
 * To run a query within a React component, call `useGetRouteLegWrappersByRouteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteLegWrappersByRouteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteLegWrappersByRouteIdQuery({
 *   variables: {
 *      routeId: // value for 'routeId'
 *   },
 * });
 */
export function useGetRouteLegWrappersByRouteIdQuery(baseOptions: Apollo.QueryHookOptions<GetRouteLegWrappersByRouteIdQuery, GetRouteLegWrappersByRouteIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRouteLegWrappersByRouteIdQuery, GetRouteLegWrappersByRouteIdQueryVariables>(GetRouteLegWrappersByRouteIdDocument, options);
      }
export function useGetRouteLegWrappersByRouteIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRouteLegWrappersByRouteIdQuery, GetRouteLegWrappersByRouteIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRouteLegWrappersByRouteIdQuery, GetRouteLegWrappersByRouteIdQueryVariables>(GetRouteLegWrappersByRouteIdDocument, options);
        }
export type GetRouteLegWrappersByRouteIdQueryHookResult = ReturnType<typeof useGetRouteLegWrappersByRouteIdQuery>;
export type GetRouteLegWrappersByRouteIdLazyQueryHookResult = ReturnType<typeof useGetRouteLegWrappersByRouteIdLazyQuery>;
export type GetRouteLegWrappersByRouteIdQueryResult = Apollo.QueryResult<GetRouteLegWrappersByRouteIdQuery, GetRouteLegWrappersByRouteIdQueryVariables>;
export const GetRouteLegsDocument = gql`
    query GetRouteLegs($id: Int!) {
  route(id: $id) {
    id
    turnummer
    rutekode
    trainNumber
    legs {
      gateNumber
      carRegistrationNumber
      trailerRegistrationNumber
      routeDriverName
      routeDriverPhoneNumber
      actualCapacity
      arrivalTime
      actualArrivalTime
      actualDepartureTime
      actualArrivalDate
      actualDepartureDate
      departureTime
      fuel
      id
      load
      note
      position
      unload
      isNonArrivalMarked
      nonArrivalMarkedFrom
      productionDate
      transportationDate
      transportationDateOffset
      isNewLegVariant
      isLoadingInCar
      isLoadingInTrailer
      locationId
      distanceInKM
      weight
      receivedStatus
      receivedBy
      timeWhenReceived
      kippReceivedBy
      kippTimeWhenReceived
      assigned
      ansvBefraktare
      timeWhenAssigned
      tom
      routeDriverEmail
      lastUpdatedBy
      updatedAt
      location {
        id
        type
        name
        address
        city
        country
        postalCode
      }
      carDetails {
        id
        operationType
        actualCapacity
        registrationNumber
        gateNumber
        tripStartDateTime
        tripEndDateTime
        togref
        containerId
        loadingListItems {
          id
          volume {
            bpx
            pri03
            pri49
            upri03
            upri49
            parti
            brev
            pru
            pip
          }
        }
      }
      trailerDetails {
        id
        operationType
        actualCapacity
        registrationNumber
        gateNumber
        tripStartDateTime
        tripEndDateTime
      }
    }
    transits {
      id
      routeId
      fromLegId
      toLegId
      transitType
      distanceKm
      durationMin
      isBorderCrossing
      fuelType
      driverName
      driverPhoneNumber
      driverEmail
      subcontractorLocationId
      dispatcherId
      trainRef
      trainNumber
    }
  }
}
    `;

/**
 * __useGetRouteLegsQuery__
 *
 * To run a query within a React component, call `useGetRouteLegsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteLegsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteLegsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRouteLegsQuery(baseOptions: Apollo.QueryHookOptions<GetRouteLegsQuery, GetRouteLegsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRouteLegsQuery, GetRouteLegsQueryVariables>(GetRouteLegsDocument, options);
      }
export function useGetRouteLegsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRouteLegsQuery, GetRouteLegsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRouteLegsQuery, GetRouteLegsQueryVariables>(GetRouteLegsDocument, options);
        }
export type GetRouteLegsQueryHookResult = ReturnType<typeof useGetRouteLegsQuery>;
export type GetRouteLegsLazyQueryHookResult = ReturnType<typeof useGetRouteLegsLazyQuery>;
export type GetRouteLegsQueryResult = Apollo.QueryResult<GetRouteLegsQuery, GetRouteLegsQueryVariables>;
export const GetRouteLegsForProdAppDocument = gql`
    query GetRouteLegsForProdApp($unitId: String!, $event: String!, $futureHours: Int!, $cetDateTimeString: String!, $pastHours: Int, $gateNumbers: [String!], $tripStatus: String) {
  fetchRoutesForProdApp(
    unitId: $unitId
    event: $event
    futureHours: $futureHours
    cetDateTimeString: $cetDateTimeString
    pastHours: $pastHours
    gateNumbers: $gateNumbers
    tripStatus: $tripStatus
  ) {
    id
    position
    transportationDate
    arrivalTime
    actualArrivalTime
    actualArrivalDate
    departureTime
    actualDepartureTime
    actualDepartureDate
    routeDriverName
    routeDriverEmail
    tripStatus
    isNewLegVariant
    isLoadingInCar
    isLoadingInTrailer
    carDetails {
      id
      actualCapacity
      registrationNumber
      gateNumber
      tripStartDateTime
      tripEndDateTime
      tripStatus
    }
    trailerDetails {
      id
      actualCapacity
      registrationNumber
      gateNumber
      tripStartDateTime
      tripEndDateTime
      tripStatus
    }
    route {
      id
      routeId
      capacity
      kilometer
      type
      trailerCarrierId
      carCarrierId
      containerId
      departureAddress {
        city
        country
      }
      arrivalAddress {
        city
        country
      }
    }
  }
}
    `;

/**
 * __useGetRouteLegsForProdAppQuery__
 *
 * To run a query within a React component, call `useGetRouteLegsForProdAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteLegsForProdAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteLegsForProdAppQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *      event: // value for 'event'
 *      futureHours: // value for 'futureHours'
 *      cetDateTimeString: // value for 'cetDateTimeString'
 *      pastHours: // value for 'pastHours'
 *      gateNumbers: // value for 'gateNumbers'
 *      tripStatus: // value for 'tripStatus'
 *   },
 * });
 */
export function useGetRouteLegsForProdAppQuery(baseOptions: Apollo.QueryHookOptions<GetRouteLegsForProdAppQuery, GetRouteLegsForProdAppQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRouteLegsForProdAppQuery, GetRouteLegsForProdAppQueryVariables>(GetRouteLegsForProdAppDocument, options);
      }
export function useGetRouteLegsForProdAppLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRouteLegsForProdAppQuery, GetRouteLegsForProdAppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRouteLegsForProdAppQuery, GetRouteLegsForProdAppQueryVariables>(GetRouteLegsForProdAppDocument, options);
        }
export type GetRouteLegsForProdAppQueryHookResult = ReturnType<typeof useGetRouteLegsForProdAppQuery>;
export type GetRouteLegsForProdAppLazyQueryHookResult = ReturnType<typeof useGetRouteLegsForProdAppLazyQuery>;
export type GetRouteLegsForProdAppQueryResult = Apollo.QueryResult<GetRouteLegsForProdAppQuery, GetRouteLegsForProdAppQueryVariables>;
export const GetRouteLegsForProdAppWithTokenDocument = gql`
    query GetRouteLegsForProdAppWithToken($unitId: String!, $event: String!, $futureHours: Int!, $cetDateTimeString: String, $pastHours: Int, $gateNumbers: [String!], $tripStatus: String) {
  fetchRoutesForProdAppWithToken(
    unitId: $unitId
    event: $event
    futureHours: $futureHours
    cetDateTimeString: $cetDateTimeString
    pastHours: $pastHours
    gateNumbers: $gateNumbers
    tripStatus: $tripStatus
  ) {
    id
    position
    transportationDate
    arrivalTime
    actualArrivalTime
    actualArrivalDate
    departureTime
    actualDepartureTime
    actualDepartureDate
    routeDriverName
    routeDriverEmail
    tripStatus
    actualCapacity
    routeDetails {
      id
      routeId
      type
      trailerCarrierId
      carCarrierId
      departureCity
      departureCountry
      arrivalCity
      arrivalCountry
    }
    carDetails {
      id
      actualCapacity
      registrationNumber
      gateNumber
      tripStartDateTime
      tripEndDateTime
      tripStatus
    }
    trailerDetails {
      id
      actualCapacity
      registrationNumber
      gateNumber
      tripStartDateTime
      tripEndDateTime
      tripStatus
    }
  }
}
    `;

/**
 * __useGetRouteLegsForProdAppWithTokenQuery__
 *
 * To run a query within a React component, call `useGetRouteLegsForProdAppWithTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteLegsForProdAppWithTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteLegsForProdAppWithTokenQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *      event: // value for 'event'
 *      futureHours: // value for 'futureHours'
 *      cetDateTimeString: // value for 'cetDateTimeString'
 *      pastHours: // value for 'pastHours'
 *      gateNumbers: // value for 'gateNumbers'
 *      tripStatus: // value for 'tripStatus'
 *   },
 * });
 */
export function useGetRouteLegsForProdAppWithTokenQuery(baseOptions: Apollo.QueryHookOptions<GetRouteLegsForProdAppWithTokenQuery, GetRouteLegsForProdAppWithTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRouteLegsForProdAppWithTokenQuery, GetRouteLegsForProdAppWithTokenQueryVariables>(GetRouteLegsForProdAppWithTokenDocument, options);
      }
export function useGetRouteLegsForProdAppWithTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRouteLegsForProdAppWithTokenQuery, GetRouteLegsForProdAppWithTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRouteLegsForProdAppWithTokenQuery, GetRouteLegsForProdAppWithTokenQueryVariables>(GetRouteLegsForProdAppWithTokenDocument, options);
        }
export type GetRouteLegsForProdAppWithTokenQueryHookResult = ReturnType<typeof useGetRouteLegsForProdAppWithTokenQuery>;
export type GetRouteLegsForProdAppWithTokenLazyQueryHookResult = ReturnType<typeof useGetRouteLegsForProdAppWithTokenLazyQuery>;
export type GetRouteLegsForProdAppWithTokenQueryResult = Apollo.QueryResult<GetRouteLegsForProdAppWithTokenQuery, GetRouteLegsForProdAppWithTokenQueryVariables>;
export const GetRouteLockDocument = gql`
    query GetRouteLock($routeId: Int!) {
  routeLock(routeId: $routeId) {
    lockedBy
    lockedAt
    isChecklistLocked
  }
}
    `;

/**
 * __useGetRouteLockQuery__
 *
 * To run a query within a React component, call `useGetRouteLockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteLockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteLockQuery({
 *   variables: {
 *      routeId: // value for 'routeId'
 *   },
 * });
 */
export function useGetRouteLockQuery(baseOptions: Apollo.QueryHookOptions<GetRouteLockQuery, GetRouteLockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRouteLockQuery, GetRouteLockQueryVariables>(GetRouteLockDocument, options);
      }
export function useGetRouteLockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRouteLockQuery, GetRouteLockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRouteLockQuery, GetRouteLockQueryVariables>(GetRouteLockDocument, options);
        }
export type GetRouteLockQueryHookResult = ReturnType<typeof useGetRouteLockQuery>;
export type GetRouteLockLazyQueryHookResult = ReturnType<typeof useGetRouteLockLazyQuery>;
export type GetRouteLockQueryResult = Apollo.QueryResult<GetRouteLockQuery, GetRouteLockQueryVariables>;
export const GetTransportAgreementDataDocument = gql`
    query GetTransportAgreementData($id: Int!) {
  route(id: $id) {
    ...TransportAgreementFields
  }
}
    ${TransportAgreementFieldsFragmentDoc}`;

/**
 * __useGetTransportAgreementDataQuery__
 *
 * To run a query within a React component, call `useGetTransportAgreementDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransportAgreementDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransportAgreementDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTransportAgreementDataQuery(baseOptions: Apollo.QueryHookOptions<GetTransportAgreementDataQuery, GetTransportAgreementDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransportAgreementDataQuery, GetTransportAgreementDataQueryVariables>(GetTransportAgreementDataDocument, options);
      }
export function useGetTransportAgreementDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransportAgreementDataQuery, GetTransportAgreementDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransportAgreementDataQuery, GetTransportAgreementDataQueryVariables>(GetTransportAgreementDataDocument, options);
        }
export type GetTransportAgreementDataQueryHookResult = ReturnType<typeof useGetTransportAgreementDataQuery>;
export type GetTransportAgreementDataLazyQueryHookResult = ReturnType<typeof useGetTransportAgreementDataLazyQuery>;
export type GetTransportAgreementDataQueryResult = Apollo.QueryResult<GetTransportAgreementDataQuery, GetTransportAgreementDataQueryVariables>;
export const ListAssociatedRoutesDocument = gql`
    query ListAssociatedRoutes($id: Int!) {
  associatedRoutes(id: $id) {
    id
    routeId
    routePosition
    tourId
    routeName
    tourName
    departureLocation
    departureTime
    arrivalLocation
    arrivalTime
    subContractorLocationName
    frequency
  }
}
    `;

/**
 * __useListAssociatedRoutesQuery__
 *
 * To run a query within a React component, call `useListAssociatedRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAssociatedRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAssociatedRoutesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListAssociatedRoutesQuery(baseOptions: Apollo.QueryHookOptions<ListAssociatedRoutesQuery, ListAssociatedRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAssociatedRoutesQuery, ListAssociatedRoutesQueryVariables>(ListAssociatedRoutesDocument, options);
      }
export function useListAssociatedRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAssociatedRoutesQuery, ListAssociatedRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAssociatedRoutesQuery, ListAssociatedRoutesQueryVariables>(ListAssociatedRoutesDocument, options);
        }
export type ListAssociatedRoutesQueryHookResult = ReturnType<typeof useListAssociatedRoutesQuery>;
export type ListAssociatedRoutesLazyQueryHookResult = ReturnType<typeof useListAssociatedRoutesLazyQuery>;
export type ListAssociatedRoutesQueryResult = Apollo.QueryResult<ListAssociatedRoutesQuery, ListAssociatedRoutesQueryVariables>;
export const ListRoutesDocument = gql`
    query ListRoutes($startDate: String!, $endDate: String!) {
  routes(startDate: $startDate, endDate: $endDate) {
    id
    isCreatedFromTerminal
    isCreatedFromPlanned
    routeId
    amphoraTripId
    invoiceNumber
    invoiceNote
    transportationDate
    dispatcher {
      name
    }
    subcontractor {
      name
    }
    agreedPrice
    currency
    driverName
    driverPhoneNumber
    licensePlate
    fuel
    capacity
    kilometer
    weight
    note
    externalNote
    legs {
      isNonArrivalMarked
      arrivalTime
      departureTime
      position
      location {
        id
        type
        name
        city
        country
      }
    }
    ftl {
      customerNumber
      price
      currency
      invoiceNote
      cmr
      cdc
    }
    tour {
      name
    }
  }
}
    `;

/**
 * __useListRoutesQuery__
 *
 * To run a query within a React component, call `useListRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRoutesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useListRoutesQuery(baseOptions: Apollo.QueryHookOptions<ListRoutesQuery, ListRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRoutesQuery, ListRoutesQueryVariables>(ListRoutesDocument, options);
      }
export function useListRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRoutesQuery, ListRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRoutesQuery, ListRoutesQueryVariables>(ListRoutesDocument, options);
        }
export type ListRoutesQueryHookResult = ReturnType<typeof useListRoutesQuery>;
export type ListRoutesLazyQueryHookResult = ReturnType<typeof useListRoutesLazyQuery>;
export type ListRoutesQueryResult = Apollo.QueryResult<ListRoutesQuery, ListRoutesQueryVariables>;
export const PingRouteLockUserDocument = gql`
    query PingRouteLockUser($routeId: Int!) {
  pingUser(routeId: $routeId)
}
    `;

/**
 * __usePingRouteLockUserQuery__
 *
 * To run a query within a React component, call `usePingRouteLockUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePingRouteLockUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingRouteLockUserQuery({
 *   variables: {
 *      routeId: // value for 'routeId'
 *   },
 * });
 */
export function usePingRouteLockUserQuery(baseOptions: Apollo.QueryHookOptions<PingRouteLockUserQuery, PingRouteLockUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PingRouteLockUserQuery, PingRouteLockUserQueryVariables>(PingRouteLockUserDocument, options);
      }
export function usePingRouteLockUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PingRouteLockUserQuery, PingRouteLockUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PingRouteLockUserQuery, PingRouteLockUserQueryVariables>(PingRouteLockUserDocument, options);
        }
export type PingRouteLockUserQueryHookResult = ReturnType<typeof usePingRouteLockUserQuery>;
export type PingRouteLockUserLazyQueryHookResult = ReturnType<typeof usePingRouteLockUserLazyQuery>;
export type PingRouteLockUserQueryResult = Apollo.QueryResult<PingRouteLockUserQuery, PingRouteLockUserQueryVariables>;
export const RefetchRouteLegDocument = gql`
    query RefetchRouteLeg($legId: Int!, $locationId: Int!) {
  refetchLatestLeg(legId: $legId, locationId: $locationId) {
    ...LiveUpdateRouteLeg
  }
}
    ${LiveUpdateRouteLegFragmentDoc}`;

/**
 * __useRefetchRouteLegQuery__
 *
 * To run a query within a React component, call `useRefetchRouteLegQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefetchRouteLegQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefetchRouteLegQuery({
 *   variables: {
 *      legId: // value for 'legId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useRefetchRouteLegQuery(baseOptions: Apollo.QueryHookOptions<RefetchRouteLegQuery, RefetchRouteLegQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefetchRouteLegQuery, RefetchRouteLegQueryVariables>(RefetchRouteLegDocument, options);
      }
export function useRefetchRouteLegLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefetchRouteLegQuery, RefetchRouteLegQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefetchRouteLegQuery, RefetchRouteLegQueryVariables>(RefetchRouteLegDocument, options);
        }
export type RefetchRouteLegQueryHookResult = ReturnType<typeof useRefetchRouteLegQuery>;
export type RefetchRouteLegLazyQueryHookResult = ReturnType<typeof useRefetchRouteLegLazyQuery>;
export type RefetchRouteLegQueryResult = Apollo.QueryResult<RefetchRouteLegQuery, RefetchRouteLegQueryVariables>;
export const GetClientAppVersionDocument = gql`
    query getClientAppVersion {
  settings {
    id
    version
  }
}
    `;

/**
 * __useGetClientAppVersionQuery__
 *
 * To run a query within a React component, call `useGetClientAppVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientAppVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientAppVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientAppVersionQuery(baseOptions?: Apollo.QueryHookOptions<GetClientAppVersionQuery, GetClientAppVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientAppVersionQuery, GetClientAppVersionQueryVariables>(GetClientAppVersionDocument, options);
      }
export function useGetClientAppVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientAppVersionQuery, GetClientAppVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientAppVersionQuery, GetClientAppVersionQueryVariables>(GetClientAppVersionDocument, options);
        }
export type GetClientAppVersionQueryHookResult = ReturnType<typeof useGetClientAppVersionQuery>;
export type GetClientAppVersionLazyQueryHookResult = ReturnType<typeof useGetClientAppVersionLazyQuery>;
export type GetClientAppVersionQueryResult = Apollo.QueryResult<GetClientAppVersionQuery, GetClientAppVersionQueryVariables>;
export const GetShipmentTagsDocument = gql`
    query GetShipmentTags {
  getShipmentTags {
    id
    title
  }
}
    `;

/**
 * __useGetShipmentTagsQuery__
 *
 * To run a query within a React component, call `useGetShipmentTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShipmentTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetShipmentTagsQuery, GetShipmentTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentTagsQuery, GetShipmentTagsQueryVariables>(GetShipmentTagsDocument, options);
      }
export function useGetShipmentTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentTagsQuery, GetShipmentTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentTagsQuery, GetShipmentTagsQueryVariables>(GetShipmentTagsDocument, options);
        }
export type GetShipmentTagsQueryHookResult = ReturnType<typeof useGetShipmentTagsQuery>;
export type GetShipmentTagsLazyQueryHookResult = ReturnType<typeof useGetShipmentTagsLazyQuery>;
export type GetShipmentTagsQueryResult = Apollo.QueryResult<GetShipmentTagsQuery, GetShipmentTagsQueryVariables>;
export const GetTagsDocument = gql`
    query GetTags {
  cardContactTags {
    id
    title
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const TagsByTypeDocument = gql`
    query TagsByType($type: String!) {
  tagsByType(type: $type)
}
    `;

/**
 * __useTagsByTypeQuery__
 *
 * To run a query within a React component, call `useTagsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTagsByTypeQuery(baseOptions: Apollo.QueryHookOptions<TagsByTypeQuery, TagsByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsByTypeQuery, TagsByTypeQueryVariables>(TagsByTypeDocument, options);
      }
export function useTagsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsByTypeQuery, TagsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsByTypeQuery, TagsByTypeQueryVariables>(TagsByTypeDocument, options);
        }
export type TagsByTypeQueryHookResult = ReturnType<typeof useTagsByTypeQuery>;
export type TagsByTypeLazyQueryHookResult = ReturnType<typeof useTagsByTypeLazyQuery>;
export type TagsByTypeQueryResult = Apollo.QueryResult<TagsByTypeQuery, TagsByTypeQueryVariables>;
export const BookmarkedDispatchedRoutesDocument = gql`
    query BookmarkedDispatchedRoutes($date: String) {
  bookmarkedDispatchedRoutes(date: $date) {
    id
    routeId
    tourRouteId
    capacity
    truckLicencePlateNo
    legs {
      id
      loadingListItems {
        id
        packages
        pallets
        palletSpace
        weight
        note
        checked
      }
    }
    status
  }
}
    `;

/**
 * __useBookmarkedDispatchedRoutesQuery__
 *
 * To run a query within a React component, call `useBookmarkedDispatchedRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookmarkedDispatchedRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookmarkedDispatchedRoutesQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useBookmarkedDispatchedRoutesQuery(baseOptions?: Apollo.QueryHookOptions<BookmarkedDispatchedRoutesQuery, BookmarkedDispatchedRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookmarkedDispatchedRoutesQuery, BookmarkedDispatchedRoutesQueryVariables>(BookmarkedDispatchedRoutesDocument, options);
      }
export function useBookmarkedDispatchedRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookmarkedDispatchedRoutesQuery, BookmarkedDispatchedRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookmarkedDispatchedRoutesQuery, BookmarkedDispatchedRoutesQueryVariables>(BookmarkedDispatchedRoutesDocument, options);
        }
export type BookmarkedDispatchedRoutesQueryHookResult = ReturnType<typeof useBookmarkedDispatchedRoutesQuery>;
export type BookmarkedDispatchedRoutesLazyQueryHookResult = ReturnType<typeof useBookmarkedDispatchedRoutesLazyQuery>;
export type BookmarkedDispatchedRoutesQueryResult = Apollo.QueryResult<BookmarkedDispatchedRoutesQuery, BookmarkedDispatchedRoutesQueryVariables>;
export const GetOneTourRouteDocument = gql`
    query GetOneTourRoute($routeId: Int!) {
  getTourRoute(routeId: $routeId) {
    id
    routeId
    note
    externalNote
    days
    schedule
    lc1TotalCapacity
    lc2TotalCapacity
    lc3TotalCapacity
    price
    createdAt
    updatedAt
    files {
      originalname
      id
      path
      createdBy
      createdAt
      mimetype
      size
      tags {
        id
        title
        createdAt
        updatedAt
      }
    }
    routeDriverName
    routeDriverPhoneNumber
    routeCarRegNumber
    routeTrailerRegNumber
    isCopyDriverPlateInfo
    capacity
    kilometer
    weight
    startDate
    originalStartDate
    endDate
    startExceptionDate
    endExceptionDate
    exceptionDates
    routeDateType
    tourRouteType
    rutekode
    turnummer
    trainNumber
    legs {
      id
      fuel
      locationId
      gateNumber
      carRegistrationNumber
      trailerRegistrationNumber
      routeDriverName
      routeDriverPhoneNumber
      routeDriverEmail
      note
      arrivalTime
      departureTime
      position
      load
      unload
      transportationDateOffset
      location {
        id
        type
        name
        city
        country
      }
      isNewLegVariant
      isLoadingInCar
      isLoadingInTrailer
      carDetails {
        id
        loadingListItems {
          id
          locationId
          packages
          pallets
          palletSpace
          weight
          checked
          isDangerous
          classification
          unNumber
          isLimitedQty
          note
          lastUpdatedBy
          createdBy
          updatedAt
        }
        actualCapacity
        registrationNumber
        gateNumber
        description
      }
      trailerDetails {
        id
        loadingListItems {
          id
          locationId
          packages
          pallets
          palletSpace
          weight
          checked
          isDangerous
          classification
          unNumber
          isLimitedQty
          note
          lastUpdatedBy
          createdBy
          updatedAt
        }
        actualCapacity
        registrationNumber
        gateNumber
        description
      }
      loadingListItems {
        id
        locationId
        packages
        pallets
        palletSpace
        weight
        checked
        isDangerous
        classification
        unNumber
        isLimitedQty
        note
        lastUpdatedBy
        createdBy
        updatedAt
      }
    }
    costAllocations {
      id
      departmentId
      cost
      includedKpi
      includedPrice
      bringCost
      additionalCost
      additionalDiscount
      type
      comment
    }
  }
}
    `;

/**
 * __useGetOneTourRouteQuery__
 *
 * To run a query within a React component, call `useGetOneTourRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneTourRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneTourRouteQuery({
 *   variables: {
 *      routeId: // value for 'routeId'
 *   },
 * });
 */
export function useGetOneTourRouteQuery(baseOptions: Apollo.QueryHookOptions<GetOneTourRouteQuery, GetOneTourRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneTourRouteQuery, GetOneTourRouteQueryVariables>(GetOneTourRouteDocument, options);
      }
export function useGetOneTourRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneTourRouteQuery, GetOneTourRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneTourRouteQuery, GetOneTourRouteQueryVariables>(GetOneTourRouteDocument, options);
        }
export type GetOneTourRouteQueryHookResult = ReturnType<typeof useGetOneTourRouteQuery>;
export type GetOneTourRouteLazyQueryHookResult = ReturnType<typeof useGetOneTourRouteLazyQuery>;
export type GetOneTourRouteQueryResult = Apollo.QueryResult<GetOneTourRouteQuery, GetOneTourRouteQueryVariables>;
export const GetTourRouteTemplatesDocument = gql`
    query GetTourRouteTemplates($fetchBookmarked: Boolean) {
  tourRouteTemplates(fetchBookmarked: $fetchBookmarked) {
    id
    routeId
    price
    days
    schedule
    lc1TotalCapacity
    lc2TotalCapacity
    lc3TotalCapacity
    note
    externalNote
    position
    departureLocation {
      type
      city
      country
    }
    arrivalLocation {
      type
      city
      country
    }
    tour {
      id
      name
      capacity
      currency
      isInactive
      isDateActive
      fuel
      startDate
      endDate
      startExceptionDate
      endExceptionDate
      subcontractor {
        name
      }
      dispatcher {
        name
      }
      createdBy
      lastUpdatedBy
      updatedAt
    }
    legs {
      id
      locationId
      location {
        id
        type
        name
        city
        country
      }
      note
      arrivalTime
      departureTime
      position
      load
      unload
      transportationDateOffset
      loadingListItems {
        id
        locationId
        packages
        pallets
        palletSpace
        weight
        note
        checked
        isDangerous
        classification
        unNumber
        isLimitedQty
        lastUpdatedBy
        createdBy
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetTourRouteTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTourRouteTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTourRouteTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTourRouteTemplatesQuery({
 *   variables: {
 *      fetchBookmarked: // value for 'fetchBookmarked'
 *   },
 * });
 */
export function useGetTourRouteTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetTourRouteTemplatesQuery, GetTourRouteTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTourRouteTemplatesQuery, GetTourRouteTemplatesQueryVariables>(GetTourRouteTemplatesDocument, options);
      }
export function useGetTourRouteTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTourRouteTemplatesQuery, GetTourRouteTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTourRouteTemplatesQuery, GetTourRouteTemplatesQueryVariables>(GetTourRouteTemplatesDocument, options);
        }
export type GetTourRouteTemplatesQueryHookResult = ReturnType<typeof useGetTourRouteTemplatesQuery>;
export type GetTourRouteTemplatesLazyQueryHookResult = ReturnType<typeof useGetTourRouteTemplatesLazyQuery>;
export type GetTourRouteTemplatesQueryResult = Apollo.QueryResult<GetTourRouteTemplatesQuery, GetTourRouteTemplatesQueryVariables>;
export const CheckRouteDeleteImpactDocument = gql`
    query CheckRouteDeleteImpact($tourId: Int!, $routeStartDates: [RouteStartDateInput!]!) {
  checkRouteDeleteImpact(tourId: $tourId, routeStartDates: $routeStartDates) {
    willDeleteCount
    dateFrom
    dateTo
    routes {
      id
      routeId
      transportationDate
    }
  }
}
    `;

/**
 * __useCheckRouteDeleteImpactQuery__
 *
 * To run a query within a React component, call `useCheckRouteDeleteImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckRouteDeleteImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRouteDeleteImpactQuery({
 *   variables: {
 *      tourId: // value for 'tourId'
 *      routeStartDates: // value for 'routeStartDates'
 *   },
 * });
 */
export function useCheckRouteDeleteImpactQuery(baseOptions: Apollo.QueryHookOptions<CheckRouteDeleteImpactQuery, CheckRouteDeleteImpactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckRouteDeleteImpactQuery, CheckRouteDeleteImpactQueryVariables>(CheckRouteDeleteImpactDocument, options);
      }
export function useCheckRouteDeleteImpactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckRouteDeleteImpactQuery, CheckRouteDeleteImpactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckRouteDeleteImpactQuery, CheckRouteDeleteImpactQueryVariables>(CheckRouteDeleteImpactDocument, options);
        }
export type CheckRouteDeleteImpactQueryHookResult = ReturnType<typeof useCheckRouteDeleteImpactQuery>;
export type CheckRouteDeleteImpactLazyQueryHookResult = ReturnType<typeof useCheckRouteDeleteImpactLazyQuery>;
export type CheckRouteDeleteImpactQueryResult = Apollo.QueryResult<CheckRouteDeleteImpactQuery, CheckRouteDeleteImpactQueryVariables>;
export const GetDepartmentOptionsDocument = gql`
    query GetDepartmentOptions {
  getDepartmentOptions {
    country
    departments
  }
}
    `;

/**
 * __useGetDepartmentOptionsQuery__
 *
 * To run a query within a React component, call `useGetDepartmentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDepartmentOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDepartmentOptionsQuery, GetDepartmentOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepartmentOptionsQuery, GetDepartmentOptionsQueryVariables>(GetDepartmentOptionsDocument, options);
      }
export function useGetDepartmentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentOptionsQuery, GetDepartmentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepartmentOptionsQuery, GetDepartmentOptionsQueryVariables>(GetDepartmentOptionsDocument, options);
        }
export type GetDepartmentOptionsQueryHookResult = ReturnType<typeof useGetDepartmentOptionsQuery>;
export type GetDepartmentOptionsLazyQueryHookResult = ReturnType<typeof useGetDepartmentOptionsLazyQuery>;
export type GetDepartmentOptionsQueryResult = Apollo.QueryResult<GetDepartmentOptionsQuery, GetDepartmentOptionsQueryVariables>;
export const GetGroupingTagDocument = gql`
    query GetGroupingTag {
  tourTemplatesWithGroupTag
}
    `;

/**
 * __useGetGroupingTagQuery__
 *
 * To run a query within a React component, call `useGetGroupingTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupingTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupingTagQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupingTagQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupingTagQuery, GetGroupingTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupingTagQuery, GetGroupingTagQueryVariables>(GetGroupingTagDocument, options);
      }
export function useGetGroupingTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupingTagQuery, GetGroupingTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupingTagQuery, GetGroupingTagQueryVariables>(GetGroupingTagDocument, options);
        }
export type GetGroupingTagQueryHookResult = ReturnType<typeof useGetGroupingTagQuery>;
export type GetGroupingTagLazyQueryHookResult = ReturnType<typeof useGetGroupingTagLazyQuery>;
export type GetGroupingTagQueryResult = Apollo.QueryResult<GetGroupingTagQuery, GetGroupingTagQueryVariables>;
export const GetOtherToursDocument = gql`
    query GetOtherTours($excludeId: Int!, $searchTerm: String) {
  otherTours(excludeId: $excludeId, searchTerm: $searchTerm) {
    id
    name
    subcontractorLocationId
    capacity
    fuel
    price
    currency
    startDate
    endDate
    isInactive
    isDateActive
    note
    createdBy
    lastUpdatedBy
    updatedAt
    startExceptionDate
    endExceptionDate
    subcontractor {
      name
    }
  }
}
    `;

/**
 * __useGetOtherToursQuery__
 *
 * To run a query within a React component, call `useGetOtherToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherToursQuery({
 *   variables: {
 *      excludeId: // value for 'excludeId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetOtherToursQuery(baseOptions: Apollo.QueryHookOptions<GetOtherToursQuery, GetOtherToursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOtherToursQuery, GetOtherToursQueryVariables>(GetOtherToursDocument, options);
      }
export function useGetOtherToursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOtherToursQuery, GetOtherToursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOtherToursQuery, GetOtherToursQueryVariables>(GetOtherToursDocument, options);
        }
export type GetOtherToursQueryHookResult = ReturnType<typeof useGetOtherToursQuery>;
export type GetOtherToursLazyQueryHookResult = ReturnType<typeof useGetOtherToursLazyQuery>;
export type GetOtherToursQueryResult = Apollo.QueryResult<GetOtherToursQuery, GetOtherToursQueryVariables>;
export const GetResponsiblePersonDocument = gql`
    query GetResponsiblePerson {
  tourTemplatesWithResponsiblePerson
}
    `;

/**
 * __useGetResponsiblePersonQuery__
 *
 * To run a query within a React component, call `useGetResponsiblePersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponsiblePersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponsiblePersonQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetResponsiblePersonQuery(baseOptions?: Apollo.QueryHookOptions<GetResponsiblePersonQuery, GetResponsiblePersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResponsiblePersonQuery, GetResponsiblePersonQueryVariables>(GetResponsiblePersonDocument, options);
      }
export function useGetResponsiblePersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResponsiblePersonQuery, GetResponsiblePersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResponsiblePersonQuery, GetResponsiblePersonQueryVariables>(GetResponsiblePersonDocument, options);
        }
export type GetResponsiblePersonQueryHookResult = ReturnType<typeof useGetResponsiblePersonQuery>;
export type GetResponsiblePersonLazyQueryHookResult = ReturnType<typeof useGetResponsiblePersonLazyQuery>;
export type GetResponsiblePersonQueryResult = Apollo.QueryResult<GetResponsiblePersonQuery, GetResponsiblePersonQueryVariables>;
export const GetTourTemplateDocument = gql`
    query GetTourTemplate($id: Int!) {
  tourTemplate(id: $id) {
    id
    name
    tourAgreementNo
    subcontractorLocationId
    subcontractorLocation {
      name
    }
    dispatcherId
    dispatcher {
      name
    }
    createdBy
    capacity
    fuel
    price
    currency
    startDate
    endDate
    originalStartDate
    startExceptionDate
    endExceptionDate
    exceptionDates
    note
    driverName
    licensePlate
    driverPhoneNumber
    responsiblePerson
    groupingTag
    isPriceEquallyDivided
    isNewVersion
    country
    department
    templateType
    sameSubcontractorToAllRoutes
    isInactive
    isDateActive
    routes {
      id
      capacity
      kilometer
      weight
      startDate
      originalStartDate
      endDate
      startExceptionDate
      endExceptionDate
      exceptionDates
      routeDateType
      tourRouteType
      routeId
      routeTag
      rutekode
      turnummer
      trainNumber
      note
      externalNote
      routeDriverName
      routeDriverPhoneNumber
      routeCarRegNumber
      routeTrailerRegNumber
      isCopyDriverPlateInfo
      files {
        originalname
        id
        path
        createdBy
        createdAt
        mimetype
        size
        tags {
          id
          title
          createdAt
          updatedAt
        }
      }
      days
      schedule
      lc1TotalCapacity
      lc2TotalCapacity
      lc3TotalCapacity
      transits {
        id
        tourRouteId
        fromLegId
        toLegId
        transitType
        fuelType
        driverName
        driverPhoneNumber
        driverEmail
        subcontractorLocationId
        dispatcherId
        trainNumber
        trainRef
        distanceKm
        durationMin
      }
      legs {
        id
        fuel
        locationId
        gateNumber
        carRegistrationNumber
        trailerRegistrationNumber
        routeDriverName
        routeDriverPhoneNumber
        routeDriverEmail
        subcontractorLocationId
        dispatcherId
        dispatcher {
          id
          name
          email
        }
        subcontractorLocation {
          id
          name
        }
        location {
          name
          city
          country
          postalCode
          address
          deletedBy
          type
        }
        note
        arrivalTime
        departureTime
        position
        load
        unload
        transportationDateOffset
        isNewLegVariant
        isLoadingInCar
        isLoadingInTrailer
        legTags
        km
        duration
        carDetails {
          id
          loadingListItems {
            id
            locationId
            packages
            pallets
            palletSpace
            weight
            checked
            isDangerous
            classification
            unNumber
            isLimitedQty
            note
            lastUpdatedBy
            createdBy
            updatedAt
          }
          actualCapacity
          registrationNumber
          gateNumber
          estDock
          estUndock
          togRef
          trainCompany
          containerId
          description
          operationType
          note
        }
        trailerDetails {
          id
          loadingListItems {
            id
            locationId
            packages
            pallets
            palletSpace
            weight
            checked
            isDangerous
            classification
            unNumber
            isLimitedQty
            note
            lastUpdatedBy
            createdBy
            updatedAt
          }
          actualCapacity
          registrationNumber
          gateNumber
          estDock
          estUndock
          togRef
          trainCompany
          containerId
          description
          operationType
          note
        }
        loadingListItems {
          id
          locationId
          packages
          pallets
          palletSpace
          weight
          note
          checked
          isDangerous
          classification
          unNumber
          isLimitedQty
          lastUpdatedBy
          createdBy
          updatedAt
        }
      }
      price
      costAllocations {
        id
        departmentId
        cost
        includedKpi
        includedPrice
        bringCost
        additionalCost
        additionalDiscount
        type
        comment
        tags
        currency
        location {
          id
          type
          name
          postalCode
          city
          country
          address
        }
      }
      createdAt
      updatedAt
    }
    createdBy
    lastUpdatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetTourTemplateQuery__
 *
 * To run a query within a React component, call `useGetTourTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTourTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTourTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTourTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetTourTemplateQuery, GetTourTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTourTemplateQuery, GetTourTemplateQueryVariables>(GetTourTemplateDocument, options);
      }
export function useGetTourTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTourTemplateQuery, GetTourTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTourTemplateQuery, GetTourTemplateQueryVariables>(GetTourTemplateDocument, options);
        }
export type GetTourTemplateQueryHookResult = ReturnType<typeof useGetTourTemplateQuery>;
export type GetTourTemplateLazyQueryHookResult = ReturnType<typeof useGetTourTemplateLazyQuery>;
export type GetTourTemplateQueryResult = Apollo.QueryResult<GetTourTemplateQuery, GetTourTemplateQueryVariables>;
export const GetTourTemplatesDocument = gql`
    query GetTourTemplates {
  tourTemplates {
    id
    name
    subcontractorLocationId
    capacity
    fuel
    price
    currency
    startDate
    endDate
    originalStartDate
    isInactive
    isDateActive
    note
    createdBy
    lastUpdatedBy
    updatedAt
    startExceptionDate
    endExceptionDate
    exceptionDates
    responsiblePerson
    groupingTag
    isPriceEquallyDivided
    isNewVersion
    country
    department
    sameSubcontractorToAllRoutes
    templateType
    subcontractor {
      name
    }
    dispatcher {
      name
    }
  }
}
    `;

/**
 * __useGetTourTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTourTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTourTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTourTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTourTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetTourTemplatesQuery, GetTourTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTourTemplatesQuery, GetTourTemplatesQueryVariables>(GetTourTemplatesDocument, options);
      }
export function useGetTourTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTourTemplatesQuery, GetTourTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTourTemplatesQuery, GetTourTemplatesQueryVariables>(GetTourTemplatesDocument, options);
        }
export type GetTourTemplatesQueryHookResult = ReturnType<typeof useGetTourTemplatesQuery>;
export type GetTourTemplatesLazyQueryHookResult = ReturnType<typeof useGetTourTemplatesLazyQuery>;
export type GetTourTemplatesQueryResult = Apollo.QueryResult<GetTourTemplatesQuery, GetTourTemplatesQueryVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    id
    createdAt
    department
    firstName
    fullName
    configuration
    trafficAccess
    terminalAccess
    customsAccess
    admin
    locationId
    location {
      id
      name
      address
      city
      country
    }
    lastName
    roles
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetRouteGridConfigDocument = gql`
    query GetRouteGridConfig {
  getRouteGridConfig {
    id
    routesConfiguration
  }
}
    `;

/**
 * __useGetRouteGridConfigQuery__
 *
 * To run a query within a React component, call `useGetRouteGridConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteGridConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteGridConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRouteGridConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetRouteGridConfigQuery, GetRouteGridConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRouteGridConfigQuery, GetRouteGridConfigQueryVariables>(GetRouteGridConfigDocument, options);
      }
export function useGetRouteGridConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRouteGridConfigQuery, GetRouteGridConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRouteGridConfigQuery, GetRouteGridConfigQueryVariables>(GetRouteGridConfigDocument, options);
        }
export type GetRouteGridConfigQueryHookResult = ReturnType<typeof useGetRouteGridConfigQuery>;
export type GetRouteGridConfigLazyQueryHookResult = ReturnType<typeof useGetRouteGridConfigLazyQuery>;
export type GetRouteGridConfigQueryResult = Apollo.QueryResult<GetRouteGridConfigQuery, GetRouteGridConfigQueryVariables>;
export const GetTftConfigDocument = gql`
    query GetTftConfig {
  getTftConfig {
    id
    tftConfiguration
  }
}
    `;

/**
 * __useGetTftConfigQuery__
 *
 * To run a query within a React component, call `useGetTftConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTftConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTftConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTftConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetTftConfigQuery, GetTftConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTftConfigQuery, GetTftConfigQueryVariables>(GetTftConfigDocument, options);
      }
export function useGetTftConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTftConfigQuery, GetTftConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTftConfigQuery, GetTftConfigQueryVariables>(GetTftConfigDocument, options);
        }
export type GetTftConfigQueryHookResult = ReturnType<typeof useGetTftConfigQuery>;
export type GetTftConfigLazyQueryHookResult = ReturnType<typeof useGetTftConfigLazyQuery>;
export type GetTftConfigQueryResult = Apollo.QueryResult<GetTftConfigQuery, GetTftConfigQueryVariables>;
export const GetTrafficGridsConfigDocument = gql`
    query GetTrafficGridsConfig {
  getTrafficGridsConfig {
    id
    configuration
  }
}
    `;

/**
 * __useGetTrafficGridsConfigQuery__
 *
 * To run a query within a React component, call `useGetTrafficGridsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrafficGridsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrafficGridsConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTrafficGridsConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetTrafficGridsConfigQuery, GetTrafficGridsConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrafficGridsConfigQuery, GetTrafficGridsConfigQueryVariables>(GetTrafficGridsConfigDocument, options);
      }
export function useGetTrafficGridsConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrafficGridsConfigQuery, GetTrafficGridsConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrafficGridsConfigQuery, GetTrafficGridsConfigQueryVariables>(GetTrafficGridsConfigDocument, options);
        }
export type GetTrafficGridsConfigQueryHookResult = ReturnType<typeof useGetTrafficGridsConfigQuery>;
export type GetTrafficGridsConfigLazyQueryHookResult = ReturnType<typeof useGetTrafficGridsConfigLazyQuery>;
export type GetTrafficGridsConfigQueryResult = Apollo.QueryResult<GetTrafficGridsConfigQuery, GetTrafficGridsConfigQueryVariables>;
export const GetUserWithTerminalDocument = gql`
    query GetUserWithTerminal {
  getUserLocationData {
    locationId
    locationName
    userFullName
  }
}
    `;

/**
 * __useGetUserWithTerminalQuery__
 *
 * To run a query within a React component, call `useGetUserWithTerminalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWithTerminalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWithTerminalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWithTerminalQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWithTerminalQuery, GetUserWithTerminalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWithTerminalQuery, GetUserWithTerminalQueryVariables>(GetUserWithTerminalDocument, options);
      }
export function useGetUserWithTerminalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWithTerminalQuery, GetUserWithTerminalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWithTerminalQuery, GetUserWithTerminalQueryVariables>(GetUserWithTerminalDocument, options);
        }
export type GetUserWithTerminalQueryHookResult = ReturnType<typeof useGetUserWithTerminalQuery>;
export type GetUserWithTerminalLazyQueryHookResult = ReturnType<typeof useGetUserWithTerminalLazyQuery>;
export type GetUserWithTerminalQueryResult = Apollo.QueryResult<GetUserWithTerminalQuery, GetUserWithTerminalQueryVariables>;
export const UpdateRouteGridConfigDocument = gql`
    mutation UpdateRouteGridConfig($input: UserConfigurationInput!) {
  updateRouteGridConfig(input: $input) {
    id
  }
}
    `;
export type UpdateRouteGridConfigMutationFn = Apollo.MutationFunction<UpdateRouteGridConfigMutation, UpdateRouteGridConfigMutationVariables>;

/**
 * __useUpdateRouteGridConfigMutation__
 *
 * To run a mutation, you first call `useUpdateRouteGridConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRouteGridConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRouteGridConfigMutation, { data, loading, error }] = useUpdateRouteGridConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRouteGridConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRouteGridConfigMutation, UpdateRouteGridConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRouteGridConfigMutation, UpdateRouteGridConfigMutationVariables>(UpdateRouteGridConfigDocument, options);
      }
export type UpdateRouteGridConfigMutationHookResult = ReturnType<typeof useUpdateRouteGridConfigMutation>;
export type UpdateRouteGridConfigMutationResult = Apollo.MutationResult<UpdateRouteGridConfigMutation>;
export type UpdateRouteGridConfigMutationOptions = Apollo.BaseMutationOptions<UpdateRouteGridConfigMutation, UpdateRouteGridConfigMutationVariables>;
export const UpdateTftConfigurationDocument = gql`
    mutation UpdateTftConfiguration($input: UserConfigurationInput!) {
  updateTftConfiguration(input: $input) {
    id
  }
}
    `;
export type UpdateTftConfigurationMutationFn = Apollo.MutationFunction<UpdateTftConfigurationMutation, UpdateTftConfigurationMutationVariables>;

/**
 * __useUpdateTftConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateTftConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTftConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTftConfigurationMutation, { data, loading, error }] = useUpdateTftConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTftConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTftConfigurationMutation, UpdateTftConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTftConfigurationMutation, UpdateTftConfigurationMutationVariables>(UpdateTftConfigurationDocument, options);
      }
export type UpdateTftConfigurationMutationHookResult = ReturnType<typeof useUpdateTftConfigurationMutation>;
export type UpdateTftConfigurationMutationResult = Apollo.MutationResult<UpdateTftConfigurationMutation>;
export type UpdateTftConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateTftConfigurationMutation, UpdateTftConfigurationMutationVariables>;
export const UpdateTrafficGridsConfigDocument = gql`
    mutation UpdateTrafficGridsConfig($input: UserConfigurationInputWithTableName!) {
  updateTrafficGridsConfig(input: $input) {
    id
  }
}
    `;
export type UpdateTrafficGridsConfigMutationFn = Apollo.MutationFunction<UpdateTrafficGridsConfigMutation, UpdateTrafficGridsConfigMutationVariables>;

/**
 * __useUpdateTrafficGridsConfigMutation__
 *
 * To run a mutation, you first call `useUpdateTrafficGridsConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrafficGridsConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrafficGridsConfigMutation, { data, loading, error }] = useUpdateTrafficGridsConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrafficGridsConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrafficGridsConfigMutation, UpdateTrafficGridsConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrafficGridsConfigMutation, UpdateTrafficGridsConfigMutationVariables>(UpdateTrafficGridsConfigDocument, options);
      }
export type UpdateTrafficGridsConfigMutationHookResult = ReturnType<typeof useUpdateTrafficGridsConfigMutation>;
export type UpdateTrafficGridsConfigMutationResult = Apollo.MutationResult<UpdateTrafficGridsConfigMutation>;
export type UpdateTrafficGridsConfigMutationOptions = Apollo.BaseMutationOptions<UpdateTrafficGridsConfigMutation, UpdateTrafficGridsConfigMutationVariables>;
export const UpdateUserConfigurationDocument = gql`
    mutation UpdateUserConfiguration($input: UserConfigurationInput!) {
  updateConfiguration(input: $input) {
    id
    createdAt
    department
    firstName
    fullName
    configuration
    location {
      id
      name
    }
    lastName
    roles
    locationId
  }
}
    `;
export type UpdateUserConfigurationMutationFn = Apollo.MutationFunction<UpdateUserConfigurationMutation, UpdateUserConfigurationMutationVariables>;

/**
 * __useUpdateUserConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateUserConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserConfigurationMutation, { data, loading, error }] = useUpdateUserConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserConfigurationMutation, UpdateUserConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserConfigurationMutation, UpdateUserConfigurationMutationVariables>(UpdateUserConfigurationDocument, options);
      }
export type UpdateUserConfigurationMutationHookResult = ReturnType<typeof useUpdateUserConfigurationMutation>;
export type UpdateUserConfigurationMutationResult = Apollo.MutationResult<UpdateUserConfigurationMutation>;
export type UpdateUserConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateUserConfigurationMutation, UpdateUserConfigurationMutationVariables>;
export const ChecklistResetSubDocument = gql`
    subscription ChecklistResetSub($ownerUserId: String!, $forGroup: String!) {
  checklistReset(ownerUserId: $ownerUserId, forGroup: $forGroup) {
    ownerUserId
    forGroup
  }
}
    `;

/**
 * __useChecklistResetSubSubscription__
 *
 * To run a query within a React component, call `useChecklistResetSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChecklistResetSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistResetSubSubscription({
 *   variables: {
 *      ownerUserId: // value for 'ownerUserId'
 *      forGroup: // value for 'forGroup'
 *   },
 * });
 */
export function useChecklistResetSubSubscription(baseOptions: Apollo.SubscriptionHookOptions<ChecklistResetSubSubscription, ChecklistResetSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChecklistResetSubSubscription, ChecklistResetSubSubscriptionVariables>(ChecklistResetSubDocument, options);
      }
export type ChecklistResetSubSubscriptionHookResult = ReturnType<typeof useChecklistResetSubSubscription>;
export type ChecklistResetSubSubscriptionResult = Apollo.SubscriptionResult<ChecklistResetSubSubscription>;
export const LegsListUpdateSubDocument = gql`
    subscription LegsListUpdateSub($legId: Int!) {
  legsListUpdateSub(legId: $legId) {
    refreshWholeGrid
    legId
    routeLeg {
      id
      locationId
      arrivalTime
      departureTime
      actualArrivalTime
      actualDepartureTime
      actualArrivalDate
      actualDepartureDate
      arrivalStatus
      productionDate
      transportationDate
      actualCapacity
      position
      load
      unload
      loadCar
      loadTrailer
      loadCages
      unloadCar
      unloadTrailer
      unloadCages
      loadCarPPL
      loadTrailerPPL
      unloadCarPPL
      unloadTrailerPPL
      note
      terminalNote
      gateNumber
      carRegistrationNumber
      trailerRegistrationNumber
      terminalNickname
      lastUpdatedBy
      updatedAt
      createdAt
      deletedAt
      isNonArrivalMarked
      nonArrivalMarkedFrom
      isSealBroken
      sealNumber
      productionGroup
      priority
      isLoadingInCar
      isLoadingInTrailer
      assigned
      ansvBefraktare
      timeWhenAssigned
      receivedStatus
      receivedBy
      timeWhenReceived
      kippReceivedBy
      kippTimeWhenReceived
      tom
      fuel
      routeDriverName
      routeDriverPhoneNumber
      terminalStatus
      terminalStatusDescription
      terminalStatusUpdatedAt
      terminalStatusLog {
        id
        status
        timestamp
        timeZone
        locationId
        legId
        locationOrder
        locationLabel
        locationName
        createdBy
        updatedBy
        updatedAt
        gate
      }
      location {
        id
        name
        city
        country
        tags {
          id
          title
        }
      }
      files {
        id
        size
        path
        mimetype
        originalname
      }
      carDetails {
        id
        actualCapacity
        registrationNumber
        gateNumber
        togref
        containerId
        loadingListItems {
          id
          volume {
            id
            bpx
            pri03
            pri49
            upri03
            upri49
            parti
            brev
            pru
            pip
          }
        }
      }
      trailerDetails {
        id
        actualCapacity
        registrationNumber
        gateNumber
        togref
        containerId
      }
      route {
        id
        routeId
        type
        capacity
        trailerCarrierId
        carCarrierId
        agreedPrice
        currency
        transportType
        trainNumber
        containerId
        togref
        turnummer
        rutekode
        inneholdsbeskrivelse
        adr
        transportationDate
        driverName
        isCreatedFromTerminal
        isCreatedFromPlanned
        subcontractor {
          id
          name
        }
        legs {
          position
          load
          unload
          location {
            name
            city
            country
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLegsListUpdateSubSubscription__
 *
 * To run a query within a React component, call `useLegsListUpdateSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLegsListUpdateSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegsListUpdateSubSubscription({
 *   variables: {
 *      legId: // value for 'legId'
 *   },
 * });
 */
export function useLegsListUpdateSubSubscription(baseOptions: Apollo.SubscriptionHookOptions<LegsListUpdateSubSubscription, LegsListUpdateSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LegsListUpdateSubSubscription, LegsListUpdateSubSubscriptionVariables>(LegsListUpdateSubDocument, options);
      }
export type LegsListUpdateSubSubscriptionHookResult = ReturnType<typeof useLegsListUpdateSubSubscription>;
export type LegsListUpdateSubSubscriptionResult = Apollo.SubscriptionResult<LegsListUpdateSubSubscription>;
export const RouteGridUpdateSubDocument = gql`
    subscription RouteGridUpdateSub {
  routeGridUpdate {
    routeId
    transportationDate
    eventType
    changedData
  }
}
    `;

/**
 * __useRouteGridUpdateSubSubscription__
 *
 * To run a query within a React component, call `useRouteGridUpdateSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRouteGridUpdateSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteGridUpdateSubSubscription({
 *   variables: {
 *   },
 * });
 */
export function useRouteGridUpdateSubSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RouteGridUpdateSubSubscription, RouteGridUpdateSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RouteGridUpdateSubSubscription, RouteGridUpdateSubSubscriptionVariables>(RouteGridUpdateSubDocument, options);
      }
export type RouteGridUpdateSubSubscriptionHookResult = ReturnType<typeof useRouteGridUpdateSubSubscription>;
export type RouteGridUpdateSubSubscriptionResult = Apollo.SubscriptionResult<RouteGridUpdateSubSubscription>;
export const RouteLockSubDocument = gql`
    subscription RouteLockSub($routeId: Int!) {
  routeLockSub(routeId: $routeId) {
    lockedBy
    lockedAt
    lock
    routeId
    reload
  }
}
    `;

/**
 * __useRouteLockSubSubscription__
 *
 * To run a query within a React component, call `useRouteLockSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRouteLockSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteLockSubSubscription({
 *   variables: {
 *      routeId: // value for 'routeId'
 *   },
 * });
 */
export function useRouteLockSubSubscription(baseOptions: Apollo.SubscriptionHookOptions<RouteLockSubSubscription, RouteLockSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RouteLockSubSubscription, RouteLockSubSubscriptionVariables>(RouteLockSubDocument, options);
      }
export type RouteLockSubSubscriptionHookResult = ReturnType<typeof useRouteLockSubSubscription>;
export type RouteLockSubSubscriptionResult = Apollo.SubscriptionResult<RouteLockSubSubscription>;
export const RouteLockPingSubDocument = gql`
    subscription RouteLockPingSub($routeId: Int!) {
  routeLockPing(routeId: $routeId) {
    lockedByUserId
    pingedByUserName
    routeId
  }
}
    `;

/**
 * __useRouteLockPingSubSubscription__
 *
 * To run a query within a React component, call `useRouteLockPingSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRouteLockPingSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteLockPingSubSubscription({
 *   variables: {
 *      routeId: // value for 'routeId'
 *   },
 * });
 */
export function useRouteLockPingSubSubscription(baseOptions: Apollo.SubscriptionHookOptions<RouteLockPingSubSubscription, RouteLockPingSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RouteLockPingSubSubscription, RouteLockPingSubSubscriptionVariables>(RouteLockPingSubDocument, options);
      }
export type RouteLockPingSubSubscriptionHookResult = ReturnType<typeof useRouteLockPingSubSubscription>;
export type RouteLockPingSubSubscriptionResult = Apollo.SubscriptionResult<RouteLockPingSubSubscription>;
export const ShipmentAddNexusOrderSubDocument = gql`
    subscription ShipmentAddNexusOrderSub($isNexusAdd: Boolean!) {
  shipmentNexusAddOrderSub(isNexusAdd: $isNexusAdd) {
    orders {
      id
      shipmentDate
      cmrDate
      note
      customsProcedure
      pallets
      packages
      palletSpace
      weight
      customCleared
      terminalCleared
      customClearedForImport
      isRemainingGoods
      customWaybillNo
      templateName
      preplannedRoute
      isImportedFromShipment
      locationId
      fromLocationId
      toLocationId
      locationName
      fromLocationName
      toLocationName
    }
  }
}
    `;

/**
 * __useShipmentAddNexusOrderSubSubscription__
 *
 * To run a query within a React component, call `useShipmentAddNexusOrderSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShipmentAddNexusOrderSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentAddNexusOrderSubSubscription({
 *   variables: {
 *      isNexusAdd: // value for 'isNexusAdd'
 *   },
 * });
 */
export function useShipmentAddNexusOrderSubSubscription(baseOptions: Apollo.SubscriptionHookOptions<ShipmentAddNexusOrderSubSubscription, ShipmentAddNexusOrderSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ShipmentAddNexusOrderSubSubscription, ShipmentAddNexusOrderSubSubscriptionVariables>(ShipmentAddNexusOrderSubDocument, options);
      }
export type ShipmentAddNexusOrderSubSubscriptionHookResult = ReturnType<typeof useShipmentAddNexusOrderSubSubscription>;
export type ShipmentAddNexusOrderSubSubscriptionResult = Apollo.SubscriptionResult<ShipmentAddNexusOrderSubSubscription>;
export const ShipmentBulkOrderUpdateSubDocument = gql`
    subscription ShipmentBulkOrderUpdateSub($userId: String!) {
  shipmentBulkOrderUpdateSub(userId: $userId) {
    byUserName
    userId
  }
}
    `;

/**
 * __useShipmentBulkOrderUpdateSubSubscription__
 *
 * To run a query within a React component, call `useShipmentBulkOrderUpdateSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShipmentBulkOrderUpdateSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentBulkOrderUpdateSubSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useShipmentBulkOrderUpdateSubSubscription(baseOptions: Apollo.SubscriptionHookOptions<ShipmentBulkOrderUpdateSubSubscription, ShipmentBulkOrderUpdateSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ShipmentBulkOrderUpdateSubSubscription, ShipmentBulkOrderUpdateSubSubscriptionVariables>(ShipmentBulkOrderUpdateSubDocument, options);
      }
export type ShipmentBulkOrderUpdateSubSubscriptionHookResult = ReturnType<typeof useShipmentBulkOrderUpdateSubSubscription>;
export type ShipmentBulkOrderUpdateSubSubscriptionResult = Apollo.SubscriptionResult<ShipmentBulkOrderUpdateSubSubscription>;
export const ShipmentLinkUnlinkSubDocument = gql`
    subscription ShipmentLinkUnlinkSub($terminalId: Int!, $transDate: String!) {
  shipmentLinkUnlinkSub(terminalId: $terminalId, transDate: $transDate) {
    terminalId
    transDate
    isLink
    routeId
  }
}
    `;

/**
 * __useShipmentLinkUnlinkSubSubscription__
 *
 * To run a query within a React component, call `useShipmentLinkUnlinkSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShipmentLinkUnlinkSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentLinkUnlinkSubSubscription({
 *   variables: {
 *      terminalId: // value for 'terminalId'
 *      transDate: // value for 'transDate'
 *   },
 * });
 */
export function useShipmentLinkUnlinkSubSubscription(baseOptions: Apollo.SubscriptionHookOptions<ShipmentLinkUnlinkSubSubscription, ShipmentLinkUnlinkSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ShipmentLinkUnlinkSubSubscription, ShipmentLinkUnlinkSubSubscriptionVariables>(ShipmentLinkUnlinkSubDocument, options);
      }
export type ShipmentLinkUnlinkSubSubscriptionHookResult = ReturnType<typeof useShipmentLinkUnlinkSubSubscription>;
export type ShipmentLinkUnlinkSubSubscriptionResult = Apollo.SubscriptionResult<ShipmentLinkUnlinkSubSubscription>;
export const ShipmentListUpdateSubDocument = gql`
    subscription ShipmentListUpdateSub($startDate: String!, $endDate: String!) {
  shipmentListUpdateSub(startDate: $startDate, endDate: $endDate) {
    shipmentDate
  }
}
    `;

/**
 * __useShipmentListUpdateSubSubscription__
 *
 * To run a query within a React component, call `useShipmentListUpdateSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShipmentListUpdateSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentListUpdateSubSubscription({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useShipmentListUpdateSubSubscription(baseOptions: Apollo.SubscriptionHookOptions<ShipmentListUpdateSubSubscription, ShipmentListUpdateSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ShipmentListUpdateSubSubscription, ShipmentListUpdateSubSubscriptionVariables>(ShipmentListUpdateSubDocument, options);
      }
export type ShipmentListUpdateSubSubscriptionHookResult = ReturnType<typeof useShipmentListUpdateSubSubscription>;
export type ShipmentListUpdateSubSubscriptionResult = Apollo.SubscriptionResult<ShipmentListUpdateSubSubscription>;
export const ShipmentOrderDeleteSubDocument = gql`
    subscription ShipmentOrderDeleteSub($startDate: String!, $endDate: String!) {
  shipmentOrderDeleteSub(startDate: $startDate, endDate: $endDate) {
    loadingListItemId
    orderShipmentDate
  }
}
    `;

/**
 * __useShipmentOrderDeleteSubSubscription__
 *
 * To run a query within a React component, call `useShipmentOrderDeleteSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShipmentOrderDeleteSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentOrderDeleteSubSubscription({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useShipmentOrderDeleteSubSubscription(baseOptions: Apollo.SubscriptionHookOptions<ShipmentOrderDeleteSubSubscription, ShipmentOrderDeleteSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ShipmentOrderDeleteSubSubscription, ShipmentOrderDeleteSubSubscriptionVariables>(ShipmentOrderDeleteSubDocument, options);
      }
export type ShipmentOrderDeleteSubSubscriptionHookResult = ReturnType<typeof useShipmentOrderDeleteSubSubscription>;
export type ShipmentOrderDeleteSubSubscriptionResult = Apollo.SubscriptionResult<ShipmentOrderDeleteSubSubscription>;
export const ShipmentPartialUpdateSubDocument = gql`
    subscription ShipmentPartialUpdateSub($shipmentId: Int!, $userId: String!) {
  shipmentPartialUpdateSub(shipmentId: $shipmentId, userId: $userId) {
    shipmentId
    orderId
    forFieldName
    forFieldValue
    userId
    loadingListItems {
      id
      locationId
      note
      customsProcedure
      packages
      pallets
      palletSpace
      weight
      customCleared
      terminalCleared
      customClearedForImport
      isRemainingGoods
      customWaybillNo
      locationName
      isImportedFromShipment
      linkedRouteName
      createdFrom
    }
  }
}
    `;

/**
 * __useShipmentPartialUpdateSubSubscription__
 *
 * To run a query within a React component, call `useShipmentPartialUpdateSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShipmentPartialUpdateSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentPartialUpdateSubSubscription({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useShipmentPartialUpdateSubSubscription(baseOptions: Apollo.SubscriptionHookOptions<ShipmentPartialUpdateSubSubscription, ShipmentPartialUpdateSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ShipmentPartialUpdateSubSubscription, ShipmentPartialUpdateSubSubscriptionVariables>(ShipmentPartialUpdateSubDocument, options);
      }
export type ShipmentPartialUpdateSubSubscriptionHookResult = ReturnType<typeof useShipmentPartialUpdateSubSubscription>;
export type ShipmentPartialUpdateSubSubscriptionResult = Apollo.SubscriptionResult<ShipmentPartialUpdateSubSubscription>;
export const ShipmentOrderUpdateSubDocument = gql`
    subscription ShipmentOrderUpdateSub($startDate: String!, $endDate: String!) {
  shipmentOrderUpdateSub(startDate: $startDate, endDate: $endDate) {
    id
    isOrderHidden
    hiddenBy
    shipmentDate
    cmrDate
    note
    customsProcedure
    pallets
    packages
    palletSpace
    weight
    customCleared
    terminalCleared
    customClearedForImport
    isRemainingGoods
    customWaybillNo
    templateName
    preplannedRoute
    isImportedFromShipment
    locationId
    fromLocationId
    toLocationId
    locationName
    fromLocationName
    toLocationName
  }
}
    `;

/**
 * __useShipmentOrderUpdateSubSubscription__
 *
 * To run a query within a React component, call `useShipmentOrderUpdateSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShipmentOrderUpdateSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentOrderUpdateSubSubscription({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useShipmentOrderUpdateSubSubscription(baseOptions: Apollo.SubscriptionHookOptions<ShipmentOrderUpdateSubSubscription, ShipmentOrderUpdateSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ShipmentOrderUpdateSubSubscription, ShipmentOrderUpdateSubSubscriptionVariables>(ShipmentOrderUpdateSubDocument, options);
      }
export type ShipmentOrderUpdateSubSubscriptionHookResult = ReturnType<typeof useShipmentOrderUpdateSubSubscription>;
export type ShipmentOrderUpdateSubSubscriptionResult = Apollo.SubscriptionResult<ShipmentOrderUpdateSubSubscription>;
export const TemplateRouteUpdateSubDocument = gql`
    subscription TemplateRouteUpdateSub {
  templateRouteUpdate {
    eventType
    userId
  }
}
    `;

/**
 * __useTemplateRouteUpdateSubSubscription__
 *
 * To run a query within a React component, call `useTemplateRouteUpdateSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTemplateRouteUpdateSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateRouteUpdateSubSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTemplateRouteUpdateSubSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TemplateRouteUpdateSubSubscription, TemplateRouteUpdateSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TemplateRouteUpdateSubSubscription, TemplateRouteUpdateSubSubscriptionVariables>(TemplateRouteUpdateSubDocument, options);
      }
export type TemplateRouteUpdateSubSubscriptionHookResult = ReturnType<typeof useTemplateRouteUpdateSubSubscription>;
export type TemplateRouteUpdateSubSubscriptionResult = Apollo.SubscriptionResult<TemplateRouteUpdateSubSubscription>;
export const TerminalStatusTruckFillAndTimeUpdateDocument = gql`
    subscription TerminalStatusTruckFillAndTimeUpdate($locationId: Int!) {
  truckFillAndTimeUpdate(locationId: $locationId) {
    refreshWholeGrid
    locationId
    updateType
    routeLeg {
      id
      actualArrivalTime
      actualArrivalDate
      actualDepartureTime
      actualDepartureDate
      actualDockTime
      actualDockDate
      actualUndockTime
      actualUndockDate
      loadCar
      loadCarPPL
      loadTrailer
      loadTrailerPPL
      loadCages
      actualCapacity
      gateNumber
      carRegistrationNumber
      trailerRegistrationNumber
      unloadCar
      unloadCarPPL
      unloadTrailer
      unloadTrailerPPL
      unloadCages
      isNonArrivalMarked
      isSealBroken
      sealNumber
      terminalNickname
      terminalNote
      productionGroup
      terminalResponsible
      operator
      arrivalStatus
      note
      priority
      files {
        id
        originalname
        mimetype
        path
        size
      }
      updatedAt
      lastUpdatedBy
      receivedStatus
      receivedBy
      timeWhenReceived
      kippReceivedBy
      kippTimeWhenReceived
      assigned
      ansvBefraktare
      timeWhenAssigned
      routeDriverName
      tom
      terminalStatus
      terminalStatusDescription
      terminalStatusUpdatedAt
      terminalStatusLog {
        id
        status
        timestamp
        timeZone
        locationId
        legId
        locationId
        locationOrder
        locationLabel
        locationName
        createdBy
        updatedBy
        updatedAt
        gate
      }
      carDetails {
        actualCapacity
        gateNumber
        registrationNumber
        togref
        containerId
        loadingListItems {
          volume {
            id
            bpx
            pri03
            pri49
            upri03
            upri49
            parti
            brev
            pru
            pip
          }
        }
      }
      trailerDetails {
        actualCapacity
        gateNumber
        registrationNumber
      }
      route {
        id
        rutekode
        turnummer
        trainNumber
        adr
        inneholdsbeskrivelse
      }
    }
  }
}
    `;

/**
 * __useTerminalStatusTruckFillAndTimeUpdateSubscription__
 *
 * To run a query within a React component, call `useTerminalStatusTruckFillAndTimeUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTerminalStatusTruckFillAndTimeUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerminalStatusTruckFillAndTimeUpdateSubscription({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useTerminalStatusTruckFillAndTimeUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<TerminalStatusTruckFillAndTimeUpdateSubscription, TerminalStatusTruckFillAndTimeUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TerminalStatusTruckFillAndTimeUpdateSubscription, TerminalStatusTruckFillAndTimeUpdateSubscriptionVariables>(TerminalStatusTruckFillAndTimeUpdateDocument, options);
      }
export type TerminalStatusTruckFillAndTimeUpdateSubscriptionHookResult = ReturnType<typeof useTerminalStatusTruckFillAndTimeUpdateSubscription>;
export type TerminalStatusTruckFillAndTimeUpdateSubscriptionResult = Apollo.SubscriptionResult<TerminalStatusTruckFillAndTimeUpdateSubscription>;
export const TruckFillAndTimeUpdateDocument = gql`
    subscription TruckFillAndTimeUpdate($locationId: Int!) {
  truckFillAndTimeUpdate(locationId: $locationId) {
    refreshWholeGrid
    locationId
    updateType
    routeLeg {
      operator
      ...LiveUpdateRouteLeg
      route {
        id
        rutekode
        turnummer
        trainNumber
        adr
        inneholdsbeskrivelse
      }
      carDetails {
        actualCapacity
        gateNumber
        registrationNumber
        togref
        containerId
        loadingListItems {
          volume {
            id
            bpx
            pri03
            pri49
            upri03
            upri49
            parti
            brev
            pru
            pip
          }
        }
      }
      trailerDetails {
        actualCapacity
        gateNumber
        registrationNumber
      }
    }
  }
}
    ${LiveUpdateRouteLegFragmentDoc}`;

/**
 * __useTruckFillAndTimeUpdateSubscription__
 *
 * To run a query within a React component, call `useTruckFillAndTimeUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTruckFillAndTimeUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTruckFillAndTimeUpdateSubscription({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useTruckFillAndTimeUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<TruckFillAndTimeUpdateSubscription, TruckFillAndTimeUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TruckFillAndTimeUpdateSubscription, TruckFillAndTimeUpdateSubscriptionVariables>(TruckFillAndTimeUpdateDocument, options);
      }
export type TruckFillAndTimeUpdateSubscriptionHookResult = ReturnType<typeof useTruckFillAndTimeUpdateSubscription>;
export type TruckFillAndTimeUpdateSubscriptionResult = Apollo.SubscriptionResult<TruckFillAndTimeUpdateSubscription>;